const gcJcamp2 = `

##TITLE=Spectrum
##JCAMP-DX=5.00 $$ chemotion-converter-app (1.1.0)
##DATA TYPE=GAS CHROMATOGRAPHY
##DATA CLASS=NTUPLES
##$CSCATEGORY=SPECTRUM
##ORIGIN=
##OWNER=
##XUNITS=MINUTES
##YUNITS=Intensity
##SOFTWARE=LabSolutions
##SOFTWARE_VERSION=5.110
##METHOD=D:\\Methods\\GC-BID_inc-5min-30_GC-3min-40-7min-180-2min_Calibrated.gcm
##DATE=14.11.2023
##TIME=12:48:40
##OPERATOR=System Administrator
##INSTRUMENT=ComPlat_GC-BID
##NAME1=H2
##RTIME1=2.887
##CONC_PPM1=24148.876
##CONC_QUOTA1=13.975
##NAME2=Ar / O2
##RTIME2=3.472
##CONC_PPM2=0.000
##CONC_QUOTA2=0.000
##NAME3=N2
##RTIME3=4.355
##CONC_PPM3=0.000
##CONC_QUOTA3=0.000
##NAME4=CH4
##RTIME4=0.000
##CONC_PPM4=0.000
##CONC_QUOTA4=0.000
##NAME5=CO
##RTIME5=6.682
##CONC_PPM5=148645.945
##CONC_QUOTA5=86.025
##FIRSTX=0.0
##LASTX=12.0
##MINX=0.0
##MAXX=12.0
##MINY=-28.0
##MAXY=7613705.0
##NPOINTS=18001
##FIRSTY=0.0
##XUNITS=MINUTES
##YUNITS=Intensity
##XYDATA=(XY..XY)
0.0, 0.0
0.00067, 2.0
0.00133, 4.0
0.002, 5.0
0.00267, 7.0
0.00333, 8.0
0.004, 9.0
0.00467, 10.0
0.00533, 11.0
0.006, 12.0
0.00667, 12.0
0.00733, 13.0
0.008, 13.0
0.00867, 14.0
0.00933, 15.0
0.01, 16.0
0.01067, 17.0
0.01133, 18.0
0.012, 18.0
0.01267, 20.0
0.01333, 27.0
0.014, 44.0
0.01467, 77.0
0.01533, 128.0
0.016, 194.0
0.01667, 274.0
0.01733, 364.0
0.018, 460.0
0.01867, 557.0
0.01933, 653.0
0.02, 742.0
0.02067, 825.0
0.02133, 898.0
0.022, 963.0
0.02267, 1021.0
0.02333, 1072.0
0.024, 1120.0
0.02467, 1167.0
0.02533, 1216.0
0.026, 1270.0
0.02667, 1331.0
0.02733, 1400.0
0.028, 1479.0
0.02867, 1569.0
0.02933, 1670.0
0.03, 1781.0
0.03067, 1902.0
0.03133, 2032.0
0.032, 2167.0
0.03267, 2308.0
0.03333, 2452.0
0.034, 2598.0
0.03467, 2743.0
0.03533, 2887.0
0.036, 3029.0
0.03667, 3166.0
0.03733, 3299.0
0.038, 3427.0
0.03867, 3549.0
0.03933, 3665.0
0.04, 3776.0
0.04067, 3882.0
0.04133, 3983.0
0.042, 4079.0
0.04267, 4170.0
0.04333, 4258.0
0.044, 4342.0
0.04467, 4422.0
0.04533, 4499.0
0.046, 4573.0
0.04667, 4645.0
0.04733, 4713.0
0.048, 4778.0
0.04867, 4841.0
0.04933, 4901.0
0.05, 4959.0
0.05067, 5014.0
0.05133, 5066.0
0.052, 5117.0
0.05267, 5165.0
0.05333, 5210.0
0.054, 5254.0
0.05467, 5295.0
0.05533, 5334.0
0.056, 5372.0
0.05667, 5408.0
0.05733, 5442.0
0.058, 5475.0
0.05867, 5506.0
0.05933, 5536.0
0.06, 5566.0
0.06067, 5594.0
0.06133, 5621.0
0.062, 5647.0
0.06267, 5672.0
0.06333, 5697.0
0.064, 5721.0
0.06467, 5744.0
0.06533, 5766.0
0.066, 5788.0
0.06667, 5809.0
0.06733, 5830.0
0.068, 5851.0
0.06867, 5871.0
0.06933, 5891.0
0.07, 5910.0
0.07067, 5929.0
0.07133, 5947.0
0.072, 5966.0
0.07267, 5984.0
0.07333, 6002.0
0.074, 6019.0
0.07467, 6037.0
0.07533, 6054.0
0.076, 6071.0
0.07667, 6088.0
0.07733, 6105.0
0.078, 6121.0
0.07867, 6138.0
0.07933, 6155.0
0.08, 6171.0
0.08067, 6188.0
0.08133, 6205.0
0.082, 6222.0
0.08267, 6240.0
0.08333, 6257.0
0.084, 6276.0
0.08467, 6294.0
0.08533, 6312.0
0.086, 6331.0
0.08667, 6349.0
0.08733, 6368.0
0.088, 6387.0
0.08867, 6406.0
0.08933, 6425.0
0.09, 6444.0
0.09067, 6463.0
0.09133, 6482.0
0.092, 6501.0
0.09267, 6520.0
0.09333, 6539.0
0.094, 6558.0
0.09467, 6577.0
0.09533, 6595.0
0.096, 6614.0
0.09667, 6632.0
0.09733, 6650.0
0.098, 6668.0
0.09867, 6686.0
0.09933, 6704.0
0.1, 6721.0
0.10067, 6739.0
0.10133, 6756.0
0.102, 6772.0
0.10267, 6789.0
0.10333, 6805.0
0.104, 6820.0
0.10467, 6836.0
0.10533, 6850.0
0.106, 6864.0
0.10667, 6878.0
0.10733, 6890.0
0.108, 6902.0
0.10867, 6912.0
0.10933, 6922.0
0.11, 6931.0
0.11067, 6940.0
0.11133, 6947.0
0.112, 6954.0
0.11267, 6960.0
0.11333, 6965.0
0.114, 6970.0
0.11467, 6975.0
0.11533, 6979.0
0.116, 6982.0
0.11667, 6985.0
0.11733, 6988.0
0.118, 6990.0
0.11867, 6992.0
0.11933, 6993.0
0.12, 6995.0
0.12067, 6995.0
0.12133, 6996.0
0.122, 6996.0
0.12267, 6996.0
0.12333, 6996.0
0.124, 6995.0
0.12467, 6995.0
0.12533, 6994.0
0.126, 6992.0
0.12667, 6990.0
0.12733, 6988.0
0.128, 6985.0
0.12867, 6982.0
0.12933, 6978.0
0.13, 6974.0
0.13067, 6970.0
0.13133, 6966.0
0.132, 6962.0
0.13267, 6958.0
0.13333, 6954.0
0.134, 6949.0
0.13467, 6945.0
0.13533, 6940.0
0.136, 6935.0
0.13667, 6931.0
0.13733, 6926.0
0.138, 6921.0
0.13867, 6916.0
0.13933, 6911.0
0.14, 6907.0
0.14067, 6903.0
0.14133, 6898.0
0.142, 6894.0
0.14267, 6890.0
0.14333, 6886.0
0.144, 6882.0
0.14467, 6878.0
0.14533, 6874.0
0.146, 6870.0
0.14667, 6866.0
0.14733, 6863.0
0.148, 6859.0
0.14867, 6855.0
0.14933, 6851.0
0.15, 6847.0
0.15067, 6842.0
0.15133, 6838.0
0.152, 6833.0
0.15267, 6829.0
0.15333, 6825.0
0.154, 6821.0
0.15467, 6818.0
0.15533, 6815.0
0.156, 6813.0
0.15667, 6810.0
0.15733, 6808.0
0.158, 6807.0
0.15867, 6805.0
0.15933, 6804.0
0.16, 6803.0
0.16067, 6803.0
0.16133, 6803.0
0.162, 6802.0
0.16267, 6802.0
0.16333, 6802.0
0.164, 6803.0
0.16467, 6803.0
0.16533, 6803.0
0.166, 6803.0
0.16667, 6803.0
0.16733, 6803.0
0.168, 6803.0
0.16867, 6803.0
0.16933, 6803.0
0.17, 6803.0
0.17067, 6804.0
0.17133, 6804.0
0.172, 6804.0
0.17267, 6804.0
0.17333, 6804.0
0.174, 6805.0
0.17467, 6805.0
0.17533, 6806.0
0.176, 6806.0
0.17667, 6806.0
0.17733, 6806.0
0.178, 6806.0
0.17867, 6806.0
0.17933, 6806.0
0.18, 6806.0
0.18067, 6805.0
0.18133, 6804.0
0.182, 6803.0
0.18267, 6802.0
0.18333, 6800.0
0.184, 6798.0
0.18467, 6797.0
0.18533, 6795.0
0.186, 6793.0
0.18667, 6791.0
0.18733, 6790.0
0.188, 6789.0
0.18867, 6788.0
0.18933, 6787.0
0.19, 6786.0
0.19067, 6785.0
0.19133, 6785.0
0.192, 6784.0
0.19267, 6783.0
0.19333, 6782.0
0.194, 6781.0
0.19467, 6780.0
0.19533, 6778.0
0.196, 6777.0
0.19667, 6775.0
0.19733, 6773.0
0.198, 6771.0
0.19867, 6769.0
0.19933, 6767.0
0.2, 6766.0
0.20067, 6764.0
0.20133, 6762.0
0.202, 6760.0
0.20267, 6758.0
0.20333, 6756.0
0.204, 6753.0
0.20467, 6751.0
0.20533, 6748.0
0.206, 6746.0
0.20667, 6744.0
0.20733, 6741.0
0.208, 6739.0
0.20867, 6736.0
0.20933, 6734.0
0.21, 6731.0
0.21067, 6729.0
0.21133, 6727.0
0.212, 6725.0
0.21267, 6724.0
0.21333, 6723.0
0.214, 6722.0
0.21467, 6721.0
0.21533, 6721.0
0.216, 6721.0
0.21667, 6721.0
0.21733, 6721.0
0.218, 6721.0
0.21867, 6720.0
0.21933, 6720.0
0.22, 6719.0
0.22067, 6719.0
0.22133, 6718.0
0.222, 6718.0
0.22267, 6717.0
0.22333, 6717.0
0.224, 6717.0
0.22467, 6716.0
0.22533, 6716.0
0.226, 6715.0
0.22667, 6715.0
0.22733, 6714.0
0.228, 6713.0
0.22867, 6712.0
0.22933, 6711.0
0.23, 6711.0
0.23067, 6710.0
0.23133, 6709.0
0.232, 6709.0
0.23267, 6709.0
0.23333, 6709.0
0.234, 6709.0
0.23467, 6709.0
0.23533, 6709.0
0.236, 6710.0
0.23667, 6710.0
0.23733, 6710.0
0.238, 6710.0
0.23867, 6711.0
0.23933, 6711.0
0.24, 6711.0
0.24067, 6711.0
0.24133, 6710.0
0.242, 6710.0
0.24267, 6710.0
0.24333, 6709.0
0.244, 6709.0
0.24467, 6708.0
0.24533, 6708.0
0.246, 6707.0
0.24667, 6707.0
0.24733, 6707.0
0.248, 6707.0
0.24867, 6707.0
0.24933, 6707.0
0.25, 6707.0
0.25067, 6707.0
0.25133, 6707.0
0.252, 6707.0
0.25267, 6708.0
0.25333, 6708.0
0.254, 6709.0
0.25467, 6709.0
0.25533, 6710.0
0.256, 6710.0
0.25667, 6711.0
0.25733, 6711.0
0.258, 6712.0
0.25867, 6713.0
0.25933, 6713.0
0.26, 6714.0
0.26067, 6714.0
0.26133, 6715.0
0.262, 6715.0
0.26267, 6715.0
0.26333, 6715.0
0.264, 6714.0
0.26467, 6714.0
0.26533, 6713.0
0.266, 6712.0
0.26667, 6711.0
0.26733, 6710.0
0.268, 6709.0
0.26867, 6708.0
0.26933, 6706.0
0.27, 6705.0
0.27067, 6704.0
0.27133, 6704.0
0.272, 6703.0
0.27267, 6703.0
0.27333, 6702.0
0.274, 6702.0
0.27467, 6702.0
0.27533, 6703.0
0.276, 6703.0
0.27667, 6704.0
0.27733, 6706.0
0.278, 6707.0
0.27867, 6709.0
0.27933, 6712.0
0.28, 6715.0
0.28067, 6718.0
0.28133, 6722.0
0.282, 6726.0
0.28267, 6730.0
0.28333, 6734.0
0.284, 6739.0
0.28467, 6744.0
0.28533, 6749.0
0.286, 6754.0
0.28667, 6759.0
0.28733, 6764.0
0.288, 6770.0
0.28867, 6775.0
0.28933, 6780.0
0.29, 6785.0
0.29067, 6790.0
0.29133, 6795.0
0.292, 6800.0
0.29267, 6805.0
0.29333, 6810.0
0.294, 6815.0
0.29467, 6821.0
0.29533, 6826.0
0.296, 6832.0
0.29667, 6837.0
0.29733, 6843.0
0.298, 6849.0
0.29867, 6854.0
0.29933, 6860.0
0.3, 6866.0
0.30067, 6872.0
0.30133, 6878.0
0.302, 6884.0
0.30267, 6890.0
0.30333, 6896.0
0.304, 6903.0
0.30467, 6909.0
0.30533, 6916.0
0.306, 6922.0
0.30667, 6929.0
0.30733, 6935.0
0.308, 6942.0
0.30867, 6948.0
0.30933, 6955.0
0.31, 6961.0
0.31067, 6967.0
0.31133, 6973.0
0.312, 6979.0
0.31267, 6985.0
0.31333, 6990.0
0.314, 6996.0
0.31467, 7001.0
0.31533, 7005.0
0.316, 7009.0
0.31667, 7013.0
0.31733, 7016.0
0.318, 7019.0
0.31867, 7022.0
0.31933, 7024.0
0.32, 7026.0
0.32067, 7028.0
0.32133, 7029.0
0.322, 7030.0
0.32267, 7032.0
0.32333, 7033.0
0.324, 7034.0
0.32467, 7035.0
0.32533, 7035.0
0.326, 7036.0
0.32667, 7036.0
0.32733, 7037.0
0.328, 7037.0
0.32867, 7037.0
0.32933, 7037.0
0.33, 7037.0
0.33067, 7036.0
0.33133, 7035.0
0.332, 7034.0
0.33267, 7033.0
0.33333, 7032.0
0.334, 7031.0
0.33467, 7030.0
0.33533, 7028.0
0.336, 7027.0
0.33667, 7025.0
0.33733, 7023.0
0.338, 7021.0
0.33867, 7019.0
0.33933, 7017.0
0.34, 7014.0
0.34067, 7012.0
0.34133, 7009.0
0.342, 7007.0
0.34267, 7004.0
0.34333, 7001.0
0.344, 6999.0
0.34467, 6996.0
0.34533, 6993.0
0.346, 6990.0
0.34667, 6987.0
0.34733, 6983.0
0.348, 6980.0
0.34867, 6976.0
0.34933, 6973.0
0.35, 6969.0
0.35067, 6965.0
0.35133, 6960.0
0.352, 6956.0
0.35267, 6951.0
0.35333, 6947.0
0.354, 6943.0
0.35467, 6938.0
0.35533, 6934.0
0.356, 6930.0
0.35667, 6926.0
0.35733, 6922.0
0.358, 6918.0
0.35867, 6914.0
0.35933, 6910.0
0.36, 6906.0
0.36067, 6902.0
0.36133, 6898.0
0.362, 6895.0
0.36267, 6891.0
0.36333, 6887.0
0.364, 6883.0
0.36467, 6879.0
0.36533, 6875.0
0.366, 6871.0
0.36667, 6866.0
0.36733, 6862.0
0.368, 6857.0
0.36867, 6852.0
0.36933, 6847.0
0.37, 6841.0
0.37067, 6836.0
0.37133, 6831.0
0.372, 6825.0
0.37267, 6820.0
0.37333, 6815.0
0.374, 6809.0
0.37467, 6804.0
0.37533, 6799.0
0.376, 6794.0
0.37667, 6789.0
0.37733, 6784.0
0.378, 6780.0
0.37867, 6775.0
0.37933, 6770.0
0.38, 6766.0
0.38067, 6761.0
0.38133, 6757.0
0.382, 6752.0
0.38267, 6748.0
0.38333, 6743.0
0.384, 6738.0
0.38467, 6733.0
0.38533, 6728.0
0.386, 6723.0
0.38667, 6718.0
0.38733, 6713.0
0.388, 6708.0
0.38867, 6704.0
0.38933, 6700.0
0.39, 6695.0
0.39067, 6691.0
0.39133, 6688.0
0.392, 6684.0
0.39267, 6680.0
0.39333, 6676.0
0.394, 6672.0
0.39467, 6669.0
0.39533, 6665.0
0.396, 6662.0
0.39667, 6658.0
0.39733, 6655.0
0.398, 6652.0
0.39867, 6648.0
0.39933, 6645.0
0.4, 6643.0
0.40067, 6640.0
0.40133, 6637.0
0.402, 6635.0
0.40267, 6633.0
0.40333, 6630.0
0.404, 6628.0
0.40467, 6625.0
0.40533, 6622.0
0.406, 6619.0
0.40667, 6616.0
0.40733, 6612.0
0.408, 6608.0
0.40867, 6604.0
0.40933, 6599.0
0.41, 6595.0
0.41067, 6590.0
0.41133, 6586.0
0.412, 6581.0
0.41267, 6577.0
0.41333, 6573.0
0.414, 6569.0
0.41467, 6566.0
0.41533, 6562.0
0.416, 6558.0
0.41667, 6554.0
0.41733, 6550.0
0.418, 6546.0
0.41867, 6541.0
0.41933, 6537.0
0.42, 6532.0
0.42067, 6527.0
0.42133, 6523.0
0.422, 6518.0
0.42267, 6513.0
0.42333, 6509.0
0.424, 6504.0
0.42467, 6499.0
0.42533, 6495.0
0.426, 6491.0
0.42667, 6486.0
0.42733, 6482.0
0.428, 6478.0
0.42867, 6473.0
0.42933, 6469.0
0.43, 6465.0
0.43067, 6461.0
0.43133, 6457.0
0.432, 6454.0
0.43267, 6450.0
0.43333, 6448.0
0.434, 6445.0
0.43467, 6442.0
0.43533, 6439.0
0.436, 6437.0
0.43667, 6434.0
0.43733, 6432.0
0.438, 6429.0
0.43867, 6427.0
0.43933, 6425.0
0.44, 6423.0
0.44067, 6421.0
0.44133, 6420.0
0.442, 6418.0
0.44267, 6417.0
0.44333, 6416.0
0.444, 6414.0
0.44467, 6413.0
0.44533, 6411.0
0.446, 6410.0
0.44667, 6408.0
0.44733, 6406.0
0.448, 6404.0
0.44867, 6402.0
0.44933, 6399.0
0.45, 6397.0
0.45067, 6395.0
0.45133, 6392.0
0.452, 6390.0
0.45267, 6387.0
0.45333, 6385.0
0.454, 6382.0
0.45467, 6380.0
0.45533, 6377.0
0.456, 6374.0
0.45667, 6372.0
0.45733, 6369.0
0.458, 6366.0
0.45867, 6363.0
0.45933, 6360.0
0.46, 6356.0
0.46067, 6353.0
0.46133, 6350.0
0.462, 6347.0
0.46267, 6343.0
0.46333, 6340.0
0.464, 6336.0
0.46467, 6333.0
0.46533, 6330.0
0.466, 6327.0
0.46667, 6324.0
0.46733, 6321.0
0.468, 6319.0
0.46867, 6316.0
0.46933, 6314.0
0.47, 6312.0
0.47067, 6311.0
0.47133, 6310.0
0.472, 6309.0
0.47267, 6309.0
0.47333, 6308.0
0.474, 6308.0
0.47467, 6308.0
0.47533, 6308.0
0.476, 6308.0
0.47667, 6308.0
0.47733, 6308.0
0.478, 6308.0
0.47867, 6308.0
0.47933, 6308.0
0.48, 6308.0
0.48067, 6308.0
0.48133, 6308.0
0.482, 6308.0
0.48267, 6308.0
0.48333, 6308.0
0.484, 6309.0
0.48467, 6309.0
0.48533, 6310.0
0.486, 6310.0
0.48667, 6310.0
0.48733, 6311.0
0.488, 6312.0
0.48867, 6313.0
0.48933, 6315.0
0.49, 6317.0
0.49067, 6319.0
0.49133, 6321.0
0.492, 6324.0
0.49267, 6327.0
0.49333, 6330.0
0.494, 6332.0
0.49467, 6335.0
0.49533, 6338.0
0.496, 6341.0
0.49667, 6343.0
0.49733, 6346.0
0.498, 6348.0
0.49867, 6349.0
0.49933, 6351.0
0.5, 6352.0
0.50067, 6354.0
0.50133, 6355.0
0.502, 6356.0
0.50267, 6357.0
0.50333, 6358.0
0.504, 6359.0
0.50467, 6360.0
0.50533, 6361.0
0.506, 6361.0
0.50667, 6362.0
0.50733, 6363.0
0.508, 6364.0
0.50867, 6366.0
0.50933, 6367.0
0.51, 6369.0
0.51067, 6371.0
0.51133, 6373.0
0.512, 6376.0
0.51267, 6378.0
0.51333, 6380.0
0.514, 6383.0
0.51467, 6384.0
0.51533, 6386.0
0.516, 6387.0
0.51667, 6388.0
0.51733, 6388.0
0.518, 6388.0
0.51867, 6388.0
0.51933, 6387.0
0.52, 6387.0
0.52067, 6387.0
0.52133, 6386.0
0.522, 6386.0
0.52267, 6386.0
0.52333, 6385.0
0.524, 6385.0
0.52467, 6384.0
0.52533, 6384.0
0.526, 6383.0
0.52667, 6383.0
0.52733, 6382.0
0.528, 6382.0
0.52867, 6381.0
0.52933, 6379.0
0.53, 6378.0
0.53067, 6377.0
0.53133, 6376.0
0.532, 6374.0
0.53267, 6372.0
0.53333, 6371.0
0.534, 6369.0
0.53467, 6367.0
0.53533, 6366.0
0.536, 6364.0
0.53667, 6363.0
0.53733, 6361.0
0.538, 6360.0
0.53867, 6359.0
0.53933, 6358.0
0.54, 6358.0
0.54067, 6358.0
0.54133, 6357.0
0.542, 6358.0
0.54267, 6358.0
0.54333, 6358.0
0.544, 6359.0
0.54467, 6359.0
0.54533, 6360.0
0.546, 6361.0
0.54667, 6362.0
0.54733, 6364.0
0.548, 6366.0
0.54867, 6369.0
0.54933, 6372.0
0.55, 6375.0
0.55067, 6378.0
0.55133, 6382.0
0.552, 6386.0
0.55267, 6391.0
0.55333, 6395.0
0.554, 6400.0
0.55467, 6404.0
0.55533, 6409.0
0.556, 6413.0
0.55667, 6417.0
0.55733, 6422.0
0.558, 6426.0
0.55867, 6431.0
0.55933, 6435.0
0.56, 6439.0
0.56067, 6443.0
0.56133, 6448.0
0.562, 6452.0
0.56267, 6457.0
0.56333, 6461.0
0.564, 6465.0
0.56467, 6470.0
0.56533, 6474.0
0.566, 6479.0
0.56667, 6483.0
0.56733, 6488.0
0.568, 6493.0
0.56867, 6498.0
0.56933, 6503.0
0.57, 6507.0
0.57067, 6512.0
0.57133, 6516.0
0.572, 6520.0
0.57267, 6524.0
0.57333, 6528.0
0.574, 6532.0
0.57467, 6535.0
0.57533, 6539.0
0.576, 6542.0
0.57667, 6546.0
0.57733, 6550.0
0.578, 6554.0
0.57867, 6557.0
0.57933, 6561.0
0.58, 6565.0
0.58067, 6570.0
0.58133, 6574.0
0.582, 6578.0
0.58267, 6582.0
0.58333, 6586.0
0.584, 6590.0
0.58467, 6594.0
0.58533, 6599.0
0.586, 6603.0
0.58667, 6607.0
0.58733, 6612.0
0.588, 6616.0
0.58867, 6621.0
0.58933, 6625.0
0.59, 6629.0
0.59067, 6633.0
0.59133, 6638.0
0.592, 6642.0
0.59267, 6646.0
0.59333, 6650.0
0.594, 6654.0
0.59467, 6658.0
0.59533, 6662.0
0.596, 6665.0
0.59667, 6668.0
0.59733, 6672.0
0.598, 6675.0
0.59867, 6678.0
0.59933, 6681.0
0.6, 6684.0
0.60067, 6687.0
0.60133, 6690.0
0.602, 6693.0
0.60267, 6695.0
0.60333, 6697.0
0.604, 6699.0
0.60467, 6700.0
0.60533, 6702.0
0.606, 6703.0
0.60667, 6703.0
0.60733, 6704.0
0.608, 6704.0
0.60867, 6705.0
0.60933, 6705.0
0.61, 6705.0
0.61067, 6706.0
0.61133, 6707.0
0.612, 6707.0
0.61267, 6708.0
0.61333, 6709.0
0.614, 6710.0
0.61467, 6710.0
0.61533, 6711.0
0.616, 6711.0
0.61667, 6711.0
0.61733, 6711.0
0.618, 6711.0
0.61867, 6711.0
0.61933, 6711.0
0.62, 6711.0
0.62067, 6711.0
0.62133, 6712.0
0.622, 6713.0
0.62267, 6714.0
0.62333, 6715.0
0.624, 6717.0
0.62467, 6719.0
0.62533, 6722.0
0.626, 6724.0
0.62667, 6726.0
0.62733, 6729.0
0.628, 6731.0
0.62867, 6732.0
0.62933, 6734.0
0.63, 6735.0
0.63067, 6735.0
0.63133, 6735.0
0.632, 6735.0
0.63267, 6735.0
0.63333, 6734.0
0.634, 6734.0
0.63467, 6732.0
0.63533, 6731.0
0.636, 6729.0
0.63667, 6727.0
0.63733, 6725.0
0.638, 6723.0
0.63867, 6721.0
0.63933, 6719.0
0.64, 6717.0
0.64067, 6714.0
0.64133, 6712.0
0.642, 6710.0
0.64267, 6708.0
0.64333, 6706.0
0.644, 6704.0
0.64467, 6702.0
0.64533, 6699.0
0.646, 6697.0
0.64667, 6694.0
0.64733, 6691.0
0.648, 6688.0
0.64867, 6685.0
0.64933, 6682.0
0.65, 6679.0
0.65067, 6676.0
0.65133, 6673.0
0.652, 6670.0
0.65267, 6667.0
0.65333, 6664.0
0.654, 6662.0
0.65467, 6659.0
0.65533, 6656.0
0.656, 6654.0
0.65667, 6651.0
0.65733, 6647.0
0.658, 6644.0
0.65867, 6640.0
0.65933, 6635.0
0.66, 6631.0
0.66067, 6625.0
0.66133, 6620.0
0.662, 6614.0
0.66267, 6608.0
0.66333, 6602.0
0.664, 6597.0
0.66467, 6591.0
0.66533, 6585.0
0.666, 6579.0
0.66667, 6573.0
0.66733, 6568.0
0.668, 6562.0
0.66867, 6557.0
0.66933, 6551.0
0.67, 6546.0
0.67067, 6541.0
0.67133, 6535.0
0.672, 6530.0
0.67267, 6525.0
0.67333, 6521.0
0.674, 6516.0
0.67467, 6511.0
0.67533, 6506.0
0.676, 6500.0
0.67667, 6495.0
0.67733, 6490.0
0.678, 6485.0
0.67867, 6480.0
0.67933, 6475.0
0.68, 6470.0
0.68067, 6465.0
0.68133, 6460.0
0.682, 6456.0
0.68267, 6451.0
0.68333, 6447.0
0.684, 6442.0
0.68467, 6438.0
0.68533, 6434.0
0.686, 6430.0
0.68667, 6427.0
0.68733, 6423.0
0.688, 6419.0
0.68867, 6416.0
0.68933, 6412.0
0.69, 6409.0
0.69067, 6406.0
0.69133, 6402.0
0.692, 6398.0
0.69267, 6395.0
0.69333, 6391.0
0.694, 6386.0
0.69467, 6382.0
0.69533, 6378.0
0.696, 6373.0
0.69667, 6369.0
0.69733, 6365.0
0.698, 6360.0
0.69867, 6356.0
0.69933, 6351.0
0.7, 6346.0
0.70067, 6341.0
0.70133, 6336.0
0.702, 6331.0
0.70267, 6327.0
0.70333, 6322.0
0.704, 6318.0
0.70467, 6314.0
0.70533, 6310.0
0.706, 6306.0
0.70667, 6303.0
0.70733, 6300.0
0.708, 6297.0
0.70867, 6294.0
0.70933, 6291.0
0.71, 6288.0
0.71067, 6286.0
0.71133, 6283.0
0.712, 6281.0
0.71267, 6279.0
0.71333, 6278.0
0.714, 6277.0
0.71467, 6276.0
0.71533, 6275.0
0.716, 6275.0
0.71667, 6275.0
0.71733, 6276.0
0.718, 6276.0
0.71867, 6277.0
0.71933, 6279.0
0.72, 6280.0
0.72067, 6282.0
0.72133, 6284.0
0.722, 6286.0
0.72267, 6288.0
0.72333, 6291.0
0.724, 6293.0
0.72467, 6296.0
0.72533, 6298.0
0.726, 6301.0
0.72667, 6304.0
0.72733, 6306.0
0.728, 6309.0
0.72867, 6312.0
0.72933, 6315.0
0.73, 6318.0
0.73067, 6321.0
0.73133, 6323.0
0.732, 6326.0
0.73267, 6329.0
0.73333, 6331.0
0.734, 6334.0
0.73467, 6337.0
0.73533, 6341.0
0.736, 6344.0
0.73667, 6347.0
0.73733, 6351.0
0.738, 6354.0
0.73867, 6357.0
0.73933, 6360.0
0.74, 6363.0
0.74067, 6366.0
0.74133, 6369.0
0.742, 6372.0
0.74267, 6375.0
0.74333, 6378.0
0.744, 6381.0
0.74467, 6384.0
0.74533, 6387.0
0.746, 6389.0
0.74667, 6392.0
0.74733, 6395.0
0.748, 6398.0
0.74867, 6400.0
0.74933, 6403.0
0.75, 6405.0
0.75067, 6407.0
0.75133, 6410.0
0.752, 6412.0
0.75267, 6414.0
0.75333, 6416.0
0.754, 6418.0
0.75467, 6420.0
0.75533, 6421.0
0.756, 6423.0
0.75667, 6425.0
0.75733, 6427.0
0.758, 6429.0
0.75867, 6431.0
0.75933, 6434.0
0.76, 6436.0
0.76067, 6439.0
0.76133, 6442.0
0.762, 6445.0
0.76267, 6449.0
0.76333, 6452.0
0.764, 6456.0
0.76467, 6460.0
0.76533, 6465.0
0.766, 6469.0
0.76667, 6474.0
0.76733, 6478.0
0.768, 6483.0
0.76867, 6488.0
0.76933, 6492.0
0.77, 6497.0
0.77067, 6501.0
0.77133, 6505.0
0.772, 6509.0
0.77267, 6513.0
0.77333, 6517.0
0.774, 6521.0
0.77467, 6525.0
0.77533, 6529.0
0.776, 6533.0
0.77667, 6537.0
0.77733, 6541.0
0.778, 6545.0
0.77867, 6549.0
0.77933, 6553.0
0.78, 6558.0
0.78067, 6562.0
0.78133, 6567.0
0.782, 6572.0
0.78267, 6577.0
0.78333, 6582.0
0.784, 6587.0
0.78467, 6592.0
0.78533, 6597.0
0.786, 6602.0
0.78667, 6607.0
0.78733, 6611.0
0.788, 6616.0
0.78867, 6620.0
0.78933, 6625.0
0.79, 6629.0
0.79067, 6633.0
0.79133, 6638.0
0.792, 6642.0
0.79267, 6646.0
0.79333, 6651.0
0.794, 6656.0
0.79467, 6661.0
0.79533, 6666.0
0.796, 6672.0
0.79667, 6678.0
0.79733, 6684.0
0.798, 6690.0
0.79867, 6697.0
0.79933, 6703.0
0.8, 6710.0
0.80067, 6716.0
0.80133, 6722.0
0.802, 6728.0
0.80267, 6734.0
0.80333, 6739.0
0.804, 6744.0
0.80467, 6749.0
0.80533, 6754.0
0.806, 6759.0
0.80667, 6764.0
0.80733, 6769.0
0.808, 6774.0
0.80867, 6780.0
0.80933, 6786.0
0.81, 6792.0
0.81067, 6798.0
0.81133, 6804.0
0.812, 6811.0
0.81267, 6818.0
0.81333, 6824.0
0.814, 6831.0
0.81467, 6838.0
0.81533, 6844.0
0.816, 6851.0
0.81667, 6858.0
0.81733, 6864.0
0.818, 6870.0
0.81867, 6877.0
0.81933, 6883.0
0.82, 6890.0
0.82067, 6896.0
0.82133, 6903.0
0.822, 6909.0
0.82267, 6916.0
0.82333, 6923.0
0.824, 6930.0
0.82467, 6936.0
0.82533, 6943.0
0.826, 6949.0
0.82667, 6956.0
0.82733, 6962.0
0.828, 6968.0
0.82867, 6974.0
0.82933, 6979.0
0.83, 6984.0
0.83067, 6989.0
0.83133, 6993.0
0.832, 6997.0
0.83267, 7001.0
0.83333, 7005.0
0.834, 7008.0
0.83467, 7011.0
0.83533, 7014.0
0.836, 7017.0
0.83667, 7019.0
0.83733, 7021.0
0.838, 7023.0
0.83867, 7024.0
0.83933, 7025.0
0.84, 7026.0
0.84067, 7026.0
0.84133, 7026.0
0.842, 7026.0
0.84267, 7025.0
0.84333, 7024.0
0.844, 7023.0
0.84467, 7022.0
0.84533, 7020.0
0.846, 7019.0
0.84667, 7017.0
0.84733, 7015.0
0.848, 7013.0
0.84867, 7011.0
0.84933, 7010.0
0.85, 7008.0
0.85067, 7006.0
0.85133, 7004.0
0.852, 7002.0
0.85267, 6999.0
0.85333, 6996.0
0.854, 6993.0
0.85467, 6990.0
0.85533, 6987.0
0.856, 6983.0
0.85667, 6979.0
0.85733, 6975.0
0.858, 6971.0
0.85867, 6967.0
0.85933, 6963.0
0.86, 6958.0
0.86067, 6954.0
0.86133, 6949.0
0.862, 6945.0
0.86267, 6940.0
0.86333, 6936.0
0.864, 6931.0
0.86467, 6927.0
0.86533, 6922.0
0.866, 6917.0
0.86667, 6913.0
0.86733, 6908.0
0.868, 6904.0
0.86867, 6900.0
0.86933, 6896.0
0.87, 6892.0
0.87067, 6887.0
0.87133, 6883.0
0.872, 6879.0
0.87267, 6875.0
0.87333, 6871.0
0.874, 6867.0
0.87467, 6862.0
0.87533, 6858.0
0.876, 6853.0
0.87667, 6849.0
0.87733, 6845.0
0.878, 6841.0
0.87867, 6837.0
0.87933, 6833.0
0.88, 6830.0
0.88067, 6826.0
0.88133, 6823.0
0.882, 6820.0
0.88267, 6816.0
0.88333, 6813.0
0.884, 6809.0
0.88467, 6805.0
0.88533, 6802.0
0.886, 6798.0
0.88667, 6795.0
0.88733, 6792.0
0.888, 6788.0
0.88867, 6785.0
0.88933, 6782.0
0.89, 6779.0
0.89067, 6777.0
0.89133, 6774.0
0.892, 6772.0
0.89267, 6771.0
0.89333, 6769.0
0.894, 6768.0
0.89467, 6767.0
0.89533, 6766.0
0.896, 6765.0
0.89667, 6765.0
0.89733, 6765.0
0.898, 6765.0
0.89867, 6765.0
0.89933, 6765.0
0.9, 6765.0
0.90067, 6766.0
0.90133, 6767.0
0.902, 6768.0
0.90267, 6769.0
0.90333, 6771.0
0.904, 6773.0
0.90467, 6775.0
0.90533, 6778.0
0.906, 6780.0
0.90667, 6783.0
0.90733, 6786.0
0.908, 6789.0
0.90867, 6792.0
0.90933, 6796.0
0.91, 6799.0
0.91067, 6802.0
0.91133, 6804.0
0.912, 6807.0
0.91267, 6809.0
0.91333, 6811.0
0.914, 6813.0
0.91467, 6815.0
0.91533, 6817.0
0.916, 6819.0
0.91667, 6821.0
0.91733, 6823.0
0.918, 6825.0
0.91867, 6827.0
0.91933, 6829.0
0.92, 6831.0
0.92067, 6833.0
0.92133, 6835.0
0.922, 6836.0
0.92267, 6838.0
0.92333, 6840.0
0.924, 6841.0
0.92467, 6843.0
0.92533, 6846.0
0.926, 6848.0
0.92667, 6851.0
0.92733, 6854.0
0.928, 6858.0
0.92867, 6861.0
0.92933, 6865.0
0.93, 6868.0
0.93067, 6871.0
0.93133, 6874.0
0.932, 6878.0
0.93267, 6880.0
0.93333, 6883.0
0.934, 6886.0
0.93467, 6888.0
0.93533, 6891.0
0.936, 6893.0
0.93667, 6896.0
0.93733, 6899.0
0.938, 6901.0
0.93867, 6904.0
0.93933, 6906.0
0.94, 6909.0
0.94067, 6911.0
0.94133, 6914.0
0.942, 6916.0
0.94267, 6919.0
0.94333, 6921.0
0.944, 6924.0
0.94467, 6927.0
0.94533, 6931.0
0.946, 6934.0
0.94667, 6937.0
0.94733, 6940.0
0.948, 6944.0
0.94867, 6947.0
0.94933, 6950.0
0.95, 6954.0
0.95067, 6957.0
0.95133, 6960.0
0.952, 6964.0
0.95267, 6967.0
0.95333, 6970.0
0.954, 6972.0
0.95467, 6975.0
0.95533, 6977.0
0.956, 6978.0
0.95667, 6980.0
0.95733, 6981.0
0.958, 6982.0
0.95867, 6983.0
0.95933, 6984.0
0.96, 6984.0
0.96067, 6984.0
0.96133, 6984.0
0.962, 6983.0
0.96267, 6982.0
0.96333, 6981.0
0.964, 6980.0
0.96467, 6979.0
0.96533, 6977.0
0.966, 6976.0
0.96667, 6975.0
0.96733, 6973.0
0.968, 6972.0
0.96867, 6971.0
0.96933, 6969.0
0.97, 6968.0
0.97067, 6966.0
0.97133, 6964.0
0.972, 6962.0
0.97267, 6959.0
0.97333, 6957.0
0.974, 6953.0
0.97467, 6950.0
0.97533, 6945.0
0.976, 6941.0
0.97667, 6937.0
0.97733, 6932.0
0.978, 6927.0
0.97867, 6922.0
0.97933, 6916.0
0.98, 6911.0
0.98067, 6905.0
0.98133, 6899.0
0.982, 6894.0
0.98267, 6888.0
0.98333, 6881.0
0.984, 6875.0
0.98467, 6869.0
0.98533, 6862.0
0.986, 6856.0
0.98667, 6849.0
0.98733, 6842.0
0.988, 6835.0
0.98867, 6828.0
0.98933, 6821.0
0.99, 6814.0
0.99067, 6806.0
0.99133, 6798.0
0.992, 6791.0
0.99267, 6784.0
0.99333, 6777.0
0.994, 6770.0
0.99467, 6764.0
0.99533, 6758.0
0.996, 6752.0
0.99667, 6747.0
0.99733, 6742.0
0.998, 6737.0
0.99867, 6733.0
0.99933, 6729.0
1.0, 6726.0
1.00067, 6722.0
1.00133, 6718.0
1.002, 6715.0
1.00267, 6711.0
1.00333, 6708.0
1.004, 6704.0
1.00467, 6701.0
1.00533, 6698.0
1.006, 6695.0
1.00667, 6692.0
1.00733, 6689.0
1.008, 6686.0
1.00867, 6683.0
1.00933, 6678.0
1.01, 6674.0
1.01067, 6668.0
1.01133, 6663.0
1.012, 6657.0
1.01267, 6651.0
1.01333, 6646.0
1.014, 6641.0
1.01467, 6637.0
1.01533, 6634.0
1.016, 6633.0
1.01667, 6632.0
1.01733, 6634.0
1.018, 6636.0
1.01867, 6641.0
1.01933, 6647.0
1.02, 6655.0
1.02067, 6664.0
1.02133, 6675.0
1.022, 6686.0
1.02267, 6697.0
1.02333, 6710.0
1.024, 6722.0
1.02467, 6735.0
1.02533, 6748.0
1.026, 6760.0
1.02667, 6772.0
1.02733, 6784.0
1.028, 6796.0
1.02867, 6807.0
1.02933, 6817.0
1.03, 6827.0
1.03067, 6836.0
1.03133, 6845.0
1.032, 6852.0
1.03267, 6860.0
1.03333, 6866.0
1.034, 6872.0
1.03467, 6877.0
1.03533, 6881.0
1.036, 6885.0
1.03667, 6889.0
1.03733, 6892.0
1.038, 6895.0
1.03867, 6897.0
1.03933, 6898.0
1.04, 6899.0
1.04067, 6899.0
1.04133, 6899.0
1.042, 6899.0
1.04267, 6897.0
1.04333, 6896.0
1.044, 6894.0
1.04467, 6892.0
1.04533, 6891.0
1.046, 6889.0
1.04667, 6887.0
1.04733, 6886.0
1.048, 6884.0
1.04867, 6883.0
1.04933, 6883.0
1.05, 6882.0
1.05067, 6882.0
1.05133, 6882.0
1.052, 6882.0
1.05267, 6882.0
1.05333, 6882.0
1.054, 6882.0
1.05467, 6882.0
1.05533, 6881.0
1.056, 6881.0
1.05667, 6880.0
1.05733, 6880.0
1.058, 6880.0
1.05867, 6881.0
1.05933, 6881.0
1.06, 6882.0
1.06067, 6883.0
1.06133, 6885.0
1.062, 6887.0
1.06267, 6889.0
1.06333, 6893.0
1.064, 6897.0
1.06467, 6903.0
1.06533, 6911.0
1.066, 6921.0
1.06667, 6935.0
1.06733, 6955.0
1.068, 6985.0
1.06867, 7029.0
1.06933, 7095.0
1.07, 7191.0
1.07067, 7333.0
1.07133, 7536.0
1.072, 7825.0
1.07267, 8227.0
1.07333, 8775.0
1.074, 9510.0
1.07467, 10477.0
1.07533, 11724.0
1.076, 13305.0
1.07667, 15272.0
1.07733, 17675.0
1.078, 20562.0
1.07867, 23967.0
1.07933, 27918.0
1.08, 32425.0
1.08067, 37484.0
1.08133, 43070.0
1.082, 49143.0
1.08267, 55643.0
1.08333, 62495.0
1.084, 69612.0
1.08467, 76894.0
1.08533, 84236.0
1.086, 91536.0
1.08667, 98694.0
1.08733, 105626.0
1.088, 112271.0
1.08867, 118600.0
1.08933, 124627.0
1.09, 130426.0
1.09067, 136138.0
1.09133, 141987.0
1.092, 148289.0
1.09267, 155455.0
1.09333, 163993.0
1.094, 174501.0
1.09467, 187663.0
1.09533, 204229.0
1.096, 225015.0
1.09667, 250908.0
1.09733, 282878.0
1.098, 321998.0
1.09867, 369460.0
1.09933, 426563.0
1.1, 494681.0
1.10067, 575198.0
1.10133, 669397.0
1.102, 778310.0
1.10267, 902560.0
1.10333, 1042233.0
1.104, 1196788.0
1.10467, 1365046.0
1.10533, 1545233.0
1.106, 1735089.0
1.10667, 1931995.0
1.10733, 2133103.0
1.108, 2335427.0
1.10867, 2535934.0
1.10933, 2731612.0
1.11, 2919539.0
1.11067, 3096933.0
1.11133, 3261199.0
1.112, 3409971.0
1.11267, 3541169.0
1.11333, 3653050.0
1.114, 3744243.0
1.11467, 3813797.0
1.11533, 3861186.0
1.116, 3886317.0
1.11667, 3889520.0
1.11733, 3871530.0
1.118, 3833463.0
1.11867, 3776760.0
1.11933, 3703123.0
1.12, 3614435.0
1.12067, 3512683.0
1.12133, 3399891.0
1.122, 3278060.0
1.12267, 3149127.0
1.12333, 3014922.0
1.124, 2877149.0
1.12467, 2737364.0
1.12533, 2596961.0
1.126, 2457175.0
1.12667, 2319075.0
1.12733, 2183576.0
1.128, 2051440.0
1.12867, 1923290.0
1.12933, 1799621.0
1.13, 1680810.0
1.13067, 1567132.0
1.13133, 1458770.0
1.132, 1355827.0
1.13267, 1258339.0
1.13333, 1166282.0
1.134, 1079585.0
1.13467, 998137.0
1.13533, 921793.0
1.136, 850385.0
1.13667, 783726.0
1.13733, 721613.0
1.138, 663835.0
1.13867, 610177.0
1.13933, 560419.0
1.14, 514342.0
1.14067, 471732.0
1.14133, 432375.0
1.142, 396068.0
1.14267, 362611.0
1.14333, 331814.0
1.144, 303492.0
1.14467, 277474.0
1.14533, 253592.0
1.146, 231691.0
1.14667, 211624.0
1.14733, 193251.0
1.148, 176443.0
1.14867, 161078.0
1.14933, 147042.0
1.15, 134230.0
1.15067, 122541.0
1.15133, 111886.0
1.152, 102177.0
1.15267, 93337.0
1.15333, 85292.0
1.154, 77975.0
1.15467, 71322.0
1.15533, 65277.0
1.156, 59786.0
1.15667, 54801.0
1.15733, 50277.0
1.158, 46173.0
1.15867, 42451.0
1.15933, 39077.0
1.16, 36018.0
1.16067, 33248.0
1.16133, 30738.0
1.162, 28466.0
1.16267, 26410.0
1.16333, 24549.0
1.164, 22865.0
1.16467, 21342.0
1.16533, 19966.0
1.166, 18722.0
1.16667, 17597.0
1.16733, 16581.0
1.168, 15664.0
1.16867, 14835.0
1.16933, 14087.0
1.17, 13412.0
1.17067, 12802.0
1.17133, 12253.0
1.172, 11757.0
1.17267, 11311.0
1.17333, 10908.0
1.174, 10545.0
1.17467, 10218.0
1.17533, 9923.0
1.176, 9657.0
1.17667, 9418.0
1.17733, 9203.0
1.178, 9009.0
1.17867, 8835.0
1.17933, 8678.0
1.18, 8537.0
1.18067, 8410.0
1.18133, 8296.0
1.182, 8194.0
1.18267, 8102.0
1.18333, 8019.0
1.184, 7944.0
1.18467, 7877.0
1.18533, 7817.0
1.186, 7762.0
1.18667, 7713.0
1.18733, 7668.0
1.188, 7627.0
1.18867, 7591.0
1.18933, 7558.0
1.19, 7528.0
1.19067, 7501.0
1.19133, 7476.0
1.192, 7454.0
1.19267, 7434.0
1.19333, 7416.0
1.194, 7400.0
1.19467, 7386.0
1.19533, 7372.0
1.196, 7360.0
1.19667, 7350.0
1.19733, 7340.0
1.198, 7332.0
1.19867, 7324.0
1.19933, 7318.0
1.2, 7311.0
1.20067, 7306.0
1.20133, 7301.0
1.202, 7297.0
1.20267, 7293.0
1.20333, 7289.0
1.204, 7286.0
1.20467, 7284.0
1.20533, 7282.0
1.206, 7280.0
1.20667, 7279.0
1.20733, 7279.0
1.208, 7279.0
1.20867, 7279.0
1.20933, 7279.0
1.21, 7280.0
1.21067, 7281.0
1.21133, 7282.0
1.212, 7283.0
1.21267, 7285.0
1.21333, 7287.0
1.214, 7288.0
1.21467, 7290.0
1.21533, 7292.0
1.216, 7295.0
1.21667, 7297.0
1.21733, 7299.0
1.218, 7302.0
1.21867, 7305.0
1.21933, 7308.0
1.22, 7311.0
1.22067, 7314.0
1.22133, 7317.0
1.222, 7320.0
1.22267, 7322.0
1.22333, 7325.0
1.224, 7328.0
1.22467, 7331.0
1.22533, 7334.0
1.226, 7337.0
1.22667, 7341.0
1.22733, 7344.0
1.228, 7348.0
1.22867, 7352.0
1.22933, 7356.0
1.23, 7360.0
1.23067, 7364.0
1.23133, 7368.0
1.232, 7372.0
1.23267, 7377.0
1.23333, 7381.0
1.234, 7385.0
1.23467, 7389.0
1.23533, 7392.0
1.236, 7396.0
1.23667, 7399.0
1.23733, 7402.0
1.238, 7405.0
1.23867, 7408.0
1.23933, 7411.0
1.24, 7414.0
1.24067, 7417.0
1.24133, 7420.0
1.242, 7423.0
1.24267, 7426.0
1.24333, 7430.0
1.244, 7433.0
1.24467, 7437.0
1.24533, 7440.0
1.246, 7443.0
1.24667, 7447.0
1.24733, 7450.0
1.248, 7454.0
1.24867, 7457.0
1.24933, 7461.0
1.25, 7465.0
1.25067, 7469.0
1.25133, 7473.0
1.252, 7478.0
1.25267, 7482.0
1.25333, 7487.0
1.254, 7491.0
1.25467, 7496.0
1.25533, 7500.0
1.256, 7505.0
1.25667, 7510.0
1.25733, 7514.0
1.258, 7518.0
1.25867, 7523.0
1.25933, 7527.0
1.26, 7531.0
1.26067, 7535.0
1.26133, 7538.0
1.262, 7542.0
1.26267, 7546.0
1.26333, 7549.0
1.264, 7553.0
1.26467, 7558.0
1.26533, 7562.0
1.266, 7567.0
1.26667, 7572.0
1.26733, 7578.0
1.268, 7583.0
1.26867, 7589.0
1.26933, 7594.0
1.27, 7600.0
1.27067, 7606.0
1.27133, 7611.0
1.272, 7617.0
1.27267, 7623.0
1.27333, 7628.0
1.274, 7633.0
1.27467, 7637.0
1.27533, 7642.0
1.276, 7646.0
1.27667, 7650.0
1.27733, 7653.0
1.278, 7657.0
1.27867, 7660.0
1.27933, 7662.0
1.28, 7665.0
1.28067, 7667.0
1.28133, 7669.0
1.282, 7671.0
1.28267, 7673.0
1.28333, 7674.0
1.284, 7676.0
1.28467, 7678.0
1.28533, 7679.0
1.286, 7681.0
1.28667, 7682.0
1.28733, 7684.0
1.288, 7685.0
1.28867, 7686.0
1.28933, 7687.0
1.29, 7688.0
1.29067, 7689.0
1.29133, 7689.0
1.292, 7689.0
1.29267, 7688.0
1.29333, 7687.0
1.294, 7686.0
1.29467, 7684.0
1.29533, 7681.0
1.296, 7679.0
1.29667, 7675.0
1.29733, 7671.0
1.298, 7667.0
1.29867, 7663.0
1.29933, 7658.0
1.3, 7653.0
1.30067, 7647.0
1.30133, 7642.0
1.302, 7636.0
1.30267, 7630.0
1.30333, 7624.0
1.304, 7617.0
1.30467, 7610.0
1.30533, 7604.0
1.306, 7597.0
1.30667, 7590.0
1.30733, 7583.0
1.308, 7576.0
1.30867, 7569.0
1.30933, 7562.0
1.31, 7555.0
1.31067, 7549.0
1.31133, 7542.0
1.312, 7536.0
1.31267, 7529.0
1.31333, 7523.0
1.314, 7517.0
1.31467, 7511.0
1.31533, 7505.0
1.316, 7500.0
1.31667, 7494.0
1.31733, 7489.0
1.318, 7484.0
1.31867, 7479.0
1.31933, 7475.0
1.32, 7471.0
1.32067, 7467.0
1.32133, 7463.0
1.322, 7460.0
1.32267, 7457.0
1.32333, 7453.0
1.324, 7450.0
1.32467, 7447.0
1.32533, 7444.0
1.326, 7442.0
1.32667, 7439.0
1.32733, 7437.0
1.328, 7434.0
1.32867, 7432.0
1.32933, 7430.0
1.33, 7428.0
1.33067, 7426.0
1.33133, 7424.0
1.332, 7423.0
1.33267, 7421.0
1.33333, 7420.0
1.334, 7419.0
1.33467, 7417.0
1.33533, 7416.0
1.336, 7414.0
1.33667, 7412.0
1.33733, 7411.0
1.338, 7409.0
1.33867, 7407.0
1.33933, 7405.0
1.34, 7404.0
1.34067, 7402.0
1.34133, 7400.0
1.342, 7398.0
1.34267, 7395.0
1.34333, 7393.0
1.344, 7390.0
1.34467, 7387.0
1.34533, 7384.0
1.346, 7381.0
1.34667, 7379.0
1.34733, 7376.0
1.348, 7373.0
1.34867, 7370.0
1.34933, 7367.0
1.35, 7364.0
1.35067, 7361.0
1.35133, 7358.0
1.352, 7355.0
1.35267, 7352.0
1.35333, 7349.0
1.354, 7346.0
1.35467, 7343.0
1.35533, 7340.0
1.356, 7336.0
1.35667, 7333.0
1.35733, 7329.0
1.358, 7325.0
1.35867, 7321.0
1.35933, 7317.0
1.36, 7313.0
1.36067, 7309.0
1.36133, 7305.0
1.362, 7301.0
1.36267, 7298.0
1.36333, 7294.0
1.364, 7291.0
1.36467, 7287.0
1.36533, 7284.0
1.366, 7281.0
1.36667, 7278.0
1.36733, 7275.0
1.368, 7273.0
1.36867, 7270.0
1.36933, 7267.0
1.37, 7264.0
1.37067, 7262.0
1.37133, 7259.0
1.372, 7257.0
1.37267, 7255.0
1.37333, 7252.0
1.374, 7250.0
1.37467, 7248.0
1.37533, 7246.0
1.376, 7245.0
1.37667, 7243.0
1.37733, 7242.0
1.378, 7240.0
1.37867, 7239.0
1.37933, 7238.0
1.38, 7237.0
1.38067, 7236.0
1.38133, 7236.0
1.382, 7236.0
1.38267, 7236.0
1.38333, 7236.0
1.384, 7237.0
1.38467, 7237.0
1.38533, 7238.0
1.386, 7239.0
1.38667, 7241.0
1.38733, 7242.0
1.388, 7243.0
1.38867, 7245.0
1.38933, 7246.0
1.39, 7248.0
1.39067, 7249.0
1.39133, 7251.0
1.392, 7253.0
1.39267, 7255.0
1.39333, 7257.0
1.394, 7259.0
1.39467, 7261.0
1.39533, 7263.0
1.396, 7265.0
1.39667, 7267.0
1.39733, 7269.0
1.398, 7270.0
1.39867, 7272.0
1.39933, 7273.0
1.4, 7274.0
1.40067, 7274.0
1.40133, 7274.0
1.402, 7274.0
1.40267, 7274.0
1.40333, 7274.0
1.404, 7273.0
1.40467, 7272.0
1.40533, 7272.0
1.406, 7271.0
1.40667, 7270.0
1.40733, 7269.0
1.408, 7268.0
1.40867, 7267.0
1.40933, 7266.0
1.41, 7266.0
1.41067, 7266.0
1.41133, 7266.0
1.412, 7266.0
1.41267, 7267.0
1.41333, 7268.0
1.414, 7268.0
1.41467, 7269.0
1.41533, 7270.0
1.416, 7270.0
1.41667, 7271.0
1.41733, 7271.0
1.418, 7272.0
1.41867, 7273.0
1.41933, 7274.0
1.42, 7275.0
1.42067, 7276.0
1.42133, 7278.0
1.422, 7280.0
1.42267, 7282.0
1.42333, 7285.0
1.424, 7288.0
1.42467, 7291.0
1.42533, 7295.0
1.426, 7299.0
1.42667, 7304.0
1.42733, 7308.0
1.428, 7313.0
1.42867, 7318.0
1.42933, 7323.0
1.43, 7328.0
1.43067, 7332.0
1.43133, 7337.0
1.432, 7341.0
1.43267, 7345.0
1.43333, 7349.0
1.434, 7353.0
1.43467, 7356.0
1.43533, 7360.0
1.436, 7362.0
1.43667, 7365.0
1.43733, 7367.0
1.438, 7370.0
1.43867, 7372.0
1.43933, 7374.0
1.44, 7376.0
1.44067, 7378.0
1.44133, 7380.0
1.442, 7382.0
1.44267, 7385.0
1.44333, 7388.0
1.444, 7391.0
1.44467, 7394.0
1.44533, 7397.0
1.446, 7401.0
1.44667, 7405.0
1.44733, 7409.0
1.448, 7413.0
1.44867, 7417.0
1.44933, 7421.0
1.45, 7425.0
1.45067, 7429.0
1.45133, 7432.0
1.452, 7435.0
1.45267, 7438.0
1.45333, 7440.0
1.454, 7442.0
1.45467, 7444.0
1.45533, 7445.0
1.456, 7446.0
1.45667, 7447.0
1.45733, 7448.0
1.458, 7449.0
1.45867, 7449.0
1.45933, 7450.0
1.46, 7451.0
1.46067, 7451.0
1.46133, 7452.0
1.462, 7452.0
1.46267, 7452.0
1.46333, 7452.0
1.464, 7452.0
1.46467, 7451.0
1.46533, 7450.0
1.466, 7449.0
1.46667, 7448.0
1.46733, 7447.0
1.468, 7446.0
1.46867, 7445.0
1.46933, 7444.0
1.47, 7444.0
1.47067, 7444.0
1.47133, 7445.0
1.472, 7446.0
1.47267, 7447.0
1.47333, 7449.0
1.474, 7451.0
1.47467, 7453.0
1.47533, 7456.0
1.476, 7459.0
1.47667, 7461.0
1.47733, 7464.0
1.478, 7466.0
1.47867, 7469.0
1.47933, 7471.0
1.48, 7473.0
1.48067, 7476.0
1.48133, 7479.0
1.482, 7481.0
1.48267, 7484.0
1.48333, 7487.0
1.484, 7490.0
1.48467, 7493.0
1.48533, 7496.0
1.486, 7499.0
1.48667, 7501.0
1.48733, 7503.0
1.488, 7504.0
1.48867, 7505.0
1.48933, 7507.0
1.49, 7508.0
1.49067, 7509.0
1.49133, 7511.0
1.492, 7512.0
1.49267, 7513.0
1.49333, 7515.0
1.494, 7517.0
1.49467, 7519.0
1.49533, 7520.0
1.496, 7522.0
1.49667, 7524.0
1.49733, 7526.0
1.498, 7527.0
1.49867, 7529.0
1.49933, 7530.0
1.5, 7531.0
1.50067, 7532.0
1.50133, 7534.0
1.502, 7534.0
1.50267, 7535.0
1.50333, 7536.0
1.504, 7537.0
1.50467, 7538.0
1.50533, 7538.0
1.506, 7539.0
1.50667, 7539.0
1.50733, 7540.0
1.508, 7540.0
1.50867, 7540.0
1.50933, 7541.0
1.51, 7541.0
1.51067, 7542.0
1.51133, 7542.0
1.512, 7542.0
1.51267, 7543.0
1.51333, 7543.0
1.514, 7543.0
1.51467, 7544.0
1.51533, 7544.0
1.516, 7544.0
1.51667, 7544.0
1.51733, 7545.0
1.518, 7545.0
1.51867, 7545.0
1.51933, 7545.0
1.52, 7545.0
1.52067, 7544.0
1.52133, 7544.0
1.522, 7544.0
1.52267, 7544.0
1.52333, 7544.0
1.524, 7543.0
1.52467, 7544.0
1.52533, 7544.0
1.526, 7544.0
1.52667, 7544.0
1.52733, 7545.0
1.528, 7545.0
1.52867, 7545.0
1.52933, 7546.0
1.53, 7546.0
1.53067, 7546.0
1.53133, 7547.0
1.532, 7547.0
1.53267, 7548.0
1.53333, 7548.0
1.534, 7549.0
1.53467, 7549.0
1.53533, 7550.0
1.536, 7551.0
1.53667, 7551.0
1.53733, 7552.0
1.538, 7552.0
1.53867, 7552.0
1.53933, 7552.0
1.54, 7552.0
1.54067, 7552.0
1.54133, 7552.0
1.542, 7551.0
1.54267, 7551.0
1.54333, 7549.0
1.544, 7548.0
1.54467, 7546.0
1.54533, 7544.0
1.546, 7542.0
1.54667, 7539.0
1.54733, 7537.0
1.548, 7534.0
1.54867, 7532.0
1.54933, 7530.0
1.55, 7527.0
1.55067, 7525.0
1.55133, 7523.0
1.552, 7520.0
1.55267, 7518.0
1.55333, 7515.0
1.554, 7513.0
1.55467, 7511.0
1.55533, 7510.0
1.556, 7530.0
1.55667, 8060.0
1.55733, 14451.0
1.558, 43773.0
1.55867, 116678.0
1.55933, 243304.0
1.56, 422645.0
1.56067, 647985.0
1.56133, 910711.0
1.562, 1202157.0
1.56267, 1514350.0
1.56333, 1840294.0
1.564, 2173997.0
1.56467, 2510401.0
1.56533, 2845315.0
1.566, 3175319.0
1.56667, 3497674.0
1.56733, 3810223.0
1.568, 4111313.0
1.56867, 4399723.0
1.56933, 4674593.0
1.57, 4935357.0
1.57067, 5181698.0
1.57133, 5413499.0
1.572, 5630818.0
1.57267, 5833847.0
1.57333, 6022884.0
1.574, 6198307.0
1.57467, 6360550.0
1.57533, 6510094.0
1.576, 6647452.0
1.57667, 6773154.0
1.57733, 6887748.0
1.578, 6991783.0
1.57867, 7085802.0
1.57933, 7170334.0
1.58, 7245895.0
1.58067, 7312985.0
1.58133, 7372084.0
1.582, 7423656.0
1.58267, 7468139.0
1.58333, 7505947.0
1.584, 7537467.0
1.58467, 7563066.0
1.58533, 7583093.0
1.586, 7597873.0
1.58667, 7607712.0
1.58733, 7612899.0
1.588, 7613705.0
1.58867, 7610370.0
1.58933, 7603103.0
1.59, 7592087.0
1.59067, 7577495.0
1.59133, 7559488.0
1.592, 7538209.0
1.59267, 7513796.0
1.59333, 7486381.0
1.594, 7456084.0
1.59467, 7423007.0
1.59533, 7387245.0
1.596, 7348885.0
1.59667, 7308017.0
1.59733, 7264718.0
1.598, 7219056.0
1.59867, 7171094.0
1.59933, 7120893.0
1.6, 7068516.0
1.60067, 7014016.0
1.60133, 6957445.0
1.602, 6898850.0
1.60267, 6838263.0
1.60333, 6775710.0
1.604, 6711216.0
1.60467, 6644808.0
1.60533, 6576497.0
1.606, 6506285.0
1.60667, 6434174.0
1.60733, 6360172.0
1.608, 6284287.0
1.60867, 6206524.0
1.60933, 6126893.0
1.61, 6045407.0
1.61067, 5962077.0
1.61133, 5876908.0
1.612, 5789911.0
1.61267, 5701096.0
1.61333, 5610472.0
1.614, 5518047.0
1.61467, 5423843.0
1.61533, 5327887.0
1.616, 5230206.0
1.61667, 5130831.0
1.61733, 5029790.0
1.618, 4927109.0
1.61867, 4822816.0
1.61933, 4716949.0
1.62, 4609558.0
1.62067, 4500692.0
1.62133, 4390408.0
1.622, 4278764.0
1.62267, 4165825.0
1.62333, 4051662.0
1.624, 3936359.0
1.62467, 3820017.0
1.62533, 3702755.0
1.626, 3584705.0
1.62667, 3466020.0
1.62733, 3346867.0
1.628, 3227432.0
1.62867, 3107920.0
1.62933, 2988548.0
1.63, 2869548.0
1.63067, 2751159.0
1.63133, 2633632.0
1.632, 2517217.0
1.63267, 2402172.0
1.63333, 2288751.0
1.634, 2177208.0
1.63467, 2067790.0
1.63533, 1960733.0
1.636, 1856261.0
1.63667, 1754581.0
1.63733, 1655883.0
1.638, 1560333.0
1.63867, 1468078.0
1.63933, 1379239.0
1.64, 1293911.0
1.64067, 1212165.0
1.64133, 1134047.0
1.642, 1059577.0
1.64267, 988752.0
1.64333, 921547.0
1.644, 857916.0
1.64467, 797797.0
1.64533, 741111.0
1.646, 687764.0
1.64667, 637653.0
1.64733, 590663.0
1.648, 546675.0
1.64867, 505561.0
1.64933, 467193.0
1.65, 431439.0
1.65067, 398166.0
1.65133, 367243.0
1.652, 338539.0
1.65267, 311927.0
1.65333, 287281.0
1.654, 264482.0
1.65467, 243411.0
1.65533, 223957.0
1.656, 206013.0
1.65667, 189476.0
1.65733, 174247.0
1.658, 160236.0
1.65867, 147355.0
1.65933, 135520.0
1.66, 124655.0
1.66067, 114686.0
1.66133, 105546.0
1.662, 97170.0
1.66267, 89500.0
1.66333, 82478.0
1.664, 76055.0
1.66467, 70181.0
1.66533, 64812.0
1.666, 59907.0
1.66667, 55427.0
1.66733, 51338.0
1.668, 47606.0
1.66867, 44201.0
1.66933, 41095.0
1.67, 38264.0
1.67067, 35683.0
1.67133, 33330.0
1.672, 31187.0
1.67267, 29234.0
1.67333, 27455.0
1.674, 25834.0
1.67467, 24357.0
1.67533, 23012.0
1.676, 21786.0
1.67667, 20670.0
1.67733, 19653.0
1.678, 18726.0
1.67867, 17882.0
1.67933, 17112.0
1.68, 16410.0
1.68067, 15771.0
1.68133, 15187.0
1.682, 14655.0
1.68267, 14170.0
1.68333, 13726.0
1.684, 13322.0
1.68467, 12951.0
1.68533, 12613.0
1.686, 12303.0
1.68667, 12020.0
1.68733, 11761.0
1.688, 11523.0
1.68867, 11306.0
1.68933, 11106.0
1.69, 10922.0
1.69067, 10754.0
1.69133, 10599.0
1.692, 10456.0
1.69267, 10324.0
1.69333, 10203.0
1.694, 10090.0
1.69467, 9987.0
1.69533, 9890.0
1.696, 9801.0
1.69667, 9719.0
1.69733, 9642.0
1.698, 9570.0
1.69867, 9503.0
1.69933, 9441.0
1.7, 9382.0
1.70067, 9327.0
1.70133, 9276.0
1.702, 9227.0
1.70267, 9182.0
1.70333, 9139.0
1.704, 9098.0
1.70467, 9060.0
1.70533, 9024.0
1.706, 8989.0
1.70667, 8957.0
1.70733, 8926.0
1.708, 8897.0
1.70867, 8869.0
1.70933, 8843.0
1.71, 8818.0
1.71067, 8794.0
1.71133, 8771.0
1.712, 8750.0
1.71267, 8729.0
1.71333, 8710.0
1.714, 8692.0
1.71467, 8675.0
1.71533, 8659.0
1.716, 8643.0
1.71667, 8629.0
1.71733, 8615.0
1.718, 8602.0
1.71867, 8589.0
1.71933, 8577.0
1.72, 8565.0
1.72067, 8554.0
1.72133, 8543.0
1.722, 8533.0
1.72267, 8524.0
1.72333, 8514.0
1.724, 8506.0
1.72467, 8497.0
1.72533, 8489.0
1.726, 8481.0
1.72667, 8474.0
1.72733, 8467.0
1.728, 8460.0
1.72867, 8453.0
1.72933, 8446.0
1.73, 8440.0
1.73067, 8434.0
1.73133, 8428.0
1.732, 8422.0
1.73267, 8416.0
1.73333, 8410.0
1.734, 8405.0
1.73467, 8399.0
1.73533, 8393.0
1.736, 8388.0
1.73667, 8382.0
1.73733, 8376.0
1.738, 8371.0
1.73867, 8365.0
1.73933, 8359.0
1.74, 8353.0
1.74067, 8347.0
1.74133, 8341.0
1.742, 8335.0
1.74267, 8329.0
1.74333, 8323.0
1.744, 8318.0
1.74467, 8312.0
1.74533, 8306.0
1.746, 8300.0
1.74667, 8294.0
1.74733, 8288.0
1.748, 8282.0
1.74867, 8276.0
1.74933, 8271.0
1.75, 8266.0
1.75067, 8261.0
1.75133, 8256.0
1.752, 8251.0
1.75267, 8246.0
1.75333, 8241.0
1.754, 8237.0
1.75467, 8233.0
1.75533, 8230.0
1.756, 8227.0
1.75667, 8225.0
1.75733, 8223.0
1.758, 8221.0
1.75867, 8219.0
1.75933, 8218.0
1.76, 8218.0
1.76067, 8217.0
1.76133, 8217.0
1.762, 8217.0
1.76267, 8217.0
1.76333, 8218.0
1.764, 8219.0
1.76467, 8220.0
1.76533, 8222.0
1.766, 8224.0
1.76667, 8226.0
1.76733, 8228.0
1.768, 8230.0
1.76867, 8232.0
1.76933, 8234.0
1.77, 8235.0
1.77067, 8237.0
1.77133, 8238.0
1.772, 8239.0
1.77267, 8240.0
1.77333, 8241.0
1.774, 8242.0
1.77467, 8242.0
1.77533, 8242.0
1.776, 8242.0
1.77667, 8242.0
1.77733, 8242.0
1.778, 8242.0
1.77867, 8242.0
1.77933, 8242.0
1.78, 8242.0
1.78067, 8242.0
1.78133, 8242.0
1.782, 8241.0
1.78267, 8241.0
1.78333, 8240.0
1.784, 8239.0
1.78467, 8237.0
1.78533, 8235.0
1.786, 8233.0
1.78667, 8231.0
1.78733, 8228.0
1.788, 8225.0
1.78867, 8221.0
1.78933, 8217.0
1.79, 8213.0
1.79067, 8208.0
1.79133, 8203.0
1.792, 8198.0
1.79267, 8192.0
1.79333, 8187.0
1.794, 8181.0
1.79467, 8175.0
1.79533, 8169.0
1.796, 8163.0
1.79667, 8157.0
1.79733, 8151.0
1.798, 8145.0
1.79867, 8139.0
1.79933, 8134.0
1.8, 8128.0
1.80067, 8122.0
1.80133, 8116.0
1.802, 8111.0
1.80267, 8105.0
1.80333, 8100.0
1.804, 8095.0
1.80467, 8090.0
1.80533, 8086.0
1.806, 8081.0
1.80667, 8077.0
1.80733, 8072.0
1.808, 8068.0
1.80867, 8064.0
1.80933, 8060.0
1.81, 8055.0
1.81067, 8051.0
1.81133, 8047.0
1.812, 8043.0
1.81267, 8039.0
1.81333, 8036.0
1.814, 8032.0
1.81467, 8029.0
1.81533, 8026.0
1.816, 8023.0
1.81667, 8020.0
1.81733, 8017.0
1.818, 8014.0
1.81867, 8012.0
1.81933, 8009.0
1.82, 8007.0
1.82067, 8004.0
1.82133, 8003.0
1.822, 8001.0
1.82267, 8000.0
1.82333, 7998.0
1.824, 7998.0
1.82467, 7997.0
1.82533, 7996.0
1.826, 7996.0
1.82667, 7996.0
1.82733, 7997.0
1.828, 7997.0
1.82867, 7998.0
1.82933, 7999.0
1.83, 8000.0
1.83067, 8001.0
1.83133, 8002.0
1.832, 8003.0
1.83267, 8004.0
1.83333, 8005.0
1.834, 8006.0
1.83467, 8007.0
1.83533, 8008.0
1.836, 8010.0
1.83667, 8011.0
1.83733, 8013.0
1.838, 8014.0
1.83867, 8016.0
1.83933, 8017.0
1.84, 8019.0
1.84067, 8020.0
1.84133, 8022.0
1.842, 8023.0
1.84267, 8024.0
1.84333, 8025.0
1.844, 8026.0
1.84467, 8026.0
1.84533, 8027.0
1.846, 8027.0
1.84667, 8027.0
1.84733, 8027.0
1.848, 8027.0
1.84867, 8027.0
1.84933, 8027.0
1.85, 8027.0
1.85067, 8026.0
1.85133, 8026.0
1.852, 8026.0
1.85267, 8025.0
1.85333, 8025.0
1.854, 8025.0
1.85467, 8025.0
1.85533, 8025.0
1.856, 8024.0
1.85667, 8024.0
1.85733, 8023.0
1.858, 8022.0
1.85867, 8021.0
1.85933, 8021.0
1.86, 8020.0
1.86067, 8019.0
1.86133, 8018.0
1.862, 8017.0
1.86267, 8016.0
1.86333, 8014.0
1.864, 8012.0
1.86467, 8010.0
1.86533, 8008.0
1.866, 8005.0
1.86667, 8001.0
1.86733, 7998.0
1.868, 7994.0
1.86867, 7989.0
1.86933, 7984.0
1.87, 7979.0
1.87067, 7974.0
1.87133, 7969.0
1.872, 7963.0
1.87267, 7957.0
1.87333, 7951.0
1.874, 7945.0
1.87467, 7938.0
1.87533, 7932.0
1.876, 7926.0
1.87667, 7919.0
1.87733, 7912.0
1.878, 7904.0
1.87867, 7896.0
1.87933, 7888.0
1.88, 7880.0
1.88067, 7872.0
1.88133, 7863.0
1.882, 7854.0
1.88267, 7845.0
1.88333, 7836.0
1.884, 7827.0
1.88467, 7819.0
1.88533, 7810.0
1.886, 7801.0
1.88667, 7792.0
1.88733, 7783.0
1.888, 7774.0
1.88867, 7765.0
1.88933, 7756.0
1.89, 7747.0
1.89067, 7737.0
1.89133, 7728.0
1.892, 7718.0
1.89267, 7708.0
1.89333, 7698.0
1.894, 7688.0
1.89467, 7678.0
1.89533, 7668.0
1.896, 7658.0
1.89667, 7648.0
1.89733, 7638.0
1.898, 7628.0
1.89867, 7618.0
1.89933, 7608.0
1.9, 7599.0
1.90067, 7590.0
1.90133, 7581.0
1.902, 7572.0
1.90267, 7558.0
1.90333, 7520.0
1.904, 7442.0
1.90467, 7317.0
1.90533, 7142.0
1.906, 6919.0
1.90667, 6654.0
1.90733, 6353.0
1.908, 6021.0
1.90867, 5665.0
1.90933, 5293.0
1.91, 4910.0
1.91067, 4524.0
1.91133, 4144.0
1.912, 3777.0
1.91267, 3426.0
1.91333, 3096.0
1.914, 2788.0
1.91467, 2502.0
1.91533, 2238.0
1.916, 1995.0
1.91667, 1772.0
1.91733, 1568.0
1.918, 1382.0
1.91867, 1213.0
1.91933, 1058.0
1.92, 918.0
1.92067, 791.0
1.92133, 676.0
1.922, 574.0
1.92267, 482.0
1.92333, 402.0
1.924, 332.0
1.92467, 271.0
1.92533, 219.0
1.926, 176.0
1.92667, 141.0
1.92733, 113.0
1.928, 91.0
1.92867, 76.0
1.92933, 65.0
1.93, 59.0
1.93067, 56.0
1.93133, 56.0
1.932, 58.0
1.93267, 62.0
1.93333, 67.0
1.934, 72.0
1.93467, 78.0
1.93533, 83.0
1.936, 88.0
1.93667, 93.0
1.93733, 96.0
1.938, 99.0
1.93867, 102.0
1.93933, 103.0
1.94, 104.0
1.94067, 105.0
1.94133, 105.0
1.942, 105.0
1.94267, 104.0
1.94333, 103.0
1.944, 102.0
1.94467, 102.0
1.94533, 101.0
1.946, 100.0
1.94667, 100.0
1.94733, 99.0
1.948, 99.0
1.94867, 98.0
1.94933, 98.0
1.95, 97.0
1.95067, 96.0
1.95133, 95.0
1.952, 94.0
1.95267, 93.0
1.95333, 91.0
1.954, 89.0
1.95467, 87.0
1.95533, 84.0
1.956, 82.0
1.95667, 79.0
1.95733, 76.0
1.958, 74.0
1.95867, 71.0
1.95933, 68.0
1.96, 65.0
1.96067, 63.0
1.96133, 61.0
1.962, 58.0
1.96267, 56.0
1.96333, 55.0
1.964, 53.0
1.96467, 51.0
1.96533, 50.0
1.966, 48.0
1.96667, 47.0
1.96733, 45.0
1.968, 44.0
1.96867, 43.0
1.96933, 42.0
1.97, 40.0
1.97067, 39.0
1.97133, 37.0
1.972, 35.0
1.97267, 33.0
1.97333, 31.0
1.974, 29.0
1.97467, 27.0
1.97533, 25.0
1.976, 23.0
1.97667, 21.0
1.97733, 19.0
1.978, 17.0
1.97867, 15.0
1.97933, 13.0
1.98, 11.0
1.98067, 9.0
1.98133, 7.0
1.982, 5.0
1.98267, 3.0
1.98333, 1.0
1.984, -1.0
1.98467, -3.0
1.98533, -5.0
1.986, -7.0
1.98667, -9.0
1.98733, -11.0
1.988, -13.0
1.98867, -15.0
1.98933, -17.0
1.99, -19.0
1.99067, -21.0
1.99133, -22.0
1.992, -24.0
1.99267, -25.0
1.99333, -26.0
1.994, -27.0
1.99467, -27.0
1.99533, -28.0
1.996, -28.0
1.99667, -28.0
1.99733, -28.0
1.998, -28.0
1.99867, -28.0
1.99933, -27.0
2.0, -27.0
2.00067, -26.0
2.00133, -25.0
2.002, -23.0
2.00267, -22.0
2.00333, -21.0
2.004, -19.0
2.00467, -18.0
2.00533, -16.0
2.006, -14.0
2.00667, -12.0
2.00733, -10.0
2.008, -8.0
2.00867, -6.0
2.00933, -4.0
2.01, -2.0
2.01067, -0.0
2.01133, 2.0
2.012, 4.0
2.01267, 6.0
2.01333, 8.0
2.014, 11.0
2.01467, 13.0
2.01533, 16.0
2.016, 18.0
2.01667, 21.0
2.01733, 24.0
2.018, 27.0
2.01867, 30.0
2.01933, 33.0
2.02, 37.0
2.02067, 40.0
2.02133, 44.0
2.022, 47.0
2.02267, 51.0
2.02333, 55.0
2.024, 59.0
2.02467, 63.0
2.02533, 68.0
2.026, 72.0
2.02667, 77.0
2.02733, 82.0
2.028, 86.0
2.02867, 91.0
2.02933, 96.0
2.03, 101.0
2.03067, 107.0
2.03133, 112.0
2.032, 118.0
2.03267, 123.0
2.03333, 129.0
2.034, 135.0
2.03467, 140.0
2.03533, 146.0
2.036, 151.0
2.03667, 156.0
2.03733, 162.0
2.038, 167.0
2.03867, 172.0
2.03933, 177.0
2.04, 182.0
2.04067, 186.0
2.04133, 191.0
2.042, 195.0
2.04267, 199.0
2.04333, 203.0
2.044, 207.0
2.04467, 210.0
2.04533, 214.0
2.046, 217.0
2.04667, 221.0
2.04733, 224.0
2.048, 227.0
2.04867, 231.0
2.04933, 234.0
2.05, 237.0
2.05067, 240.0
2.05133, 243.0
2.052, 246.0
2.05267, 249.0
2.05333, 251.0
2.054, 254.0
2.05467, 256.0
2.05533, 259.0
2.056, 261.0
2.05667, 263.0
2.05733, 266.0
2.058, 268.0
2.05867, 270.0
2.05933, 272.0
2.06, 274.0
2.06067, 277.0
2.06133, 279.0
2.062, 282.0
2.06267, 284.0
2.06333, 287.0
2.064, 289.0
2.06467, 292.0
2.06533, 294.0
2.066, 297.0
2.06667, 300.0
2.06733, 302.0
2.068, 304.0
2.06867, 307.0
2.06933, 309.0
2.07, 311.0
2.07067, 313.0
2.07133, 316.0
2.072, 318.0
2.07267, 320.0
2.07333, 322.0
2.074, 324.0
2.07467, 326.0
2.07533, 328.0
2.076, 330.0
2.07667, 332.0
2.07733, 334.0
2.078, 336.0
2.07867, 338.0
2.07933, 340.0
2.08, 342.0
2.08067, 345.0
2.08133, 347.0
2.082, 349.0
2.08267, 351.0
2.08333, 354.0
2.084, 356.0
2.08467, 358.0
2.08533, 361.0
2.086, 363.0
2.08667, 366.0
2.08733, 369.0
2.088, 372.0
2.08867, 376.0
2.08933, 379.0
2.09, 382.0
2.09067, 386.0
2.09133, 389.0
2.092, 393.0
2.09267, 397.0
2.09333, 400.0
2.094, 404.0
2.09467, 408.0
2.09533, 411.0
2.096, 415.0
2.09667, 418.0
2.09733, 421.0
2.098, 425.0
2.09867, 428.0
2.09933, 431.0
2.1, 434.0
2.10067, 436.0
2.10133, 439.0
2.102, 441.0
2.10267, 443.0
2.10333, 445.0
2.104, 446.0
2.10467, 448.0
2.10533, 450.0
2.106, 452.0
2.10667, 454.0
2.10733, 457.0
2.108, 459.0
2.10867, 461.0
2.10933, 464.0
2.11, 466.0
2.11067, 469.0
2.11133, 471.0
2.112, 474.0
2.11267, 477.0
2.11333, 479.0
2.114, 482.0
2.11467, 485.0
2.11533, 487.0
2.116, 490.0
2.11667, 493.0
2.11733, 496.0
2.118, 499.0
2.11867, 501.0
2.11933, 504.0
2.12, 506.0
2.12067, 508.0
2.12133, 511.0
2.122, 513.0
2.12267, 515.0
2.12333, 518.0
2.124, 520.0
2.12467, 522.0
2.12533, 524.0
2.126, 526.0
2.12667, 528.0
2.12733, 530.0
2.128, 532.0
2.12867, 533.0
2.12933, 535.0
2.13, 537.0
2.13067, 538.0
2.13133, 540.0
2.132, 542.0
2.13267, 544.0
2.13333, 547.0
2.134, 549.0
2.13467, 551.0
2.13533, 553.0
2.136, 556.0
2.13667, 558.0
2.13733, 561.0
2.138, 563.0
2.13867, 565.0
2.13933, 567.0
2.14, 569.0
2.14067, 571.0
2.14133, 573.0
2.142, 574.0
2.14267, 575.0
2.14333, 576.0
2.144, 577.0
2.14467, 578.0
2.14533, 578.0
2.146, 578.0
2.14667, 578.0
2.14733, 578.0
2.148, 578.0
2.14867, 578.0
2.14933, 578.0
2.15, 578.0
2.15067, 578.0
2.15133, 577.0
2.152, 577.0
2.15267, 577.0
2.15333, 577.0
2.154, 577.0
2.15467, 577.0
2.15533, 578.0
2.156, 578.0
2.15667, 578.0
2.15733, 579.0
2.158, 579.0
2.15867, 580.0
2.15933, 581.0
2.16, 583.0
2.16067, 584.0
2.16133, 585.0
2.162, 587.0
2.16267, 589.0
2.16333, 590.0
2.164, 592.0
2.16467, 594.0
2.16533, 596.0
2.166, 598.0
2.16667, 599.0
2.16733, 601.0
2.168, 603.0
2.16867, 605.0
2.16933, 607.0
2.17, 610.0
2.17067, 612.0
2.17133, 615.0
2.172, 618.0
2.17267, 621.0
2.17333, 624.0
2.174, 627.0
2.17467, 631.0
2.17533, 635.0
2.176, 639.0
2.17667, 643.0
2.17733, 647.0
2.178, 652.0
2.17867, 657.0
2.17933, 663.0
2.18, 668.0
2.18067, 674.0
2.18133, 680.0
2.182, 686.0
2.18267, 692.0
2.18333, 698.0
2.184, 704.0
2.18467, 711.0
2.18533, 717.0
2.186, 724.0
2.18667, 730.0
2.18733, 737.0
2.188, 744.0
2.18867, 750.0
2.18933, 757.0
2.19, 763.0
2.19067, 769.0
2.19133, 775.0
2.192, 781.0
2.19267, 787.0
2.19333, 792.0
2.194, 798.0
2.19467, 803.0
2.19533, 809.0
2.196, 815.0
2.19667, 821.0
2.19733, 827.0
2.198, 833.0
2.19867, 838.0
2.19933, 844.0
2.2, 850.0
2.20067, 856.0
2.20133, 861.0
2.202, 867.0
2.20267, 873.0
2.20333, 878.0
2.204, 884.0
2.20467, 890.0
2.20533, 895.0
2.206, 901.0
2.20667, 907.0
2.20733, 914.0
2.208, 920.0
2.20867, 926.0
2.20933, 933.0
2.21, 940.0
2.21067, 947.0
2.21133, 954.0
2.212, 961.0
2.21267, 969.0
2.21333, 976.0
2.214, 984.0
2.21467, 992.0
2.21533, 1000.0
2.216, 1008.0
2.21667, 1016.0
2.21733, 1023.0
2.218, 1031.0
2.21867, 1039.0
2.21933, 1047.0
2.22, 1056.0
2.22067, 1064.0
2.22133, 1072.0
2.222, 1081.0
2.22267, 1089.0
2.22333, 1099.0
2.224, 1108.0
2.22467, 1117.0
2.22533, 1127.0
2.226, 1137.0
2.22667, 1147.0
2.22733, 1156.0
2.228, 1166.0
2.22867, 1176.0
2.22933, 1185.0
2.23, 1195.0
2.23067, 1204.0
2.23133, 1214.0
2.232, 1223.0
2.23267, 1232.0
2.23333, 1242.0
2.234, 1251.0
2.23467, 1260.0
2.23533, 1270.0
2.236, 1279.0
2.23667, 1288.0
2.23733, 1297.0
2.238, 1307.0
2.23867, 1316.0
2.23933, 1325.0
2.24, 1334.0
2.24067, 1342.0
2.24133, 1351.0
2.242, 1359.0
2.24267, 1367.0
2.24333, 1375.0
2.244, 1383.0
2.24467, 1390.0
2.24533, 1397.0
2.246, 1404.0
2.24667, 1411.0
2.24733, 1418.0
2.248, 1425.0
2.24867, 1431.0
2.24933, 1437.0
2.25, 1443.0
2.25067, 1449.0
2.25133, 1455.0
2.252, 1461.0
2.25267, 1466.0
2.25333, 1471.0
2.254, 1476.0
2.25467, 1481.0
2.25533, 1485.0
2.256, 1490.0
2.25667, 1494.0
2.25733, 1498.0
2.258, 1502.0
2.25867, 1505.0
2.25933, 1508.0
2.26, 1511.0
2.26067, 1513.0
2.26133, 1516.0
2.262, 1518.0
2.26267, 1520.0
2.26333, 1522.0
2.264, 1523.0
2.26467, 1525.0
2.26533, 1526.0
2.266, 1527.0
2.26667, 1529.0
2.26733, 1530.0
2.268, 1531.0
2.26867, 1532.0
2.26933, 1533.0
2.27, 1534.0
2.27067, 1534.0
2.27133, 1535.0
2.272, 1535.0
2.27267, 1535.0
2.27333, 1536.0
2.274, 1536.0
2.27467, 1536.0
2.27533, 1536.0
2.276, 1536.0
2.27667, 1535.0
2.27733, 1535.0
2.278, 1534.0
2.27867, 1534.0
2.27933, 1534.0
2.28, 1534.0
2.28067, 1534.0
2.28133, 1534.0
2.282, 1534.0
2.28267, 1534.0
2.28333, 1535.0
2.284, 1536.0
2.28467, 1537.0
2.28533, 1539.0
2.286, 1540.0
2.28667, 1543.0
2.28733, 1545.0
2.288, 1547.0
2.28867, 1550.0
2.28933, 1553.0
2.29, 1556.0
2.29067, 1559.0
2.29133, 1563.0
2.292, 1566.0
2.29267, 1570.0
2.29333, 1573.0
2.294, 1577.0
2.29467, 1581.0
2.29533, 1584.0
2.296, 1588.0
2.29667, 1592.0
2.29733, 1596.0
2.298, 1600.0
2.29867, 1605.0
2.29933, 1609.0
2.3, 1613.0
2.30067, 1618.0
2.30133, 1623.0
2.302, 1628.0
2.30267, 1633.0
2.30333, 1639.0
2.304, 1644.0
2.30467, 1649.0
2.30533, 1655.0
2.306, 1660.0
2.30667, 1666.0
2.30733, 1671.0
2.308, 1677.0
2.30867, 1682.0
2.30933, 1688.0
2.31, 1693.0
2.31067, 1698.0
2.31133, 1703.0
2.312, 1708.0
2.31267, 1713.0
2.31333, 1718.0
2.314, 1722.0
2.31467, 1727.0
2.31533, 1731.0
2.316, 1735.0
2.31667, 1740.0
2.31733, 1744.0
2.318, 1748.0
2.31867, 1753.0
2.31933, 1757.0
2.32, 1761.0
2.32067, 1765.0
2.32133, 1769.0
2.322, 1773.0
2.32267, 1776.0
2.32333, 1779.0
2.324, 1782.0
2.32467, 1784.0
2.32533, 1786.0
2.326, 1788.0
2.32667, 1789.0
2.32733, 1790.0
2.328, 1791.0
2.32867, 1792.0
2.32933, 1793.0
2.33, 1794.0
2.33067, 1794.0
2.33133, 1795.0
2.332, 1796.0
2.33267, 1797.0
2.33333, 1798.0
2.334, 1799.0
2.33467, 1800.0
2.33533, 1802.0
2.336, 1803.0
2.33667, 1805.0
2.33733, 1807.0
2.338, 1809.0
2.33867, 1811.0
2.33933, 1814.0
2.34, 1816.0
2.34067, 1819.0
2.34133, 1821.0
2.342, 1824.0
2.34267, 1827.0
2.34333, 1830.0
2.344, 1833.0
2.34467, 1836.0
2.34533, 1840.0
2.346, 1843.0
2.34667, 1846.0
2.34733, 1849.0
2.348, 1852.0
2.34867, 1854.0
2.34933, 1857.0
2.35, 1860.0
2.35067, 1863.0
2.35133, 1866.0
2.352, 1869.0
2.35267, 1872.0
2.35333, 1874.0
2.354, 1877.0
2.35467, 1880.0
2.35533, 1883.0
2.356, 1886.0
2.35667, 1889.0
2.35733, 1892.0
2.358, 1895.0
2.35867, 1898.0
2.35933, 1901.0
2.36, 1903.0
2.36067, 1906.0
2.36133, 1910.0
2.362, 1913.0
2.36267, 1916.0
2.36333, 1920.0
2.364, 1923.0
2.36467, 1927.0
2.36533, 1931.0
2.366, 1934.0
2.36667, 1938.0
2.36733, 1942.0
2.368, 1946.0
2.36867, 1949.0
2.36933, 1953.0
2.37, 1956.0
2.37067, 1959.0
2.37133, 1962.0
2.372, 1965.0
2.37267, 1967.0
2.37333, 1970.0
2.374, 1972.0
2.37467, 1975.0
2.37533, 1977.0
2.376, 1979.0
2.37667, 1980.0
2.37733, 1982.0
2.378, 1983.0
2.37867, 1984.0
2.37933, 1985.0
2.38, 1986.0
2.38067, 1987.0
2.38133, 1987.0
2.382, 1988.0
2.38267, 1988.0
2.38333, 1989.0
2.384, 1989.0
2.38467, 1990.0
2.38533, 1990.0
2.386, 1990.0
2.38667, 1990.0
2.38733, 1990.0
2.388, 1990.0
2.38867, 1990.0
2.38933, 1989.0
2.39, 1989.0
2.39067, 1989.0
2.39133, 1989.0
2.392, 1989.0
2.39267, 1990.0
2.39333, 1990.0
2.394, 1991.0
2.39467, 1992.0
2.39533, 1994.0
2.396, 1995.0
2.39667, 1997.0
2.39733, 1999.0
2.398, 2001.0
2.39867, 2003.0
2.39933, 2005.0
2.4, 2007.0
2.40067, 2009.0
2.40133, 2012.0
2.402, 2014.0
2.40267, 2017.0
2.40333, 2020.0
2.404, 2023.0
2.40467, 2026.0
2.40533, 2029.0
2.406, 2031.0
2.40667, 2034.0
2.40733, 2037.0
2.408, 2039.0
2.40867, 2041.0
2.40933, 2043.0
2.41, 2045.0
2.41067, 2047.0
2.41133, 2048.0
2.412, 2050.0
2.41267, 2051.0
2.41333, 2052.0
2.414, 2053.0
2.41467, 2054.0
2.41533, 2055.0
2.416, 2055.0
2.41667, 2055.0
2.41733, 2055.0
2.418, 2056.0
2.41867, 2056.0
2.41933, 2056.0
2.42, 2056.0
2.42067, 2055.0
2.42133, 2055.0
2.422, 2055.0
2.42267, 2054.0
2.42333, 2054.0
2.424, 2053.0
2.42467, 2052.0
2.42533, 2052.0
2.426, 2051.0
2.42667, 2050.0
2.42733, 2050.0
2.428, 2049.0
2.42867, 2049.0
2.42933, 2048.0
2.43, 2048.0
2.43067, 2047.0
2.43133, 2047.0
2.432, 2047.0
2.43267, 2047.0
2.43333, 2047.0
2.434, 2047.0
2.43467, 2046.0
2.43533, 2046.0
2.436, 2045.0
2.43667, 2045.0
2.43733, 2044.0
2.438, 2044.0
2.43867, 2043.0
2.43933, 2042.0
2.44, 2041.0
2.44067, 2041.0
2.44133, 2040.0
2.442, 2039.0
2.44267, 2038.0
2.44333, 2036.0
2.444, 2035.0
2.44467, 2034.0
2.44533, 2033.0
2.446, 2032.0
2.44667, 2031.0
2.44733, 2030.0
2.448, 2029.0
2.44867, 2028.0
2.44933, 2027.0
2.45, 2026.0
2.45067, 2025.0
2.45133, 2025.0
2.452, 2024.0
2.45267, 2024.0
2.45333, 2023.0
2.454, 2023.0
2.45467, 2023.0
2.45533, 2022.0
2.456, 2022.0
2.45667, 2021.0
2.45733, 2021.0
2.458, 2020.0
2.45867, 2019.0
2.45933, 2019.0
2.46, 2018.0
2.46067, 2018.0
2.46133, 2017.0
2.462, 2017.0
2.46267, 2016.0
2.46333, 2015.0
2.464, 2015.0
2.46467, 2014.0
2.46533, 2014.0
2.466, 2014.0
2.46667, 2013.0
2.46733, 2013.0
2.468, 2013.0
2.46867, 2012.0
2.46933, 2012.0
2.47, 2012.0
2.47067, 2012.0
2.47133, 2011.0
2.472, 2011.0
2.47267, 2011.0
2.47333, 2011.0
2.474, 2011.0
2.47467, 2010.0
2.47533, 2010.0
2.476, 2010.0
2.47667, 2010.0
2.47733, 2010.0
2.478, 2010.0
2.47867, 2009.0
2.47933, 2009.0
2.48, 2009.0
2.48067, 2008.0
2.48133, 2008.0
2.482, 2007.0
2.48267, 2007.0
2.48333, 2006.0
2.484, 2006.0
2.48467, 2006.0
2.48533, 2006.0
2.486, 2005.0
2.48667, 2005.0
2.48733, 2005.0
2.488, 2004.0
2.48867, 2004.0
2.48933, 2004.0
2.49, 2003.0
2.49067, 2003.0
2.49133, 2003.0
2.492, 2002.0
2.49267, 2002.0
2.49333, 2001.0
2.494, 2001.0
2.49467, 2001.0
2.49533, 2000.0
2.496, 1999.0
2.49667, 1999.0
2.49733, 1998.0
2.498, 1997.0
2.49867, 1997.0
2.49933, 1997.0
2.5, 1996.0
2.50067, 1996.0
2.50133, 1996.0
2.502, 1996.0
2.50267, 1996.0
2.50333, 1996.0
2.504, 1996.0
2.50467, 1997.0
2.50533, 1997.0
2.506, 1997.0
2.50667, 1997.0
2.50733, 1998.0
2.508, 1997.0
2.50867, 1997.0
2.50933, 1997.0
2.51, 1997.0
2.51067, 1997.0
2.51133, 1997.0
2.512, 1997.0
2.51267, 1997.0
2.51333, 1997.0
2.514, 1997.0
2.51467, 1997.0
2.51533, 1996.0
2.516, 1996.0
2.51667, 1996.0
2.51733, 1995.0
2.518, 1994.0
2.51867, 1993.0
2.51933, 1992.0
2.52, 1991.0
2.52067, 1990.0
2.52133, 1988.0
2.522, 1987.0
2.52267, 1985.0
2.52333, 1983.0
2.524, 1980.0
2.52467, 1978.0
2.52533, 1975.0
2.526, 1973.0
2.52667, 1970.0
2.52733, 1967.0
2.528, 1965.0
2.52867, 1962.0
2.52933, 1959.0
2.53, 1957.0
2.53067, 1954.0
2.53133, 1951.0
2.532, 1948.0
2.53267, 1945.0
2.53333, 1942.0
2.534, 1939.0
2.53467, 1937.0
2.53533, 1934.0
2.536, 1931.0
2.53667, 1928.0
2.53733, 1925.0
2.538, 1922.0
2.53867, 1919.0
2.53933, 1916.0
2.54, 1912.0
2.54067, 1908.0
2.54133, 1905.0
2.542, 1901.0
2.54267, 1897.0
2.54333, 1893.0
2.544, 1889.0
2.54467, 1885.0
2.54533, 1882.0
2.546, 1878.0
2.54667, 1875.0
2.54733, 1872.0
2.548, 1869.0
2.54867, 1866.0
2.54933, 1862.0
2.55, 1859.0
2.55067, 1855.0
2.55133, 1851.0
2.552, 1848.0
2.55267, 1844.0
2.55333, 1840.0
2.554, 1836.0
2.55467, 1832.0
2.55533, 1829.0
2.556, 1825.0
2.55667, 1821.0
2.55733, 1817.0
2.558, 1813.0
2.55867, 1809.0
2.55933, 1805.0
2.56, 1801.0
2.56067, 1797.0
2.56133, 1794.0
2.562, 1790.0
2.56267, 1787.0
2.56333, 1785.0
2.564, 1783.0
2.56467, 1780.0
2.56533, 1779.0
2.566, 1777.0
2.56667, 1775.0
2.56733, 1773.0
2.568, 1772.0
2.56867, 1771.0
2.56933, 1770.0
2.57, 1769.0
2.57067, 1768.0
2.57133, 1768.0
2.572, 1767.0
2.57267, 1767.0
2.57333, 1767.0
2.574, 1767.0
2.57467, 1767.0
2.57533, 1767.0
2.576, 1768.0
2.57667, 1769.0
2.57733, 1770.0
2.578, 1771.0
2.57867, 1773.0
2.57933, 1774.0
2.58, 1775.0
2.58067, 1777.0
2.58133, 1779.0
2.582, 1780.0
2.58267, 1782.0
2.58333, 1783.0
2.584, 1785.0
2.58467, 1786.0
2.58533, 1788.0
2.586, 1789.0
2.58667, 1790.0
2.58733, 1791.0
2.588, 1793.0
2.58867, 1794.0
2.58933, 1795.0
2.59, 1795.0
2.59067, 1796.0
2.59133, 1797.0
2.592, 1797.0
2.59267, 1798.0
2.59333, 1799.0
2.594, 1800.0
2.59467, 1801.0
2.59533, 1801.0
2.596, 1802.0
2.59667, 1803.0
2.59733, 1805.0
2.598, 1806.0
2.59867, 1807.0
2.59933, 1809.0
2.6, 1810.0
2.60067, 1812.0
2.60133, 1813.0
2.602, 1814.0
2.60267, 1815.0
2.60333, 1816.0
2.604, 1817.0
2.60467, 1818.0
2.60533, 1818.0
2.606, 1819.0
2.60667, 1820.0
2.60733, 1820.0
2.608, 1821.0
2.60867, 1822.0
2.60933, 1823.0
2.61, 1824.0
2.61067, 1825.0
2.61133, 1825.0
2.612, 1826.0
2.61267, 1827.0
2.61333, 1828.0
2.614, 1829.0
2.61467, 1830.0
2.61533, 1831.0
2.616, 1832.0
2.61667, 1833.0
2.61733, 1834.0
2.618, 1835.0
2.61867, 1836.0
2.61933, 1838.0
2.62, 1839.0
2.62067, 1840.0
2.62133, 1841.0
2.622, 1842.0
2.62267, 1843.0
2.62333, 1844.0
2.624, 1846.0
2.62467, 1847.0
2.62533, 1849.0
2.626, 1850.0
2.62667, 1852.0
2.62733, 1855.0
2.628, 1857.0
2.62867, 1860.0
2.62933, 1863.0
2.63, 1866.0
2.63067, 1869.0
2.63133, 1873.0
2.632, 1876.0
2.63267, 1880.0
2.63333, 1884.0
2.634, 1888.0
2.63467, 1892.0
2.63533, 1897.0
2.636, 1901.0
2.63667, 1906.0
2.63733, 1910.0
2.638, 1915.0
2.63867, 1920.0
2.63933, 1925.0
2.64, 1931.0
2.64067, 1936.0
2.64133, 1941.0
2.642, 1947.0
2.64267, 1952.0
2.64333, 1958.0
2.644, 1963.0
2.64467, 1969.0
2.64533, 1974.0
2.646, 1979.0
2.64667, 1985.0
2.64733, 1990.0
2.648, 1995.0
2.64867, 2000.0
2.64933, 2006.0
2.65, 2011.0
2.65067, 2016.0
2.65133, 2021.0
2.652, 2026.0
2.65267, 2031.0
2.65333, 2036.0
2.654, 2041.0
2.65467, 2045.0
2.65533, 2050.0
2.656, 2054.0
2.65667, 2058.0
2.65733, 2063.0
2.658, 2067.0
2.65867, 2072.0
2.65933, 2076.0
2.66, 2081.0
2.66067, 2085.0
2.66133, 2090.0
2.662, 2094.0
2.66267, 2099.0
2.66333, 2104.0
2.664, 2108.0
2.66467, 2113.0
2.66533, 2117.0
2.666, 2122.0
2.66667, 2126.0
2.66733, 2130.0
2.668, 2134.0
2.66867, 2138.0
2.66933, 2142.0
2.67, 2146.0
2.67067, 2150.0
2.67133, 2153.0
2.672, 2157.0
2.67267, 2161.0
2.67333, 2165.0
2.674, 2169.0
2.67467, 2173.0
2.67533, 2176.0
2.676, 2180.0
2.67667, 2183.0
2.67733, 2187.0
2.678, 2190.0
2.67867, 2194.0
2.67933, 2197.0
2.68, 2200.0
2.68067, 2203.0
2.68133, 2206.0
2.682, 2208.0
2.68267, 2211.0
2.68333, 2213.0
2.684, 2215.0
2.68467, 2216.0
2.68533, 2218.0
2.686, 2219.0
2.68667, 2220.0
2.68733, 2221.0
2.688, 2222.0
2.68867, 2223.0
2.68933, 2224.0
2.69, 2224.0
2.69067, 2225.0
2.69133, 2226.0
2.692, 2226.0
2.69267, 2226.0
2.69333, 2226.0
2.694, 2226.0
2.69467, 2226.0
2.69533, 2226.0
2.696, 2226.0
2.69667, 2226.0
2.69733, 2225.0
2.698, 2225.0
2.69867, 2224.0
2.69933, 2223.0
2.7, 2222.0
2.70067, 2220.0
2.70133, 2219.0
2.702, 2217.0
2.70267, 2215.0
2.70333, 2213.0
2.704, 2212.0
2.70467, 2210.0
2.70533, 2209.0
2.706, 2208.0
2.70667, 2208.0
2.70733, 2207.0
2.708, 2206.0
2.70867, 2206.0
2.70933, 2206.0
2.71, 2206.0
2.71067, 2206.0
2.71133, 2206.0
2.712, 2206.0
2.71267, 2207.0
2.71333, 2207.0
2.714, 2209.0
2.71467, 2210.0
2.71533, 2212.0
2.716, 2214.0
2.71667, 2216.0
2.71733, 2219.0
2.718, 2222.0
2.71867, 2226.0
2.71933, 2230.0
2.72, 2233.0
2.72067, 2237.0
2.72133, 2240.0
2.722, 2243.0
2.72267, 2247.0
2.72333, 2251.0
2.724, 2255.0
2.72467, 2260.0
2.72533, 2265.0
2.726, 2270.0
2.72667, 2275.0
2.72733, 2281.0
2.728, 2286.0
2.72867, 2292.0
2.72933, 2298.0
2.73, 2304.0
2.73067, 2310.0
2.73133, 2316.0
2.732, 2321.0
2.73267, 2327.0
2.73333, 2333.0
2.734, 2340.0
2.73467, 2346.0
2.73533, 2352.0
2.736, 2359.0
2.73667, 2365.0
2.73733, 2372.0
2.738, 2378.0
2.73867, 2384.0
2.73933, 2390.0
2.74, 2396.0
2.74067, 2401.0
2.74133, 2407.0
2.742, 2412.0
2.74267, 2417.0
2.74333, 2423.0
2.744, 2428.0
2.74467, 2433.0
2.74533, 2438.0
2.746, 2443.0
2.74667, 2448.0
2.74733, 2453.0
2.748, 2458.0
2.74867, 2462.0
2.74933, 2467.0
2.75, 2471.0
2.75067, 2475.0
2.75133, 2479.0
2.752, 2482.0
2.75267, 2486.0
2.75333, 2489.0
2.754, 2492.0
2.75467, 2495.0
2.75533, 2498.0
2.756, 2501.0
2.75667, 2503.0
2.75733, 2505.0
2.758, 2508.0
2.75867, 2509.0
2.75933, 2511.0
2.76, 2513.0
2.76067, 2514.0
2.76133, 2516.0
2.762, 2517.0
2.76267, 2519.0
2.76333, 2520.0
2.764, 2521.0
2.76467, 2522.0
2.76533, 2523.0
2.766, 2525.0
2.76667, 2525.0
2.76733, 2526.0
2.768, 2527.0
2.76867, 2528.0
2.76933, 2528.0
2.77, 2529.0
2.77067, 2529.0
2.77133, 2529.0
2.772, 2528.0
2.77267, 2528.0
2.77333, 2528.0
2.774, 2528.0
2.77467, 2528.0
2.77533, 2528.0
2.776, 2528.0
2.77667, 2527.0
2.77733, 2526.0
2.778, 2525.0
2.77867, 2524.0
2.77933, 2523.0
2.78, 2522.0
2.78067, 2520.0
2.78133, 2518.0
2.782, 2517.0
2.78267, 2515.0
2.78333, 2513.0
2.784, 2511.0
2.78467, 2509.0
2.78533, 2506.0
2.786, 2504.0
2.78667, 2502.0
2.78733, 2499.0
2.788, 2497.0
2.78867, 2495.0
2.78933, 2492.0
2.79, 2490.0
2.79067, 2487.0
2.79133, 2484.0
2.792, 2481.0
2.79267, 2478.0
2.79333, 2475.0
2.794, 2472.0
2.79467, 2468.0
2.79533, 2464.0
2.796, 2460.0
2.79667, 2455.0
2.79733, 2451.0
2.798, 2446.0
2.79867, 2442.0
2.79933, 2438.0
2.8, 2433.0
2.80067, 2429.0
2.80133, 2424.0
2.802, 2420.0
2.80267, 2416.0
2.80333, 2411.0
2.804, 2407.0
2.80467, 2403.0
2.80533, 2398.0
2.806, 2394.0
2.80667, 2390.0
2.80733, 2385.0
2.808, 2381.0
2.80867, 2377.0
2.80933, 2372.0
2.81, 2367.0
2.81067, 2363.0
2.81133, 2358.0
2.812, 2353.0
2.81267, 2348.0
2.81333, 2344.0
2.814, 2339.0
2.81467, 2334.0
2.81533, 2330.0
2.816, 2325.0
2.81667, 2321.0
2.81733, 2316.0
2.818, 2312.0
2.81867, 2308.0
2.81933, 2304.0
2.82, 2299.0
2.82067, 2295.0
2.82133, 2291.0
2.822, 2286.0
2.82267, 2282.0
2.82333, 2277.0
2.824, 2272.0
2.82467, 2267.0
2.82533, 2262.0
2.826, 2257.0
2.82667, 2252.0
2.82733, 2247.0
2.828, 2241.0
2.82867, 2236.0
2.82933, 2231.0
2.83, 2225.0
2.83067, 2220.0
2.83133, 2215.0
2.832, 2210.0
2.83267, 2204.0
2.83333, 2199.0
2.834, 2194.0
2.83467, 2188.0
2.83533, 2183.0
2.836, 2178.0
2.83667, 2172.0
2.83733, 2167.0
2.838, 2162.0
2.83867, 2157.0
2.83933, 2152.0
2.84, 2148.0
2.84067, 2143.0
2.84133, 2138.0
2.842, 2134.0
2.84267, 2130.0
2.84333, 2125.0
2.844, 2122.0
2.84467, 2118.0
2.84533, 2114.0
2.846, 2111.0
2.84667, 2108.0
2.84733, 2105.0
2.848, 2102.0
2.84867, 2099.0
2.84933, 2097.0
2.85, 2094.0
2.85067, 2092.0
2.85133, 2089.0
2.852, 2087.0
2.85267, 2084.0
2.85333, 2082.0
2.854, 2080.0
2.85467, 2078.0
2.85533, 2077.0
2.856, 2076.0
2.85667, 2075.0
2.85733, 2075.0
2.858, 2075.0
2.85867, 2074.0
2.85933, 2074.0
2.86, 2074.0
2.86067, 2074.0
2.86133, 2074.0
2.862, 2074.0
2.86267, 2074.0
2.86333, 2075.0
2.864, 2075.0
2.86467, 2075.0
2.86533, 2075.0
2.866, 2076.0
2.86667, 2076.0
2.86733, 2076.0
2.868, 2077.0
2.86867, 2077.0
2.86933, 2077.0
2.87, 2077.0
2.87067, 2078.0
2.87133, 2078.0
2.872, 2078.0
2.87267, 2079.0
2.87333, 2079.0
2.874, 2079.0
2.87467, 2080.0
2.87533, 2081.0
2.876, 2082.0
2.87667, 2083.0
2.87733, 2085.0
2.878, 2086.0
2.87867, 2088.0
2.87933, 2090.0
2.88, 2092.0
2.88067, 2094.0
2.88133, 2096.0
2.882, 2099.0
2.88267, 2101.0
2.88333, 2104.0
2.884, 2107.0
2.88467, 2110.0
2.88533, 2113.0
2.886, 2116.0
2.88667, 2120.0
2.88733, 2123.0
2.888, 2126.0
2.88867, 2130.0
2.88933, 2133.0
2.89, 2137.0
2.89067, 2140.0
2.89133, 2143.0
2.892, 2147.0
2.89267, 2150.0
2.89333, 2153.0
2.894, 2156.0
2.89467, 2159.0
2.89533, 2162.0
2.896, 2165.0
2.89667, 2168.0
2.89733, 2171.0
2.898, 2174.0
2.89867, 2178.0
2.89933, 2181.0
2.9, 2184.0
2.90067, 2187.0
2.90133, 2191.0
2.902, 2194.0
2.90267, 2197.0
2.90333, 2201.0
2.904, 2204.0
2.90467, 2207.0
2.90533, 2209.0
2.906, 2212.0
2.90667, 2215.0
2.90733, 2218.0
2.908, 2220.0
2.90867, 2222.0
2.90933, 2225.0
2.91, 2227.0
2.91067, 2228.0
2.91133, 2230.0
2.912, 2231.0
2.91267, 2233.0
2.91333, 2234.0
2.914, 2235.0
2.91467, 2236.0
2.91533, 2237.0
2.916, 2238.0
2.91667, 2239.0
2.91733, 2240.0
2.918, 2241.0
2.91867, 2243.0
2.91933, 2244.0
2.92, 2245.0
2.92067, 2247.0
2.92133, 2248.0
2.922, 2250.0
2.92267, 2251.0
2.92333, 2252.0
2.924, 2254.0
2.92467, 2255.0
2.92533, 2256.0
2.926, 2257.0
2.92667, 2258.0
2.92733, 2258.0
2.928, 2259.0
2.92867, 2260.0
2.92933, 2260.0
2.93, 2261.0
2.93067, 2261.0
2.93133, 2261.0
2.932, 2262.0
2.93267, 2262.0
2.93333, 2262.0
2.934, 2262.0
2.93467, 2262.0
2.93533, 2262.0
2.936, 2261.0
2.93667, 2261.0
2.93733, 2261.0
2.938, 2260.0
2.93867, 2260.0
2.93933, 2260.0
2.94, 2260.0
2.94067, 2260.0
2.94133, 2260.0
2.942, 2260.0
2.94267, 2260.0
2.94333, 2261.0
2.944, 2262.0
2.94467, 2262.0
2.94533, 2263.0
2.946, 2264.0
2.94667, 2266.0
2.94733, 2267.0
2.948, 2269.0
2.94867, 2271.0
2.94933, 2273.0
2.95, 2275.0
2.95067, 2277.0
2.95133, 2280.0
2.952, 2282.0
2.95267, 2285.0
2.95333, 2287.0
2.954, 2290.0
2.95467, 2292.0
2.95533, 2295.0
2.956, 2297.0
2.95667, 2300.0
2.95733, 2303.0
2.958, 2306.0
2.95867, 2309.0
2.95933, 2313.0
2.96, 2316.0
2.96067, 2319.0
2.96133, 2322.0
2.962, 2325.0
2.96267, 2328.0
2.96333, 2331.0
2.964, 2334.0
2.96467, 2337.0
2.96533, 2340.0
2.966, 2343.0
2.96667, 2346.0
2.96733, 2350.0
2.968, 2353.0
2.96867, 2356.0
2.96933, 2359.0
2.97, 2363.0
2.97067, 2366.0
2.97133, 2369.0
2.972, 2372.0
2.97267, 2375.0
2.97333, 2378.0
2.974, 2381.0
2.97467, 2384.0
2.97533, 2386.0
2.976, 2388.0
2.97667, 2390.0
2.97733, 2391.0
2.978, 2392.0
2.97867, 2393.0
2.97933, 2393.0
2.98, 2394.0
2.98067, 2394.0
2.98133, 2394.0
2.982, 2395.0
2.98267, 2395.0
2.98333, 2395.0
2.984, 2396.0
2.98467, 2396.0
2.98533, 2396.0
2.986, 2397.0
2.98667, 2397.0
2.98733, 2397.0
2.988, 2397.0
2.98867, 2397.0
2.98933, 2396.0
2.99, 2395.0
2.99067, 2394.0
2.99133, 2393.0
2.992, 2391.0
2.99267, 2389.0
2.99333, 2388.0
2.994, 2386.0
2.99467, 2384.0
2.99533, 2382.0
2.996, 2380.0
2.99667, 2377.0
2.99733, 2375.0
2.998, 2372.0
2.99867, 2369.0
2.99933, 2366.0
3.0, 2362.0
3.00067, 2359.0
3.00133, 2355.0
3.002, 2351.0
3.00267, 2347.0
3.00333, 2342.0
3.004, 2338.0
3.00467, 2333.0
3.00533, 2327.0
3.006, 2322.0
3.00667, 2316.0
3.00733, 2310.0
3.008, 2304.0
3.00867, 2297.0
3.00933, 2291.0
3.01, 2284.0
3.01067, 2277.0
3.01133, 2271.0
3.012, 2264.0
3.01267, 2256.0
3.01333, 2249.0
3.014, 2241.0
3.01467, 2234.0
3.01533, 2226.0
3.016, 2218.0
3.01667, 2210.0
3.01733, 2201.0
3.018, 2193.0
3.01867, 2185.0
3.01933, 2176.0
3.02, 2168.0
3.02067, 2159.0
3.02133, 2151.0
3.022, 2143.0
3.02267, 2135.0
3.02333, 2127.0
3.024, 2119.0
3.02467, 2110.0
3.02533, 2102.0
3.026, 2094.0
3.02667, 2086.0
3.02733, 2077.0
3.028, 2069.0
3.02867, 2061.0
3.02933, 2053.0
3.03, 2046.0
3.03067, 2038.0
3.03133, 2030.0
3.032, 2023.0
3.03267, 2015.0
3.03333, 2008.0
3.034, 2000.0
3.03467, 1993.0
3.03533, 1985.0
3.036, 1978.0
3.03667, 1971.0
3.03733, 1964.0
3.038, 1957.0
3.03867, 1950.0
3.03933, 1943.0
3.04, 1936.0
3.04067, 1929.0
3.04133, 1923.0
3.042, 1916.0
3.04267, 1910.0
3.04333, 1904.0
3.044, 1898.0
3.04467, 1892.0
3.04533, 1887.0
3.046, 1881.0
3.04667, 1876.0
3.04733, 1871.0
3.048, 1867.0
3.04867, 1862.0
3.04933, 1858.0
3.05, 1854.0
3.05067, 1850.0
3.05133, 1847.0
3.052, 1844.0
3.05267, 1842.0
3.05333, 1840.0
3.054, 1839.0
3.05467, 1837.0
3.05533, 1836.0
3.056, 1835.0
3.05667, 1835.0
3.05733, 1835.0
3.058, 1835.0
3.05867, 1835.0
3.05933, 1835.0
3.06, 1835.0
3.06067, 1835.0
3.06133, 1834.0
3.062, 1834.0
3.06267, 1834.0
3.06333, 1834.0
3.064, 1835.0
3.06467, 1835.0
3.06533, 1836.0
3.066, 1837.0
3.06667, 1839.0
3.06733, 1841.0
3.068, 1843.0
3.06867, 1846.0
3.06933, 1849.0
3.07, 1852.0
3.07067, 1856.0
3.07133, 1861.0
3.072, 1866.0
3.07267, 1873.0
3.07333, 1879.0
3.074, 1887.0
3.07467, 1894.0
3.07533, 1902.0
3.076, 1911.0
3.07667, 1920.0
3.07733, 1928.0
3.078, 1937.0
3.07867, 1946.0
3.07933, 1955.0
3.08, 1964.0
3.08067, 1974.0
3.08133, 1983.0
3.082, 1992.0
3.08267, 2002.0
3.08333, 2011.0
3.084, 2021.0
3.08467, 2031.0
3.08533, 2040.0
3.086, 2050.0
3.08667, 2059.0
3.08733, 2069.0
3.088, 2078.0
3.08867, 2088.0
3.08933, 2098.0
3.09, 2108.0
3.09067, 2118.0
3.09133, 2128.0
3.092, 2139.0
3.09267, 2150.0
3.09333, 2161.0
3.094, 2173.0
3.09467, 2184.0
3.09533, 2196.0
3.096, 2208.0
3.09667, 2221.0
3.09733, 2233.0
3.098, 2245.0
3.09867, 2258.0
3.09933, 2270.0
3.1, 2283.0
3.10067, 2295.0
3.10133, 2308.0
3.102, 2320.0
3.10267, 2332.0
3.10333, 2344.0
3.104, 2356.0
3.10467, 2368.0
3.10533, 2380.0
3.106, 2392.0
3.10667, 2404.0
3.10733, 2416.0
3.108, 2428.0
3.10867, 2440.0
3.10933, 2453.0
3.11, 2465.0
3.11067, 2478.0
3.11133, 2491.0
3.112, 2504.0
3.11267, 2518.0
3.11333, 2531.0
3.114, 2545.0
3.11467, 2559.0
3.11533, 2573.0
3.116, 2587.0
3.11667, 2600.0
3.11733, 2614.0
3.118, 2628.0
3.11867, 2642.0
3.11933, 2655.0
3.12, 2668.0
3.12067, 2682.0
3.12133, 2695.0
3.122, 2708.0
3.12267, 2721.0
3.12333, 2734.0
3.124, 2747.0
3.12467, 2760.0
3.12533, 2773.0
3.126, 2786.0
3.12667, 2800.0
3.12733, 2813.0
3.128, 2827.0
3.12867, 2841.0
3.12933, 2855.0
3.13, 2870.0
3.13067, 2884.0
3.13133, 2898.0
3.132, 2912.0
3.13267, 2927.0
3.13333, 2941.0
3.134, 2956.0
3.13467, 2970.0
3.13533, 2985.0
3.136, 3000.0
3.13667, 3015.0
3.13733, 3030.0
3.138, 3045.0
3.13867, 3060.0
3.13933, 3075.0
3.14, 3090.0
3.14067, 3105.0
3.14133, 3120.0
3.142, 3135.0
3.14267, 3150.0
3.14333, 3165.0
3.144, 3179.0
3.14467, 3193.0
3.14533, 3207.0
3.146, 3221.0
3.14667, 3235.0
3.14733, 3248.0
3.148, 3261.0
3.14867, 3274.0
3.14933, 3286.0
3.15, 3299.0
3.15067, 3310.0
3.15133, 3322.0
3.152, 3334.0
3.15267, 3345.0
3.15333, 3357.0
3.154, 3368.0
3.15467, 3379.0
3.15533, 3390.0
3.156, 3402.0
3.15667, 3413.0
3.15733, 3424.0
3.158, 3436.0
3.15867, 3447.0
3.15933, 3459.0
3.16, 3471.0
3.16067, 3483.0
3.16133, 3495.0
3.162, 3508.0
3.16267, 3520.0
3.16333, 3533.0
3.164, 3546.0
3.16467, 3559.0
3.16533, 3571.0
3.166, 3584.0
3.16667, 3596.0
3.16733, 3608.0
3.168, 3619.0
3.16867, 3630.0
3.16933, 3641.0
3.17, 3652.0
3.17067, 3663.0
3.17133, 3673.0
3.172, 3683.0
3.17267, 3694.0
3.17333, 3703.0
3.174, 3713.0
3.17467, 3722.0
3.17533, 3731.0
3.176, 3740.0
3.17667, 3749.0
3.17733, 3757.0
3.178, 3764.0
3.17867, 3772.0
3.17933, 3779.0
3.18, 3786.0
3.18067, 3792.0
3.18133, 3799.0
3.182, 3805.0
3.18267, 3810.0
3.18333, 3816.0
3.184, 3821.0
3.18467, 3827.0
3.18533, 3832.0
3.186, 3838.0
3.18667, 3843.0
3.18733, 3848.0
3.188, 3854.0
3.18867, 3860.0
3.18933, 3866.0
3.19, 3872.0
3.19067, 3878.0
3.19133, 3884.0
3.192, 3890.0
3.19267, 3896.0
3.19333, 3902.0
3.194, 3908.0
3.19467, 3914.0
3.19533, 3920.0
3.196, 3925.0
3.19667, 3930.0
3.19733, 3935.0
3.198, 3940.0
3.19867, 3945.0
3.19933, 3950.0
3.2, 3955.0
3.20067, 3960.0
3.20133, 3965.0
3.202, 3970.0
3.20267, 3975.0
3.20333, 3980.0
3.204, 3986.0
3.20467, 3991.0
3.20533, 3997.0
3.206, 4003.0
3.20667, 4008.0
3.20733, 4014.0
3.208, 4020.0
3.20867, 4026.0
3.20933, 4032.0
3.21, 4039.0
3.21067, 4045.0
3.21133, 4051.0
3.212, 4058.0
3.21267, 4064.0
3.21333, 4070.0
3.214, 4076.0
3.21467, 4082.0
3.21533, 4088.0
3.216, 4094.0
3.21667, 4100.0
3.21733, 4106.0
3.218, 4112.0
3.21867, 4118.0
3.21933, 4124.0
3.22, 4131.0
3.22067, 4138.0
3.22133, 4145.0
3.222, 4152.0
3.22267, 4160.0
3.22333, 4168.0
3.224, 4175.0
3.22467, 4183.0
3.22533, 4191.0
3.226, 4200.0
3.22667, 4208.0
3.22733, 4216.0
3.228, 4225.0
3.22867, 4233.0
3.22933, 4242.0
3.23, 4250.0
3.23067, 4257.0
3.23133, 4265.0
3.232, 4272.0
3.23267, 4279.0
3.23333, 4285.0
3.234, 4292.0
3.23467, 4298.0
3.23533, 4305.0
3.236, 4311.0
3.23667, 4317.0
3.23733, 4324.0
3.238, 4330.0
3.23867, 4336.0
3.23933, 4342.0
3.24, 4348.0
3.24067, 4354.0
3.24133, 4359.0
3.242, 4365.0
3.24267, 4371.0
3.24333, 4376.0
3.244, 4383.0
3.24467, 4389.0
3.24533, 4395.0
3.246, 4402.0
3.24667, 4409.0
3.24733, 4416.0
3.248, 4423.0
3.24867, 4431.0
3.24933, 4439.0
3.25, 4446.0
3.25067, 4454.0
3.25133, 4462.0
3.252, 4469.0
3.25267, 4477.0
3.25333, 4484.0
3.254, 4491.0
3.25467, 4498.0
3.25533, 4504.0
3.256, 4511.0
3.25667, 4517.0
3.25733, 4523.0
3.258, 4529.0
3.25867, 4535.0
3.25933, 4541.0
3.26, 4547.0
3.26067, 4552.0
3.26133, 4558.0
3.262, 4563.0
3.26267, 4569.0
3.26333, 4573.0
3.264, 4578.0
3.26467, 4583.0
3.26533, 4587.0
3.266, 4591.0
3.26667, 4595.0
3.26733, 4599.0
3.268, 4602.0
3.26867, 4605.0
3.26933, 4608.0
3.27, 4611.0
3.27067, 4614.0
3.27133, 4617.0
3.272, 4621.0
3.27267, 4625.0
3.27333, 4629.0
3.274, 4633.0
3.27467, 4637.0
3.27533, 4642.0
3.276, 4647.0
3.27667, 4652.0
3.27733, 4657.0
3.278, 4662.0
3.27867, 4667.0
3.27933, 4672.0
3.28, 4677.0
3.28067, 4681.0
3.28133, 4685.0
3.282, 4689.0
3.28267, 4692.0
3.28333, 4695.0
3.284, 4698.0
3.28467, 4701.0
3.28533, 4704.0
3.286, 4707.0
3.28667, 4711.0
3.28733, 4714.0
3.288, 4718.0
3.28867, 4721.0
3.28933, 4725.0
3.29, 4729.0
3.29067, 4733.0
3.29133, 4737.0
3.292, 4741.0
3.29267, 4744.0
3.29333, 4748.0
3.294, 4751.0
3.29467, 4754.0
3.29533, 4757.0
3.296, 4759.0
3.29667, 4762.0
3.29733, 4764.0
3.298, 4767.0
3.29867, 4770.0
3.29933, 4772.0
3.3, 4776.0
3.30067, 4779.0
3.30133, 4783.0
3.302, 4788.0
3.30267, 4793.0
3.30333, 4798.0
3.304, 4804.0
3.30467, 4810.0
3.30533, 4816.0
3.306, 4822.0
3.30667, 4829.0
3.30733, 4835.0
3.308, 4841.0
3.30867, 4848.0
3.30933, 4853.0
3.31, 4859.0
3.31067, 4864.0
3.31133, 4869.0
3.312, 4873.0
3.31267, 4877.0
3.31333, 4881.0
3.314, 4884.0
3.31467, 4887.0
3.31533, 4890.0
3.316, 4892.0
3.31667, 4895.0
3.31733, 4897.0
3.318, 4900.0
3.31867, 4903.0
3.31933, 4906.0
3.32, 4910.0
3.32067, 4914.0
3.32133, 4919.0
3.322, 4924.0
3.32267, 4930.0
3.32333, 4936.0
3.324, 4942.0
3.32467, 4949.0
3.32533, 4956.0
3.326, 4962.0
3.32667, 4969.0
3.32733, 4976.0
3.328, 4982.0
3.32867, 4988.0
3.32933, 4995.0
3.33, 5001.0
3.33067, 5007.0
3.33133, 5013.0
3.332, 5019.0
3.33267, 5025.0
3.33333, 5031.0
3.334, 5036.0
3.33467, 5041.0
3.33533, 5046.0
3.336, 5051.0
3.33667, 5055.0
3.33733, 5058.0
3.338, 5061.0
3.33867, 5065.0
3.33933, 5067.0
3.34, 5070.0
3.34067, 5073.0
3.34133, 5075.0
3.342, 5077.0
3.34267, 5079.0
3.34333, 5082.0
3.344, 5084.0
3.34467, 5086.0
3.34533, 5089.0
3.346, 5091.0
3.34667, 5094.0
3.34733, 5096.0
3.348, 5099.0
3.34867, 5102.0
3.34933, 5105.0
3.35, 5108.0
3.35067, 5111.0
3.35133, 5114.0
3.352, 5117.0
3.35267, 5120.0
3.35333, 5123.0
3.354, 5127.0
3.35467, 5130.0
3.35533, 5133.0
3.356, 5135.0
3.35667, 5137.0
3.35733, 5138.0
3.358, 5139.0
3.35867, 5140.0
3.35933, 5141.0
3.36, 5141.0
3.36067, 5142.0
3.36133, 5143.0
3.362, 5144.0
3.36267, 5145.0
3.36333, 5147.0
3.364, 5149.0
3.36467, 5151.0
3.36533, 5154.0
3.366, 5157.0
3.36667, 5161.0
3.36733, 5166.0
3.368, 5171.0
3.36867, 5177.0
3.36933, 5183.0
3.37, 5189.0
3.37067, 5196.0
3.37133, 5203.0
3.372, 5212.0
3.37267, 5221.0
3.37333, 5230.0
3.374, 5240.0
3.37467, 5251.0
3.37533, 5262.0
3.376, 5273.0
3.37667, 5285.0
3.37733, 5298.0
3.378, 5310.0
3.37867, 5322.0
3.37933, 5334.0
3.38, 5347.0
3.38067, 5359.0
3.38133, 5371.0
3.382, 5383.0
3.38267, 5394.0
3.38333, 5406.0
3.384, 5418.0
3.38467, 5430.0
3.38533, 5441.0
3.386, 5453.0
3.38667, 5464.0
3.38733, 5475.0
3.388, 5486.0
3.38867, 5497.0
3.38933, 5508.0
3.39, 5518.0
3.39067, 5528.0
3.39133, 5538.0
3.392, 5548.0
3.39267, 5558.0
3.39333, 5569.0
3.394, 5579.0
3.39467, 5590.0
3.39533, 5601.0
3.396, 5612.0
3.39667, 5624.0
3.39733, 5635.0
3.398, 5646.0
3.39867, 5658.0
3.39933, 5670.0
3.4, 5681.0
3.40067, 5693.0
3.40133, 5704.0
3.402, 5715.0
3.40267, 5726.0
3.40333, 5736.0
3.404, 5746.0
3.40467, 5756.0
3.40533, 5765.0
3.406, 5774.0
3.40667, 5783.0
3.40733, 5792.0
3.408, 5800.0
3.40867, 5808.0
3.40933, 5816.0
3.41, 5825.0
3.41067, 5833.0
3.41133, 5841.0
3.412, 5850.0
3.41267, 5858.0
3.41333, 5867.0
3.414, 5877.0
3.41467, 5886.0
3.41533, 5895.0
3.416, 5905.0
3.41667, 5915.0
3.41733, 5925.0
3.418, 5935.0
3.41867, 5945.0
3.41933, 5956.0
3.42, 5966.0
3.42067, 5977.0
3.42133, 5988.0
3.422, 5998.0
3.42267, 6009.0
3.42333, 6019.0
3.424, 6029.0
3.42467, 6039.0
3.42533, 6048.0
3.426, 6058.0
3.42667, 6067.0
3.42733, 6077.0
3.428, 6087.0
3.42867, 6096.0
3.42933, 6106.0
3.43, 6115.0
3.43067, 6125.0
3.43133, 6134.0
3.432, 6144.0
3.43267, 6153.0
3.43333, 6163.0
3.434, 6172.0
3.43467, 6180.0
3.43533, 6189.0
3.436, 6198.0
3.43667, 6206.0
3.43733, 6214.0
3.438, 6221.0
3.43867, 6228.0
3.43933, 6235.0
3.44, 6242.0
3.44067, 6248.0
3.44133, 6253.0
3.442, 6259.0
3.44267, 6264.0
3.44333, 6269.0
3.444, 6274.0
3.44467, 6279.0
3.44533, 6284.0
3.446, 6290.0
3.44667, 6295.0
3.44733, 6302.0
3.448, 6308.0
3.44867, 6315.0
3.44933, 6322.0
3.45, 6329.0
3.45067, 6337.0
3.45133, 6345.0
3.452, 6353.0
3.45267, 6361.0
3.45333, 6369.0
3.454, 6377.0
3.45467, 6385.0
3.45533, 6393.0
3.456, 6402.0
3.45667, 6411.0
3.45733, 6420.0
3.458, 6430.0
3.45867, 6439.0
3.45933, 6449.0
3.46, 6459.0
3.46067, 6469.0
3.46133, 6479.0
3.462, 6489.0
3.46267, 6499.0
3.46333, 6509.0
3.464, 6519.0
3.46467, 6530.0
3.46533, 6540.0
3.466, 6551.0
3.46667, 6562.0
3.46733, 6574.0
3.468, 6586.0
3.46867, 6598.0
3.46933, 6610.0
3.47, 6623.0
3.47067, 6636.0
3.47133, 6649.0
3.472, 6663.0
3.47267, 6677.0
3.47333, 6691.0
3.474, 6706.0
3.47467, 6721.0
3.47533, 6737.0
3.476, 6752.0
3.47667, 6768.0
3.47733, 6784.0
3.478, 6800.0
3.47867, 6816.0
3.47933, 6832.0
3.48, 6847.0
3.48067, 6863.0
3.48133, 6878.0
3.482, 6893.0
3.48267, 6908.0
3.48333, 6924.0
3.484, 6939.0
3.48467, 6954.0
3.48533, 6969.0
3.486, 6984.0
3.48667, 6999.0
3.48733, 7015.0
3.488, 7030.0
3.48867, 7045.0
3.48933, 7060.0
3.49, 7076.0
3.49067, 7091.0
3.49133, 7106.0
3.492, 7121.0
3.49267, 7136.0
3.49333, 7150.0
3.494, 7165.0
3.49467, 7180.0
3.49533, 7195.0
3.496, 7210.0
3.49667, 7225.0
3.49733, 7240.0
3.498, 7255.0
3.49867, 7270.0
3.49933, 7286.0
3.5, 7302.0
3.50067, 7318.0
3.50133, 7335.0
3.502, 7352.0
3.50267, 7369.0
3.50333, 7386.0
3.504, 7404.0
3.50467, 7422.0
3.50533, 7440.0
3.506, 7459.0
3.50667, 7477.0
3.50733, 7496.0
3.508, 7515.0
3.50867, 7533.0
3.50933, 7552.0
3.51, 7572.0
3.51067, 7591.0
3.51133, 7610.0
3.512, 7630.0
3.51267, 7649.0
3.51333, 7669.0
3.514, 7689.0
3.51467, 7709.0
3.51533, 7729.0
3.516, 7749.0
3.51667, 7770.0
3.51733, 7791.0
3.518, 7813.0
3.51867, 7834.0
3.51933, 7856.0
3.52, 7878.0
3.52067, 7901.0
3.52133, 7923.0
3.522, 7946.0
3.52267, 7969.0
3.52333, 7991.0
3.524, 8014.0
3.52467, 8036.0
3.52533, 8059.0
3.526, 8081.0
3.52667, 8104.0
3.52733, 8126.0
3.528, 8148.0
3.52867, 8171.0
3.52933, 8193.0
3.53, 8216.0
3.53067, 8239.0
3.53133, 8261.0
3.532, 8284.0
3.53267, 8306.0
3.53333, 8329.0
3.534, 8351.0
3.53467, 8372.0
3.53533, 8393.0
3.536, 8414.0
3.53667, 8434.0
3.53733, 8453.0
3.538, 8472.0
3.53867, 8491.0
3.53933, 8508.0
3.54, 8525.0
3.54067, 8542.0
3.54133, 8557.0
3.542, 8572.0
3.54267, 8587.0
3.54333, 8601.0
3.544, 8615.0
3.54467, 8628.0
3.54533, 8641.0
3.546, 8654.0
3.54667, 8666.0
3.54733, 8678.0
3.548, 8690.0
3.54867, 8701.0
3.54933, 8712.0
3.55, 8723.0
3.55067, 8734.0
3.55133, 8745.0
3.552, 8756.0
3.55267, 8766.0
3.55333, 8777.0
3.554, 8786.0
3.55467, 8796.0
3.55533, 8805.0
3.556, 8813.0
3.55667, 8821.0
3.55733, 8829.0
3.558, 8837.0
3.55867, 8844.0
3.55933, 8851.0
3.56, 8858.0
3.56067, 8865.0
3.56133, 8872.0
3.562, 8879.0
3.56267, 8885.0
3.56333, 8892.0
3.564, 8899.0
3.56467, 8905.0
3.56533, 8912.0
3.566, 8920.0
3.56667, 8928.0
3.56733, 8935.0
3.568, 8944.0
3.56867, 8952.0
3.56933, 8960.0
3.57, 8968.0
3.57067, 8976.0
3.57133, 8984.0
3.572, 8992.0
3.57267, 8999.0
3.57333, 9007.0
3.574, 9014.0
3.57467, 9021.0
3.57533, 9029.0
3.576, 9036.0
3.57667, 9043.0
3.57733, 9051.0
3.578, 9058.0
3.57867, 9066.0
3.57933, 9075.0
3.58, 9085.0
3.58067, 9095.0
3.58133, 9105.0
3.582, 9116.0
3.58267, 9126.0
3.58333, 9137.0
3.584, 9148.0
3.58467, 9159.0
3.58533, 9170.0
3.586, 9181.0
3.58667, 9191.0
3.58733, 9202.0
3.588, 9213.0
3.58867, 9224.0
3.58933, 9235.0
3.59, 9245.0
3.59067, 9256.0
3.59133, 9266.0
3.592, 9277.0
3.59267, 9287.0
3.59333, 9297.0
3.594, 9307.0
3.59467, 9317.0
3.59533, 9328.0
3.596, 9338.0
3.59667, 9349.0
3.59733, 9360.0
3.598, 9371.0
3.59867, 9382.0
3.59933, 9392.0
3.6, 9402.0
3.60067, 9412.0
3.60133, 9421.0
3.602, 9430.0
3.60267, 9438.0
3.60333, 9445.0
3.604, 9451.0
3.60467, 9457.0
3.60533, 9462.0
3.606, 9467.0
3.60667, 9471.0
3.60733, 9475.0
3.608, 9479.0
3.60867, 9483.0
3.60933, 9487.0
3.61, 9491.0
3.61067, 9495.0
3.61133, 9499.0
3.612, 9503.0
3.61267, 9508.0
3.61333, 9513.0
3.614, 9518.0
3.61467, 9523.0
3.61533, 9530.0
3.616, 9537.0
3.61667, 9544.0
3.61733, 9552.0
3.618, 9560.0
3.61867, 9568.0
3.61933, 9576.0
3.62, 9584.0
3.62067, 9592.0
3.62133, 9600.0
3.622, 9608.0
3.62267, 9616.0
3.62333, 9623.0
3.624, 9631.0
3.62467, 9638.0
3.62533, 9644.0
3.626, 9650.0
3.62667, 9656.0
3.62733, 9662.0
3.628, 9667.0
3.62867, 9671.0
3.62933, 9675.0
3.63, 9678.0
3.63067, 9681.0
3.63133, 9684.0
3.632, 9687.0
3.63267, 9690.0
3.63333, 9692.0
3.634, 9695.0
3.63467, 9697.0
3.63533, 9700.0
3.636, 9702.0
3.63667, 9705.0
3.63733, 9708.0
3.638, 9712.0
3.63867, 9716.0
3.63933, 9721.0
3.64, 9726.0
3.64067, 9732.0
3.64133, 9738.0
3.642, 9745.0
3.64267, 9752.0
3.64333, 9758.0
3.644, 9765.0
3.64467, 9772.0
3.64533, 9779.0
3.646, 9786.0
3.64667, 9793.0
3.64733, 9800.0
3.648, 9808.0
3.64867, 9816.0
3.64933, 9825.0
3.65, 9834.0
3.65067, 9843.0
3.65133, 9853.0
3.652, 9863.0
3.65267, 9873.0
3.65333, 9884.0
3.654, 9894.0
3.65467, 9905.0
3.65533, 9916.0
3.656, 9926.0
3.65667, 9937.0
3.65733, 9947.0
3.658, 9956.0
3.65867, 9966.0
3.65933, 9975.0
3.66, 9983.0
3.66067, 9991.0
3.66133, 9999.0
3.662, 10006.0
3.66267, 10012.0
3.66333, 10019.0
3.664, 10025.0
3.66467, 10032.0
3.66533, 10040.0
3.666, 10048.0
3.66667, 10056.0
3.66733, 10065.0
3.668, 10074.0
3.66867, 10084.0
3.66933, 10093.0
3.67, 10102.0
3.67067, 10111.0
3.67133, 10120.0
3.672, 10128.0
3.67267, 10136.0
3.67333, 10144.0
3.674, 10153.0
3.67467, 10161.0
3.67533, 10169.0
3.676, 10178.0
3.67667, 10186.0
3.67733, 10194.0
3.678, 10202.0
3.67867, 10210.0
3.67933, 10217.0
3.68, 10225.0
3.68067, 10232.0
3.68133, 10238.0
3.682, 10245.0
3.68267, 10251.0
3.68333, 10258.0
3.684, 10264.0
3.68467, 10270.0
3.68533, 10276.0
3.686, 10282.0
3.68667, 10288.0
3.68733, 10294.0
3.688, 10301.0
3.68867, 10308.0
3.68933, 10315.0
3.69, 10322.0
3.69067, 10329.0
3.69133, 10336.0
3.692, 10343.0
3.69267, 10350.0
3.69333, 10357.0
3.694, 10363.0
3.69467, 10370.0
3.69533, 10376.0
3.696, 10382.0
3.69667, 10388.0
3.69733, 10394.0
3.698, 10399.0
3.69867, 10404.0
3.69933, 10409.0
3.7, 10413.0
3.70067, 10418.0
3.70133, 10422.0
3.702, 10426.0
3.70267, 10430.0
3.70333, 10434.0
3.704, 10439.0
3.70467, 10443.0
3.70533, 10448.0
3.706, 10452.0
3.70667, 10457.0
3.70733, 10462.0
3.708, 10467.0
3.70867, 10471.0
3.70933, 10475.0
3.71, 10479.0
3.71067, 10483.0
3.71133, 10487.0
3.712, 10490.0
3.71267, 10492.0
3.71333, 10494.0
3.714, 10496.0
3.71467, 10497.0
3.71533, 10498.0
3.716, 10499.0
3.71667, 10499.0
3.71733, 10498.0
3.718, 10497.0
3.71867, 10496.0
3.71933, 10495.0
3.72, 10494.0
3.72067, 10492.0
3.72133, 10491.0
3.722, 10490.0
3.72267, 10490.0
3.72333, 10491.0
3.724, 10492.0
3.72467, 10493.0
3.72533, 10495.0
3.726, 10498.0
3.72667, 10500.0
3.72733, 10503.0
3.728, 10507.0
3.72867, 10511.0
3.72933, 10515.0
3.73, 10521.0
3.73067, 10527.0
3.73133, 10533.0
3.732, 10541.0
3.73267, 10549.0
3.73333, 10557.0
3.734, 10567.0
3.73467, 10577.0
3.73533, 10588.0
3.736, 10600.0
3.73667, 10613.0
3.73733, 10626.0
3.738, 10640.0
3.73867, 10654.0
3.73933, 10668.0
3.74, 10683.0
3.74067, 10697.0
3.74133, 10711.0
3.742, 10725.0
3.74267, 10739.0
3.74333, 10753.0
3.744, 10766.0
3.74467, 10780.0
3.74533, 10792.0
3.746, 10805.0
3.74667, 10816.0
3.74733, 10828.0
3.748, 10839.0
3.74867, 10850.0
3.74933, 10860.0
3.75, 10870.0
3.75067, 10879.0
3.75133, 10889.0
3.752, 10898.0
3.75267, 10908.0
3.75333, 10917.0
3.754, 10927.0
3.75467, 10937.0
3.75533, 10946.0
3.756, 10956.0
3.75667, 10966.0
3.75733, 10977.0
3.758, 10987.0
3.75867, 10999.0
3.75933, 11011.0
3.76, 11023.0
3.76067, 11037.0
3.76133, 11051.0
3.762, 11066.0
3.76267, 11082.0
3.76333, 11098.0
3.764, 11115.0
3.76467, 11132.0
3.76533, 11149.0
3.766, 11166.0
3.76667, 11183.0
3.76733, 11200.0
3.768, 11216.0
3.76867, 11232.0
3.76933, 11247.0
3.77, 11262.0
3.77067, 11276.0
3.77133, 11289.0
3.772, 11301.0
3.77267, 11313.0
3.77333, 11324.0
3.774, 11334.0
3.77467, 11344.0
3.77533, 11353.0
3.776, 11361.0
3.77667, 11369.0
3.77733, 11377.0
3.778, 11384.0
3.77867, 11390.0
3.77933, 11396.0
3.78, 11403.0
3.78067, 11409.0
3.78133, 11416.0
3.782, 11422.0
3.78267, 11430.0
3.78333, 11437.0
3.784, 11444.0
3.78467, 11452.0
3.78533, 11461.0
3.786, 11469.0
3.78667, 11477.0
3.78733, 11486.0
3.788, 11494.0
3.78867, 11503.0
3.78933, 11512.0
3.79, 11520.0
3.79067, 11529.0
3.79133, 11538.0
3.792, 11547.0
3.79267, 11557.0
3.79333, 11567.0
3.794, 11577.0
3.79467, 11588.0
3.79533, 11599.0
3.796, 11611.0
3.79667, 11624.0
3.79733, 11636.0
3.798, 11649.0
3.79867, 11662.0
3.79933, 11675.0
3.8, 11688.0
3.80067, 11700.0
3.80133, 11712.0
3.802, 11723.0
3.80267, 11734.0
3.80333, 11745.0
3.804, 11755.0
3.80467, 11765.0
3.80533, 11774.0
3.806, 11784.0
3.80667, 11792.0
3.80733, 11801.0
3.808, 11809.0
3.80867, 11816.0
3.80933, 11823.0
3.81, 11830.0
3.81067, 11836.0
3.81133, 11842.0
3.812, 11847.0
3.81267, 11851.0
3.81333, 11855.0
3.814, 11858.0
3.81467, 11860.0
3.81533, 11862.0
3.816, 11863.0
3.81667, 11864.0
3.81733, 11865.0
3.818, 11865.0
3.81867, 11865.0
3.81933, 11865.0
3.82, 11865.0
3.82067, 11864.0
3.82133, 11863.0
3.822, 11862.0
3.82267, 11861.0
3.82333, 11859.0
3.824, 11858.0
3.82467, 11856.0
3.82533, 11854.0
3.826, 11852.0
3.82667, 11849.0
3.82733, 11847.0
3.828, 11845.0
3.82867, 11843.0
3.82933, 11841.0
3.83, 11839.0
3.83067, 11838.0
3.83133, 11837.0
3.832, 11836.0
3.83267, 11836.0
3.83333, 11836.0
3.834, 11836.0
3.83467, 11836.0
3.83533, 11836.0
3.836, 11836.0
3.83667, 11835.0
3.83733, 11835.0
3.838, 11833.0
3.83867, 11832.0
3.83933, 11830.0
3.84, 11827.0
3.84067, 11823.0
3.84133, 11818.0
3.842, 11813.0
3.84267, 11807.0
3.84333, 11800.0
3.844, 11793.0
3.84467, 11787.0
3.84533, 11780.0
3.846, 11773.0
3.84667, 11766.0
3.84733, 11759.0
3.848, 11753.0
3.84867, 11746.0
3.84933, 11740.0
3.85, 11734.0
3.85067, 11728.0
3.85133, 11722.0
3.852, 11717.0
3.85267, 11712.0
3.85333, 11708.0
3.854, 11704.0
3.85467, 11700.0
3.85533, 11696.0
3.856, 11692.0
3.85667, 11688.0
3.85733, 11684.0
3.858, 11679.0
3.85867, 11674.0
3.85933, 11669.0
3.86, 11665.0
3.86067, 11661.0
3.86133, 11658.0
3.862, 11656.0
3.86267, 11655.0
3.86333, 11655.0
3.864, 11656.0
3.86467, 11658.0
3.86533, 11661.0
3.866, 11665.0
3.86667, 11670.0
3.86733, 11675.0
3.868, 11681.0
3.86867, 11687.0
3.86933, 11693.0
3.87, 11699.0
3.87067, 11705.0
3.87133, 11711.0
3.872, 11716.0
3.87267, 11722.0
3.87333, 11727.0
3.874, 11731.0
3.87467, 11736.0
3.87533, 11740.0
3.876, 11745.0
3.87667, 11749.0
3.87733, 11754.0
3.878, 11758.0
3.87867, 11762.0
3.87933, 11766.0
3.88, 11770.0
3.88067, 11773.0
3.88133, 11777.0
3.882, 11780.0
3.88267, 11783.0
3.88333, 11786.0
3.884, 11790.0
3.88467, 11794.0
3.88533, 11797.0
3.886, 11801.0
3.88667, 11806.0
3.88733, 11811.0
3.888, 11816.0
3.88867, 11821.0
3.88933, 11827.0
3.89, 11833.0
3.89067, 11839.0
3.89133, 11844.0
3.892, 11850.0
3.89267, 11854.0
3.89333, 11859.0
3.894, 11862.0
3.89467, 11866.0
3.89533, 11868.0
3.896, 11870.0
3.89667, 11872.0
3.89733, 11874.0
3.898, 11875.0
3.89867, 11876.0
3.89933, 11878.0
3.9, 11879.0
3.90067, 11880.0
3.90133, 11881.0
3.902, 11883.0
3.90267, 11885.0
3.90333, 11887.0
3.904, 11889.0
3.90467, 11891.0
3.90533, 11893.0
3.906, 11895.0
3.90667, 11897.0
3.90733, 11899.0
3.908, 11901.0
3.90867, 11903.0
3.90933, 11905.0
3.91, 11908.0
3.91067, 11910.0
3.91133, 11913.0
3.912, 11915.0
3.91267, 11918.0
3.91333, 11921.0
3.914, 11923.0
3.91467, 11925.0
3.91533, 11927.0
3.916, 11929.0
3.91667, 11930.0
3.91733, 11932.0
3.918, 11933.0
3.91867, 11934.0
3.91933, 11935.0
3.92, 11936.0
3.92067, 11938.0
3.92133, 11939.0
3.922, 11941.0
3.92267, 11943.0
3.92333, 11945.0
3.924, 11948.0
3.92467, 11951.0
3.92533, 11954.0
3.926, 11958.0
3.92667, 11961.0
3.92733, 11965.0
3.928, 11969.0
3.92867, 11973.0
3.92933, 11977.0
3.93, 11981.0
3.93067, 11986.0
3.93133, 11990.0
3.932, 11995.0
3.93267, 11999.0
3.93333, 12004.0
3.934, 12007.0
3.93467, 12010.0
3.93533, 12013.0
3.936, 12015.0
3.93667, 12016.0
3.93733, 12015.0
3.938, 12014.0
3.93867, 12012.0
3.93933, 12010.0
3.94, 12007.0
3.94067, 12003.0
3.94133, 11999.0
3.942, 11995.0
3.94267, 11990.0
3.94333, 11986.0
3.944, 11981.0
3.94467, 11976.0
3.94533, 11970.0
3.946, 11965.0
3.94667, 11959.0
3.94733, 11954.0
3.948, 11948.0
3.94867, 11942.0
3.94933, 11935.0
3.95, 11929.0
3.95067, 11923.0
3.95133, 11917.0
3.952, 11911.0
3.95267, 11906.0
3.95333, 11901.0
3.954, 11896.0
3.95467, 11891.0
3.95533, 11887.0
3.956, 11884.0
3.95667, 11881.0
3.95733, 11879.0
3.958, 11877.0
3.95867, 11875.0
3.95933, 11875.0
3.96, 11874.0
3.96067, 11874.0
3.96133, 11874.0
3.962, 11874.0
3.96267, 11874.0
3.96333, 11874.0
3.964, 11874.0
3.96467, 11874.0
3.96533, 11875.0
3.966, 11876.0
3.96667, 11876.0
3.96733, 11877.0
3.968, 11877.0
3.96867, 11878.0
3.96933, 11879.0
3.97, 11880.0
3.97067, 11881.0
3.97133, 11882.0
3.972, 11883.0
3.97267, 11885.0
3.97333, 11886.0
3.974, 11888.0
3.97467, 11890.0
3.97533, 11891.0
3.976, 11893.0
3.97667, 11895.0
3.97733, 11897.0
3.978, 11899.0
3.97867, 11900.0
3.97933, 11901.0
3.98, 11903.0
3.98067, 11904.0
3.98133, 11904.0
3.982, 11904.0
3.98267, 11904.0
3.98333, 11903.0
3.984, 11902.0
3.98467, 11901.0
3.98533, 11899.0
3.986, 11897.0
3.98667, 11895.0
3.98733, 11891.0
3.988, 11888.0
3.98867, 11883.0
3.98933, 11878.0
3.99, 11873.0
3.99067, 11867.0
3.99133, 11861.0
3.992, 11856.0
3.99267, 11851.0
3.99333, 11846.0
3.994, 11842.0
3.99467, 11839.0
3.99533, 11836.0
3.996, 11834.0
3.99667, 11832.0
3.99733, 11831.0
3.998, 11830.0
3.99867, 11830.0
3.99933, 11831.0
4.0, 11832.0
4.00067, 11834.0
4.00133, 11836.0
4.002, 11840.0
4.00267, 11843.0
4.00333, 11848.0
4.004, 11853.0
4.00467, 11859.0
4.00533, 11866.0
4.006, 11872.0
4.00667, 11880.0
4.00733, 11887.0
4.008, 11895.0
4.00867, 11903.0
4.00933, 11911.0
4.01, 11919.0
4.01067, 11926.0
4.01133, 11934.0
4.012, 11941.0
4.01267, 11948.0
4.01333, 11954.0
4.014, 11960.0
4.01467, 11965.0
4.01533, 11970.0
4.016, 11975.0
4.01667, 11980.0
4.01733, 11985.0
4.018, 11990.0
4.01867, 11995.0
4.01933, 12000.0
4.02, 12006.0
4.02067, 12012.0
4.02133, 12019.0
4.022, 12025.0
4.02267, 12031.0
4.02333, 12038.0
4.024, 12044.0
4.02467, 12050.0
4.02533, 12056.0
4.026, 12061.0
4.02667, 12067.0
4.02733, 12074.0
4.028, 12080.0
4.02867, 12087.0
4.02933, 12095.0
4.03, 12103.0
4.03067, 12111.0
4.03133, 12120.0
4.032, 12130.0
4.03267, 12141.0
4.03333, 12152.0
4.034, 12165.0
4.03467, 12179.0
4.03533, 12194.0
4.036, 12209.0
4.03667, 12225.0
4.03733, 12243.0
4.038, 12261.0
4.03867, 12279.0
4.03933, 12299.0
4.04, 12319.0
4.04067, 12339.0
4.04133, 12359.0
4.042, 12380.0
4.04267, 12400.0
4.04333, 12420.0
4.044, 12440.0
4.04467, 12459.0
4.04533, 12477.0
4.046, 12494.0
4.04667, 12510.0
4.04733, 12525.0
4.048, 12539.0
4.04867, 12552.0
4.04933, 12565.0
4.05, 12577.0
4.05067, 12589.0
4.05133, 12601.0
4.052, 12612.0
4.05267, 12623.0
4.05333, 12634.0
4.054, 12646.0
4.05467, 12657.0
4.05533, 12668.0
4.056, 12680.0
4.05667, 12691.0
4.05733, 12701.0
4.058, 12711.0
4.05867, 12721.0
4.05933, 12730.0
4.06, 12738.0
4.06067, 12746.0
4.06133, 12753.0
4.062, 12759.0
4.06267, 12765.0
4.06333, 12769.0
4.064, 12773.0
4.06467, 12776.0
4.06533, 12779.0
4.066, 12780.0
4.06667, 12781.0
4.06733, 12782.0
4.068, 12782.0
4.06867, 12782.0
4.06933, 12782.0
4.07, 12782.0
4.07067, 12782.0
4.07133, 12783.0
4.072, 12784.0
4.07267, 12785.0
4.07333, 12786.0
4.074, 12787.0
4.07467, 12788.0
4.07533, 12790.0
4.076, 12791.0
4.07667, 12793.0
4.07733, 12795.0
4.078, 12797.0
4.07867, 12799.0
4.07933, 12801.0
4.08, 12804.0
4.08067, 12805.0
4.08133, 12807.0
4.082, 12809.0
4.08267, 12811.0
4.08333, 12812.0
4.084, 12813.0
4.08467, 12813.0
4.08533, 12813.0
4.086, 12812.0
4.08667, 12810.0
4.08733, 12807.0
4.088, 12802.0
4.08867, 12797.0
4.08933, 12791.0
4.09, 12784.0
4.09067, 12777.0
4.09133, 12770.0
4.092, 12763.0
4.09267, 12756.0
4.09333, 12749.0
4.094, 12743.0
4.09467, 12736.0
4.09533, 12730.0
4.096, 12724.0
4.09667, 12718.0
4.09733, 12712.0
4.098, 12706.0
4.09867, 12701.0
4.09933, 12695.0
4.1, 12689.0
4.10067, 12683.0
4.10133, 12677.0
4.102, 12671.0
4.10267, 12665.0
4.10333, 12659.0
4.104, 12654.0
4.10467, 12648.0
4.10533, 12642.0
4.106, 12637.0
4.10667, 12631.0
4.10733, 12626.0
4.108, 12620.0
4.10867, 12614.0
4.10933, 12607.0
4.11, 12601.0
4.11067, 12594.0
4.11133, 12587.0
4.112, 12580.0
4.11267, 12574.0
4.11333, 12569.0
4.114, 12564.0
4.11467, 12560.0
4.11533, 12558.0
4.116, 12556.0
4.11667, 12555.0
4.11733, 12554.0
4.118, 12555.0
4.11867, 12555.0
4.11933, 12556.0
4.12, 12557.0
4.12067, 12558.0
4.12133, 12560.0
4.122, 12562.0
4.12267, 12564.0
4.12333, 12567.0
4.124, 12569.0
4.12467, 12571.0
4.12533, 12574.0
4.126, 12576.0
4.12667, 12579.0
4.12733, 12581.0
4.128, 12583.0
4.12867, 12585.0
4.12933, 12587.0
4.13, 12588.0
4.13067, 12589.0
4.13133, 12589.0
4.132, 12590.0
4.13267, 12590.0
4.13333, 12591.0
4.134, 12592.0
4.13467, 12594.0
4.13533, 12596.0
4.136, 12599.0
4.13667, 12602.0
4.13733, 12606.0
4.138, 12610.0
4.13867, 12615.0
4.13933, 12620.0
4.14, 12626.0
4.14067, 12632.0
4.14133, 12640.0
4.142, 12648.0
4.14267, 12657.0
4.14333, 12668.0
4.144, 12678.0
4.14467, 12690.0
4.14533, 12702.0
4.146, 12714.0
4.14667, 12727.0
4.14733, 12739.0
4.148, 12752.0
4.14867, 12764.0
4.14933, 12776.0
4.15, 12788.0
4.15067, 12799.0
4.15133, 12811.0
4.152, 12823.0
4.15267, 12835.0
4.15333, 12846.0
4.154, 12858.0
4.15467, 12870.0
4.15533, 12882.0
4.156, 12893.0
4.15667, 12904.0
4.15733, 12914.0
4.158, 12924.0
4.15867, 12932.0
4.15933, 12939.0
4.16, 12946.0
4.16067, 12951.0
4.16133, 12954.0
4.162, 12957.0
4.16267, 12958.0
4.16333, 12958.0
4.164, 12958.0
4.16467, 12957.0
4.16533, 12955.0
4.166, 12954.0
4.16667, 12952.0
4.16733, 12950.0
4.168, 12947.0
4.16867, 12945.0
4.16933, 12942.0
4.17, 12939.0
4.17067, 12935.0
4.17133, 12930.0
4.172, 12925.0
4.17267, 12920.0
4.17333, 12915.0
4.174, 12910.0
4.17467, 12905.0
4.17533, 12900.0
4.176, 12895.0
4.17667, 12890.0
4.17733, 12885.0
4.178, 12880.0
4.17867, 12874.0
4.17933, 12869.0
4.18, 12863.0
4.18067, 12857.0
4.18133, 12852.0
4.182, 12846.0
4.18267, 12841.0
4.18333, 12835.0
4.184, 12831.0
4.18467, 12826.0
4.18533, 12823.0
4.186, 12820.0
4.18667, 12817.0
4.18733, 12816.0
4.188, 12816.0
4.18867, 12817.0
4.18933, 12819.0
4.19, 12821.0
4.19067, 12824.0
4.19133, 12828.0
4.192, 12832.0
4.19267, 12837.0
4.19333, 12842.0
4.194, 12847.0
4.19467, 12853.0
4.19533, 12859.0
4.196, 12865.0
4.19667, 12872.0
4.19733, 12878.0
4.198, 12886.0
4.19867, 12894.0
4.19933, 12903.0
4.2, 12913.0
4.20067, 12925.0
4.20133, 12937.0
4.202, 12950.0
4.20267, 12963.0
4.20333, 12977.0
4.204, 12991.0
4.20467, 13005.0
4.20533, 13018.0
4.206, 13031.0
4.20667, 13043.0
4.20733, 13054.0
4.208, 13065.0
4.20867, 13075.0
4.20933, 13084.0
4.21, 13092.0
4.21067, 13099.0
4.21133, 13106.0
4.212, 13112.0
4.21267, 13117.0
4.21333, 13121.0
4.214, 13125.0
4.21467, 13127.0
4.21533, 13129.0
4.216, 13131.0
4.21667, 13133.0
4.21733, 13134.0
4.218, 13136.0
4.21867, 13138.0
4.21933, 13139.0
4.22, 13141.0
4.22067, 13143.0
4.22133, 13145.0
4.222, 13147.0
4.22267, 13149.0
4.22333, 13152.0
4.224, 13155.0
4.22467, 13158.0
4.22533, 13161.0
4.226, 13165.0
4.22667, 13169.0
4.22733, 13173.0
4.228, 13177.0
4.22867, 13181.0
4.22933, 13185.0
4.23, 13189.0
4.23067, 13192.0
4.23133, 13195.0
4.232, 13198.0
4.23267, 13201.0
4.23333, 13203.0
4.234, 13206.0
4.23467, 13208.0
4.23533, 13211.0
4.236, 13214.0
4.23667, 13217.0
4.23733, 13221.0
4.238, 13225.0
4.23867, 13230.0
4.23933, 13235.0
4.24, 13240.0
4.24067, 13246.0
4.24133, 13252.0
4.242, 13258.0
4.24267, 13264.0
4.24333, 13270.0
4.244, 13276.0
4.24467, 13282.0
4.24533, 13288.0
4.246, 13293.0
4.24667, 13299.0
4.24733, 13304.0
4.248, 13308.0
4.24867, 13313.0
4.24933, 13316.0
4.25, 13320.0
4.25067, 13322.0
4.25133, 13325.0
4.252, 13326.0
4.25267, 13327.0
4.25333, 13327.0
4.254, 13326.0
4.25467, 13325.0
4.25533, 13324.0
4.256, 13322.0
4.25667, 13320.0
4.25733, 13318.0
4.258, 13317.0
4.25867, 13315.0
4.25933, 13313.0
4.26, 13311.0
4.26067, 13309.0
4.26133, 13306.0
4.262, 13303.0
4.26267, 13300.0
4.26333, 13297.0
4.264, 13293.0
4.26467, 13290.0
4.26533, 13287.0
4.266, 13284.0
4.26667, 13282.0
4.26733, 13279.0
4.268, 13276.0
4.26867, 13274.0
4.26933, 13272.0
4.27, 13270.0
4.27067, 13268.0
4.27133, 13267.0
4.272, 13266.0
4.27267, 13266.0
4.27333, 13266.0
4.274, 13267.0
4.27467, 13268.0
4.27533, 13269.0
4.276, 13270.0
4.27667, 13272.0
4.27733, 13274.0
4.278, 13276.0
4.27867, 13278.0
4.27933, 13281.0
4.28, 13284.0
4.28067, 13287.0
4.28133, 13290.0
4.282, 13293.0
4.28267, 13297.0
4.28333, 13301.0
4.284, 13306.0
4.28467, 13310.0
4.28533, 13315.0
4.286, 13321.0
4.28667, 13326.0
4.28733, 13333.0
4.288, 13340.0
4.28867, 13347.0
4.28933, 13354.0
4.29, 13361.0
4.29067, 13368.0
4.29133, 13374.0
4.292, 13381.0
4.29267, 13387.0
4.29333, 13393.0
4.294, 13399.0
4.29467, 13405.0
4.29533, 13410.0
4.296, 13416.0
4.29667, 13421.0
4.29733, 13426.0
4.298, 13430.0
4.29867, 13435.0
4.29933, 13439.0
4.3, 13443.0
4.30067, 13447.0
4.30133, 13451.0
4.302, 13454.0
4.30267, 13458.0
4.30333, 13461.0
4.304, 13465.0
4.30467, 13468.0
4.30533, 13472.0
4.306, 13476.0
4.30667, 13480.0
4.30733, 13484.0
4.308, 13487.0
4.30867, 13491.0
4.30933, 13494.0
4.31, 13497.0
4.31067, 13499.0
4.31133, 13501.0
4.312, 13503.0
4.31267, 13505.0
4.31333, 13506.0
4.314, 13506.0
4.31467, 13506.0
4.31533, 13506.0
4.316, 13505.0
4.31667, 13505.0
4.31733, 13503.0
4.318, 13502.0
4.31867, 13501.0
4.31933, 13500.0
4.32, 13500.0
4.32067, 13500.0
4.32133, 13500.0
4.322, 13501.0
4.32267, 13502.0
4.32333, 13504.0
4.324, 13505.0
4.32467, 13507.0
4.32533, 13509.0
4.326, 13512.0
4.32667, 13515.0
4.32733, 13519.0
4.328, 13524.0
4.32867, 13529.0
4.32933, 13536.0
4.33, 13543.0
4.33067, 13551.0
4.33133, 13559.0
4.332, 13569.0
4.33267, 13579.0
4.33333, 13590.0
4.334, 13601.0
4.33467, 13611.0
4.33533, 13622.0
4.336, 13632.0
4.33667, 13641.0
4.33733, 13650.0
4.338, 13659.0
4.33867, 13668.0
4.33933, 13676.0
4.34, 13683.0
4.34067, 13691.0
4.34133, 13699.0
4.342, 13706.0
4.34267, 13714.0
4.34333, 13721.0
4.344, 13730.0
4.34467, 13738.0
4.34533, 13748.0
4.346, 13757.0
4.34667, 13767.0
4.34733, 13778.0
4.348, 13790.0
4.34867, 13802.0
4.34933, 13814.0
4.35, 13827.0
4.35067, 13839.0
4.35133, 13852.0
4.352, 13864.0
4.35267, 13876.0
4.35333, 13888.0
4.354, 13900.0
4.35467, 13911.0
4.35533, 13922.0
4.356, 13932.0
4.35667, 13942.0
4.35733, 13952.0
4.358, 13962.0
4.35867, 13971.0
4.35933, 13980.0
4.36, 13989.0
4.36067, 13998.0
4.36133, 14007.0
4.362, 14016.0
4.36267, 14024.0
4.36333, 14031.0
4.364, 14038.0
4.36467, 14045.0
4.36533, 14050.0
4.366, 14055.0
4.36667, 14059.0
4.36733, 14062.0
4.368, 14065.0
4.36867, 14067.0
4.36933, 14068.0
4.37, 14068.0
4.37067, 14067.0
4.37133, 14066.0
4.372, 14064.0
4.37267, 14061.0
4.37333, 14058.0
4.374, 14054.0
4.37467, 14050.0
4.37533, 14046.0
4.376, 14042.0
4.37667, 14038.0
4.37733, 14034.0
4.378, 14031.0
4.37867, 14028.0
4.37933, 14025.0
4.38, 14023.0
4.38067, 14022.0
4.38133, 14020.0
4.382, 14019.0
4.38267, 14018.0
4.38333, 14017.0
4.384, 14017.0
4.38467, 14017.0
4.38533, 14018.0
4.386, 14018.0
4.38667, 14019.0
4.38733, 14020.0
4.388, 14021.0
4.38867, 14021.0
4.38933, 14022.0
4.39, 14022.0
4.39067, 14021.0
4.39133, 14021.0
4.392, 14020.0
4.39267, 14019.0
4.39333, 14017.0
4.394, 14016.0
4.39467, 14013.0
4.39533, 14011.0
4.396, 14007.0
4.39667, 14004.0
4.39733, 14000.0
4.398, 13996.0
4.39867, 13992.0
4.39933, 13987.0
4.4, 13982.0
4.40067, 13977.0
4.40133, 13971.0
4.402, 13964.0
4.40267, 13956.0
4.40333, 13948.0
4.404, 13939.0
4.40467, 13930.0
4.40533, 13920.0
4.406, 13910.0
4.40667, 13900.0
4.40733, 13890.0
4.408, 13880.0
4.40867, 13870.0
4.40933, 13860.0
4.41, 13850.0
4.41067, 13840.0
4.41133, 13830.0
4.412, 13820.0
4.41267, 13811.0
4.41333, 13803.0
4.414, 13795.0
4.41467, 13787.0
4.41533, 13780.0
4.416, 13774.0
4.41667, 13769.0
4.41733, 13764.0
4.418, 13759.0
4.41867, 13755.0
4.41933, 13752.0
4.42, 13748.0
4.42067, 13745.0
4.42133, 13742.0
4.422, 13740.0
4.42267, 13738.0
4.42333, 13736.0
4.424, 13735.0
4.42467, 13735.0
4.42533, 13736.0
4.426, 13739.0
4.42667, 13742.0
4.42733, 13747.0
4.428, 13754.0
4.42867, 13761.0
4.42933, 13769.0
4.43, 13778.0
4.43067, 13787.0
4.43133, 13796.0
4.432, 13805.0
4.43267, 13814.0
4.43333, 13823.0
4.434, 13833.0
4.43467, 13842.0
4.43533, 13851.0
4.436, 13860.0
4.43667, 13870.0
4.43733, 13879.0
4.438, 13889.0
4.43867, 13899.0
4.43933, 13908.0
4.44, 13918.0
4.44067, 13928.0
4.44133, 13938.0
4.442, 13948.0
4.44267, 13958.0
4.44333, 13968.0
4.444, 13978.0
4.44467, 13987.0
4.44533, 13996.0
4.446, 14004.0
4.44667, 14012.0
4.44733, 14020.0
4.448, 14027.0
4.44867, 14035.0
4.44933, 14043.0
4.45, 14051.0
4.45067, 14059.0
4.45133, 14067.0
4.452, 14074.0
4.45267, 14082.0
4.45333, 14089.0
4.454, 14096.0
4.45467, 14103.0
4.45533, 14109.0
4.456, 14116.0
4.45667, 14123.0
4.45733, 14131.0
4.458, 14138.0
4.45867, 14147.0
4.45933, 14155.0
4.46, 14165.0
4.46067, 14175.0
4.46133, 14185.0
4.462, 14195.0
4.46267, 14206.0
4.46333, 14217.0
4.464, 14228.0
4.46467, 14240.0
4.46533, 14251.0
4.466, 14262.0
4.46667, 14274.0
4.46733, 14285.0
4.468, 14296.0
4.46867, 14307.0
4.46933, 14319.0
4.47, 14329.0
4.47067, 14340.0
4.47133, 14351.0
4.472, 14361.0
4.47267, 14372.0
4.47333, 14382.0
4.474, 14391.0
4.47467, 14401.0
4.47533, 14411.0
4.476, 14421.0
4.47667, 14431.0
4.47733, 14441.0
4.478, 14451.0
4.47867, 14461.0
4.47933, 14470.0
4.48, 14480.0
4.48067, 14489.0
4.48133, 14498.0
4.482, 14506.0
4.48267, 14513.0
4.48333, 14520.0
4.484, 14527.0
4.48467, 14532.0
4.48533, 14537.0
4.486, 14541.0
4.48667, 14544.0
4.48733, 14547.0
4.488, 14548.0
4.48867, 14549.0
4.48933, 14550.0
4.49, 14550.0
4.49067, 14550.0
4.49133, 14550.0
4.492, 14550.0
4.49267, 14549.0
4.49333, 14548.0
4.494, 14547.0
4.49467, 14546.0
4.49533, 14544.0
4.496, 14543.0
4.49667, 14541.0
4.49733, 14539.0
4.498, 14537.0
4.49867, 14534.0
4.49933, 14531.0
4.5, 14529.0
4.50067, 14526.0
4.50133, 14524.0
4.502, 14522.0
4.50267, 14520.0
4.50333, 14518.0
4.504, 14516.0
4.50467, 14515.0
4.50533, 14513.0
4.506, 14512.0
4.50667, 14510.0
4.50733, 14508.0
4.508, 14506.0
4.50867, 14504.0
4.50933, 14503.0
4.51, 14502.0
4.51067, 14501.0
4.51133, 14500.0
4.512, 14501.0
4.51267, 14502.0
4.51333, 14504.0
4.514, 14506.0
4.51467, 14510.0
4.51533, 14515.0
4.516, 14521.0
4.51667, 14528.0
4.51733, 14536.0
4.518, 14546.0
4.51867, 14556.0
4.51933, 14567.0
4.52, 14579.0
4.52067, 14592.0
4.52133, 14606.0
4.522, 14620.0
4.52267, 14635.0
4.52333, 14650.0
4.524, 14665.0
4.52467, 14680.0
4.52533, 14695.0
4.526, 14710.0
4.52667, 14725.0
4.52733, 14740.0
4.528, 14755.0
4.52867, 14770.0
4.52933, 14785.0
4.53, 14800.0
4.53067, 14815.0
4.53133, 14830.0
4.532, 14845.0
4.53267, 14860.0
4.53333, 14874.0
4.534, 14887.0
4.53467, 14899.0
4.53533, 14911.0
4.536, 14923.0
4.53667, 14934.0
4.53733, 14944.0
4.538, 14954.0
4.53867, 14963.0
4.53933, 14971.0
4.54, 14978.0
4.54067, 14985.0
4.54133, 14991.0
4.542, 14997.0
4.54267, 15002.0
4.54333, 15007.0
4.544, 15011.0
4.54467, 15016.0
4.54533, 15021.0
4.546, 15026.0
4.54667, 15032.0
4.54733, 15038.0
4.548, 15044.0
4.54867, 15050.0
4.54933, 15057.0
4.55, 15064.0
4.55067, 15072.0
4.55133, 15080.0
4.552, 15087.0
4.55267, 15096.0
4.55333, 15104.0
4.554, 15113.0
4.55467, 15122.0
4.55533, 15131.0
4.556, 15140.0
4.55667, 15150.0
4.55733, 15160.0
4.558, 15171.0
4.55867, 15182.0
4.55933, 15192.0
4.56, 15203.0
4.56067, 15214.0
4.56133, 15225.0
4.562, 15236.0
4.56267, 15247.0
4.56333, 15257.0
4.564, 15268.0
4.56467, 15278.0
4.56533, 15287.0
4.566, 15295.0
4.56667, 15303.0
4.56733, 15310.0
4.568, 15316.0
4.56867, 15321.0
4.56933, 15325.0
4.57, 15329.0
4.57067, 15332.0
4.57133, 15334.0
4.572, 15337.0
4.57267, 15339.0
4.57333, 15342.0
4.574, 15344.0
4.57467, 15348.0
4.57533, 15352.0
4.576, 15356.0
4.57667, 15361.0
4.57733, 15366.0
4.578, 15372.0
4.57867, 15378.0
4.57933, 15385.0
4.58, 15391.0
4.58067, 15398.0
4.58133, 15405.0
4.582, 15411.0
4.58267, 15417.0
4.58333, 15422.0
4.584, 15427.0
4.58467, 15432.0
4.58533, 15437.0
4.586, 15441.0
4.58667, 15445.0
4.58733, 15449.0
4.588, 15453.0
4.58867, 15457.0
4.58933, 15462.0
4.59, 15466.0
4.59067, 15469.0
4.59133, 15473.0
4.592, 15477.0
4.59267, 15481.0
4.59333, 15484.0
4.594, 15488.0
4.59467, 15492.0
4.59533, 15496.0
4.596, 15501.0
4.59667, 15505.0
4.59733, 15509.0
4.598, 15513.0
4.59867, 15518.0
4.59933, 15522.0
4.6, 15526.0
4.60067, 15530.0
4.60133, 15535.0
4.602, 15539.0
4.60267, 15543.0
4.60333, 15547.0
4.604, 15551.0
4.60467, 15555.0
4.60533, 15558.0
4.606, 15562.0
4.60667, 15565.0
4.60733, 15568.0
4.608, 15571.0
4.60867, 15574.0
4.60933, 15577.0
4.61, 15580.0
4.61067, 15583.0
4.61133, 15585.0
4.612, 15588.0
4.61267, 15591.0
4.61333, 15594.0
4.614, 15597.0
4.61467, 15600.0
4.61533, 15603.0
4.616, 15606.0
4.61667, 15609.0
4.61733, 15612.0
4.618, 15615.0
4.61867, 15618.0
4.61933, 15621.0
4.62, 15625.0
4.62067, 15630.0
4.62133, 15635.0
4.622, 15640.0
4.62267, 15646.0
4.62333, 15653.0
4.624, 15659.0
4.62467, 15666.0
4.62533, 15673.0
4.626, 15680.0
4.62667, 15686.0
4.62733, 15692.0
4.628, 15698.0
4.62867, 15704.0
4.62933, 15709.0
4.63, 15714.0
4.63067, 15719.0
4.63133, 15723.0
4.632, 15728.0
4.63267, 15732.0
4.63333, 15736.0
4.634, 15739.0
4.63467, 15742.0
4.63533, 15744.0
4.636, 15747.0
4.63667, 15748.0
4.63733, 15750.0
4.638, 15752.0
4.63867, 15754.0
4.63933, 15755.0
4.64, 15757.0
4.64067, 15758.0
4.64133, 15759.0
4.642, 15761.0
4.64267, 15762.0
4.64333, 15763.0
4.644, 15764.0
4.64467, 15766.0
4.64533, 15768.0
4.646, 15771.0
4.64667, 15774.0
4.64733, 15778.0
4.648, 15783.0
4.64867, 15788.0
4.64933, 15793.0
4.65, 15799.0
4.65067, 15805.0
4.65133, 15811.0
4.652, 15819.0
4.65267, 15826.0
4.65333, 15834.0
4.654, 15842.0
4.65467, 15851.0
4.65533, 15859.0
4.656, 15867.0
4.65667, 15875.0
4.65733, 15883.0
4.658, 15891.0
4.65867, 15899.0
4.65933, 15907.0
4.66, 15915.0
4.66067, 15922.0
4.66133, 15929.0
4.662, 15936.0
4.66267, 15942.0
4.66333, 15947.0
4.664, 15952.0
4.66467, 15956.0
4.66533, 15960.0
4.666, 15963.0
4.66667, 15966.0
4.66733, 15969.0
4.668, 15973.0
4.66867, 15977.0
4.66933, 15981.0
4.67, 15986.0
4.67067, 15992.0
4.67133, 15998.0
4.672, 16004.0
4.67267, 16010.0
4.67333, 16017.0
4.674, 16024.0
4.67467, 16031.0
4.67533, 16038.0
4.676, 16046.0
4.67667, 16053.0
4.67733, 16060.0
4.678, 16068.0
4.67867, 16075.0
4.67933, 16081.0
4.68, 16088.0
4.68067, 16094.0
4.68133, 16099.0
4.682, 16104.0
4.68267, 16107.0
4.68333, 16110.0
4.684, 16111.0
4.68467, 16112.0
4.68533, 16113.0
4.686, 16113.0
4.68667, 16112.0
4.68733, 16112.0
4.688, 16110.0
4.68867, 16109.0
4.68933, 16107.0
4.69, 16105.0
4.69067, 16102.0
4.69133, 16099.0
4.692, 16096.0
4.69267, 16092.0
4.69333, 16088.0
4.694, 16084.0
4.69467, 16080.0
4.69533, 16077.0
4.696, 16073.0
4.69667, 16070.0
4.69733, 16068.0
4.698, 16065.0
4.69867, 16063.0
4.69933, 16061.0
4.7, 16059.0
4.70067, 16057.0
4.70133, 16055.0
4.702, 16053.0
4.70267, 16050.0
4.70333, 16047.0
4.704, 16044.0
4.70467, 16040.0
4.70533, 16037.0
4.706, 16032.0
4.70667, 16027.0
4.70733, 16022.0
4.708, 16017.0
4.70867, 16011.0
4.70933, 16006.0
4.71, 16001.0
4.71067, 15996.0
4.71133, 15991.0
4.712, 15987.0
4.71267, 15982.0
4.71333, 15978.0
4.714, 15974.0
4.71467, 15971.0
4.71533, 15967.0
4.716, 15964.0
4.71667, 15960.0
4.71733, 15957.0
4.718, 15954.0
4.71867, 15951.0
4.71933, 15947.0
4.72, 15944.0
4.72067, 15941.0
4.72133, 15938.0
4.722, 15935.0
4.72267, 15933.0
4.72333, 15930.0
4.724, 15928.0
4.72467, 15926.0
4.72533, 15923.0
4.726, 15921.0
4.72667, 15919.0
4.72733, 15916.0
4.728, 15914.0
4.72867, 15912.0
4.72933, 15911.0
4.73, 15909.0
4.73067, 15908.0
4.73133, 15907.0
4.732, 15907.0
4.73267, 15907.0
4.73333, 15907.0
4.734, 15907.0
4.73467, 15908.0
4.73533, 15909.0
4.736, 15909.0
4.73667, 15910.0
4.73733, 15911.0
4.738, 15911.0
4.73867, 15911.0
4.73933, 15909.0
4.74, 15907.0
4.74067, 15905.0
4.74133, 15902.0
4.742, 15899.0
4.74267, 15896.0
4.74333, 15892.0
4.744, 15887.0
4.74467, 15883.0
4.74533, 15878.0
4.746, 15873.0
4.74667, 15868.0
4.74733, 15863.0
4.748, 15858.0
4.74867, 15853.0
4.74933, 15848.0
4.75, 15843.0
4.75067, 15839.0
4.75133, 15835.0
4.752, 15832.0
4.75267, 15828.0
4.75333, 15824.0
4.754, 15821.0
4.75467, 15818.0
4.75533, 15816.0
4.756, 15814.0
4.75667, 15812.0
4.75733, 15811.0
4.758, 15810.0
4.75867, 15810.0
4.75933, 15811.0
4.76, 15811.0
4.76067, 15813.0
4.76133, 15815.0
4.762, 15818.0
4.76267, 15821.0
4.76333, 15825.0
4.764, 15830.0
4.76467, 15836.0
4.76533, 15843.0
4.766, 15851.0
4.76667, 15860.0
4.76733, 15869.0
4.768, 15879.0
4.76867, 15890.0
4.76933, 15902.0
4.77, 15915.0
4.77067, 15928.0
4.77133, 15942.0
4.772, 15956.0
4.77267, 15970.0
4.77333, 15985.0
4.774, 16000.0
4.77467, 16015.0
4.77533, 16030.0
4.776, 16045.0
4.77667, 16060.0
4.77733, 16075.0
4.778, 16089.0
4.77867, 16103.0
4.77933, 16116.0
4.78, 16129.0
4.78067, 16141.0
4.78133, 16154.0
4.782, 16165.0
4.78267, 16176.0
4.78333, 16187.0
4.784, 16197.0
4.78467, 16205.0
4.78533, 16213.0
4.786, 16220.0
4.78667, 16225.0
4.78733, 16230.0
4.788, 16234.0
4.78867, 16237.0
4.78933, 16240.0
4.79, 16242.0
4.79067, 16244.0
4.79133, 16245.0
4.792, 16246.0
4.79267, 16247.0
4.79333, 16248.0
4.794, 16248.0
4.79467, 16248.0
4.79533, 16248.0
4.796, 16249.0
4.79667, 16249.0
4.79733, 16249.0
4.798, 16249.0
4.79867, 16250.0
4.79933, 16251.0
4.8, 16253.0
4.80067, 16254.0
4.80133, 16256.0
4.802, 16258.0
4.80267, 16260.0
4.80333, 16262.0
4.804, 16265.0
4.80467, 16268.0
4.80533, 16271.0
4.806, 16275.0
4.80667, 16278.0
4.80733, 16283.0
4.808, 16288.0
4.80867, 16294.0
4.80933, 16300.0
4.81, 16307.0
4.81067, 16315.0
4.81133, 16324.0
4.812, 16334.0
4.81267, 16346.0
4.81333, 16359.0
4.814, 16374.0
4.81467, 16390.0
4.81533, 16406.0
4.816, 16424.0
4.81667, 16442.0
4.81733, 16461.0
4.818, 16480.0
4.81867, 16499.0
4.81933, 16518.0
4.82, 16537.0
4.82067, 16556.0
4.82133, 16575.0
4.822, 16593.0
4.82267, 16611.0
4.82333, 16630.0
4.824, 16648.0
4.82467, 16666.0
4.82533, 16683.0
4.826, 16700.0
4.82667, 16717.0
4.82733, 16732.0
4.828, 16747.0
4.82867, 16760.0
4.82933, 16773.0
4.83, 16784.0
4.83067, 16794.0
4.83133, 16804.0
4.832, 16812.0
4.83267, 16819.0
4.83333, 16826.0
4.834, 16832.0
4.83467, 16837.0
4.83533, 16842.0
4.836, 16846.0
4.83667, 16849.0
4.83733, 16853.0
4.838, 16857.0
4.83867, 16861.0
4.83933, 16866.0
4.84, 16872.0
4.84067, 16878.0
4.84133, 16885.0
4.842, 16894.0
4.84267, 16903.0
4.84333, 16914.0
4.844, 16926.0
4.84467, 16939.0
4.84533, 16952.0
4.846, 16966.0
4.84667, 16980.0
4.84733, 16994.0
4.848, 17008.0
4.84867, 17021.0
4.84933, 17035.0
4.85, 17048.0
4.85067, 17060.0
4.85133, 17072.0
4.852, 17084.0
4.85267, 17094.0
4.85333, 17103.0
4.854, 17111.0
4.85467, 17117.0
4.85533, 17122.0
4.856, 17125.0
4.85667, 17127.0
4.85733, 17128.0
4.858, 17127.0
4.85867, 17126.0
4.85933, 17124.0
4.86, 17122.0
4.86067, 17119.0
4.86133, 17115.0
4.862, 17112.0
4.86267, 17107.0
4.86333, 17103.0
4.864, 17098.0
4.86467, 17093.0
4.86533, 17088.0
4.866, 17082.0
4.86667, 17076.0
4.86733, 17071.0
4.868, 17065.0
4.86867, 17060.0
4.86933, 17055.0
4.87, 17050.0
4.87067, 17046.0
4.87133, 17042.0
4.872, 17038.0
4.87267, 17035.0
4.87333, 17031.0
4.874, 17028.0
4.87467, 17025.0
4.87533, 17022.0
4.876, 17020.0
4.87667, 17017.0
4.87733, 17015.0
4.878, 17013.0
4.87867, 17011.0
4.87933, 17010.0
4.88, 17008.0
4.88067, 17007.0
4.88133, 17006.0
4.882, 17005.0
4.88267, 17005.0
4.88333, 17006.0
4.884, 17007.0
4.88467, 17010.0
4.88533, 17013.0
4.886, 17017.0
4.88667, 17022.0
4.88733, 17028.0
4.888, 17035.0
4.88867, 17042.0
4.88933, 17050.0
4.89, 17058.0
4.89067, 17065.0
4.89133, 17073.0
4.892, 17080.0
4.89267, 17086.0
4.89333, 17093.0
4.894, 17098.0
4.89467, 17104.0
4.89533, 17109.0
4.896, 17113.0
4.89667, 17118.0
4.89733, 17122.0
4.898, 17126.0
4.89867, 17130.0
4.89933, 17134.0
4.9, 17139.0
4.90067, 17143.0
4.90133, 17148.0
4.902, 17152.0
4.90267, 17157.0
4.90333, 17162.0
4.904, 17167.0
4.90467, 17172.0
4.90533, 17178.0
4.906, 17184.0
4.90667, 17190.0
4.90733, 17197.0
4.908, 17204.0
4.90867, 17211.0
4.90933, 17219.0
4.91, 17227.0
4.91067, 17235.0
4.91133, 17244.0
4.912, 17253.0
4.91267, 17262.0
4.91333, 17272.0
4.914, 17282.0
4.91467, 17292.0
4.91533, 17303.0
4.916, 17314.0
4.91667, 17325.0
4.91733, 17337.0
4.918, 17349.0
4.91867, 17361.0
4.91933, 17373.0
4.92, 17385.0
4.92067, 17397.0
4.92133, 17409.0
4.922, 17421.0
4.92267, 17432.0
4.92333, 17444.0
4.924, 17455.0
4.92467, 17465.0
4.92533, 17475.0
4.926, 17485.0
4.92667, 17494.0
4.92733, 17503.0
4.928, 17511.0
4.92867, 17519.0
4.92933, 17526.0
4.93, 17532.0
4.93067, 17539.0
4.93133, 17545.0
4.932, 17550.0
4.93267, 17556.0
4.93333, 17561.0
4.934, 17567.0
4.93467, 17572.0
4.93533, 17578.0
4.936, 17584.0
4.93667, 17591.0
4.93733, 17598.0
4.938, 17605.0
4.93867, 17613.0
4.93933, 17623.0
4.94, 17633.0
4.94067, 17644.0
4.94133, 17656.0
4.942, 17669.0
4.94267, 17682.0
4.94333, 17696.0
4.944, 17710.0
4.94467, 17724.0
4.94533, 17738.0
4.946, 17753.0
4.94667, 17767.0
4.94733, 17781.0
4.948, 17795.0
4.94867, 17808.0
4.94933, 17821.0
4.95, 17834.0
4.95067, 17847.0
4.95133, 17858.0
4.952, 17870.0
4.95267, 17880.0
4.95333, 17890.0
4.954, 17900.0
4.95467, 17909.0
4.95533, 17918.0
4.956, 17926.0
4.95667, 17933.0
4.95733, 17940.0
4.958, 17947.0
4.95867, 17953.0
4.95933, 17958.0
4.96, 17962.0
4.96067, 17965.0
4.96133, 17967.0
4.962, 17969.0
4.96267, 17971.0
4.96333, 17973.0
4.964, 17975.0
4.96467, 17977.0
4.96533, 17979.0
4.966, 17982.0
4.96667, 17986.0
4.96733, 17990.0
4.968, 17995.0
4.96867, 18001.0
4.96933, 18008.0
4.97, 18016.0
4.97067, 18025.0
4.97133, 18034.0
4.972, 18044.0
4.97267, 18054.0
4.97333, 18065.0
4.974, 18077.0
4.97467, 18090.0
4.97533, 18103.0
4.976, 18117.0
4.97667, 18132.0
4.97733, 18147.0
4.978, 18163.0
4.97867, 18179.0
4.97933, 18195.0
4.98, 18211.0
4.98067, 18226.0
4.98133, 18242.0
4.982, 18257.0
4.98267, 18271.0
4.98333, 18286.0
4.984, 18300.0
4.98467, 18314.0
4.98533, 18327.0
4.986, 18341.0
4.98667, 18355.0
4.98733, 18369.0
4.988, 18384.0
4.98867, 18398.0
4.98933, 18412.0
4.99, 18426.0
4.99067, 18440.0
4.99133, 18454.0
4.992, 18468.0
4.99267, 18481.0
4.99333, 18493.0
4.994, 18505.0
4.99467, 18516.0
4.99533, 18527.0
4.996, 18537.0
4.99667, 18545.0
4.99733, 18553.0
4.998, 18559.0
4.99867, 18565.0
4.99933, 18569.0
5.0, 18573.0
5.00067, 18575.0
5.00133, 18577.0
5.002, 18578.0
5.00267, 18579.0
5.00333, 18579.0
5.004, 18579.0
5.00467, 18579.0
5.00533, 18579.0
5.006, 18578.0
5.00667, 18577.0
5.00733, 18576.0
5.008, 18574.0
5.00867, 18573.0
5.00933, 18571.0
5.01, 18569.0
5.01067, 18568.0
5.01133, 18566.0
5.012, 18565.0
5.01267, 18564.0
5.01333, 18562.0
5.014, 18560.0
5.01467, 18558.0
5.01533, 18556.0
5.016, 18553.0
5.01667, 18551.0
5.01733, 18548.0
5.018, 18545.0
5.01867, 18542.0
5.01933, 18539.0
5.02, 18536.0
5.02067, 18533.0
5.02133, 18531.0
5.022, 18528.0
5.02267, 18526.0
5.02333, 18524.0
5.024, 18522.0
5.02467, 18521.0
5.02533, 18520.0
5.026, 18519.0
5.02667, 18518.0
5.02733, 18518.0
5.028, 18518.0
5.02867, 18518.0
5.02933, 18518.0
5.03, 18518.0
5.03067, 18519.0
5.03133, 18520.0
5.032, 18522.0
5.03267, 18524.0
5.03333, 18527.0
5.034, 18531.0
5.03467, 18536.0
5.03533, 18542.0
5.036, 18549.0
5.03667, 18557.0
5.03733, 18565.0
5.038, 18575.0
5.03867, 18585.0
5.03933, 18595.0
5.04, 18606.0
5.04067, 18616.0
5.04133, 18626.0
5.042, 18635.0
5.04267, 18645.0
5.04333, 18654.0
5.044, 18663.0
5.04467, 18671.0
5.04533, 18679.0
5.046, 18687.0
5.04667, 18695.0
5.04733, 18702.0
5.048, 18710.0
5.04867, 18717.0
5.04933, 18725.0
5.05, 18732.0
5.05067, 18739.0
5.05133, 18746.0
5.052, 18752.0
5.05267, 18757.0
5.05333, 18762.0
5.054, 18767.0
5.05467, 18770.0
5.05533, 18773.0
5.056, 18775.0
5.05667, 18776.0
5.05733, 18777.0
5.058, 18778.0
5.05867, 18778.0
5.05933, 18777.0
5.06, 18777.0
5.06067, 18776.0
5.06133, 18775.0
5.062, 18775.0
5.06267, 18774.0
5.06333, 18774.0
5.064, 18775.0
5.06467, 18776.0
5.06533, 18778.0
5.066, 18781.0
5.06667, 18785.0
5.06733, 18789.0
5.068, 18795.0
5.06867, 18802.0
5.06933, 18810.0
5.07, 18818.0
5.07067, 18827.0
5.07133, 18836.0
5.072, 18846.0
5.07267, 18855.0
5.07333, 18865.0
5.074, 18874.0
5.07467, 18883.0
5.07533, 18891.0
5.076, 18900.0
5.07667, 18907.0
5.07733, 18915.0
5.078, 18922.0
5.07867, 18929.0
5.07933, 18936.0
5.08, 18941.0
5.08067, 18946.0
5.08133, 18951.0
5.082, 18954.0
5.08267, 18956.0
5.08333, 18957.0
5.084, 18958.0
5.08467, 18958.0
5.08533, 18958.0
5.086, 18959.0
5.08667, 18959.0
5.08733, 18960.0
5.088, 18961.0
5.08867, 18963.0
5.08933, 18965.0
5.09, 18969.0
5.09067, 18973.0
5.09133, 18977.0
5.092, 18982.0
5.09267, 18988.0
5.09333, 18994.0
5.094, 19000.0
5.09467, 19006.0
5.09533, 19013.0
5.096, 19019.0
5.09667, 19026.0
5.09733, 19032.0
5.098, 19039.0
5.09867, 19045.0
5.09933, 19050.0
5.1, 19055.0
5.10067, 19060.0
5.10133, 19065.0
5.102, 19069.0
5.10267, 19074.0
5.10333, 19078.0
5.104, 19083.0
5.10467, 19088.0
5.10533, 19092.0
5.106, 19097.0
5.10667, 19101.0
5.10733, 19106.0
5.108, 19111.0
5.10867, 19117.0
5.10933, 19123.0
5.11, 19129.0
5.11067, 19136.0
5.11133, 19142.0
5.112, 19148.0
5.11267, 19153.0
5.11333, 19156.0
5.114, 19159.0
5.11467, 19161.0
5.11533, 19162.0
5.116, 19162.0
5.11667, 19162.0
5.11733, 19162.0
5.118, 19161.0
5.11867, 19160.0
5.11933, 19159.0
5.12, 19157.0
5.12067, 19155.0
5.12133, 19153.0
5.122, 19150.0
5.12267, 19148.0
5.12333, 19145.0
5.124, 19142.0
5.12467, 19139.0
5.12533, 19137.0
5.126, 19135.0
5.12667, 19133.0
5.12733, 19132.0
5.128, 19131.0
5.12867, 19129.0
5.12933, 19128.0
5.13, 19127.0
5.13067, 19125.0
5.13133, 19123.0
5.132, 19121.0
5.13267, 19119.0
5.13333, 19117.0
5.134, 19115.0
5.13467, 19114.0
5.13533, 19112.0
5.136, 19112.0
5.13667, 19111.0
5.13733, 19111.0
5.138, 19112.0
5.13867, 19113.0
5.13933, 19114.0
5.14, 19116.0
5.14067, 19118.0
5.14133, 19120.0
5.142, 19122.0
5.14267, 19124.0
5.14333, 19126.0
5.144, 19129.0
5.14467, 19132.0
5.14533, 19136.0
5.146, 19141.0
5.14667, 19146.0
5.14733, 19152.0
5.148, 19159.0
5.14867, 19167.0
5.14933, 19176.0
5.15, 19185.0
5.15067, 19194.0
5.15133, 19204.0
5.152, 19214.0
5.15267, 19224.0
5.15333, 19234.0
5.154, 19244.0
5.15467, 19254.0
5.15533, 19263.0
5.156, 19272.0
5.15667, 19281.0
5.15733, 19289.0
5.158, 19297.0
5.15867, 19305.0
5.15933, 19312.0
5.16, 19320.0
5.16067, 19327.0
5.16133, 19334.0
5.162, 19340.0
5.16267, 19346.0
5.16333, 19352.0
5.164, 19356.0
5.16467, 19360.0
5.16533, 19364.0
5.166, 19366.0
5.16667, 19368.0
5.16733, 19370.0
5.168, 19371.0
5.16867, 19371.0
5.16933, 19372.0
5.17, 19371.0
5.17067, 19371.0
5.17133, 19369.0
5.172, 19368.0
5.17267, 19366.0
5.17333, 19363.0
5.174, 19361.0
5.17467, 19357.0
5.17533, 19354.0
5.176, 19351.0
5.17667, 19348.0
5.17733, 19346.0
5.178, 19344.0
5.17867, 19342.0
5.17933, 19342.0
5.18, 19342.0
5.18067, 19344.0
5.18133, 19346.0
5.182, 19349.0
5.18267, 19352.0
5.18333, 19357.0
5.184, 19362.0
5.18467, 19367.0
5.18533, 19374.0
5.186, 19380.0
5.18667, 19387.0
5.18733, 19394.0
5.188, 19401.0
5.18867, 19407.0
5.18933, 19414.0
5.19, 19420.0
5.19067, 19426.0
5.19133, 19431.0
5.192, 19437.0
5.19267, 19442.0
5.19333, 19447.0
5.194, 19451.0
5.19467, 19454.0
5.19533, 19458.0
5.196, 19460.0
5.19667, 19462.0
5.19733, 19464.0
5.198, 19465.0
5.19867, 19466.0
5.19933, 19468.0
5.2, 19469.0
5.20067, 19470.0
5.20133, 19472.0
5.202, 19474.0
5.20267, 19476.0
5.20333, 19478.0
5.204, 19480.0
5.20467, 19483.0
5.20533, 19484.0
5.206, 19486.0
5.20667, 19487.0
5.20733, 19489.0
5.208, 19491.0
5.20867, 19493.0
5.20933, 19496.0
5.21, 19499.0
5.21067, 19502.0
5.21133, 19505.0
5.212, 19508.0
5.21267, 19511.0
5.21333, 19514.0
5.214, 19517.0
5.21467, 19521.0
5.21533, 19526.0
5.216, 19531.0
5.21667, 19537.0
5.21733, 19544.0
5.218, 19552.0
5.21867, 19561.0
5.21933, 19570.0
5.22, 19580.0
5.22067, 19590.0
5.22133, 19600.0
5.222, 19611.0
5.22267, 19621.0
5.22333, 19631.0
5.224, 19640.0
5.22467, 19649.0
5.22533, 19656.0
5.226, 19663.0
5.22667, 19669.0
5.22733, 19674.0
5.228, 19679.0
5.22867, 19683.0
5.22933, 19686.0
5.23, 19689.0
5.23067, 19691.0
5.23133, 19693.0
5.232, 19694.0
5.23267, 19697.0
5.23333, 19699.0
5.234, 19701.0
5.23467, 19704.0
5.23533, 19708.0
5.236, 19712.0
5.23667, 19716.0
5.23733, 19721.0
5.238, 19726.0
5.23867, 19731.0
5.23933, 19736.0
5.24, 19742.0
5.24067, 19747.0
5.24133, 19752.0
5.242, 19757.0
5.24267, 19762.0
5.24333, 19767.0
5.244, 19771.0
5.24467, 19775.0
5.24533, 19779.0
5.246, 19783.0
5.24667, 19787.0
5.24733, 19790.0
5.248, 19794.0
5.24867, 19798.0
5.24933, 19803.0
5.25, 19807.0
5.25067, 19811.0
5.25133, 19816.0
5.252, 19820.0
5.25267, 19825.0
5.25333, 19831.0
5.254, 19837.0
5.25467, 19844.0
5.25533, 19851.0
5.256, 19859.0
5.25667, 19867.0
5.25733, 19875.0
5.258, 19884.0
5.25867, 19894.0
5.25933, 19904.0
5.26, 19915.0
5.26067, 19926.0
5.26133, 19938.0
5.262, 19950.0
5.26267, 19962.0
5.26333, 19975.0
5.264, 19988.0
5.26467, 20000.0
5.26533, 20013.0
5.266, 20025.0
5.26667, 20038.0
5.26733, 20051.0
5.268, 20064.0
5.26867, 20078.0
5.26933, 20092.0
5.27, 20107.0
5.27067, 20123.0
5.27133, 20139.0
5.272, 20156.0
5.27267, 20174.0
5.27333, 20193.0
5.274, 20211.0
5.27467, 20230.0
5.27533, 20249.0
5.276, 20268.0
5.27667, 20287.0
5.27733, 20306.0
5.278, 20324.0
5.27867, 20342.0
5.27933, 20359.0
5.28, 20374.0
5.28067, 20389.0
5.28133, 20403.0
5.282, 20415.0
5.28267, 20428.0
5.28333, 20440.0
5.284, 20451.0
5.28467, 20461.0
5.28533, 20472.0
5.286, 20481.0
5.28667, 20491.0
5.28733, 20500.0
5.288, 20508.0
5.28867, 20516.0
5.28933, 20523.0
5.29, 20530.0
5.29067, 20537.0
5.29133, 20543.0
5.292, 20548.0
5.29267, 20553.0
5.29333, 20557.0
5.294, 20559.0
5.29467, 20561.0
5.29533, 20562.0
5.296, 20562.0
5.29667, 20561.0
5.29733, 20561.0
5.298, 20559.0
5.29867, 20557.0
5.29933, 20554.0
5.3, 20551.0
5.30067, 20547.0
5.30133, 20542.0
5.302, 20537.0
5.30267, 20531.0
5.30333, 20526.0
5.304, 20520.0
5.30467, 20515.0
5.30533, 20509.0
5.306, 20504.0
5.30667, 20500.0
5.30733, 20496.0
5.308, 20493.0
5.30867, 20491.0
5.30933, 20491.0
5.31, 20491.0
5.31067, 20491.0
5.31133, 20492.0
5.312, 20494.0
5.31267, 20495.0
5.31333, 20497.0
5.314, 20500.0
5.31467, 20502.0
5.31533, 20505.0
5.316, 20508.0
5.31667, 20511.0
5.31733, 20513.0
5.318, 20516.0
5.31867, 20520.0
5.31933, 20523.0
5.32, 20527.0
5.32067, 20531.0
5.32133, 20535.0
5.322, 20539.0
5.32267, 20543.0
5.32333, 20547.0
5.324, 20552.0
5.32467, 20558.0
5.32533, 20564.0
5.326, 20570.0
5.32667, 20577.0
5.32733, 20585.0
5.328, 20594.0
5.32867, 20604.0
5.32933, 20615.0
5.33, 20627.0
5.33067, 20640.0
5.33133, 20655.0
5.332, 20670.0
5.33267, 20687.0
5.33333, 20706.0
5.334, 20725.0
5.33467, 20745.0
5.33533, 20765.0
5.336, 20785.0
5.33667, 20806.0
5.33733, 20827.0
5.338, 20847.0
5.33867, 20868.0
5.33933, 20889.0
5.34, 20909.0
5.34067, 20930.0
5.34133, 20950.0
5.342, 20969.0
5.34267, 20988.0
5.34333, 21005.0
5.344, 21022.0
5.34467, 21038.0
5.34533, 21054.0
5.346, 21068.0
5.34667, 21082.0
5.34733, 21096.0
5.348, 21110.0
5.34867, 21123.0
5.34933, 21136.0
5.35, 21148.0
5.35067, 21160.0
5.35133, 21171.0
5.352, 21181.0
5.35267, 21191.0
5.35333, 21200.0
5.354, 21209.0
5.35467, 21218.0
5.35533, 21225.0
5.356, 21233.0
5.35667, 21240.0
5.35733, 21246.0
5.358, 21252.0
5.35867, 21258.0
5.35933, 21264.0
5.36, 21269.0
5.36067, 21273.0
5.36133, 21277.0
5.362, 21281.0
5.36267, 21283.0
5.36333, 21285.0
5.364, 21287.0
5.36467, 21287.0
5.36533, 21286.0
5.366, 21284.0
5.36667, 21280.0
5.36733, 21276.0
5.368, 21271.0
5.36867, 21265.0
5.36933, 21259.0
5.37, 21252.0
5.37067, 21245.0
5.37133, 21239.0
5.372, 21233.0
5.37267, 21228.0
5.37333, 21224.0
5.374, 21221.0
5.37467, 21219.0
5.37533, 21219.0
5.376, 21221.0
5.37667, 21224.0
5.37733, 21228.0
5.378, 21235.0
5.37867, 21244.0
5.37933, 21255.0
5.38, 21268.0
5.38067, 21283.0
5.38133, 21299.0
5.382, 21317.0
5.38267, 21336.0
5.38333, 21356.0
5.384, 21376.0
5.38467, 21398.0
5.38533, 21420.0
5.386, 21443.0
5.38667, 21467.0
5.38733, 21492.0
5.388, 21517.0
5.38867, 21542.0
5.38933, 21569.0
5.39, 21595.0
5.39067, 21622.0
5.39133, 21649.0
5.392, 21676.0
5.39267, 21704.0
5.39333, 21731.0
5.394, 21757.0
5.39467, 21784.0
5.39533, 21811.0
5.396, 21837.0
5.39667, 21864.0
5.39733, 21891.0
5.398, 21917.0
5.39867, 21943.0
5.39933, 21968.0
5.4, 21993.0
5.40067, 22017.0
5.40133, 22039.0
5.402, 22060.0
5.40267, 22080.0
5.40333, 22099.0
5.404, 22117.0
5.40467, 22135.0
5.40533, 22152.0
5.406, 22169.0
5.40667, 22186.0
5.40733, 22203.0
5.408, 22221.0
5.40867, 22238.0
5.40933, 22256.0
5.41, 22273.0
5.41067, 22290.0
5.41133, 22307.0
5.412, 22323.0
5.41267, 22338.0
5.41333, 22352.0
5.414, 22366.0
5.41467, 22378.0
5.41533, 22390.0
5.416, 22401.0
5.41667, 22412.0
5.41733, 22422.0
5.418, 22432.0
5.41867, 22442.0
5.41933, 22451.0
5.42, 22461.0
5.42067, 22471.0
5.42133, 22480.0
5.422, 22489.0
5.42267, 22499.0
5.42333, 22508.0
5.424, 22516.0
5.42467, 22525.0
5.42533, 22534.0
5.426, 22543.0
5.42667, 22552.0
5.42733, 22561.0
5.428, 22570.0
5.42867, 22579.0
5.42933, 22588.0
5.43, 22596.0
5.43067, 22604.0
5.43133, 22612.0
5.432, 22619.0
5.43267, 22625.0
5.43333, 22631.0
5.434, 22636.0
5.43467, 22640.0
5.43533, 22645.0
5.436, 22649.0
5.43667, 22653.0
5.43733, 22659.0
5.438, 22665.0
5.43867, 22672.0
5.43933, 22681.0
5.44, 22692.0
5.44067, 22703.0
5.44133, 22717.0
5.442, 22732.0
5.44267, 22748.0
5.44333, 22766.0
5.444, 22785.0
5.44467, 22806.0
5.44533, 22827.0
5.446, 22849.0
5.44667, 22872.0
5.44733, 22895.0
5.448, 22919.0
5.44867, 22944.0
5.44933, 22969.0
5.45, 22995.0
5.45067, 23022.0
5.45133, 23050.0
5.452, 23078.0
5.45267, 23108.0
5.45333, 23138.0
5.454, 23168.0
5.45467, 23199.0
5.45533, 23231.0
5.456, 23263.0
5.45667, 23294.0
5.45733, 23326.0
5.458, 23357.0
5.45867, 23386.0
5.45933, 23415.0
5.46, 23442.0
5.46067, 23468.0
5.46133, 23492.0
5.462, 23514.0
5.46267, 23535.0
5.46333, 23555.0
5.464, 23573.0
5.46467, 23591.0
5.46533, 23608.0
5.466, 23625.0
5.46667, 23642.0
5.46733, 23658.0
5.468, 23673.0
5.46867, 23689.0
5.46933, 23704.0
5.47, 23719.0
5.47067, 23732.0
5.47133, 23745.0
5.472, 23758.0
5.47267, 23769.0
5.47333, 23779.0
5.474, 23789.0
5.47467, 23797.0
5.47533, 23805.0
5.476, 23811.0
5.47667, 23817.0
5.47733, 23821.0
5.478, 23824.0
5.47867, 23826.0
5.47933, 23828.0
5.48, 23828.0
5.48067, 23827.0
5.48133, 23826.0
5.482, 23825.0
5.48267, 23824.0
5.48333, 23823.0
5.484, 23823.0
5.48467, 23823.0
5.48533, 23825.0
5.486, 23828.0
5.48667, 23831.0
5.48733, 23836.0
5.488, 23842.0
5.48867, 23848.0
5.48933, 23856.0
5.49, 23864.0
5.49067, 23872.0
5.49133, 23881.0
5.492, 23890.0
5.49267, 23899.0
5.49333, 23909.0
5.494, 23919.0
5.49467, 23929.0
5.49533, 23939.0
5.496, 23950.0
5.49667, 23960.0
5.49733, 23971.0
5.498, 23983.0
5.49867, 23995.0
5.49933, 24008.0
5.5, 24022.0
5.50067, 24037.0
5.50133, 24053.0
5.502, 24070.0
5.50267, 24088.0
5.50333, 24106.0
5.504, 24126.0
5.50467, 24146.0
5.50533, 24167.0
5.506, 24189.0
5.50667, 24211.0
5.50733, 24234.0
5.508, 24258.0
5.50867, 24283.0
5.50933, 24309.0
5.51, 24335.0
5.51067, 24363.0
5.51133, 24392.0
5.512, 24421.0
5.51267, 24451.0
5.51333, 24481.0
5.514, 24512.0
5.51467, 24543.0
5.51533, 24575.0
5.516, 24606.0
5.51667, 24638.0
5.51733, 24670.0
5.518, 24702.0
5.51867, 24735.0
5.51933, 24767.0
5.52, 24799.0
5.52067, 24831.0
5.52133, 24863.0
5.522, 24894.0
5.52267, 24925.0
5.52333, 24955.0
5.524, 24983.0
5.52467, 25011.0
5.52533, 25037.0
5.526, 25061.0
5.52667, 25083.0
5.52733, 25104.0
5.528, 25122.0
5.52867, 25140.0
5.52933, 25155.0
5.53, 25169.0
5.53067, 25182.0
5.53133, 25193.0
5.532, 25204.0
5.53267, 25213.0
5.53333, 25222.0
5.534, 25230.0
5.53467, 25238.0
5.53533, 25244.0
5.536, 25251.0
5.53667, 25257.0
5.53733, 25262.0
5.538, 25268.0
5.53867, 25273.0
5.53933, 25278.0
5.54, 25283.0
5.54067, 25289.0
5.54133, 25294.0
5.542, 25300.0
5.54267, 25306.0
5.54333, 25313.0
5.544, 25322.0
5.54467, 25331.0
5.54533, 25342.0
5.546, 25354.0
5.54667, 25367.0
5.54733, 25381.0
5.548, 25396.0
5.54867, 25413.0
5.54933, 25431.0
5.55, 25450.0
5.55067, 25471.0
5.55133, 25493.0
5.552, 25516.0
5.55267, 25540.0
5.55333, 25564.0
5.554, 25589.0
5.55467, 25614.0
5.55533, 25639.0
5.556, 25664.0
5.55667, 25691.0
5.55733, 25717.0
5.558, 25745.0
5.55867, 25773.0
5.55933, 25801.0
5.56, 25830.0
5.56067, 25860.0
5.56133, 25890.0
5.562, 25920.0
5.56267, 25951.0
5.56333, 25982.0
5.564, 26014.0
5.56467, 26047.0
5.56533, 26080.0
5.566, 26115.0
5.56667, 26150.0
5.56733, 26186.0
5.568, 26222.0
5.56867, 26259.0
5.56933, 26296.0
5.57, 26332.0
5.57067, 26368.0
5.57133, 26403.0
5.572, 26437.0
5.57267, 26471.0
5.57333, 26505.0
5.574, 26538.0
5.57467, 26570.0
5.57533, 26602.0
5.576, 26634.0
5.57667, 26665.0
5.57733, 26696.0
5.578, 26727.0
5.57867, 26758.0
5.57933, 26788.0
5.58, 26818.0
5.58067, 26848.0
5.58133, 26878.0
5.582, 26907.0
5.58267, 26936.0
5.58333, 26965.0
5.584, 26994.0
5.58467, 27024.0
5.58533, 27052.0
5.586, 27081.0
5.58667, 27108.0
5.58733, 27136.0
5.588, 27163.0
5.58867, 27191.0
5.58933, 27219.0
5.59, 27247.0
5.59067, 27277.0
5.59133, 27308.0
5.592, 27340.0
5.59267, 27373.0
5.59333, 27407.0
5.594, 27442.0
5.59467, 27477.0
5.59533, 27513.0
5.596, 27549.0
5.59667, 27584.0
5.59733, 27619.0
5.598, 27654.0
5.59867, 27688.0
5.59933, 27720.0
5.6, 27752.0
5.60067, 27784.0
5.60133, 27814.0
5.602, 27844.0
5.60267, 27873.0
5.60333, 27902.0
5.604, 27929.0
5.60467, 27956.0
5.60533, 27983.0
5.606, 28008.0
5.60667, 28032.0
5.60733, 28056.0
5.608, 28078.0
5.60867, 28100.0
5.60933, 28120.0
5.61, 28140.0
5.61067, 28159.0
5.61133, 28178.0
5.612, 28197.0
5.61267, 28215.0
5.61333, 28234.0
5.614, 28252.0
5.61467, 28270.0
5.61533, 28288.0
5.616, 28306.0
5.61667, 28326.0
5.61733, 28346.0
5.618, 28368.0
5.61867, 28392.0
5.61933, 28417.0
5.62, 28443.0
5.62067, 28471.0
5.62133, 28501.0
5.622, 28532.0
5.62267, 28565.0
5.62333, 28599.0
5.624, 28635.0
5.62467, 28674.0
5.62533, 28714.0
5.626, 28756.0
5.62667, 28800.0
5.62733, 28845.0
5.628, 28892.0
5.62867, 28940.0
5.62933, 28989.0
5.63, 29039.0
5.63067, 29089.0
5.63133, 29139.0
5.632, 29189.0
5.63267, 29239.0
5.63333, 29290.0
5.634, 29340.0
5.63467, 29391.0
5.63533, 29442.0
5.636, 29493.0
5.63667, 29544.0
5.63733, 29596.0
5.638, 29648.0
5.63867, 29700.0
5.63933, 29754.0
5.64, 29808.0
5.64067, 29862.0
5.64133, 29917.0
5.642, 29971.0
5.64267, 30026.0
5.64333, 30080.0
5.644, 30133.0
5.64467, 30186.0
5.64533, 30239.0
5.646, 30291.0
5.64667, 30342.0
5.64733, 30393.0
5.648, 30443.0
5.64867, 30492.0
5.64933, 30540.0
5.65, 30587.0
5.65067, 30633.0
5.65133, 30677.0
5.652, 30720.0
5.65267, 30761.0
5.65333, 30800.0
5.654, 30837.0
5.65467, 30873.0
5.65533, 30906.0
5.656, 30939.0
5.65667, 30971.0
5.65733, 31001.0
5.658, 31032.0
5.65867, 31061.0
5.65933, 31090.0
5.66, 31118.0
5.66067, 31146.0
5.66133, 31173.0
5.662, 31200.0
5.66267, 31226.0
5.66333, 31251.0
5.664, 31276.0
5.66467, 31299.0
5.66533, 31322.0
5.666, 31343.0
5.66667, 31363.0
5.66733, 31382.0
5.668, 31401.0
5.66867, 31419.0
5.66933, 31436.0
5.67, 31453.0
5.67067, 31470.0
5.67133, 31487.0
5.672, 31505.0
5.67267, 31523.0
5.67333, 31541.0
5.674, 31562.0
5.67467, 31583.0
5.67533, 31607.0
5.676, 31632.0
5.67667, 31658.0
5.67733, 31686.0
5.678, 31715.0
5.67867, 31745.0
5.67933, 31777.0
5.68, 31809.0
5.68067, 31843.0
5.68133, 31879.0
5.682, 31917.0
5.68267, 31956.0
5.68333, 31998.0
5.684, 32043.0
5.68467, 32089.0
5.68533, 32137.0
5.686, 32187.0
5.68667, 32238.0
5.68733, 32292.0
5.688, 32346.0
5.68867, 32401.0
5.68933, 32457.0
5.69, 32513.0
5.69067, 32568.0
5.69133, 32623.0
5.692, 32678.0
5.69267, 32731.0
5.69333, 32785.0
5.694, 32838.0
5.69467, 32890.0
5.69533, 32943.0
5.696, 32994.0
5.69667, 33045.0
5.69733, 33096.0
5.698, 33146.0
5.69867, 33195.0
5.69933, 33243.0
5.7, 33291.0
5.70067, 33337.0
5.70133, 33382.0
5.702, 33427.0
5.70267, 33470.0
5.70333, 33514.0
5.704, 33558.0
5.70467, 33602.0
5.70533, 33647.0
5.706, 33693.0
5.70667, 33740.0
5.70733, 33788.0
5.708, 33837.0
5.70867, 33887.0
5.70933, 33936.0
5.71, 33986.0
5.71067, 34035.0
5.71133, 34083.0
5.712, 34129.0
5.71267, 34174.0
5.71333, 34216.0
5.714, 34256.0
5.71467, 34295.0
5.71533, 34330.0
5.716, 34364.0
5.71667, 34395.0
5.71733, 34425.0
5.718, 34454.0
5.71867, 34481.0
5.71933, 34509.0
5.72, 34536.0
5.72067, 34562.0
5.72133, 34589.0
5.722, 34615.0
5.72267, 34642.0
5.72333, 34670.0
5.724, 34698.0
5.72467, 34728.0
5.72533, 34760.0
5.726, 34793.0
5.72667, 34829.0
5.72733, 34869.0
5.728, 34911.0
5.72867, 34957.0
5.72933, 35007.0
5.73, 35061.0
5.73067, 35120.0
5.73133, 35182.0
5.732, 35249.0
5.73267, 35319.0
5.73333, 35392.0
5.734, 35468.0
5.73467, 35546.0
5.73533, 35624.0
5.736, 35703.0
5.73667, 35780.0
5.73733, 35856.0
5.738, 35929.0
5.73867, 36000.0
5.73933, 36069.0
5.74, 36136.0
5.74067, 36200.0
5.74133, 36263.0
5.742, 36323.0
5.74267, 36381.0
5.74333, 36438.0
5.744, 36493.0
5.74467, 36547.0
5.74533, 36601.0
5.746, 36655.0
5.74667, 36709.0
5.74733, 36764.0
5.748, 36820.0
5.74867, 36877.0
5.74933, 36935.0
5.75, 36995.0
5.75067, 37056.0
5.75133, 37120.0
5.752, 37185.0
5.75267, 37253.0
5.75333, 37321.0
5.754, 37389.0
5.75467, 37459.0
5.75533, 37528.0
5.756, 37599.0
5.75667, 37670.0
5.75733, 37743.0
5.758, 37817.0
5.75867, 37892.0
5.75933, 37968.0
5.76, 38046.0
5.76067, 38126.0
5.76133, 38206.0
5.762, 38288.0
5.76267, 38370.0
5.76333, 38451.0
5.764, 38533.0
5.76467, 38614.0
5.76533, 38693.0
5.766, 38770.0
5.76667, 38844.0
5.76733, 38915.0
5.768, 38981.0
5.76867, 39042.0
5.76933, 39099.0
5.77, 39151.0
5.77067, 39199.0
5.77133, 39242.0
5.772, 39281.0
5.77267, 39317.0
5.77333, 39350.0
5.774, 39381.0
5.77467, 39411.0
5.77533, 39438.0
5.776, 39464.0
5.77667, 39489.0
5.77733, 39511.0
5.778, 39532.0
5.77867, 39550.0
5.77933, 39567.0
5.78, 39582.0
5.78067, 39595.0
5.78133, 39608.0
5.782, 39620.0
5.78267, 39631.0
5.78333, 39643.0
5.784, 39655.0
5.78467, 39668.0
5.78533, 39682.0
5.786, 39697.0
5.78667, 39713.0
5.78733, 39731.0
5.788, 39752.0
5.78867, 39776.0
5.78933, 39804.0
5.79, 39836.0
5.79067, 39873.0
5.79133, 39916.0
5.792, 39964.0
5.79267, 40018.0
5.79333, 40079.0
5.794, 40144.0
5.79467, 40215.0
5.79533, 40291.0
5.796, 40370.0
5.79667, 40454.0
5.79733, 40540.0
5.798, 40630.0
5.79867, 40721.0
5.79933, 40815.0
5.8, 40909.0
5.80067, 41004.0
5.80133, 41099.0
5.802, 41194.0
5.80267, 41289.0
5.80333, 41382.0
5.804, 41475.0
5.80467, 41565.0
5.80533, 41653.0
5.806, 41740.0
5.80667, 41824.0
5.80733, 41906.0
5.808, 41985.0
5.80867, 42062.0
5.80933, 42136.0
5.81, 42209.0
5.81067, 42278.0
5.81133, 42346.0
5.812, 42413.0
5.81267, 42478.0
5.81333, 42543.0
5.814, 42608.0
5.81467, 42673.0
5.81533, 42740.0
5.816, 42807.0
5.81667, 42876.0
5.81733, 42947.0
5.818, 43018.0
5.81867, 43090.0
5.81933, 43163.0
5.82, 43236.0
5.82067, 43309.0
5.82133, 43380.0
5.822, 43450.0
5.82267, 43517.0
5.82333, 43582.0
5.824, 43642.0
5.82467, 43697.0
5.82533, 43748.0
5.826, 43792.0
5.82667, 43830.0
5.82733, 43861.0
5.828, 43886.0
5.82867, 43904.0
5.82933, 43917.0
5.83, 43924.0
5.83067, 43926.0
5.83133, 43925.0
5.832, 43921.0
5.83267, 43915.0
5.83333, 43908.0
5.834, 43901.0
5.83467, 43895.0
5.83533, 43889.0
5.836, 43886.0
5.83667, 43885.0
5.83733, 43888.0
5.838, 43895.0
5.83867, 43908.0
5.83933, 43928.0
5.84, 43953.0
5.84067, 43986.0
5.84133, 44025.0
5.842, 44072.0
5.84267, 44125.0
5.84333, 44184.0
5.844, 44250.0
5.84467, 44321.0
5.84533, 44400.0
5.846, 44484.0
5.84667, 44575.0
5.84733, 44673.0
5.848, 44777.0
5.84867, 44888.0
5.84933, 45003.0
5.85, 45125.0
5.85067, 45250.0
5.85133, 45380.0
5.852, 45513.0
5.85267, 45649.0
5.85333, 45786.0
5.854, 45925.0
5.85467, 46065.0
5.85533, 46206.0
5.856, 46348.0
5.85667, 46491.0
5.85733, 46634.0
5.858, 46777.0
5.85867, 46919.0
5.85933, 47061.0
5.86, 47201.0
5.86067, 47338.0
5.86133, 47473.0
5.862, 47605.0
5.86267, 47734.0
5.86333, 47859.0
5.864, 47980.0
5.86467, 48098.0
5.86533, 48211.0
5.866, 48319.0
5.86667, 48423.0
5.86733, 48522.0
5.868, 48616.0
5.86867, 48706.0
5.86933, 48791.0
5.87, 48873.0
5.87067, 48952.0
5.87133, 49029.0
5.872, 49104.0
5.87267, 49178.0
5.87333, 49249.0
5.874, 49318.0
5.87467, 49385.0
5.87533, 49450.0
5.876, 49512.0
5.87667, 49571.0
5.87733, 49628.0
5.878, 49684.0
5.87867, 49738.0
5.87933, 49790.0
5.88, 49842.0
5.88067, 49893.0
5.88133, 49944.0
5.882, 49994.0
5.88267, 50044.0
5.88333, 50095.0
5.884, 50147.0
5.88467, 50201.0
5.88533, 50257.0
5.886, 50315.0
5.88667, 50377.0
5.88733, 50443.0
5.888, 50511.0
5.88867, 50583.0
5.88933, 50659.0
5.89, 50737.0
5.89067, 50818.0
5.89133, 50902.0
5.892, 50988.0
5.89267, 51076.0
5.89333, 51166.0
5.894, 51257.0
5.89467, 51349.0
5.89533, 51443.0
5.896, 51538.0
5.89667, 51635.0
5.89733, 51734.0
5.898, 51835.0
5.89867, 51938.0
5.89933, 52043.0
5.9, 52148.0
5.90067, 52255.0
5.90133, 52364.0
5.902, 52474.0
5.90267, 52585.0
5.90333, 52698.0
5.904, 52811.0
5.90467, 52923.0
5.90533, 53035.0
5.906, 53146.0
5.90667, 53254.0
5.90733, 53361.0
5.908, 53466.0
5.90867, 53570.0
5.90933, 53673.0
5.91, 53777.0
5.91067, 53883.0
5.91133, 53991.0
5.912, 54103.0
5.91267, 54218.0
5.91333, 54339.0
5.914, 54463.0
5.91467, 54592.0
5.91533, 54725.0
5.916, 54860.0
5.91667, 54997.0
5.91733, 55133.0
5.918, 55269.0
5.91867, 55403.0
5.91933, 55533.0
5.92, 55660.0
5.92067, 55781.0
5.92133, 55898.0
5.922, 56008.0
5.92267, 56112.0
5.92333, 56210.0
5.924, 56302.0
5.92467, 56388.0
5.92533, 56469.0
5.926, 56545.0
5.92667, 56617.0
5.92733, 56686.0
5.928, 56753.0
5.92867, 56818.0
5.92933, 56882.0
5.93, 56946.0
5.93067, 57008.0
5.93133, 57069.0
5.932, 57129.0
5.93267, 57187.0
5.93333, 57243.0
5.934, 57296.0
5.93467, 57346.0
5.93533, 57394.0
5.936, 57440.0
5.93667, 57485.0
5.93733, 57528.0
5.938, 57570.0
5.93867, 57612.0
5.93933, 57656.0
5.94, 57701.0
5.94067, 57750.0
5.94133, 57802.0
5.942, 57859.0
5.94267, 57921.0
5.94333, 57986.0
5.944, 58056.0
5.94467, 58128.0
5.94533, 58203.0
5.946, 58280.0
5.94667, 58359.0
5.94733, 58439.0
5.948, 58522.0
5.94867, 58607.0
5.94933, 58696.0
5.95, 58789.0
5.95067, 58886.0
5.95133, 58989.0
5.952, 59096.0
5.95267, 59210.0
5.95333, 59331.0
5.954, 59459.0
5.95467, 59595.0
5.95533, 59740.0
5.956, 59892.0
5.95667, 60052.0
5.95733, 60219.0
5.958, 60392.0
5.95867, 60569.0
5.95933, 60750.0
5.96, 60932.0
5.96067, 61116.0
5.96133, 61298.0
5.962, 61480.0
5.96267, 61659.0
5.96333, 61835.0
5.964, 62008.0
5.96467, 62177.0
5.96533, 62345.0
5.966, 62509.0
5.96667, 62672.0
5.96733, 62833.0
5.968, 62993.0
5.96867, 63150.0
5.96933, 63306.0
5.97, 63459.0
5.97067, 63611.0
5.97133, 63760.0
5.972, 63907.0
5.97267, 64050.0
5.97333, 64190.0
5.974, 64327.0
5.97467, 64460.0
5.97533, 64589.0
5.976, 64713.0
5.97667, 64833.0
5.97733, 64946.0
5.978, 65054.0
5.97867, 65155.0
5.97933, 65248.0
5.98, 65334.0
5.98067, 65412.0
5.98133, 65480.0
5.982, 65540.0
5.98267, 65591.0
5.98333, 65633.0
5.984, 65667.0
5.98467, 65693.0
5.98533, 65711.0
5.986, 65722.0
5.98667, 65727.0
5.98733, 65726.0
5.988, 65721.0
5.98867, 65712.0
5.98933, 65701.0
5.99, 65689.0
5.99067, 65678.0
5.99133, 65669.0
5.992, 65662.0
5.99267, 65660.0
5.99333, 65662.0
5.994, 65669.0
5.99467, 65683.0
5.99533, 65704.0
5.996, 65733.0
5.99667, 65771.0
5.99733, 65817.0
5.998, 65873.0
5.99867, 65938.0
5.99933, 66013.0
6.0, 66098.0
6.00067, 66194.0
6.00133, 66302.0
6.002, 66421.0
6.00267, 66552.0
6.00333, 66695.0
6.004, 66850.0
6.00467, 67017.0
6.00533, 67196.0
6.006, 67387.0
6.00667, 67589.0
6.00733, 67802.0
6.008, 68024.0
6.00867, 68255.0
6.00933, 68495.0
6.01, 68741.0
6.01067, 68994.0
6.01133, 69252.0
6.012, 69514.0
6.01267, 69780.0
6.01333, 70047.0
6.014, 70315.0
6.01467, 70582.0
6.01533, 70848.0
6.016, 71111.0
6.01667, 71372.0
6.01733, 71628.0
6.018, 71879.0
6.01867, 72123.0
6.01933, 72360.0
6.02, 72588.0
6.02067, 72807.0
6.02133, 73014.0
6.022, 73207.0
6.02267, 73387.0
6.02333, 73551.0
6.024, 73698.0
6.02467, 73830.0
6.02533, 73945.0
6.026, 74044.0
6.02667, 74128.0
6.02733, 74199.0
6.028, 74258.0
6.02867, 74306.0
6.02933, 74347.0
6.03, 74381.0
6.03067, 74410.0
6.03133, 74438.0
6.032, 74466.0
6.03267, 74494.0
6.03333, 74524.0
6.034, 74558.0
6.03467, 74594.0
6.03533, 74634.0
6.036, 74676.0
6.03667, 74719.0
6.03733, 74764.0
6.038, 74809.0
6.03867, 74855.0
6.03933, 74900.0
6.04, 74944.0
6.04067, 74988.0
6.04133, 75032.0
6.042, 75074.0
6.04267, 75117.0
6.04333, 75159.0
6.044, 75200.0
6.04467, 75242.0
6.04533, 75284.0
6.046, 75327.0
6.04667, 75371.0
6.04733, 75416.0
6.048, 75461.0
6.04867, 75507.0
6.04933, 75555.0
6.05, 75606.0
6.05067, 75662.0
6.05133, 75724.0
6.052, 75795.0
6.05267, 75877.0
6.05333, 75971.0
6.054, 76078.0
6.05467, 76200.0
6.05533, 76339.0
6.056, 76497.0
6.05667, 76674.0
6.05733, 76870.0
6.058, 77085.0
6.05867, 77317.0
6.05933, 77566.0
6.06, 77830.0
6.06067, 78105.0
6.06133, 78389.0
6.062, 78678.0
6.06267, 78970.0
6.06333, 79263.0
6.064, 79556.0
6.06467, 79847.0
6.06533, 80136.0
6.066, 80420.0
6.06667, 80699.0
6.06733, 80972.0
6.068, 81238.0
6.06867, 81496.0
6.06933, 81745.0
6.07, 81987.0
6.07067, 82220.0
6.07133, 82444.0
6.072, 82658.0
6.07267, 82859.0
6.07333, 83048.0
6.074, 83222.0
6.07467, 83383.0
6.07533, 83529.0
6.076, 83661.0
6.07667, 83781.0
6.07733, 83888.0
6.078, 83983.0
6.07867, 84067.0
6.07933, 84139.0
6.08, 84202.0
6.08067, 84256.0
6.08133, 84301.0
6.082, 84338.0
6.08267, 84368.0
6.08333, 84392.0
6.084, 84409.0
6.08467, 84421.0
6.08533, 84427.0
6.086, 84430.0
6.08667, 84429.0
6.08733, 84425.0
6.088, 84420.0
6.08867, 84414.0
6.08933, 84411.0
6.09, 84410.0
6.09067, 84414.0
6.09133, 84423.0
6.092, 84439.0
6.09267, 84463.0
6.09333, 84495.0
6.094, 84538.0
6.09467, 84591.0
6.09533, 84657.0
6.096, 84736.0
6.09667, 84829.0
6.09733, 84935.0
6.098, 85052.0
6.09867, 85180.0
6.09933, 85318.0
6.1, 85464.0
6.10067, 85617.0
6.10133, 85777.0
6.102, 85943.0
6.10267, 86113.0
6.10333, 86286.0
6.104, 86463.0
6.10467, 86643.0
6.10533, 86824.0
6.106, 87009.0
6.10667, 87196.0
6.10733, 87387.0
6.108, 87582.0
6.10867, 87779.0
6.10933, 87977.0
6.11, 88175.0
6.11067, 88372.0
6.11133, 88565.0
6.112, 88755.0
6.11267, 88942.0
6.11333, 89128.0
6.114, 89314.0
6.11467, 89500.0
6.11533, 89685.0
6.116, 89871.0
6.11667, 90056.0
6.11733, 90242.0
6.118, 90428.0
6.11867, 90616.0
6.11933, 90805.0
6.12, 90995.0
6.12067, 91186.0
6.12133, 91378.0
6.122, 91570.0
6.12267, 91761.0
6.12333, 91948.0
6.124, 92132.0
6.12467, 92309.0
6.12533, 92478.0
6.126, 92640.0
6.12667, 92792.0
6.12733, 92936.0
6.128, 93071.0
6.12867, 93194.0
6.12933, 93306.0
6.13, 93406.0
6.13067, 93494.0
6.13133, 93570.0
6.132, 93636.0
6.13267, 93693.0
6.13333, 93740.0
6.134, 93781.0
6.13467, 93817.0
6.13533, 93849.0
6.136, 93878.0
6.13667, 93906.0
6.13733, 93932.0
6.138, 93958.0
6.13867, 93982.0
6.13933, 94004.0
6.14, 94025.0
6.14067, 94044.0
6.14133, 94061.0
6.142, 94078.0
6.14267, 94095.0
6.14333, 94114.0
6.144, 94136.0
6.14467, 94163.0
6.14533, 94195.0
6.146, 94232.0
6.14667, 94277.0
6.14733, 94331.0
6.148, 94397.0
6.14867, 94475.0
6.14933, 94569.0
6.15, 94679.0
6.15067, 94805.0
6.15133, 94948.0
6.152, 95107.0
6.15267, 95281.0
6.15333, 95471.0
6.154, 95675.0
6.15467, 95891.0
6.15533, 96119.0
6.156, 96356.0
6.15667, 96601.0
6.15733, 96854.0
6.158, 97112.0
6.15867, 97376.0
6.15933, 97643.0
6.16, 97913.0
6.16067, 98185.0
6.16133, 98459.0
6.162, 98732.0
6.16267, 99003.0
6.16333, 99269.0
6.164, 99528.0
6.16467, 99778.0
6.16533, 100019.0
6.166, 100250.0
6.16667, 100472.0
6.16733, 100686.0
6.168, 100892.0
6.16867, 101090.0
6.16933, 101281.0
6.17, 101466.0
6.17067, 101643.0
6.17133, 101815.0
6.172, 101980.0
6.17267, 102138.0
6.17333, 102288.0
6.174, 102429.0
6.17467, 102559.0
6.17533, 102677.0
6.176, 102782.0
6.17667, 102876.0
6.17733, 102958.0
6.178, 103029.0
6.17867, 103091.0
6.17933, 103145.0
6.18, 103191.0
6.18067, 103230.0
6.18133, 103264.0
6.182, 103291.0
6.18267, 103314.0
6.18333, 103332.0
6.184, 103346.0
6.18467, 103355.0
6.18533, 103358.0
6.186, 103355.0
6.18667, 103346.0
6.18733, 103331.0
6.188, 103312.0
6.18867, 103291.0
6.18933, 103269.0
6.19, 103247.0
6.19067, 103225.0
6.19133, 103205.0
6.192, 103185.0
6.19267, 103169.0
6.19333, 103156.0
6.194, 103150.0
6.19467, 103153.0
6.19533, 103169.0
6.196, 103201.0
6.19667, 103251.0
6.19733, 103321.0
6.198, 103412.0
6.19867, 103524.0
6.19933, 103655.0
6.2, 103806.0
6.20067, 103974.0
6.20133, 104157.0
6.202, 104352.0
6.20267, 104557.0
6.20333, 104771.0
6.204, 104992.0
6.20467, 105220.0
6.20533, 105454.0
6.206, 105695.0
6.20667, 105940.0
6.20733, 106190.0
6.208, 106441.0
6.20867, 106692.0
6.20933, 106942.0
6.21, 107190.0
6.21067, 107434.0
6.21133, 107676.0
6.212, 107913.0
6.21267, 108147.0
6.21333, 108377.0
6.214, 108604.0
6.21467, 108825.0
6.21533, 109040.0
6.216, 109249.0
6.21667, 109452.0
6.21733, 109649.0
6.218, 109841.0
6.21867, 110026.0
6.21933, 110206.0
6.22, 110379.0
6.22067, 110545.0
6.22133, 110703.0
6.222, 110851.0
6.22267, 110991.0
6.22333, 111122.0
6.224, 111244.0
6.22467, 111357.0
6.22533, 111460.0
6.226, 111552.0
6.22667, 111631.0
6.22733, 111697.0
6.228, 111749.0
6.22867, 111787.0
6.22933, 111812.0
6.23, 111827.0
6.23067, 111834.0
6.23133, 111835.0
6.232, 111833.0
6.23267, 111829.0
6.23333, 111823.0
6.234, 111816.0
6.23467, 111810.0
6.23533, 111804.0
6.236, 111798.0
6.23667, 111792.0
6.23733, 111787.0
6.238, 111783.0
6.23867, 111780.0
6.23933, 111780.0
6.24, 111785.0
6.24067, 111796.0
6.24133, 111817.0
6.242, 111851.0
6.24267, 111901.0
6.24333, 111971.0
6.244, 112060.0
6.24467, 112170.0
6.24533, 112299.0
6.246, 112445.0
6.24667, 112607.0
6.24733, 112783.0
6.248, 112970.0
6.24867, 113165.0
6.24933, 113367.0
6.25, 113571.0
6.25067, 113776.0
6.25133, 113981.0
6.252, 114183.0
6.25267, 114383.0
6.25333, 114582.0
6.254, 114780.0
6.25467, 114979.0
6.25533, 115179.0
6.256, 115379.0
6.25667, 115581.0
6.25733, 115782.0
6.258, 115985.0
6.25867, 116188.0
6.25933, 116392.0
6.26, 116597.0
6.26067, 116801.0
6.26133, 117003.0
6.262, 117201.0
6.26267, 117394.0
6.26333, 117580.0
6.264, 117757.0
6.26467, 117926.0
6.26533, 118090.0
6.266, 118250.0
6.26667, 118409.0
6.26733, 118569.0
6.268, 118731.0
6.26867, 118898.0
6.26933, 119068.0
6.27, 119242.0
6.27067, 119418.0
6.27133, 119595.0
6.272, 119771.0
6.27267, 119944.0
6.27333, 120114.0
6.274, 120281.0
6.27467, 120446.0
6.27533, 120608.0
6.276, 120768.0
6.27667, 120928.0
6.27733, 121087.0
6.278, 121246.0
6.27867, 121404.0
6.27933, 121560.0
6.28, 121711.0
6.28067, 121854.0
6.28133, 121988.0
6.282, 122110.0
6.28267, 122217.0
6.28333, 122307.0
6.284, 122378.0
6.28467, 122428.0
6.28533, 122456.0
6.286, 122462.0
6.28667, 122445.0
6.28733, 122405.0
6.288, 122344.0
6.28867, 122261.0
6.28933, 122158.0
6.29, 122034.0
6.29067, 121889.0
6.29133, 121722.0
6.292, 121533.0
6.29267, 121322.0
6.29333, 121091.0
6.294, 120838.0
6.29467, 120567.0
6.29533, 120277.0
6.296, 119968.0
6.29667, 119642.0
6.29733, 119297.0
6.298, 118934.0
6.29867, 118553.0
6.29933, 118157.0
6.3, 117747.0
6.30067, 117326.0
6.30133, 116896.0
6.302, 116459.0
6.30267, 116016.0
6.30333, 115569.0
6.304, 115119.0
6.30467, 114666.0
6.30533, 114210.0
6.306, 113750.0
6.30667, 113286.0
6.30733, 112818.0
6.308, 112346.0
6.30867, 111871.0
6.30933, 111393.0
6.31, 110913.0
6.31067, 110435.0
6.31133, 109959.0
6.312, 109490.0
6.31267, 109030.0
6.31333, 108582.0
6.314, 108147.0
6.31467, 107727.0
6.31533, 107323.0
6.316, 106933.0
6.31667, 106558.0
6.31733, 106196.0
6.318, 105849.0
6.31867, 105514.0
6.31933, 105193.0
6.32, 104883.0
6.32067, 104585.0
6.32133, 104298.0
6.322, 104023.0
6.32267, 103760.0
6.32333, 103508.0
6.324, 103269.0
6.32467, 103040.0
6.32533, 102823.0
6.326, 102616.0
6.32667, 102419.0
6.32733, 102231.0
6.328, 102051.0
6.32867, 101878.0
6.32933, 101712.0
6.33, 101551.0
6.33067, 101396.0
6.33133, 101247.0
6.332, 101101.0
6.33267, 100961.0
6.33333, 100824.0
6.334, 100691.0
6.33467, 100562.0
6.33533, 100438.0
6.336, 100320.0
6.33667, 100209.0
6.33733, 100105.0
6.338, 100008.0
6.33867, 99919.0
6.33933, 99837.0
6.34, 99760.0
6.34067, 99690.0
6.34133, 99625.0
6.342, 99565.0
6.34267, 99509.0
6.34333, 99457.0
6.344, 99408.0
6.34467, 99364.0
6.34533, 99324.0
6.346, 99290.0
6.34667, 99262.0
6.34733, 99241.0
6.348, 99227.0
6.34867, 99221.0
6.34933, 99219.0
6.35, 99222.0
6.35067, 99227.0
6.35133, 99234.0
6.352, 99241.0
6.35267, 99246.0
6.35333, 99251.0
6.354, 99253.0
6.35467, 99252.0
6.35533, 99247.0
6.356, 99239.0
6.35667, 99227.0
6.35733, 99212.0
6.358, 99194.0
6.35867, 99176.0
6.35933, 99158.0
6.36, 99143.0
6.36067, 99130.0
6.36133, 99121.0
6.362, 99114.0
6.36267, 99109.0
6.36333, 99106.0
6.364, 99103.0
6.36467, 99100.0
6.36533, 99095.0
6.366, 99088.0
6.36667, 99078.0
6.36733, 99067.0
6.368, 99054.0
6.36867, 99042.0
6.36933, 99028.0
6.37, 99015.0
6.37067, 99002.0
6.37133, 98988.0
6.372, 98974.0
6.37267, 98960.0
6.37333, 98945.0
6.374, 98928.0
6.37467, 98908.0
6.37533, 98884.0
6.376, 98856.0
6.37667, 98822.0
6.37733, 98783.0
6.378, 98736.0
6.37867, 98682.0
6.37933, 98620.0
6.38, 98551.0
6.38067, 98474.0
6.38133, 98390.0
6.382, 98298.0
6.38267, 98198.0
6.38333, 98090.0
6.384, 97975.0
6.38467, 97853.0
6.38533, 97724.0
6.386, 97589.0
6.38667, 97446.0
6.38733, 97297.0
6.388, 97140.0
6.38867, 96974.0
6.38933, 96799.0
6.39, 96614.0
6.39067, 96417.0
6.39133, 96209.0
6.392, 95989.0
6.39267, 95760.0
6.39333, 95521.0
6.394, 95272.0
6.39467, 95015.0
6.39533, 94750.0
6.396, 94476.0
6.39667, 94195.0
6.39733, 93904.0
6.398, 93605.0
6.39867, 93296.0
6.39933, 92977.0
6.4, 92648.0
6.40067, 92309.0
6.40133, 91961.0
6.402, 91606.0
6.40267, 91242.0
6.40333, 90872.0
6.404, 90494.0
6.40467, 90108.0
6.40533, 89716.0
6.406, 89317.0
6.40667, 88913.0
6.40733, 88505.0
6.408, 88092.0
6.40867, 87678.0
6.40933, 87262.0
6.41, 86844.0
6.41067, 86427.0
6.41133, 86010.0
6.412, 85593.0
6.41267, 85176.0
6.41333, 84760.0
6.414, 84343.0
6.41467, 83927.0
6.41533, 83511.0
6.416, 83094.0
6.41667, 82677.0
6.41733, 82258.0
6.418, 81839.0
6.41867, 81418.0
6.41933, 80995.0
6.42, 80570.0
6.42067, 80143.0
6.42133, 79714.0
6.422, 79283.0
6.42267, 78850.0
6.42333, 78413.0
6.424, 77974.0
6.42467, 77533.0
6.42533, 77089.0
6.426, 76644.0
6.42667, 76198.0
6.42733, 75751.0
6.428, 75306.0
6.42867, 74862.0
6.42933, 74420.0
6.43, 73983.0
6.43067, 73550.0
6.43133, 73123.0
6.432, 72703.0
6.43267, 72289.0
6.43333, 71881.0
6.434, 71480.0
6.43467, 71086.0
6.43533, 70698.0
6.436, 70318.0
6.43667, 69945.0
6.43733, 69580.0
6.438, 69221.0
6.43867, 68870.0
6.43933, 68525.0
6.44, 68187.0
6.44067, 67856.0
6.44133, 67530.0
6.442, 67212.0
6.44267, 66901.0
6.44333, 66596.0
6.444, 66299.0
6.44467, 66009.0
6.44533, 65726.0
6.446, 65451.0
6.44667, 65183.0
6.44733, 64921.0
6.448, 64665.0
6.44867, 64414.0
6.44933, 64167.0
6.45, 63926.0
6.45067, 63688.0
6.45133, 63455.0
6.452, 63226.0
6.45267, 63001.0
6.45333, 62779.0
6.454, 62560.0
6.45467, 62343.0
6.45533, 62130.0
6.456, 61918.0
6.45667, 61709.0
6.45733, 61501.0
6.458, 61295.0
6.45867, 61091.0
6.45933, 60889.0
6.46, 60689.0
6.46067, 60491.0
6.46133, 60296.0
6.462, 60101.0
6.46267, 59908.0
6.46333, 59717.0
6.464, 59527.0
6.46467, 59340.0
6.46533, 59156.0
6.466, 58975.0
6.46667, 58797.0
6.46733, 58623.0
6.468, 58454.0
6.46867, 58288.0
6.46933, 58127.0
6.47, 57969.0
6.47067, 57815.0
6.47133, 57663.0
6.472, 57513.0
6.47267, 57364.0
6.47333, 57217.0
6.474, 57071.0
6.47467, 56927.0
6.47533, 56786.0
6.476, 56649.0
6.47667, 56515.0
6.47733, 56384.0
6.478, 56258.0
6.47867, 56136.0
6.47933, 56018.0
6.48, 55905.0
6.48067, 55797.0
6.48133, 55693.0
6.482, 55595.0
6.48267, 55501.0
6.48333, 55413.0
6.484, 55329.0
6.48467, 55249.0
6.48533, 55173.0
6.486, 55099.0
6.48667, 55027.0
6.48733, 54957.0
6.488, 54888.0
6.48867, 54820.0
6.48933, 54752.0
6.49, 54686.0
6.49067, 54621.0
6.49133, 54556.0
6.492, 54493.0
6.49267, 54430.0
6.49333, 54367.0
6.494, 54304.0
6.49467, 54240.0
6.49533, 54173.0
6.496, 54104.0
6.49667, 54033.0
6.49733, 53959.0
6.498, 53882.0
6.49867, 53805.0
6.49933, 53727.0
6.5, 53648.0
6.50067, 53570.0
6.50133, 53492.0
6.502, 53415.0
6.50267, 53339.0
6.50333, 53264.0
6.504, 53189.0
6.50467, 53115.0
6.50533, 53042.0
6.506, 52970.0
6.50667, 52899.0
6.50733, 52831.0
6.508, 52764.0
6.50867, 52699.0
6.50933, 52635.0
6.51, 52574.0
6.51067, 52518.0
6.51133, 52470.0
6.512, 52435.0
6.51267, 52426.0
6.51333, 52462.0
6.514, 52579.0
6.51467, 52836.0
6.51533, 53323.0
6.516, 54177.0
6.51667, 55582.0
6.51733, 57774.0
6.518, 61032.0
6.51867, 65667.0
6.51933, 71996.0
6.52, 80322.0
6.52067, 90913.0
6.52133, 103974.0
6.522, 119636.0
6.52267, 137944.0
6.52333, 158857.0
6.524, 182247.0
6.52467, 207914.0
6.52533, 235593.0
6.526, 264966.0
6.52667, 295681.0
6.52733, 327364.0
6.528, 359646.0
6.52867, 392172.0
6.52933, 424603.0
6.53, 456616.0
6.53067, 487916.0
6.53133, 518237.0
6.532, 547348.0
6.53267, 575054.0
6.53333, 601193.0
6.534, 625645.0
6.53467, 648321.0
6.53533, 669162.0
6.536, 688128.0
6.53667, 705202.0
6.53733, 720383.0
6.538, 733695.0
6.53867, 745174.0
6.53933, 754867.0
6.54, 762829.0
6.54067, 769119.0
6.54133, 773803.0
6.542, 776956.0
6.54267, 778660.0
6.54333, 778995.0
6.544, 778043.0
6.54467, 775881.0
6.54533, 772589.0
6.546, 768248.0
6.54667, 762934.0
6.54733, 756723.0
6.548, 749690.0
6.54867, 741910.0
6.54933, 733456.0
6.55, 724398.0
6.55067, 714807.0
6.55133, 704748.0
6.552, 694283.0
6.55267, 683467.0
6.55333, 672351.0
6.554, 660983.0
6.55467, 649410.0
6.55533, 637675.0
6.556, 625816.0
6.55667, 613869.0
6.55733, 601863.0
6.558, 589825.0
6.55867, 577781.0
6.55933, 565757.0
6.56, 553777.0
6.56067, 541861.0
6.56133, 530026.0
6.562, 518290.0
6.56267, 506667.0
6.56333, 495169.0
6.564, 483805.0
6.56467, 472585.0
6.56533, 461517.0
6.566, 450609.0
6.56667, 439871.0
6.56733, 429311.0
6.568, 418935.0
6.56867, 408749.0
6.56933, 398756.0
6.57, 388958.0
6.57067, 379359.0
6.57133, 369961.0
6.572, 360768.0
6.57267, 351780.0
6.57333, 342998.0
6.574, 334421.0
6.57467, 326049.0
6.57533, 317879.0
6.576, 309911.0
6.57667, 302140.0
6.57733, 294565.0
6.578, 287182.0
6.57867, 279988.0
6.57933, 272980.0
6.58, 266153.0
6.58067, 259502.0
6.58133, 253024.0
6.582, 246713.0
6.58267, 240566.0
6.58333, 234578.0
6.584, 228746.0
6.58467, 223066.0
6.58533, 217534.0
6.586, 212147.0
6.58667, 206902.0
6.58733, 201795.0
6.588, 196825.0
6.58867, 191988.0
6.58933, 187282.0
6.59, 182706.0
6.59067, 178259.0
6.59133, 173940.0
6.592, 169745.0
6.59267, 165675.0
6.59333, 161726.0
6.594, 157896.0
6.59467, 154184.0
6.59533, 150587.0
6.596, 147101.0
6.59667, 143726.0
6.59733, 140459.0
6.598, 137296.0
6.59867, 134235.0
6.59933, 131275.0
6.6, 128413.0
6.60067, 125648.0
6.60133, 122977.0
6.602, 120397.0
6.60267, 117907.0
6.60333, 115504.0
6.604, 113184.0
6.60467, 110947.0
6.60533, 108790.0
6.606, 106713.0
6.60667, 104715.0
6.60733, 102794.0
6.608, 100949.0
6.60867, 99179.0
6.60933, 97481.0
6.61, 95853.0
6.61067, 94291.0
6.61133, 92794.0
6.612, 91358.0
6.61267, 89980.0
6.61333, 88656.0
6.614, 87386.0
6.61467, 86167.0
6.61533, 84997.0
6.616, 83874.0
6.61667, 82798.0
6.61733, 81767.0
6.618, 80780.0
6.61867, 79834.0
6.61933, 78930.0
6.62, 78064.0
6.62067, 77234.0
6.62133, 76439.0
6.622, 75678.0
6.62267, 74947.0
6.62333, 74248.0
6.624, 73578.0
6.62467, 72936.0
6.62533, 72321.0
6.626, 71732.0
6.62667, 71167.0
6.62733, 70625.0
6.628, 70104.0
6.62867, 69602.0
6.62933, 69116.0
6.63, 68646.0
6.63067, 68189.0
6.63133, 67745.0
6.632, 67312.0
6.63267, 66889.0
6.63333, 66475.0
6.634, 66070.0
6.63467, 65671.0
6.63533, 65277.0
6.636, 64888.0
6.63667, 64503.0
6.63733, 64123.0
6.638, 63746.0
6.63867, 63376.0
6.63933, 63012.0
6.64, 62655.0
6.64067, 62307.0
6.64133, 61967.0
6.642, 61635.0
6.64267, 61313.0
6.64333, 60999.0
6.644, 60694.0
6.64467, 60399.0
6.64533, 60112.0
6.646, 59835.0
6.64667, 59567.0
6.64733, 59310.0
6.648, 59064.0
6.64867, 58829.0
6.64933, 58607.0
6.65, 58396.0
6.65067, 58197.0
6.65133, 58009.0
6.652, 57832.0
6.65267, 57663.0
6.65333, 57503.0
6.654, 57350.0
6.65467, 57203.0
6.65533, 57062.0
6.656, 56926.0
6.65667, 56793.0
6.65733, 56665.0
6.658, 56540.0
6.65867, 56420.0
6.65933, 56303.0
6.66, 56190.0
6.66067, 56079.0
6.66133, 55972.0
6.662, 55868.0
6.66267, 55766.0
6.66333, 55666.0
6.664, 55569.0
6.66467, 55474.0
6.66533, 55380.0
6.666, 55286.0
6.66667, 55192.0
6.66733, 55097.0
6.668, 55000.0
6.66867, 54902.0
6.66933, 54803.0
6.67, 54702.0
6.67067, 54601.0
6.67133, 54499.0
6.672, 54397.0
6.67267, 54296.0
6.67333, 54197.0
6.674, 54098.0
6.67467, 54002.0
6.67533, 53908.0
6.676, 53816.0
6.67667, 53726.0
6.67733, 53639.0
6.678, 53555.0
6.67867, 53474.0
6.67933, 53397.0
6.68, 53325.0
6.68067, 53258.0
6.68133, 53197.0
6.682, 53142.0
6.68267, 53091.0
6.68333, 53045.0
6.684, 53001.0
6.68467, 52960.0
6.68533, 52920.0
6.686, 52879.0
6.68667, 52836.0
6.68733, 52791.0
6.688, 52742.0
6.68867, 52689.0
6.68933, 52632.0
6.69, 52571.0
6.69067, 52507.0
6.69133, 52441.0
6.692, 52372.0
6.69267, 52302.0
6.69333, 52230.0
6.694, 52158.0
6.69467, 52086.0
6.69533, 52014.0
6.696, 51943.0
6.69667, 51872.0
6.69733, 51801.0
6.698, 51731.0
6.69867, 51660.0
6.69933, 51589.0
6.7, 51517.0
6.70067, 51445.0
6.70133, 51372.0
6.702, 51300.0
6.70267, 51229.0
6.70333, 51159.0
6.704, 51089.0
6.70467, 51022.0
6.70533, 50956.0
6.706, 50893.0
6.70667, 50831.0
6.70733, 50772.0
6.708, 50716.0
6.70867, 50662.0
6.70933, 50613.0
6.71, 50568.0
6.71067, 50529.0
6.71133, 50496.0
6.712, 50471.0
6.71267, 50455.0
6.71333, 50447.0
6.714, 50447.0
6.71467, 50457.0
6.71533, 50474.0
6.716, 50499.0
6.71667, 50531.0
6.71733, 50567.0
6.718, 50608.0
6.71867, 50652.0
6.71933, 50697.0
6.72, 50744.0
6.72067, 50790.0
6.72133, 50837.0
6.722, 50884.0
6.72267, 50933.0
6.72333, 50983.0
6.724, 51035.0
6.72467, 51091.0
6.72533, 51149.0
6.726, 51211.0
6.72667, 51276.0
6.72733, 51344.0
6.728, 51415.0
6.72867, 51489.0
6.72933, 51566.0
6.73, 51645.0
6.73067, 51725.0
6.73133, 51808.0
6.732, 51893.0
6.73267, 51979.0
6.73333, 52068.0
6.734, 52159.0
6.73467, 52251.0
6.73533, 52345.0
6.736, 52441.0
6.73667, 52536.0
6.73733, 52632.0
6.738, 52727.0
6.73867, 52820.0
6.73933, 52911.0
6.74, 53000.0
6.74067, 53086.0
6.74133, 53171.0
6.742, 53255.0
6.74267, 53339.0
6.74333, 53424.0
6.744, 53510.0
6.74467, 53600.0
6.74533, 53694.0
6.746, 53793.0
6.74667, 53897.0
6.74733, 54008.0
6.748, 54123.0
6.74867, 54243.0
6.74933, 54367.0
6.75, 54493.0
6.75067, 54621.0
6.75133, 54750.0
6.752, 54881.0
6.75267, 55011.0
6.75333, 55143.0
6.754, 55275.0
6.75467, 55409.0
6.75533, 55544.0
6.756, 55682.0
6.75667, 55821.0
6.75733, 55963.0
6.758, 56108.0
6.75867, 56254.0
6.75933, 56401.0
6.76, 56547.0
6.76067, 56693.0
6.76133, 56837.0
6.762, 56979.0
6.76267, 57120.0
6.76333, 57258.0
6.764, 57394.0
6.76467, 57528.0
6.76533, 57659.0
6.766, 57788.0
6.76667, 57913.0
6.76733, 58036.0
6.768, 58155.0
6.76867, 58269.0
6.76933, 58378.0
6.77, 58480.0
6.77067, 58577.0
6.77133, 58667.0
6.772, 58751.0
6.77267, 58831.0
6.77333, 58908.0
6.774, 58983.0
6.77467, 59057.0
6.77533, 59133.0
6.776, 59210.0
6.77667, 59291.0
6.77733, 59377.0
6.778, 59468.0
6.77867, 59566.0
6.77933, 59670.0
6.78, 59781.0
6.78067, 59899.0
6.78133, 60023.0
6.782, 60153.0
6.78267, 60288.0
6.78333, 60427.0
6.784, 60570.0
6.78467, 60717.0
6.78533, 60870.0
6.786, 61028.0
6.78667, 61192.0
6.78733, 61363.0
6.788, 61542.0
6.78867, 61727.0
6.78933, 61920.0
6.79, 62120.0
6.79067, 62326.0
6.79133, 62538.0
6.792, 62757.0
6.79267, 62983.0
6.79333, 63217.0
6.794, 63459.0
6.79467, 63710.0
6.79533, 63972.0
6.796, 64245.0
6.79667, 64530.0
6.79733, 64827.0
6.798, 65136.0
6.79867, 65457.0
6.79933, 65789.0
6.8, 66132.0
6.80067, 66484.0
6.80133, 66845.0
6.802, 67216.0
6.80267, 67597.0
6.80333, 67988.0
6.804, 68387.0
6.80467, 68795.0
6.80533, 69211.0
6.806, 69633.0
6.80667, 70060.0
6.80733, 70492.0
6.808, 70928.0
6.80867, 71367.0
6.80933, 71807.0
6.81, 72249.0
6.81067, 72692.0
6.81133, 73136.0
6.812, 73578.0
6.81267, 74018.0
6.81333, 74454.0
6.814, 74884.0
6.81467, 75306.0
6.81533, 75720.0
6.816, 76124.0
6.81667, 76516.0
6.81733, 76898.0
6.818, 77268.0
6.81867, 77626.0
6.81933, 77972.0
6.82, 78306.0
6.82067, 78627.0
6.82133, 78935.0
6.822, 79231.0
6.82267, 79514.0
6.82333, 79783.0
6.824, 80040.0
6.82467, 80284.0
6.82533, 80517.0
6.826, 80739.0
6.82667, 80953.0
6.82733, 81160.0
6.828, 81361.0
6.82867, 81557.0
6.82933, 81748.0
6.83, 81935.0
6.83067, 82118.0
6.83133, 82300.0
6.832, 82481.0
6.83267, 82664.0
6.83333, 82850.0
6.834, 83041.0
6.83467, 83237.0
6.83533, 83440.0
6.836, 83651.0
6.83667, 83869.0
6.83733, 84096.0
6.838, 84331.0
6.83867, 84573.0
6.83933, 84821.0
6.84, 85076.0
6.84067, 85337.0
6.84133, 85603.0
6.842, 85876.0
6.84267, 86156.0
6.84333, 86440.0
6.844, 86729.0
6.84467, 87020.0
6.84533, 87312.0
6.846, 87603.0
6.84667, 87893.0
6.84733, 88179.0
6.848, 88461.0
6.84867, 88738.0
6.84933, 89007.0
6.85, 89268.0
6.85067, 89521.0
6.85133, 89766.0
6.852, 90001.0
6.85267, 90227.0
6.85333, 90443.0
6.854, 90648.0
6.85467, 90843.0
6.85533, 91028.0
6.856, 91203.0
6.85667, 91369.0
6.85733, 91526.0
6.858, 91674.0
6.85867, 91813.0
6.85933, 91943.0
6.86, 92064.0
6.86067, 92177.0
6.86133, 92280.0
6.862, 92374.0
6.86267, 92459.0
6.86333, 92536.0
6.864, 92605.0
6.86467, 92668.0
6.86533, 92727.0
6.866, 92783.0
6.86667, 92838.0
6.86733, 92892.0
6.868, 92945.0
6.86867, 92998.0
6.86933, 93051.0
6.87, 93103.0
6.87067, 93156.0
6.87133, 93211.0
6.872, 93267.0
6.87267, 93325.0
6.87333, 93386.0
6.874, 93451.0
6.87467, 93518.0
6.87533, 93589.0
6.876, 93664.0
6.87667, 93742.0
6.87733, 93825.0
6.878, 93912.0
6.87867, 94002.0
6.87933, 94097.0
6.88, 94195.0
6.88067, 94297.0
6.88133, 94401.0
6.882, 94509.0
6.88267, 94619.0
6.88333, 94733.0
6.884, 94850.0
6.88467, 94972.0
6.88533, 95100.0
6.886, 95234.0
6.88667, 95374.0
6.88733, 95520.0
6.888, 95674.0
6.88867, 95834.0
6.88933, 96001.0
6.89, 96173.0
6.89067, 96349.0
6.89133, 96528.0
6.892, 96708.0
6.89267, 96888.0
6.89333, 97065.0
6.894, 97236.0
6.89467, 97402.0
6.89533, 97559.0
6.896, 97708.0
6.89667, 97846.0
6.89733, 97975.0
6.898, 98091.0
6.89867, 98194.0
6.89933, 98284.0
6.9, 98361.0
6.90067, 98425.0
6.90133, 98477.0
6.902, 98518.0
6.90267, 98548.0
6.90333, 98568.0
6.904, 98579.0
6.90467, 98583.0
6.90533, 98579.0
6.906, 98569.0
6.90667, 98552.0
6.90733, 98528.0
6.908, 98497.0
6.90867, 98461.0
6.90933, 98418.0
6.91, 98371.0
6.91067, 98321.0
6.91133, 98267.0
6.912, 98213.0
6.91267, 98159.0
6.91333, 98108.0
6.914, 98061.0
6.91467, 98017.0
6.91533, 97977.0
6.916, 97943.0
6.91667, 97913.0
6.91733, 97888.0
6.918, 97869.0
6.91867, 97856.0
6.91933, 97852.0
6.92, 97855.0
6.92067, 97866.0
6.92133, 97885.0
6.922, 97912.0
6.92267, 97946.0
6.92333, 97988.0
6.924, 98037.0
6.92467, 98095.0
6.92533, 98160.0
6.926, 98234.0
6.92667, 98316.0
6.92733, 98407.0
6.928, 98507.0
6.92867, 98617.0
6.92933, 98736.0
6.93, 98865.0
6.93067, 99003.0
6.93133, 99151.0
6.932, 99308.0
6.93267, 99473.0
6.93333, 99645.0
6.934, 99824.0
6.93467, 100009.0
6.93533, 100200.0
6.936, 100394.0
6.93667, 100589.0
6.93733, 100785.0
6.938, 100977.0
6.93867, 101165.0
6.93933, 101345.0
6.94, 101515.0
6.94067, 101675.0
6.94133, 101822.0
6.942, 101957.0
6.94267, 102079.0
6.94333, 102185.0
6.944, 102276.0
6.94467, 102350.0
6.94533, 102405.0
6.946, 102442.0
6.94667, 102460.0
6.94733, 102461.0
6.948, 102445.0
6.94867, 102414.0
6.94933, 102368.0
6.95, 102307.0
6.95067, 102232.0
6.95133, 102142.0
6.952, 102037.0
6.95267, 101917.0
6.95333, 101781.0
6.954, 101629.0
6.95467, 101460.0
6.95533, 101276.0
6.956, 101076.0
6.95667, 100862.0
6.95733, 100634.0
6.958, 100393.0
6.95867, 100141.0
6.95933, 99877.0
6.96, 99603.0
6.96067, 99320.0
6.96133, 99029.0
6.962, 98732.0
6.96267, 98429.0
6.96333, 98123.0
6.964, 97813.0
6.96467, 97500.0
6.96533, 97187.0
6.966, 96874.0
6.96667, 96561.0
6.96733, 96250.0
6.968, 95940.0
6.96867, 95631.0
6.96933, 95325.0
6.97, 95022.0
6.97067, 94722.0
6.97133, 94424.0
6.972, 94130.0
6.97267, 93838.0
6.97333, 93550.0
6.974, 93264.0
6.97467, 92981.0
6.97533, 92701.0
6.976, 92422.0
6.97667, 92145.0
6.97733, 91868.0
6.978, 91591.0
6.97867, 91314.0
6.97933, 91035.0
6.98, 90754.0
6.98067, 90472.0
6.98133, 90187.0
6.982, 89901.0
6.98267, 89612.0
6.98333, 89321.0
6.984, 89028.0
6.98467, 88733.0
6.98533, 88438.0
6.986, 88143.0
6.98667, 87849.0
6.98733, 87555.0
6.988, 87261.0
6.98867, 86968.0
6.98933, 86676.0
6.99, 86384.0
6.99067, 86091.0
6.99133, 85796.0
6.992, 85500.0
6.99267, 85201.0
6.99333, 84900.0
6.994, 84595.0
6.99467, 84288.0
6.99533, 83979.0
6.996, 83671.0
6.99667, 83364.0
6.99733, 83060.0
6.998, 82759.0
6.99867, 82463.0
6.99933, 82172.0
7.0, 81885.0
7.00067, 81602.0
7.00133, 81324.0
7.002, 81051.0
7.00267, 80781.0
7.00333, 80516.0
7.004, 80256.0
7.00467, 79999.0
7.00533, 79747.0
7.006, 79500.0
7.00667, 79255.0
7.00733, 79014.0
7.008, 78775.0
7.00867, 78538.0
7.00933, 78303.0
7.01, 78067.0
7.01067, 77831.0
7.01133, 77595.0
7.012, 77358.0
7.01267, 77120.0
7.01333, 76882.0
7.014, 76645.0
7.01467, 76408.0
7.01533, 76173.0
7.016, 75939.0
7.01667, 75707.0
7.01733, 75477.0
7.018, 75250.0
7.01867, 75025.0
7.01933, 74803.0
7.02, 74583.0
7.02067, 74364.0
7.02133, 74145.0
7.022, 73926.0
7.02267, 73706.0
7.02333, 73485.0
7.024, 73263.0
7.02467, 73042.0
7.02533, 72822.0
7.026, 72605.0
7.02667, 72390.0
7.02733, 72178.0
7.028, 71971.0
7.02867, 71768.0
7.02933, 71569.0
7.03, 71374.0
7.03067, 71183.0
7.03133, 70995.0
7.032, 70809.0
7.03267, 70626.0
7.03333, 70444.0
7.034, 70263.0
7.03467, 70083.0
7.03533, 69905.0
7.036, 69727.0
7.03667, 69550.0
7.03733, 69373.0
7.038, 69196.0
7.03867, 69019.0
7.03933, 68840.0
7.04, 68660.0
7.04067, 68479.0
7.04133, 68295.0
7.042, 68111.0
7.04267, 67926.0
7.04333, 67740.0
7.044, 67552.0
7.04467, 67364.0
7.04533, 67175.0
7.046, 66985.0
7.04667, 66793.0
7.04733, 66601.0
7.048, 66410.0
7.04867, 66219.0
7.04933, 66031.0
7.05, 65844.0
7.05067, 65658.0
7.05133, 65473.0
7.052, 65287.0
7.05267, 65102.0
7.05333, 64915.0
7.054, 64729.0
7.05467, 64541.0
7.05533, 64354.0
7.056, 64166.0
7.05667, 63979.0
7.05733, 63793.0
7.058, 63608.0
7.05867, 63424.0
7.05933, 63243.0
7.06, 63064.0
7.06067, 62890.0
7.06133, 62721.0
7.062, 62557.0
7.06267, 62400.0
7.06333, 62250.0
7.064, 62106.0
7.06467, 61967.0
7.06533, 61834.0
7.066, 61705.0
7.06667, 61580.0
7.06733, 61459.0
7.068, 61340.0
7.06867, 61224.0
7.06933, 61110.0
7.07, 60998.0
7.07067, 60887.0
7.07133, 60779.0
7.072, 60672.0
7.07267, 60567.0
7.07333, 60462.0
7.074, 60357.0
7.07467, 60253.0
7.07533, 60148.0
7.076, 60043.0
7.07667, 59939.0
7.07733, 59837.0
7.078, 59736.0
7.07867, 59636.0
7.07933, 59537.0
7.08, 59439.0
7.08067, 59340.0
7.08133, 59241.0
7.082, 59141.0
7.08267, 59039.0
7.08333, 58935.0
7.084, 58829.0
7.08467, 58721.0
7.08533, 58611.0
7.086, 58499.0
7.08667, 58386.0
7.08733, 58271.0
7.088, 58155.0
7.08867, 58038.0
7.08933, 57920.0
7.09, 57803.0
7.09067, 57686.0
7.09133, 57569.0
7.092, 57453.0
7.09267, 57338.0
7.09333, 57225.0
7.094, 57113.0
7.09467, 57003.0
7.09533, 56894.0
7.096, 56785.0
7.09667, 56676.0
7.09733, 56567.0
7.098, 56458.0
7.09867, 56348.0
7.09933, 56237.0
7.1, 56127.0
7.10067, 56016.0
7.10133, 55905.0
7.102, 55794.0
7.10267, 55682.0
7.10333, 55571.0
7.104, 55459.0
7.10467, 55349.0
7.10533, 55239.0
7.106, 55132.0
7.10667, 55027.0
7.10733, 54925.0
7.108, 54826.0
7.10867, 54730.0
7.10933, 54637.0
7.11, 54546.0
7.11067, 54456.0
7.11133, 54368.0
7.112, 54282.0
7.11267, 54196.0
7.11333, 54110.0
7.114, 54023.0
7.11467, 53936.0
7.11533, 53847.0
7.116, 53757.0
7.11667, 53665.0
7.11733, 53571.0
7.118, 53476.0
7.11867, 53380.0
7.11933, 53282.0
7.12, 53183.0
7.12067, 53083.0
7.12133, 52982.0
7.122, 52880.0
7.12267, 52779.0
7.12333, 52678.0
7.124, 52577.0
7.12467, 52476.0
7.12533, 52376.0
7.126, 52276.0
7.12667, 52177.0
7.12733, 52078.0
7.128, 51981.0
7.12867, 51884.0
7.12933, 51787.0
7.13, 51692.0
7.13067, 51598.0
7.13133, 51504.0
7.132, 51411.0
7.13267, 51319.0
7.13333, 51228.0
7.134, 51137.0
7.13467, 51046.0
7.13533, 50956.0
7.136, 50867.0
7.13667, 50779.0
7.13733, 50692.0
7.138, 50606.0
7.13867, 50521.0
7.13933, 50436.0
7.14, 50351.0
7.14067, 50266.0
7.14133, 50181.0
7.142, 50096.0
7.14267, 50011.0
7.14333, 49927.0
7.144, 49842.0
7.14467, 49757.0
7.14533, 49671.0
7.146, 49584.0
7.14667, 49497.0
7.14733, 49408.0
7.148, 49320.0
7.14867, 49232.0
7.14933, 49144.0
7.15, 49057.0
7.15067, 48971.0
7.15133, 48886.0
7.152, 48803.0
7.15267, 48722.0
7.15333, 48643.0
7.154, 48567.0
7.15467, 48493.0
7.15533, 48421.0
7.156, 48351.0
7.15667, 48283.0
7.15733, 48217.0
7.158, 48153.0
7.15867, 48089.0
7.15933, 48027.0
7.16, 47966.0
7.16067, 47905.0
7.16133, 47845.0
7.162, 47785.0
7.16267, 47726.0
7.16333, 47667.0
7.164, 47608.0
7.16467, 47549.0
7.16533, 47490.0
7.166, 47431.0
7.16667, 47372.0
7.16733, 47312.0
7.168, 47253.0
7.16867, 47193.0
7.16933, 47132.0
7.17, 47071.0
7.17067, 47010.0
7.17133, 46948.0
7.172, 46885.0
7.17267, 46821.0
7.17333, 46756.0
7.174, 46690.0
7.17467, 46623.0
7.17533, 46554.0
7.176, 46484.0
7.17667, 46412.0
7.17733, 46338.0
7.178, 46263.0
7.17867, 46187.0
7.17933, 46109.0
7.18, 46031.0
7.18067, 45951.0
7.18133, 45871.0
7.182, 45791.0
7.18267, 45710.0
7.18333, 45629.0
7.184, 45548.0
7.18467, 45468.0
7.18533, 45388.0
7.186, 45308.0
7.18667, 45229.0
7.18733, 45150.0
7.188, 45071.0
7.18867, 44993.0
7.18933, 44914.0
7.19, 44836.0
7.19067, 44758.0
7.19133, 44680.0
7.192, 44604.0
7.19267, 44529.0
7.19333, 44455.0
7.194, 44383.0
7.19467, 44312.0
7.19533, 44242.0
7.196, 44172.0
7.19667, 44104.0
7.19733, 44037.0
7.198, 43971.0
7.19867, 43906.0
7.19933, 43843.0
7.2, 43781.0
7.20067, 43721.0
7.20133, 43663.0
7.202, 43606.0
7.20267, 43551.0
7.20333, 43498.0
7.204, 43447.0
7.20467, 43398.0
7.20533, 43350.0
7.206, 43304.0
7.20667, 43260.0
7.20733, 43217.0
7.208, 43176.0
7.20867, 43135.0
7.20933, 43094.0
7.21, 43054.0
7.21067, 43014.0
7.21133, 42974.0
7.212, 42933.0
7.21267, 42892.0
7.21333, 42851.0
7.214, 42808.0
7.21467, 42764.0
7.21533, 42719.0
7.216, 42672.0
7.21667, 42623.0
7.21733, 42572.0
7.218, 42519.0
7.21867, 42464.0
7.21933, 42408.0
7.22, 42349.0
7.22067, 42290.0
7.22133, 42231.0
7.222, 42171.0
7.22267, 42111.0
7.22333, 42051.0
7.224, 41991.0
7.22467, 41930.0
7.22533, 41867.0
7.226, 41804.0
7.22667, 41739.0
7.22733, 41673.0
7.228, 41606.0
7.22867, 41538.0
7.22933, 41470.0
7.23, 41401.0
7.23067, 41333.0
7.23133, 41265.0
7.232, 41198.0
7.23267, 41132.0
7.23333, 41067.0
7.234, 41004.0
7.23467, 40942.0
7.23533, 40884.0
7.236, 40828.0
7.23667, 40775.0
7.23733, 40724.0
7.238, 40677.0
7.23867, 40634.0
7.23933, 40594.0
7.24, 40558.0
7.24067, 40525.0
7.24133, 40495.0
7.242, 40467.0
7.24267, 40442.0
7.24333, 40418.0
7.244, 40395.0
7.24467, 40371.0
7.24533, 40348.0
7.246, 40324.0
7.24667, 40300.0
7.24733, 40275.0
7.248, 40250.0
7.24867, 40225.0
7.24933, 40199.0
7.25, 40174.0
7.25067, 40148.0
7.25133, 40122.0
7.252, 40096.0
7.25267, 40069.0
7.25333, 40042.0
7.254, 40014.0
7.25467, 39984.0
7.25533, 39953.0
7.256, 39919.0
7.25667, 39883.0
7.25733, 39845.0
7.258, 39804.0
7.25867, 39761.0
7.25933, 39715.0
7.26, 39666.0
7.26067, 39616.0
7.26133, 39563.0
7.262, 39509.0
7.26267, 39454.0
7.26333, 39399.0
7.264, 39343.0
7.26467, 39287.0
7.26533, 39232.0
7.266, 39177.0
7.26667, 39122.0
7.26733, 39068.0
7.268, 39016.0
7.26867, 38964.0
7.26933, 38915.0
7.27, 38867.0
7.27067, 38820.0
7.27133, 38776.0
7.272, 38733.0
7.27267, 38691.0
7.27333, 38650.0
7.274, 38610.0
7.27467, 38571.0
7.27533, 38533.0
7.276, 38495.0
7.27667, 38458.0
7.27733, 38421.0
7.278, 38384.0
7.27867, 38348.0
7.27933, 38311.0
7.28, 38275.0
7.28067, 38240.0
7.28133, 38205.0
7.282, 38172.0
7.28267, 38140.0
7.28333, 38109.0
7.284, 38080.0
7.28467, 38051.0
7.28533, 38022.0
7.286, 37994.0
7.28667, 37966.0
7.28733, 37937.0
7.288, 37908.0
7.28867, 37877.0
7.28933, 37845.0
7.29, 37812.0
7.29067, 37776.0
7.29133, 37738.0
7.292, 37697.0
7.29267, 37654.0
7.29333, 37609.0
7.294, 37562.0
7.29467, 37513.0
7.29533, 37463.0
7.296, 37412.0
7.29667, 37359.0
7.29733, 37305.0
7.298, 37251.0
7.29867, 37195.0
7.29933, 37138.0
7.3, 37081.0
7.30067, 37023.0
7.30133, 36965.0
7.302, 36907.0
7.30267, 36848.0
7.30333, 36789.0
7.304, 36729.0
7.30467, 36669.0
7.30533, 36609.0
7.306, 36549.0
7.30667, 36490.0
7.30733, 36431.0
7.308, 36373.0
7.30867, 36316.0
7.30933, 36261.0
7.31, 36207.0
7.31067, 36156.0
7.31133, 36108.0
7.312, 36062.0
7.31267, 36020.0
7.31333, 35980.0
7.314, 35942.0
7.31467, 35907.0
7.31533, 35872.0
7.316, 35839.0
7.31667, 35807.0
7.31733, 35775.0
7.318, 35743.0
7.31867, 35711.0
7.31933, 35679.0
7.32, 35646.0
7.32067, 35612.0
7.32133, 35578.0
7.322, 35542.0
7.32267, 35505.0
7.32333, 35468.0
7.324, 35429.0
7.32467, 35391.0
7.32533, 35352.0
7.326, 35314.0
7.32667, 35277.0
7.32733, 35240.0
7.328, 35203.0
7.32867, 35168.0
7.32933, 35132.0
7.33, 35097.0
7.33067, 35063.0
7.33133, 35029.0
7.332, 34995.0
7.33267, 34961.0
7.33333, 34928.0
7.334, 34894.0
7.33467, 34861.0
7.33533, 34828.0
7.336, 34795.0
7.33667, 34762.0
7.33733, 34729.0
7.338, 34696.0
7.33867, 34665.0
7.33933, 34634.0
7.34, 34605.0
7.34067, 34576.0
7.34133, 34547.0
7.342, 34518.0
7.34267, 34488.0
7.34333, 34456.0
7.344, 34422.0
7.34467, 34387.0
7.34533, 34350.0
7.346, 34310.0
7.34667, 34270.0
7.34733, 34227.0
7.348, 34183.0
7.34867, 34138.0
7.34933, 34091.0
7.35, 34043.0
7.35067, 33993.0
7.35133, 33943.0
7.352, 33891.0
7.35267, 33840.0
7.35333, 33788.0
7.354, 33738.0
7.35467, 33689.0
7.35533, 33642.0
7.356, 33596.0
7.35667, 33553.0
7.35733, 33511.0
7.358, 33472.0
7.35867, 33434.0
7.35933, 33398.0
7.36, 33363.0
7.36067, 33329.0
7.36133, 33296.0
7.362, 33264.0
7.36267, 33232.0
7.36333, 33201.0
7.364, 33170.0
7.36467, 33140.0
7.36533, 33109.0
7.366, 33079.0
7.36667, 33050.0
7.36733, 33022.0
7.368, 32995.0
7.36867, 32970.0
7.36933, 32946.0
7.37, 32922.0
7.37067, 32900.0
7.37133, 32878.0
7.372, 32856.0
7.37267, 32835.0
7.37333, 32814.0
7.374, 32794.0
7.37467, 32774.0
7.37533, 32755.0
7.376, 32736.0
7.37667, 32718.0
7.37733, 32701.0
7.378, 32683.0
7.37867, 32666.0
7.37933, 32649.0
7.38, 32633.0
7.38067, 32617.0
7.38133, 32602.0
7.382, 32588.0
7.38267, 32575.0
7.38333, 32563.0
7.384, 32551.0
7.38467, 32541.0
7.38533, 32533.0
7.386, 32525.0
7.38667, 32518.0
7.38733, 32512.0
7.388, 32506.0
7.38867, 32500.0
7.38933, 32495.0
7.39, 32489.0
7.39067, 32482.0
7.39133, 32473.0
7.392, 32464.0
7.39267, 32452.0
7.39333, 32438.0
7.394, 32424.0
7.39467, 32408.0
7.39533, 32392.0
7.396, 32375.0
7.39667, 32358.0
7.39733, 32340.0
7.398, 32323.0
7.39867, 32305.0
7.39933, 32287.0
7.4, 32270.0
7.40067, 32253.0
7.40133, 32236.0
7.402, 32219.0
7.40267, 32202.0
7.40333, 32184.0
7.404, 32166.0
7.40467, 32148.0
7.40533, 32128.0
7.406, 32108.0
7.40667, 32088.0
7.40733, 32067.0
7.408, 32044.0
7.40867, 32021.0
7.40933, 31997.0
7.41, 31973.0
7.41067, 31948.0
7.41133, 31923.0
7.412, 31898.0
7.41267, 31874.0
7.41333, 31851.0
7.414, 31828.0
7.41467, 31807.0
7.41533, 31786.0
7.416, 31767.0
7.41667, 31749.0
7.41733, 31733.0
7.418, 31718.0
7.41867, 31704.0
7.41933, 31691.0
7.42, 31679.0
7.42067, 31667.0
7.42133, 31656.0
7.422, 31645.0
7.42267, 31634.0
7.42333, 31624.0
7.424, 31615.0
7.42467, 31606.0
7.42533, 31598.0
7.426, 31590.0
7.42667, 31583.0
7.42733, 31575.0
7.428, 31567.0
7.42867, 31559.0
7.42933, 31550.0
7.43, 31540.0
7.43067, 31529.0
7.43133, 31517.0
7.432, 31504.0
7.43267, 31490.0
7.43333, 31475.0
7.434, 31459.0
7.43467, 31442.0
7.43533, 31425.0
7.436, 31406.0
7.43667, 31386.0
7.43733, 31365.0
7.438, 31344.0
7.43867, 31321.0
7.43933, 31298.0
7.44, 31274.0
7.44067, 31249.0
7.44133, 31222.0
7.442, 31195.0
7.44267, 31167.0
7.44333, 31138.0
7.444, 31110.0
7.44467, 31081.0
7.44533, 31052.0
7.446, 31024.0
7.44667, 30997.0
7.44733, 30969.0
7.448, 30942.0
7.44867, 30915.0
7.44933, 30888.0
7.45, 30862.0
7.45067, 30837.0
7.45133, 30813.0
7.452, 30789.0
7.45267, 30767.0
7.45333, 30747.0
7.454, 30728.0
7.45467, 30710.0
7.45533, 30694.0
7.456, 30678.0
7.45667, 30664.0
7.45733, 30650.0
7.458, 30637.0
7.45867, 30623.0
7.45933, 30609.0
7.46, 30594.0
7.46067, 30578.0
7.46133, 30562.0
7.462, 30544.0
7.46267, 30526.0
7.46333, 30506.0
7.464, 30486.0
7.46467, 30464.0
7.46533, 30441.0
7.466, 30417.0
7.46667, 30392.0
7.46733, 30365.0
7.468, 30337.0
7.46867, 30308.0
7.46933, 30278.0
7.47, 30247.0
7.47067, 30216.0
7.47133, 30185.0
7.472, 30153.0
7.47267, 30122.0
7.47333, 30090.0
7.474, 30058.0
7.47467, 30026.0
7.47533, 29995.0
7.476, 29963.0
7.47667, 29931.0
7.47733, 29900.0
7.478, 29869.0
7.47867, 29838.0
7.47933, 29809.0
7.48, 29780.0
7.48067, 29752.0
7.48133, 29726.0
7.482, 29701.0
7.48267, 29677.0
7.48333, 29655.0
7.484, 29633.0
7.48467, 29611.0
7.48533, 29590.0
7.486, 29569.0
7.48667, 29547.0
7.48733, 29526.0
7.488, 29504.0
7.48867, 29482.0
7.48933, 29460.0
7.49, 29437.0
7.49067, 29415.0
7.49133, 29392.0
7.492, 29369.0
7.49267, 29346.0
7.49333, 29323.0
7.494, 29299.0
7.49467, 29275.0
7.49533, 29250.0
7.496, 29226.0
7.49667, 29201.0
7.49733, 29177.0
7.498, 29153.0
7.49867, 29130.0
7.49933, 29106.0
7.5, 29083.0
7.50067, 29061.0
7.50133, 29038.0
7.502, 29016.0
7.50267, 28994.0
7.50333, 28972.0
7.504, 28949.0
7.50467, 28928.0
7.50533, 28906.0
7.506, 28885.0
7.50667, 28863.0
7.50733, 28842.0
7.508, 28820.0
7.50867, 28799.0
7.50933, 28778.0
7.51, 28757.0
7.51067, 28736.0
7.51133, 28715.0
7.512, 28694.0
7.51267, 28672.0
7.51333, 28650.0
7.514, 28628.0
7.51467, 28605.0
7.51533, 28581.0
7.516, 28556.0
7.51667, 28531.0
7.51733, 28505.0
7.518, 28478.0
7.51867, 28450.0
7.51933, 28421.0
7.52, 28391.0
7.52067, 28361.0
7.52133, 28330.0
7.522, 28299.0
7.52267, 28268.0
7.52333, 28238.0
7.524, 28209.0
7.52467, 28181.0
7.52533, 28154.0
7.526, 28128.0
7.52667, 28104.0
7.52733, 28080.0
7.528, 28058.0
7.52867, 28036.0
7.52933, 28016.0
7.53, 27997.0
7.53067, 27979.0
7.53133, 27962.0
7.532, 27946.0
7.53267, 27930.0
7.53333, 27914.0
7.534, 27899.0
7.53467, 27884.0
7.53533, 27870.0
7.536, 27856.0
7.53667, 27843.0
7.53733, 27831.0
7.538, 27820.0
7.53867, 27809.0
7.53933, 27799.0
7.54, 27790.0
7.54067, 27781.0
7.54133, 27772.0
7.542, 27762.0
7.54267, 27753.0
7.54333, 27743.0
7.544, 27733.0
7.54467, 27722.0
7.54533, 27710.0
7.546, 27698.0
7.54667, 27685.0
7.54733, 27672.0
7.548, 27657.0
7.54867, 27642.0
7.54933, 27626.0
7.55, 27610.0
7.55067, 27593.0
7.55133, 27576.0
7.552, 27559.0
7.55267, 27542.0
7.55333, 27525.0
7.554, 27507.0
7.55467, 27490.0
7.55533, 27473.0
7.556, 27456.0
7.55667, 27439.0
7.55733, 27423.0
7.558, 27408.0
7.55867, 27392.0
7.55933, 27377.0
7.56, 27361.0
7.56067, 27346.0
7.56133, 27330.0
7.562, 27315.0
7.56267, 27299.0
7.56333, 27283.0
7.564, 27267.0
7.56467, 27251.0
7.56533, 27235.0
7.566, 27218.0
7.56667, 27202.0
7.56733, 27185.0
7.568, 27167.0
7.56867, 27149.0
7.56933, 27130.0
7.57, 27109.0
7.57067, 27087.0
7.57133, 27063.0
7.572, 27038.0
7.57267, 27011.0
7.57333, 26983.0
7.574, 26954.0
7.57467, 26924.0
7.57533, 26894.0
7.576, 26864.0
7.57667, 26833.0
7.57733, 26803.0
7.578, 26772.0
7.57867, 26742.0
7.57933, 26712.0
7.58, 26682.0
7.58067, 26653.0
7.58133, 26625.0
7.582, 26598.0
7.58267, 26572.0
7.58333, 26548.0
7.584, 26526.0
7.58467, 26506.0
7.58533, 26488.0
7.586, 26472.0
7.58667, 26457.0
7.58733, 26445.0
7.588, 26434.0
7.58867, 26424.0
7.58933, 26416.0
7.59, 26410.0
7.59067, 26404.0
7.59133, 26399.0
7.592, 26396.0
7.59267, 26393.0
7.59333, 26390.0
7.594, 26389.0
7.59467, 26387.0
7.59533, 26386.0
7.596, 26384.0
7.59667, 26382.0
7.59733, 26380.0
7.598, 26377.0
7.59867, 26373.0
7.59933, 26368.0
7.6, 26363.0
7.60067, 26356.0
7.60133, 26349.0
7.602, 26341.0
7.60267, 26333.0
7.60333, 26324.0
7.604, 26315.0
7.60467, 26305.0
7.60533, 26294.0
7.606, 26283.0
7.60667, 26272.0
7.60733, 26260.0
7.608, 26247.0
7.60867, 26235.0
7.60933, 26222.0
7.61, 26210.0
7.61067, 26197.0
7.61133, 26184.0
7.612, 26172.0
7.61267, 26160.0
7.61333, 26150.0
7.614, 26140.0
7.61467, 26132.0
7.61533, 26125.0
7.616, 26120.0
7.61667, 26115.0
7.61733, 26112.0
7.618, 26110.0
7.61867, 26110.0
7.61933, 26111.0
7.62, 26113.0
7.62067, 26117.0
7.62133, 26122.0
7.622, 26129.0
7.62267, 26136.0
7.62333, 26143.0
7.624, 26151.0
7.62467, 26159.0
7.62533, 26166.0
7.626, 26173.0
7.62667, 26178.0
7.62733, 26183.0
7.628, 26187.0
7.62867, 26191.0
7.62933, 26194.0
7.63, 26196.0
7.63067, 26198.0
7.63133, 26199.0
7.632, 26199.0
7.63267, 26199.0
7.63333, 26198.0
7.634, 26196.0
7.63467, 26192.0
7.63533, 26188.0
7.636, 26182.0
7.63667, 26175.0
7.63733, 26167.0
7.638, 26157.0
7.63867, 26146.0
7.63933, 26134.0
7.64, 26120.0
7.64067, 26106.0
7.64133, 26091.0
7.642, 26075.0
7.64267, 26059.0
7.64333, 26042.0
7.644, 26025.0
7.64467, 26009.0
7.64533, 25992.0
7.646, 25975.0
7.64667, 25959.0
7.64733, 25944.0
7.648, 25929.0
7.64867, 25916.0
7.64933, 25903.0
7.65, 25890.0
7.65067, 25879.0
7.65133, 25868.0
7.652, 25857.0
7.65267, 25846.0
7.65333, 25836.0
7.654, 25825.0
7.65467, 25813.0
7.65533, 25801.0
7.656, 25789.0
7.65667, 25775.0
7.65733, 25761.0
7.658, 25746.0
7.65867, 25731.0
7.65933, 25715.0
7.66, 25699.0
7.66067, 25683.0
7.66133, 25666.0
7.662, 25651.0
7.66267, 25635.0
7.66333, 25620.0
7.664, 25605.0
7.66467, 25590.0
7.66533, 25576.0
7.666, 25562.0
7.66667, 25548.0
7.66733, 25535.0
7.668, 25521.0
7.66867, 25508.0
7.66933, 25496.0
7.67, 25484.0
7.67067, 25473.0
7.67133, 25463.0
7.672, 25452.0
7.67267, 25442.0
7.67333, 25432.0
7.674, 25422.0
7.67467, 25412.0
7.67533, 25403.0
7.676, 25393.0
7.67667, 25383.0
7.67733, 25373.0
7.678, 25362.0
7.67867, 25351.0
7.67933, 25339.0
7.68, 25326.0
7.68067, 25313.0
7.68133, 25299.0
7.682, 25284.0
7.68267, 25269.0
7.68333, 25253.0
7.684, 25236.0
7.68467, 25219.0
7.68533, 25202.0
7.686, 25185.0
7.68667, 25168.0
7.68733, 25151.0
7.688, 25134.0
7.68867, 25117.0
7.68933, 25101.0
7.69, 25085.0
7.69067, 25070.0
7.69133, 25056.0
7.692, 25041.0
7.69267, 25027.0
7.69333, 25013.0
7.694, 25000.0
7.69467, 24986.0
7.69533, 24972.0
7.696, 24958.0
7.69667, 24944.0
7.69733, 24930.0
7.698, 24916.0
7.69867, 24902.0
7.69933, 24888.0
7.7, 24875.0
7.70067, 24861.0
7.70133, 24848.0
7.702, 24835.0
7.70267, 24823.0
7.70333, 24810.0
7.704, 24798.0
7.70467, 24786.0
7.70533, 24773.0
7.706, 24760.0
7.70667, 24746.0
7.70733, 24731.0
7.708, 24714.0
7.70867, 24697.0
7.70933, 24678.0
7.71, 24659.0
7.71067, 24638.0
7.71133, 24617.0
7.712, 24596.0
7.71267, 24573.0
7.71333, 24551.0
7.714, 24527.0
7.71467, 24504.0
7.71533, 24481.0
7.716, 24457.0
7.71667, 24433.0
7.71733, 24409.0
7.718, 24384.0
7.71867, 24359.0
7.71933, 24334.0
7.72, 24309.0
7.72067, 24285.0
7.72133, 24260.0
7.722, 24237.0
7.72267, 24214.0
7.72333, 24192.0
7.724, 24171.0
7.72467, 24151.0
7.72533, 24132.0
7.726, 24114.0
7.72667, 24096.0
7.72733, 24079.0
7.728, 24064.0
7.72867, 24048.0
7.72933, 24034.0
7.73, 24021.0
7.73067, 24009.0
7.73133, 23997.0
7.732, 23986.0
7.73267, 23976.0
7.73333, 23966.0
7.734, 23956.0
7.73467, 23946.0
7.73533, 23936.0
7.736, 23925.0
7.73667, 23914.0
7.73733, 23902.0
7.738, 23888.0
7.73867, 23874.0
7.73933, 23858.0
7.74, 23842.0
7.74067, 23825.0
7.74133, 23808.0
7.742, 23791.0
7.74267, 23773.0
7.74333, 23755.0
7.744, 23737.0
7.74467, 23719.0
7.74533, 23701.0
7.746, 23684.0
7.74667, 23667.0
7.74733, 23651.0
7.748, 23635.0
7.74867, 23621.0
7.74933, 23607.0
7.75, 23595.0
7.75067, 23585.0
7.75133, 23575.0
7.752, 23567.0
7.75267, 23559.0
7.75333, 23552.0
7.754, 23545.0
7.75467, 23538.0
7.75533, 23532.0
7.756, 23526.0
7.75667, 23520.0
7.75733, 23515.0
7.758, 23511.0
7.75867, 23507.0
7.75933, 23503.0
7.76, 23500.0
7.76067, 23497.0
7.76133, 23494.0
7.762, 23491.0
7.76267, 23487.0
7.76333, 23483.0
7.764, 23479.0
7.76467, 23474.0
7.76533, 23468.0
7.766, 23462.0
7.76667, 23455.0
7.76733, 23447.0
7.768, 23439.0
7.76867, 23430.0
7.76933, 23421.0
7.77, 23411.0
7.77067, 23400.0
7.77133, 23389.0
7.772, 23378.0
7.77267, 23366.0
7.77333, 23354.0
7.774, 23341.0
7.77467, 23329.0
7.77533, 23317.0
7.776, 23305.0
7.77667, 23294.0
7.77733, 23283.0
7.778, 23272.0
7.77867, 23262.0
7.77933, 23251.0
7.78, 23241.0
7.78067, 23231.0
7.78133, 23222.0
7.782, 23213.0
7.78267, 23205.0
7.78333, 23197.0
7.784, 23190.0
7.78467, 23184.0
7.78533, 23178.0
7.786, 23173.0
7.78667, 23169.0
7.78733, 23165.0
7.788, 23161.0
7.78867, 23157.0
7.78933, 23152.0
7.79, 23147.0
7.79067, 23143.0
7.79133, 23137.0
7.792, 23132.0
7.79267, 23126.0
7.79333, 23121.0
7.794, 23115.0
7.79467, 23110.0
7.79533, 23104.0
7.796, 23098.0
7.79667, 23091.0
7.79733, 23084.0
7.798, 23076.0
7.79867, 23068.0
7.79933, 23059.0
7.8, 23051.0
7.80067, 23043.0
7.80133, 23035.0
7.802, 23027.0
7.80267, 23019.0
7.80333, 23012.0
7.804, 23005.0
7.80467, 22998.0
7.80533, 22991.0
7.806, 22984.0
7.80667, 22978.0
7.80733, 22971.0
7.808, 22965.0
7.80867, 22960.0
7.80933, 22955.0
7.81, 22950.0
7.81067, 22946.0
7.81133, 22942.0
7.812, 22938.0
7.81267, 22934.0
7.81333, 22930.0
7.814, 22926.0
7.81467, 22922.0
7.81533, 22917.0
7.816, 22913.0
7.81667, 22908.0
7.81733, 22904.0
7.818, 22899.0
7.81867, 22896.0
7.81933, 22892.0
7.82, 22890.0
7.82067, 22887.0
7.82133, 22886.0
7.822, 22885.0
7.82267, 22884.0
7.82333, 22884.0
7.824, 22884.0
7.82467, 22885.0
7.82533, 22886.0
7.826, 22887.0
7.82667, 22888.0
7.82733, 22890.0
7.828, 22892.0
7.82867, 22894.0
7.82933, 22897.0
7.83, 22900.0
7.83067, 22903.0
7.83133, 22906.0
7.832, 22908.0
7.83267, 22911.0
7.83333, 22914.0
7.834, 22917.0
7.83467, 22920.0
7.83533, 22923.0
7.836, 22926.0
7.83667, 22929.0
7.83733, 22932.0
7.838, 22934.0
7.83867, 22936.0
7.83933, 22937.0
7.84, 22937.0
7.84067, 22936.0
7.84133, 22935.0
7.842, 22932.0
7.84267, 22929.0
7.84333, 22925.0
7.844, 22919.0
7.84467, 22913.0
7.84533, 22906.0
7.846, 22898.0
7.84667, 22890.0
7.84733, 22881.0
7.848, 22872.0
7.84867, 22863.0
7.84933, 22853.0
7.85, 22844.0
7.85067, 22834.0
7.85133, 22825.0
7.852, 22816.0
7.85267, 22808.0
7.85333, 22800.0
7.854, 22794.0
7.85467, 22788.0
7.85533, 22783.0
7.856, 22780.0
7.85667, 22777.0
7.85733, 22776.0
7.858, 22775.0
7.85867, 22776.0
7.85933, 22778.0
7.86, 22781.0
7.86067, 22786.0
7.86133, 22791.0
7.862, 22799.0
7.86267, 22807.0
7.86333, 22817.0
7.864, 22828.0
7.86467, 22839.0
7.86533, 22852.0
7.866, 22864.0
7.86667, 22877.0
7.86733, 22890.0
7.868, 22902.0
7.86867, 22914.0
7.86933, 22926.0
7.87, 22936.0
7.87067, 22946.0
7.87133, 22955.0
7.872, 22963.0
7.87267, 22970.0
7.87333, 22977.0
7.874, 22982.0
7.87467, 22987.0
7.87533, 22991.0
7.876, 22994.0
7.87667, 22997.0
7.87733, 22998.0
7.878, 22999.0
7.87867, 23000.0
7.87933, 23000.0
7.88, 22999.0
7.88067, 22998.0
7.88133, 22997.0
7.882, 22995.0
7.88267, 22993.0
7.88333, 22990.0
7.884, 22987.0
7.88467, 22983.0
7.88533, 22980.0
7.886, 22975.0
7.88667, 22971.0
7.88733, 22965.0
7.888, 22960.0
7.88867, 22955.0
7.88933, 22950.0
7.89, 22945.0
7.89067, 22941.0
7.89133, 22936.0
7.892, 22931.0
7.89267, 22927.0
7.89333, 22922.0
7.894, 22918.0
7.89467, 22913.0
7.89533, 22910.0
7.896, 22906.0
7.89667, 22903.0
7.89733, 22900.0
7.898, 22898.0
7.89867, 22895.0
7.89933, 22893.0
7.9, 22892.0
7.90067, 22890.0
7.90133, 22889.0
7.902, 22888.0
7.90267, 22887.0
7.90333, 22886.0
7.904, 22886.0
7.90467, 22885.0
7.90533, 22885.0
7.906, 22884.0
7.90667, 22883.0
7.90733, 22883.0
7.908, 22882.0
7.90867, 22880.0
7.90933, 22879.0
7.91, 22877.0
7.91067, 22875.0
7.91133, 22873.0
7.912, 22870.0
7.91267, 22866.0
7.91333, 22863.0
7.914, 22859.0
7.91467, 22854.0
7.91533, 22850.0
7.916, 22845.0
7.91667, 22840.0
7.91733, 22835.0
7.918, 22829.0
7.91867, 22824.0
7.91933, 22817.0
7.92, 22811.0
7.92067, 22803.0
7.92133, 22796.0
7.922, 22787.0
7.92267, 22779.0
7.92333, 22770.0
7.924, 22761.0
7.92467, 22752.0
7.92533, 22743.0
7.926, 22734.0
7.92667, 22724.0
7.92733, 22714.0
7.928, 22705.0
7.92867, 22695.0
7.92933, 22685.0
7.93, 22675.0
7.93067, 22665.0
7.93133, 22655.0
7.932, 22644.0
7.93267, 22633.0
7.93333, 22622.0
7.934, 22610.0
7.93467, 22598.0
7.93533, 22585.0
7.936, 22572.0
7.93667, 22558.0
7.93733, 22543.0
7.938, 22528.0
7.93867, 22512.0
7.93933, 22496.0
7.94, 22480.0
7.94067, 22463.0
7.94133, 22447.0
7.942, 22431.0
7.94267, 22415.0
7.94333, 22400.0
7.944, 22386.0
7.94467, 22371.0
7.94533, 22357.0
7.946, 22343.0
7.94667, 22330.0
7.94733, 22318.0
7.948, 22306.0
7.94867, 22295.0
7.94933, 22285.0
7.95, 22275.0
7.95067, 22266.0
7.95133, 22258.0
7.952, 22250.0
7.95267, 22242.0
7.95333, 22234.0
7.954, 22227.0
7.95467, 22219.0
7.95533, 22212.0
7.956, 22205.0
7.95667, 22198.0
7.95733, 22191.0
7.958, 22184.0
7.95867, 22178.0
7.95933, 22171.0
7.96, 22164.0
7.96067, 22156.0
7.96133, 22148.0
7.962, 22140.0
7.96267, 22130.0
7.96333, 22121.0
7.964, 22111.0
7.96467, 22100.0
7.96533, 22089.0
7.966, 22079.0
7.96667, 22068.0
7.96733, 22057.0
7.968, 22046.0
7.96867, 22035.0
7.96933, 22025.0
7.97, 22014.0
7.97067, 22003.0
7.97133, 21992.0
7.972, 21981.0
7.97267, 21970.0
7.97333, 21959.0
7.974, 21947.0
7.97467, 21935.0
7.97533, 21923.0
7.976, 21910.0
7.97667, 21898.0
7.97733, 21886.0
7.978, 21873.0
7.97867, 21861.0
7.97933, 21848.0
7.98, 21834.0
7.98067, 21821.0
7.98133, 21807.0
7.982, 21793.0
7.98267, 21779.0
7.98333, 21766.0
7.984, 21753.0
7.98467, 21740.0
7.98533, 21728.0
7.986, 21717.0
7.98667, 21705.0
7.98733, 21694.0
7.988, 21683.0
7.98867, 21672.0
7.98933, 21661.0
7.99, 21650.0
7.99067, 21639.0
7.99133, 21628.0
7.992, 21618.0
7.99267, 21608.0
7.99333, 21598.0
7.994, 21589.0
7.99467, 21579.0
7.99533, 21570.0
7.996, 21560.0
7.99667, 21550.0
7.99733, 21541.0
7.998, 21531.0
7.99867, 21520.0
7.99933, 21509.0
8.0, 21498.0
8.00067, 21486.0
8.00133, 21473.0
8.002, 21459.0
8.00267, 21445.0
8.00333, 21431.0
8.004, 21416.0
8.00467, 21401.0
8.00533, 21386.0
8.006, 21370.0
8.00667, 21354.0
8.00733, 21338.0
8.008, 21322.0
8.00867, 21306.0
8.00933, 21290.0
8.01, 21274.0
8.01067, 21258.0
8.01133, 21243.0
8.012, 21227.0
8.01267, 21211.0
8.01333, 21194.0
8.014, 21178.0
8.01467, 21162.0
8.01533, 21146.0
8.016, 21130.0
8.01667, 21115.0
8.01733, 21099.0
8.018, 21084.0
8.01867, 21068.0
8.01933, 21053.0
8.02, 21038.0
8.02067, 21022.0
8.02133, 21007.0
8.022, 20991.0
8.02267, 20976.0
8.02333, 20962.0
8.024, 20948.0
8.02467, 20935.0
8.02533, 20922.0
8.026, 20910.0
8.02667, 20898.0
8.02733, 20887.0
8.028, 20876.0
8.02867, 20866.0
8.02933, 20857.0
8.03, 20848.0
8.03067, 20839.0
8.03133, 20831.0
8.032, 20823.0
8.03267, 20816.0
8.03333, 20810.0
8.034, 20804.0
8.03467, 20799.0
8.03533, 20794.0
8.036, 20790.0
8.03667, 20787.0
8.03733, 20784.0
8.038, 20780.0
8.03867, 20778.0
8.03933, 20775.0
8.04, 20772.0
8.04067, 20770.0
8.04133, 20767.0
8.042, 20765.0
8.04267, 20763.0
8.04333, 20761.0
8.044, 20759.0
8.04467, 20758.0
8.04533, 20756.0
8.046, 20755.0
8.04667, 20753.0
8.04733, 20751.0
8.048, 20749.0
8.04867, 20746.0
8.04933, 20743.0
8.05, 20739.0
8.05067, 20735.0
8.05133, 20730.0
8.052, 20724.0
8.05267, 20718.0
8.05333, 20710.0
8.054, 20702.0
8.05467, 20693.0
8.05533, 20684.0
8.056, 20675.0
8.05667, 20665.0
8.05733, 20656.0
8.058, 20646.0
8.05867, 20637.0
8.05933, 20627.0
8.06, 20617.0
8.06067, 20608.0
8.06133, 20599.0
8.062, 20589.0
8.06267, 20580.0
8.06333, 20570.0
8.064, 20560.0
8.06467, 20551.0
8.06533, 20541.0
8.066, 20531.0
8.06667, 20521.0
8.06733, 20511.0
8.068, 20501.0
8.06867, 20491.0
8.06933, 20481.0
8.07, 20471.0
8.07067, 20461.0
8.07133, 20452.0
8.072, 20442.0
8.07267, 20433.0
8.07333, 20424.0
8.074, 20416.0
8.07467, 20407.0
8.07533, 20399.0
8.076, 20392.0
8.07667, 20385.0
8.07733, 20378.0
8.078, 20371.0
8.07867, 20364.0
8.07933, 20356.0
8.08, 20349.0
8.08067, 20341.0
8.08133, 20333.0
8.082, 20325.0
8.08267, 20316.0
8.08333, 20308.0
8.084, 20299.0
8.08467, 20290.0
8.08533, 20281.0
8.086, 20272.0
8.08667, 20264.0
8.08733, 20256.0
8.088, 20248.0
8.08867, 20240.0
8.08933, 20233.0
8.09, 20226.0
8.09067, 20218.0
8.09133, 20211.0
8.092, 20203.0
8.09267, 20196.0
8.09333, 20188.0
8.094, 20181.0
8.09467, 20173.0
8.09533, 20166.0
8.096, 20160.0
8.09667, 20153.0
8.09733, 20147.0
8.098, 20141.0
8.09867, 20136.0
8.09933, 20132.0
8.1, 20127.0
8.10067, 20122.0
8.10133, 20118.0
8.102, 20114.0
8.10267, 20109.0
8.10333, 20105.0
8.104, 20100.0
8.10467, 20095.0
8.10533, 20089.0
8.106, 20082.0
8.10667, 20076.0
8.10733, 20069.0
8.108, 20062.0
8.10867, 20055.0
8.10933, 20048.0
8.11, 20042.0
8.11067, 20035.0
8.11133, 20029.0
8.112, 20023.0
8.11267, 20018.0
8.11333, 20013.0
8.114, 20008.0
8.11467, 20004.0
8.11533, 20000.0
8.116, 19997.0
8.11667, 19994.0
8.11733, 19991.0
8.118, 19988.0
8.11867, 19986.0
8.11933, 19984.0
8.12, 19983.0
8.12067, 19981.0
8.12133, 19980.0
8.122, 19979.0
8.12267, 19979.0
8.12333, 19979.0
8.124, 19979.0
8.12467, 19980.0
8.12533, 19979.0
8.126, 19979.0
8.12667, 19978.0
8.12733, 19977.0
8.128, 19975.0
8.12867, 19973.0
8.12933, 19970.0
8.13, 19966.0
8.13067, 19962.0
8.13133, 19957.0
8.132, 19952.0
8.13267, 19947.0
8.13333, 19942.0
8.134, 19937.0
8.13467, 19932.0
8.13533, 19927.0
8.136, 19923.0
8.13667, 19918.0
8.13733, 19914.0
8.138, 19911.0
8.13867, 19909.0
8.13933, 19907.0
8.14, 19906.0
8.14067, 19905.0
8.14133, 19904.0
8.142, 19904.0
8.14267, 19905.0
8.14333, 19905.0
8.144, 19905.0
8.14467, 19905.0
8.14533, 19906.0
8.146, 19907.0
8.14667, 19908.0
8.14733, 19909.0
8.148, 19911.0
8.14867, 19913.0
8.14933, 19916.0
8.15, 19919.0
8.15067, 19922.0
8.15133, 19925.0
8.152, 19928.0
8.15267, 19931.0
8.15333, 19933.0
8.154, 19935.0
8.15467, 19936.0
8.15533, 19936.0
8.156, 19935.0
8.15667, 19933.0
8.15733, 19931.0
8.158, 19928.0
8.15867, 19925.0
8.15933, 19921.0
8.16, 19917.0
8.16067, 19912.0
8.16133, 19906.0
8.162, 19901.0
8.16267, 19895.0
8.16333, 19889.0
8.164, 19882.0
8.16467, 19876.0
8.16533, 19870.0
8.166, 19863.0
8.16667, 19856.0
8.16733, 19849.0
8.168, 19841.0
8.16867, 19834.0
8.16933, 19826.0
8.17, 19818.0
8.17067, 19810.0
8.17133, 19803.0
8.172, 19795.0
8.17267, 19788.0
8.17333, 19782.0
8.174, 19776.0
8.17467, 19771.0
8.17533, 19767.0
8.176, 19764.0
8.17667, 19761.0
8.17733, 19758.0
8.178, 19756.0
8.17867, 19755.0
8.17933, 19754.0
8.18, 19754.0
8.18067, 19753.0
8.18133, 19753.0
8.182, 19754.0
8.18267, 19754.0
8.18333, 19755.0
8.184, 19756.0
8.18467, 19756.0
8.18533, 19757.0
8.186, 19758.0
8.18667, 19758.0
8.18733, 19759.0
8.188, 19760.0
8.18867, 19760.0
8.18933, 19761.0
8.19, 19761.0
8.19067, 19762.0
8.19133, 19762.0
8.192, 19762.0
8.19267, 19762.0
8.19333, 19763.0
8.194, 19764.0
8.19467, 19765.0
8.19533, 19766.0
8.196, 19768.0
8.19667, 19770.0
8.19733, 19772.0
8.198, 19775.0
8.19867, 19778.0
8.19933, 19782.0
8.2, 19785.0
8.20067, 19789.0
8.20133, 19793.0
8.202, 19797.0
8.20267, 19801.0
8.20333, 19805.0
8.204, 19809.0
8.20467, 19813.0
8.20533, 19817.0
8.206, 19820.0
8.20667, 19824.0
8.20733, 19828.0
8.208, 19831.0
8.20867, 19834.0
8.20933, 19838.0
8.21, 19841.0
8.21067, 19845.0
8.21133, 19849.0
8.212, 19853.0
8.21267, 19857.0
8.21333, 19861.0
8.214, 19865.0
8.21467, 19869.0
8.21533, 19874.0
8.216, 19878.0
8.21667, 19882.0
8.21733, 19886.0
8.218, 19890.0
8.21867, 19893.0
8.21933, 19896.0
8.22, 19900.0
8.22067, 19903.0
8.22133, 19905.0
8.222, 19908.0
8.22267, 19910.0
8.22333, 19911.0
8.224, 19912.0
8.22467, 19913.0
8.22533, 19914.0
8.226, 19915.0
8.22667, 19916.0
8.22733, 19917.0
8.228, 19918.0
8.22867, 19919.0
8.22933, 19920.0
8.23, 19922.0
8.23067, 19923.0
8.23133, 19926.0
8.232, 19928.0
8.23267, 19930.0
8.23333, 19932.0
8.234, 19934.0
8.23467, 19936.0
8.23533, 19938.0
8.236, 19940.0
8.23667, 19942.0
8.23733, 19944.0
8.238, 19946.0
8.23867, 19949.0
8.23933, 19951.0
8.24, 19953.0
8.24067, 19954.0
8.24133, 19955.0
8.242, 19956.0
8.24267, 19956.0
8.24333, 19955.0
8.244, 19954.0
8.24467, 19952.0
8.24533, 19950.0
8.246, 19948.0
8.24667, 19945.0
8.24733, 19942.0
8.248, 19938.0
8.24867, 19935.0
8.24933, 19930.0
8.25, 19926.0
8.25067, 19921.0
8.25133, 19917.0
8.252, 19912.0
8.25267, 19908.0
8.25333, 19905.0
8.254, 19902.0
8.25467, 19900.0
8.25533, 19898.0
8.256, 19896.0
8.25667, 19895.0
8.25733, 19894.0
8.258, 19894.0
8.25867, 19893.0
8.25933, 19893.0
8.26, 19893.0
8.26067, 19893.0
8.26133, 19893.0
8.262, 19893.0
8.26267, 19892.0
8.26333, 19891.0
8.264, 19890.0
8.26467, 19889.0
8.26533, 19887.0
8.266, 19884.0
8.26667, 19882.0
8.26733, 19880.0
8.268, 19877.0
8.26867, 19875.0
8.26933, 19873.0
8.27, 19871.0
8.27067, 19869.0
8.27133, 19866.0
8.272, 19864.0
8.27267, 19861.0
8.27333, 19858.0
8.274, 19854.0
8.27467, 19850.0
8.27533, 19845.0
8.276, 19840.0
8.27667, 19834.0
8.27733, 19828.0
8.278, 19822.0
8.27867, 19816.0
8.27933, 19809.0
8.28, 19803.0
8.28067, 19797.0
8.28133, 19791.0
8.282, 19786.0
8.28267, 19780.0
8.28333, 19774.0
8.284, 19769.0
8.28467, 19763.0
8.28533, 19758.0
8.286, 19752.0
8.28667, 19747.0
8.28733, 19741.0
8.288, 19736.0
8.28867, 19730.0
8.28933, 19724.0
8.29, 19718.0
8.29067, 19712.0
8.29133, 19707.0
8.292, 19702.0
8.29267, 19697.0
8.29333, 19692.0
8.294, 19688.0
8.29467, 19683.0
8.29533, 19680.0
8.296, 19676.0
8.29667, 19672.0
8.29733, 19669.0
8.298, 19665.0
8.29867, 19661.0
8.29933, 19658.0
8.3, 19653.0
8.30067, 19649.0
8.30133, 19644.0
8.302, 19639.0
8.30267, 19634.0
8.30333, 19630.0
8.304, 19625.0
8.30467, 19620.0
8.30533, 19616.0
8.306, 19612.0
8.30667, 19609.0
8.30733, 19606.0
8.308, 19603.0
8.30867, 19601.0
8.30933, 19598.0
8.31, 19596.0
8.31067, 19593.0
8.31133, 19590.0
8.312, 19587.0
8.31267, 19584.0
8.31333, 19580.0
8.314, 19575.0
8.31467, 19570.0
8.31533, 19564.0
8.316, 19558.0
8.31667, 19551.0
8.31733, 19544.0
8.318, 19538.0
8.31867, 19531.0
8.31933, 19525.0
8.32, 19519.0
8.32067, 19514.0
8.32133, 19509.0
8.322, 19504.0
8.32267, 19500.0
8.32333, 19496.0
8.324, 19492.0
8.32467, 19489.0
8.32533, 19486.0
8.326, 19483.0
8.32667, 19481.0
8.32733, 19479.0
8.328, 19477.0
8.32867, 19476.0
8.32933, 19475.0
8.33, 19474.0
8.33067, 19474.0
8.33133, 19475.0
8.332, 19476.0
8.33267, 19477.0
8.33333, 19479.0
8.334, 19482.0
8.33467, 19484.0
8.33533, 19487.0
8.336, 19489.0
8.33667, 19492.0
8.33733, 19495.0
8.338, 19497.0
8.33867, 19499.0
8.33933, 19500.0
8.34, 19502.0
8.34067, 19503.0
8.34133, 19504.0
8.342, 19504.0
8.34267, 19504.0
8.34333, 19504.0
8.344, 19504.0
8.34467, 19503.0
8.34533, 19503.0
8.346, 19503.0
8.34667, 19503.0
8.34733, 19502.0
8.348, 19502.0
8.34867, 19502.0
8.34933, 19503.0
8.35, 19503.0
8.35067, 19503.0
8.35133, 19502.0
8.352, 19502.0
8.35267, 19501.0
8.35333, 19500.0
8.354, 19498.0
8.35467, 19497.0
8.35533, 19496.0
8.356, 19494.0
8.35667, 19493.0
8.35733, 19491.0
8.358, 19489.0
8.35867, 19487.0
8.35933, 19485.0
8.36, 19482.0
8.36067, 19480.0
8.36133, 19477.0
8.362, 19474.0
8.36267, 19470.0
8.36333, 19466.0
8.364, 19463.0
8.36467, 19459.0
8.36533, 19455.0
8.366, 19451.0
8.36667, 19447.0
8.36733, 19443.0
8.368, 19439.0
8.36867, 19435.0
8.36933, 19430.0
8.37, 19426.0
8.37067, 19422.0
8.37133, 19419.0
8.372, 19415.0
8.37267, 19412.0
8.37333, 19409.0
8.374, 19407.0
8.37467, 19404.0
8.37533, 19401.0
8.376, 19399.0
8.37667, 19396.0
8.37733, 19393.0
8.378, 19391.0
8.37867, 19388.0
8.37933, 19385.0
8.38, 19382.0
8.38067, 19380.0
8.38133, 19377.0
8.382, 19374.0
8.38267, 19371.0
8.38333, 19368.0
8.384, 19365.0
8.38467, 19362.0
8.38533, 19360.0
8.386, 19357.0
8.38667, 19353.0
8.38733, 19350.0
8.388, 19346.0
8.38867, 19343.0
8.38933, 19339.0
8.39, 19335.0
8.39067, 19331.0
8.39133, 19327.0
8.392, 19322.0
8.39267, 19317.0
8.39333, 19313.0
8.394, 19308.0
8.39467, 19303.0
8.39533, 19298.0
8.396, 19293.0
8.39667, 19288.0
8.39733, 19283.0
8.398, 19278.0
8.39867, 19274.0
8.39933, 19270.0
8.4, 19266.0
8.40067, 19262.0
8.40133, 19259.0
8.402, 19255.0
8.40267, 19252.0
8.40333, 19250.0
8.404, 19247.0
8.40467, 19245.0
8.40533, 19242.0
8.406, 19239.0
8.40667, 19237.0
8.40733, 19235.0
8.408, 19233.0
8.40867, 19232.0
8.40933, 19231.0
8.41, 19231.0
8.41067, 19231.0
8.41133, 19231.0
8.412, 19231.0
8.41267, 19231.0
8.41333, 19231.0
8.414, 19231.0
8.41467, 19231.0
8.41533, 19230.0
8.416, 19230.0
8.41667, 19229.0
8.41733, 19228.0
8.418, 19228.0
8.41867, 19226.0
8.41933, 19225.0
8.42, 19223.0
8.42067, 19221.0
8.42133, 19219.0
8.422, 19217.0
8.42267, 19214.0
8.42333, 19212.0
8.424, 19209.0
8.42467, 19206.0
8.42533, 19203.0
8.426, 19200.0
8.42667, 19196.0
8.42733, 19192.0
8.428, 19188.0
8.42867, 19183.0
8.42933, 19177.0
8.43, 19170.0
8.43067, 19163.0
8.43133, 19156.0
8.432, 19148.0
8.43267, 19140.0
8.43333, 19132.0
8.434, 19123.0
8.43467, 19115.0
8.43533, 19107.0
8.436, 19099.0
8.43667, 19092.0
8.43733, 19085.0
8.438, 19078.0
8.43867, 19072.0
8.43933, 19066.0
8.44, 19061.0
8.44067, 19057.0
8.44133, 19052.0
8.442, 19049.0
8.44267, 19045.0
8.44333, 19043.0
8.444, 19040.0
8.44467, 19038.0
8.44533, 19035.0
8.446, 19034.0
8.44667, 19032.0
8.44733, 19031.0
8.448, 19029.0
8.44867, 19028.0
8.44933, 19026.0
8.45, 19025.0
8.45067, 19022.0
8.45133, 19020.0
8.452, 19016.0
8.45267, 19012.0
8.45333, 19007.0
8.454, 19002.0
8.45467, 18996.0
8.45533, 18989.0
8.456, 18983.0
8.45667, 18976.0
8.45733, 18969.0
8.458, 18962.0
8.45867, 18955.0
8.45933, 18948.0
8.46, 18941.0
8.46067, 18933.0
8.46133, 18925.0
8.462, 18917.0
8.46267, 18910.0
8.46333, 18902.0
8.464, 18895.0
8.46467, 18888.0
8.46533, 18880.0
8.466, 18873.0
8.46667, 18866.0
8.46733, 18859.0
8.468, 18851.0
8.46867, 18844.0
8.46933, 18836.0
8.47, 18829.0
8.47067, 18821.0
8.47133, 18812.0
8.472, 18804.0
8.47267, 18795.0
8.47333, 18787.0
8.474, 18777.0
8.47467, 18768.0
8.47533, 18757.0
8.476, 18747.0
8.47667, 18736.0
8.47733, 18724.0
8.478, 18712.0
8.47867, 18700.0
8.47933, 18688.0
8.48, 18677.0
8.48067, 18665.0
8.48133, 18654.0
8.482, 18643.0
8.48267, 18632.0
8.48333, 18623.0
8.484, 18613.0
8.48467, 18605.0
8.48533, 18596.0
8.486, 18588.0
8.48667, 18581.0
8.48733, 18574.0
8.488, 18567.0
8.48867, 18560.0
8.48933, 18554.0
8.49, 18549.0
8.49067, 18544.0
8.49133, 18539.0
8.492, 18534.0
8.49267, 18531.0
8.49333, 18527.0
8.494, 18524.0
8.49467, 18522.0
8.49533, 18519.0
8.496, 18517.0
8.49667, 18516.0
8.49733, 18515.0
8.498, 18514.0
8.49867, 18513.0
8.49933, 18511.0
8.5, 18510.0
8.50067, 18509.0
8.50133, 18508.0
8.502, 18507.0
8.50267, 18507.0
8.50333, 18505.0
8.504, 18503.0
8.50467, 18501.0
8.50533, 18498.0
8.506, 18495.0
8.50667, 18492.0
8.50733, 18489.0
8.508, 18486.0
8.50867, 18483.0
8.50933, 18481.0
8.51, 18479.0
8.51067, 18477.0
8.51133, 18476.0
8.512, 18474.0
8.51267, 18473.0
8.51333, 18472.0
8.514, 18472.0
8.51467, 18472.0
8.51533, 18473.0
8.516, 18474.0
8.51667, 18475.0
8.51733, 18476.0
8.518, 18478.0
8.51867, 18479.0
8.51933, 18481.0
8.52, 18483.0
8.52067, 18486.0
8.52133, 18489.0
8.522, 18492.0
8.52267, 18495.0
8.52333, 18498.0
8.524, 18502.0
8.52467, 18505.0
8.52533, 18508.0
8.526, 18510.0
8.52667, 18513.0
8.52733, 18515.0
8.528, 18517.0
8.52867, 18519.0
8.52933, 18520.0
8.53, 18521.0
8.53067, 18521.0
8.53133, 18522.0
8.532, 18522.0
8.53267, 18522.0
8.53333, 18522.0
8.534, 18521.0
8.53467, 18521.0
8.53533, 18520.0
8.536, 18520.0
8.53667, 18520.0
8.53733, 18519.0
8.538, 18519.0
8.53867, 18519.0
8.53933, 18520.0
8.54, 18520.0
8.54067, 18522.0
8.54133, 18523.0
8.542, 18526.0
8.54267, 18528.0
8.54333, 18531.0
8.544, 18534.0
8.54467, 18538.0
8.54533, 18541.0
8.546, 18545.0
8.54667, 18549.0
8.54733, 18553.0
8.548, 18557.0
8.54867, 18560.0
8.54933, 18564.0
8.55, 18569.0
8.55067, 18573.0
8.55133, 18577.0
8.552, 18581.0
8.55267, 18585.0
8.55333, 18588.0
8.554, 18591.0
8.55467, 18594.0
8.55533, 18596.0
8.556, 18597.0
8.55667, 18599.0
8.55733, 18600.0
8.558, 18600.0
8.55867, 18600.0
8.55933, 18600.0
8.56, 18599.0
8.56067, 18598.0
8.56133, 18597.0
8.562, 18595.0
8.56267, 18594.0
8.56333, 18592.0
8.564, 18591.0
8.56467, 18589.0
8.56533, 18588.0
8.566, 18588.0
8.56667, 18587.0
8.56733, 18588.0
8.568, 18588.0
8.56867, 18589.0
8.56933, 18590.0
8.57, 18591.0
8.57067, 18593.0
8.57133, 18595.0
8.572, 18597.0
8.57267, 18599.0
8.57333, 18601.0
8.574, 18604.0
8.57467, 18607.0
8.57533, 18610.0
8.576, 18613.0
8.57667, 18616.0
8.57733, 18619.0
8.578, 18622.0
8.57867, 18624.0
8.57933, 18626.0
8.58, 18628.0
8.58067, 18628.0
8.58133, 18629.0
8.582, 18629.0
8.58267, 18628.0
8.58333, 18627.0
8.584, 18626.0
8.58467, 18625.0
8.58533, 18623.0
8.586, 18621.0
8.58667, 18619.0
8.58733, 18616.0
8.588, 18613.0
8.58867, 18610.0
8.58933, 18606.0
8.59, 18603.0
8.59067, 18599.0
8.59133, 18595.0
8.592, 18591.0
8.59267, 18587.0
8.59333, 18583.0
8.594, 18580.0
8.59467, 18576.0
8.59533, 18573.0
8.596, 18569.0
8.59667, 18565.0
8.59733, 18562.0
8.598, 18558.0
8.59867, 18554.0
8.59933, 18551.0
8.6, 18547.0
8.60067, 18543.0
8.60133, 18540.0
8.602, 18536.0
8.60267, 18531.0
8.60333, 18527.0
8.604, 18524.0
8.60467, 18520.0
8.60533, 18516.0
8.606, 18512.0
8.60667, 18508.0
8.60733, 18505.0
8.608, 18501.0
8.60867, 18498.0
8.60933, 18496.0
8.61, 18493.0
8.61067, 18492.0
8.61133, 18490.0
8.612, 18490.0
8.61267, 18490.0
8.61333, 18492.0
8.614, 18494.0
8.61467, 18496.0
8.61533, 18500.0
8.616, 18503.0
8.61667, 18507.0
8.61733, 18511.0
8.618, 18516.0
8.61867, 18521.0
8.61933, 18526.0
8.62, 18531.0
8.62067, 18537.0
8.62133, 18542.0
8.622, 18548.0
8.62267, 18553.0
8.62333, 18559.0
8.624, 18564.0
8.62467, 18569.0
8.62533, 18574.0
8.626, 18578.0
8.62667, 18582.0
8.62733, 18586.0
8.628, 18589.0
8.62867, 18592.0
8.62933, 18594.0
8.63, 18595.0
8.63067, 18596.0
8.63133, 18595.0
8.632, 18593.0
8.63267, 18591.0
8.63333, 18589.0
8.634, 18586.0
8.63467, 18582.0
8.63533, 18579.0
8.636, 18575.0
8.63667, 18571.0
8.63733, 18567.0
8.638, 18563.0
8.63867, 18560.0
8.63933, 18557.0
8.64, 18555.0
8.64067, 18554.0
8.64133, 18553.0
8.642, 18553.0
8.64267, 18554.0
8.64333, 18556.0
8.644, 18559.0
8.64467, 18563.0
8.64533, 18567.0
8.646, 18573.0
8.64667, 18579.0
8.64733, 18586.0
8.648, 18594.0
8.64867, 18602.0
8.64933, 18611.0
8.65, 18621.0
8.65067, 18631.0
8.65133, 18641.0
8.652, 18652.0
8.65267, 18662.0
8.65333, 18672.0
8.654, 18682.0
8.65467, 18692.0
8.65533, 18701.0
8.656, 18710.0
8.65667, 18718.0
8.65733, 18726.0
8.658, 18733.0
8.65867, 18739.0
8.65933, 18744.0
8.66, 18749.0
8.66067, 18753.0
8.66133, 18757.0
8.662, 18760.0
8.66267, 18763.0
8.66333, 18765.0
8.664, 18767.0
8.66467, 18768.0
8.66533, 18770.0
8.666, 18771.0
8.66667, 18771.0
8.66733, 18772.0
8.668, 18772.0
8.66867, 18772.0
8.66933, 18771.0
8.67, 18770.0
8.67067, 18769.0
8.67133, 18766.0
8.672, 18764.0
8.67267, 18761.0
8.67333, 18757.0
8.674, 18753.0
8.67467, 18749.0
8.67533, 18744.0
8.676, 18739.0
8.67667, 18734.0
8.67733, 18729.0
8.678, 18724.0
8.67867, 18718.0
8.67933, 18712.0
8.68, 18706.0
8.68067, 18700.0
8.68133, 18693.0
8.682, 18686.0
8.68267, 18679.0
8.68333, 18672.0
8.684, 18665.0
8.68467, 18657.0
8.68533, 18650.0
8.686, 18642.0
8.68667, 18634.0
8.68733, 18626.0
8.688, 18618.0
8.68867, 18609.0
8.68933, 18600.0
8.69, 18591.0
8.69067, 18582.0
8.69133, 18573.0
8.692, 18563.0
8.69267, 18553.0
8.69333, 18543.0
8.694, 18533.0
8.69467, 18522.0
8.69533, 18511.0
8.696, 18500.0
8.69667, 18488.0
8.69733, 18477.0
8.698, 18466.0
8.69867, 18455.0
8.69933, 18444.0
8.7, 18433.0
8.70067, 18423.0
8.70133, 18412.0
8.702, 18403.0
8.70267, 18393.0
8.70333, 18384.0
8.704, 18375.0
8.70467, 18366.0
8.70533, 18358.0
8.706, 18350.0
8.70667, 18341.0
8.70733, 18333.0
8.708, 18323.0
8.70867, 18314.0
8.70933, 18303.0
8.71, 18293.0
8.71067, 18282.0
8.71133, 18270.0
8.712, 18259.0
8.71267, 18247.0
8.71333, 18235.0
8.714, 18223.0
8.71467, 18212.0
8.71533, 18200.0
8.716, 18189.0
8.71667, 18178.0
8.71733, 18167.0
8.718, 18156.0
8.71867, 18146.0
8.71933, 18136.0
8.72, 18126.0
8.72067, 18117.0
8.72133, 18107.0
8.722, 18098.0
8.72267, 18089.0
8.72333, 18080.0
8.724, 18071.0
8.72467, 18063.0
8.72533, 18054.0
8.726, 18046.0
8.72667, 18038.0
8.72733, 18030.0
8.728, 18023.0
8.72867, 18016.0
8.72933, 18009.0
8.73, 18002.0
8.73067, 17996.0
8.73133, 17989.0
8.732, 17983.0
8.73267, 17977.0
8.73333, 17971.0
8.734, 17965.0
8.73467, 17959.0
8.73533, 17953.0
8.736, 17947.0
8.73667, 17942.0
8.73733, 17936.0
8.738, 17931.0
8.73867, 17926.0
8.73933, 17921.0
8.74, 17917.0
8.74067, 17913.0
8.74133, 17909.0
8.742, 17905.0
8.74267, 17901.0
8.74333, 17898.0
8.744, 17895.0
8.74467, 17892.0
8.74533, 17889.0
8.746, 17886.0
8.74667, 17883.0
8.74733, 17880.0
8.748, 17877.0
8.74867, 17874.0
8.74933, 17871.0
8.75, 17868.0
8.75067, 17865.0
8.75133, 17863.0
8.752, 17861.0
8.75267, 17859.0
8.75333, 17857.0
8.754, 17856.0
8.75467, 17855.0
8.75533, 17855.0
8.756, 17854.0
8.75667, 17854.0
8.75733, 17855.0
8.758, 17856.0
8.75867, 17857.0
8.75933, 17858.0
8.76, 17859.0
8.76067, 17861.0
8.76133, 17863.0
8.762, 17865.0
8.76267, 17868.0
8.76333, 17871.0
8.764, 17873.0
8.76467, 17876.0
8.76533, 17879.0
8.766, 17883.0
8.76667, 17886.0
8.76733, 17890.0
8.768, 17893.0
8.76867, 17895.0
8.76933, 17898.0
8.77, 17900.0
8.77067, 17901.0
8.77133, 17902.0
8.772, 17903.0
8.77267, 17904.0
8.77333, 17905.0
8.774, 17906.0
8.77467, 17907.0
8.77533, 17908.0
8.776, 17908.0
8.77667, 17909.0
8.77733, 17909.0
8.778, 17909.0
8.77867, 17909.0
8.77933, 17908.0
8.78, 17906.0
8.78067, 17904.0
8.78133, 17901.0
8.782, 17898.0
8.78267, 17894.0
8.78333, 17889.0
8.784, 17883.0
8.78467, 17877.0
8.78533, 17870.0
8.786, 17862.0
8.78667, 17854.0
8.78733, 17846.0
8.788, 17837.0
8.78867, 17828.0
8.78933, 17818.0
8.79, 17808.0
8.79067, 17799.0
8.79133, 17789.0
8.792, 17780.0
8.79267, 17771.0
8.79333, 17762.0
8.794, 17754.0
8.79467, 17747.0
8.79533, 17741.0
8.796, 17735.0
8.79667, 17730.0
8.79733, 17726.0
8.798, 17723.0
8.79867, 17720.0
8.79933, 17719.0
8.8, 17718.0
8.80067, 17718.0
8.80133, 17718.0
8.802, 17719.0
8.80267, 17720.0
8.80333, 17722.0
8.804, 17725.0
8.80467, 17727.0
8.80533, 17730.0
8.806, 17733.0
8.80667, 17735.0
8.80733, 17738.0
8.808, 17740.0
8.80867, 17742.0
8.80933, 17745.0
8.81, 17747.0
8.81067, 17749.0
8.81133, 17752.0
8.812, 17754.0
8.81267, 17756.0
8.81333, 17758.0
8.814, 17759.0
8.81467, 17761.0
8.81533, 17763.0
8.816, 17765.0
8.81667, 17767.0
8.81733, 17770.0
8.818, 17772.0
8.81867, 17774.0
8.81933, 17777.0
8.82, 17778.0
8.82067, 17780.0
8.82133, 17782.0
8.822, 17784.0
8.82267, 17786.0
8.82333, 17788.0
8.824, 17791.0
8.82467, 17794.0
8.82533, 17797.0
8.826, 17801.0
8.82667, 17805.0
8.82733, 17809.0
8.828, 17813.0
8.82867, 17818.0
8.82933, 17822.0
8.83, 17827.0
8.83067, 17832.0
8.83133, 17837.0
8.832, 17842.0
8.83267, 17846.0
8.83333, 17851.0
8.834, 17856.0
8.83467, 17860.0
8.83533, 17865.0
8.836, 17869.0
8.83667, 17873.0
8.83733, 17877.0
8.838, 17880.0
8.83867, 17884.0
8.83933, 17886.0
8.84, 17889.0
8.84067, 17890.0
8.84133, 17891.0
8.842, 17892.0
8.84267, 17892.0
8.84333, 17892.0
8.844, 17891.0
8.84467, 17889.0
8.84533, 17887.0
8.846, 17885.0
8.84667, 17883.0
8.84733, 17880.0
8.848, 17878.0
8.84867, 17875.0
8.84933, 17873.0
8.85, 17870.0
8.85067, 17868.0
8.85133, 17866.0
8.852, 17864.0
8.85267, 17862.0
8.85333, 17860.0
8.854, 17859.0
8.85467, 17857.0
8.85533, 17857.0
8.856, 17856.0
8.85667, 17856.0
8.85733, 17856.0
8.858, 17857.0
8.85867, 17858.0
8.85933, 17859.0
8.86, 17861.0
8.86067, 17863.0
8.86133, 17865.0
8.862, 17866.0
8.86267, 17868.0
8.86333, 17869.0
8.864, 17871.0
8.86467, 17872.0
8.86533, 17874.0
8.866, 17876.0
8.86667, 17878.0
8.86733, 17880.0
8.868, 17883.0
8.86867, 17885.0
8.86933, 17889.0
8.87, 17892.0
8.87067, 17895.0
8.87133, 17899.0
8.872, 17904.0
8.87267, 17908.0
8.87333, 17913.0
8.874, 17917.0
8.87467, 17922.0
8.87533, 17928.0
8.876, 17933.0
8.87667, 17939.0
8.87733, 17946.0
8.878, 17952.0
8.87867, 17959.0
8.87933, 17965.0
8.88, 17972.0
8.88067, 17979.0
8.88133, 17986.0
8.882, 17992.0
8.88267, 17999.0
8.88333, 18004.0
8.884, 18010.0
8.88467, 18015.0
8.88533, 18020.0
8.886, 18024.0
8.88667, 18027.0
8.88733, 18029.0
8.888, 18031.0
8.88867, 18032.0
8.88933, 18032.0
8.89, 18032.0
8.89067, 18032.0
8.89133, 18031.0
8.892, 18030.0
8.89267, 18029.0
8.89333, 18028.0
8.894, 18026.0
8.89467, 18025.0
8.89533, 18024.0
8.896, 18023.0
8.89667, 18022.0
8.89733, 18022.0
8.898, 18022.0
8.89867, 18024.0
8.89933, 18025.0
8.9, 18028.0
8.90067, 18032.0
8.90133, 18036.0
8.902, 18042.0
8.90267, 18048.0
8.90333, 18055.0
8.904, 18063.0
8.90467, 18071.0
8.90533, 18080.0
8.906, 18088.0
8.90667, 18096.0
8.90733, 18104.0
8.908, 18112.0
8.90867, 18119.0
8.90933, 18127.0
8.91, 18133.0
8.91067, 18139.0
8.91133, 18145.0
8.912, 18150.0
8.91267, 18155.0
8.91333, 18159.0
8.914, 18163.0
8.91467, 18166.0
8.91533, 18169.0
8.916, 18172.0
8.91667, 18174.0
8.91733, 18177.0
8.918, 18179.0
8.91867, 18181.0
8.91933, 18183.0
8.92, 18185.0
8.92067, 18186.0
8.92133, 18188.0
8.922, 18190.0
8.92267, 18191.0
8.92333, 18193.0
8.924, 18194.0
8.92467, 18195.0
8.92533, 18196.0
8.926, 18196.0
8.92667, 18197.0
8.92733, 18198.0
8.928, 18199.0
8.92867, 18201.0
8.92933, 18203.0
8.93, 18205.0
8.93067, 18207.0
8.93133, 18210.0
8.932, 18213.0
8.93267, 18215.0
8.93333, 18219.0
8.934, 18221.0
8.93467, 18224.0
8.93533, 18227.0
8.936, 18229.0
8.93667, 18231.0
8.93733, 18233.0
8.938, 18235.0
8.93867, 18238.0
8.93933, 18240.0
8.94, 18243.0
8.94067, 18246.0
8.94133, 18249.0
8.942, 18252.0
8.94267, 18256.0
8.94333, 18260.0
8.944, 18265.0
8.94467, 18270.0
8.94533, 18275.0
8.946, 18281.0
8.94667, 18288.0
8.94733, 18295.0
8.948, 18302.0
8.94867, 18309.0
8.94933, 18316.0
8.95, 18323.0
8.95067, 18329.0
8.95133, 18336.0
8.952, 18341.0
8.95267, 18347.0
8.95333, 18353.0
8.954, 18358.0
8.95467, 18363.0
8.95533, 18368.0
8.956, 18373.0
8.95667, 18377.0
8.95733, 18381.0
8.958, 18385.0
8.95867, 18389.0
8.95933, 18393.0
8.96, 18396.0
8.96067, 18398.0
8.96133, 18401.0
8.962, 18403.0
8.96267, 18404.0
8.96333, 18406.0
8.964, 18407.0
8.96467, 18408.0
8.96533, 18409.0
8.966, 18410.0
8.96667, 18411.0
8.96733, 18412.0
8.968, 18412.0
8.96867, 18412.0
8.96933, 18413.0
8.97, 18413.0
8.97067, 18413.0
8.97133, 18413.0
8.972, 18414.0
8.97267, 18414.0
8.97333, 18414.0
8.974, 18415.0
8.97467, 18415.0
8.97533, 18414.0
8.976, 18414.0
8.97667, 18413.0
8.97733, 18411.0
8.978, 18409.0
8.97867, 18406.0
8.97933, 18403.0
8.98, 18400.0
8.98067, 18396.0
8.98133, 18391.0
8.982, 18386.0
8.98267, 18381.0
8.98333, 18375.0
8.984, 18369.0
8.98467, 18363.0
8.98533, 18356.0
8.986, 18349.0
8.98667, 18343.0
8.98733, 18336.0
8.988, 18329.0
8.98867, 18322.0
8.98933, 18315.0
8.99, 18307.0
8.99067, 18300.0
8.99133, 18292.0
8.992, 18285.0
8.99267, 18277.0
8.99333, 18269.0
8.994, 18261.0
8.99467, 18254.0
8.99533, 18246.0
8.996, 18239.0
8.99667, 18233.0
8.99733, 18226.0
8.998, 18221.0
8.99867, 18215.0
8.99933, 18210.0
9.0, 18205.0
9.00067, 18199.0
9.00133, 18194.0
9.002, 18189.0
9.00267, 18184.0
9.00333, 18179.0
9.004, 18173.0
9.00467, 18168.0
9.00533, 18162.0
9.006, 18156.0
9.00667, 18150.0
9.00733, 18143.0
9.008, 18135.0
9.00867, 18127.0
9.00933, 18119.0
9.01, 18110.0
9.01067, 18101.0
9.01133, 18092.0
9.012, 18082.0
9.01267, 18072.0
9.01333, 18062.0
9.014, 18051.0
9.01467, 18039.0
9.01533, 18028.0
9.016, 18016.0
9.01667, 18005.0
9.01733, 17994.0
9.018, 17982.0
9.01867, 17971.0
9.01933, 17961.0
9.02, 17951.0
9.02067, 17941.0
9.02133, 17931.0
9.022, 17922.0
9.02267, 17913.0
9.02333, 17906.0
9.024, 17898.0
9.02467, 17892.0
9.02533, 17886.0
9.026, 17881.0
9.02667, 17877.0
9.02733, 17874.0
9.028, 17871.0
9.02867, 17870.0
9.02933, 17868.0
9.03, 17868.0
9.03067, 17868.0
9.03133, 17868.0
9.032, 17869.0
9.03267, 17870.0
9.03333, 17870.0
9.034, 17871.0
9.03467, 17871.0
9.03533, 17872.0
9.036, 17872.0
9.03667, 17871.0
9.03733, 17871.0
9.038, 17870.0
9.03867, 17869.0
9.03933, 17868.0
9.04, 17866.0
9.04067, 17865.0
9.04133, 17864.0
9.042, 17862.0
9.04267, 17861.0
9.04333, 17859.0
9.044, 17857.0
9.04467, 17855.0
9.04533, 17853.0
9.046, 17851.0
9.04667, 17849.0
9.04733, 17846.0
9.048, 17844.0
9.04867, 17841.0
9.04933, 17838.0
9.05, 17835.0
9.05067, 17832.0
9.05133, 17828.0
9.052, 17825.0
9.05267, 17821.0
9.05333, 17818.0
9.054, 17814.0
9.05467, 17811.0
9.05533, 17809.0
9.056, 17806.0
9.05667, 17804.0
9.05733, 17801.0
9.058, 17799.0
9.05867, 17797.0
9.05933, 17795.0
9.06, 17793.0
9.06067, 17791.0
9.06133, 17789.0
9.062, 17788.0
9.06267, 17786.0
9.06333, 17785.0
9.064, 17783.0
9.06467, 17782.0
9.06533, 17781.0
9.066, 17781.0
9.06667, 17780.0
9.06733, 17780.0
9.068, 17779.0
9.06867, 17779.0
9.06933, 17778.0
9.07, 17778.0
9.07067, 17777.0
9.07133, 17777.0
9.072, 17776.0
9.07267, 17776.0
9.07333, 17775.0
9.074, 17775.0
9.07467, 17775.0
9.07533, 17775.0
9.076, 17774.0
9.07667, 17773.0
9.07733, 17772.0
9.078, 17771.0
9.07867, 17769.0
9.07933, 17767.0
9.08, 17765.0
9.08067, 17763.0
9.08133, 17761.0
9.082, 17758.0
9.08267, 17755.0
9.08333, 17752.0
9.084, 17749.0
9.08467, 17746.0
9.08533, 17742.0
9.086, 17738.0
9.08667, 17735.0
9.08733, 17731.0
9.088, 17728.0
9.08867, 17725.0
9.08933, 17723.0
9.09, 17721.0
9.09067, 17719.0
9.09133, 17718.0
9.092, 17718.0
9.09267, 17718.0
9.09333, 17718.0
9.094, 17720.0
9.09467, 17721.0
9.09533, 17723.0
9.096, 17725.0
9.09667, 17728.0
9.09733, 17731.0
9.098, 17734.0
9.09867, 17738.0
9.09933, 17742.0
9.1, 17746.0
9.10067, 17751.0
9.10133, 17756.0
9.102, 17762.0
9.10267, 17767.0
9.10333, 17773.0
9.104, 17779.0
9.10467, 17785.0
9.10533, 17792.0
9.106, 17799.0
9.10667, 17807.0
9.10733, 17815.0
9.108, 17823.0
9.10867, 17832.0
9.10933, 17841.0
9.11, 17850.0
9.11067, 17859.0
9.11133, 17868.0
9.112, 17877.0
9.11267, 17886.0
9.11333, 17895.0
9.114, 17905.0
9.11467, 17916.0
9.11533, 17927.0
9.116, 17939.0
9.11667, 17951.0
9.11733, 17963.0
9.118, 17975.0
9.11867, 17987.0
9.11933, 17999.0
9.12, 18011.0
9.12067, 18022.0
9.12133, 18033.0
9.122, 18043.0
9.12267, 18053.0
9.12333, 18062.0
9.124, 18071.0
9.12467, 18079.0
9.12533, 18087.0
9.126, 18095.0
9.12667, 18101.0
9.12733, 18107.0
9.128, 18113.0
9.12867, 18117.0
9.12933, 18121.0
9.13, 18124.0
9.13067, 18127.0
9.13133, 18129.0
9.132, 18131.0
9.13267, 18132.0
9.13333, 18133.0
9.134, 18134.0
9.13467, 18134.0
9.13533, 18135.0
9.136, 18135.0
9.13667, 18134.0
9.13733, 18134.0
9.138, 18133.0
9.13867, 18133.0
9.13933, 18132.0
9.14, 18132.0
9.14067, 18132.0
9.14133, 18132.0
9.142, 18133.0
9.14267, 18133.0
9.14333, 18135.0
9.144, 18136.0
9.14467, 18138.0
9.14533, 18140.0
9.146, 18143.0
9.14667, 18146.0
9.14733, 18149.0
9.148, 18153.0
9.14867, 18156.0
9.14933, 18159.0
9.15, 18162.0
9.15067, 18165.0
9.15133, 18168.0
9.152, 18171.0
9.15267, 18173.0
9.15333, 18175.0
9.154, 18178.0
9.15467, 18180.0
9.15533, 18181.0
9.156, 18183.0
9.15667, 18185.0
9.15733, 18188.0
9.158, 18189.0
9.15867, 18191.0
9.15933, 18193.0
9.16, 18195.0
9.16067, 18198.0
9.16133, 18200.0
9.162, 18203.0
9.16267, 18205.0
9.16333, 18208.0
9.164, 18211.0
9.16467, 18214.0
9.16533, 18218.0
9.166, 18222.0
9.16667, 18226.0
9.16733, 18230.0
9.168, 18235.0
9.16867, 18239.0
9.16933, 18244.0
9.17, 18249.0
9.17067, 18254.0
9.17133, 18258.0
9.172, 18263.0
9.17267, 18268.0
9.17333, 18272.0
9.174, 18277.0
9.17467, 18282.0
9.17533, 18287.0
9.176, 18293.0
9.17667, 18299.0
9.17733, 18304.0
9.178, 18310.0
9.17867, 18315.0
9.17933, 18321.0
9.18, 18326.0
9.18067, 18331.0
9.18133, 18336.0
9.182, 18340.0
9.18267, 18345.0
9.18333, 18349.0
9.184, 18353.0
9.18467, 18356.0
9.18533, 18359.0
9.186, 18362.0
9.18667, 18364.0
9.18733, 18367.0
9.188, 18370.0
9.18867, 18373.0
9.18933, 18376.0
9.19, 18379.0
9.19067, 18383.0
9.19133, 18386.0
9.192, 18389.0
9.19267, 18393.0
9.19333, 18396.0
9.194, 18400.0
9.19467, 18404.0
9.19533, 18407.0
9.196, 18411.0
9.19667, 18415.0
9.19733, 18419.0
9.198, 18424.0
9.19867, 18428.0
9.19933, 18432.0
9.2, 18437.0
9.20067, 18442.0
9.20133, 18446.0
9.202, 18450.0
9.20267, 18454.0
9.20333, 18457.0
9.204, 18460.0
9.20467, 18463.0
9.20533, 18466.0
9.206, 18468.0
9.20667, 18471.0
9.20733, 18473.0
9.208, 18476.0
9.20867, 18479.0
9.20933, 18481.0
9.21, 18484.0
9.21067, 18487.0
9.21133, 18490.0
9.212, 18492.0
9.21267, 18495.0
9.21333, 18498.0
9.214, 18501.0
9.21467, 18504.0
9.21533, 18507.0
9.216, 18509.0
9.21667, 18512.0
9.21733, 18515.0
9.218, 18517.0
9.21867, 18520.0
9.21933, 18522.0
9.22, 18525.0
9.22067, 18527.0
9.22133, 18530.0
9.222, 18532.0
9.22267, 18535.0
9.22333, 18538.0
9.224, 18541.0
9.22467, 18544.0
9.22533, 18547.0
9.226, 18551.0
9.22667, 18554.0
9.22733, 18558.0
9.228, 18561.0
9.22867, 18564.0
9.22933, 18567.0
9.23, 18571.0
9.23067, 18574.0
9.23133, 18576.0
9.232, 18580.0
9.23267, 18583.0
9.23333, 18586.0
9.234, 18590.0
9.23467, 18593.0
9.23533, 18597.0
9.236, 18601.0
9.23667, 18606.0
9.23733, 18611.0
9.238, 18616.0
9.23867, 18621.0
9.23933, 18627.0
9.24, 18633.0
9.24067, 18639.0
9.24133, 18645.0
9.242, 18651.0
9.24267, 18657.0
9.24333, 18663.0
9.244, 18670.0
9.24467, 18676.0
9.24533, 18683.0
9.246, 18689.0
9.24667, 18695.0
9.24733, 18700.0
9.248, 18706.0
9.24867, 18711.0
9.24933, 18716.0
9.25, 18721.0
9.25067, 18725.0
9.25133, 18729.0
9.252, 18733.0
9.25267, 18737.0
9.25333, 18741.0
9.254, 18744.0
9.25467, 18748.0
9.25533, 18751.0
9.256, 18755.0
9.25667, 18759.0
9.25733, 18764.0
9.258, 18768.0
9.25867, 18772.0
9.25933, 18776.0
9.26, 18779.0
9.26067, 18782.0
9.26133, 18785.0
9.262, 18788.0
9.26267, 18791.0
9.26333, 18794.0
9.264, 18798.0
9.26467, 18802.0
9.26533, 18806.0
9.266, 18811.0
9.26667, 18816.0
9.26733, 18822.0
9.268, 18828.0
9.26867, 18833.0
9.26933, 18839.0
9.27, 18845.0
9.27067, 18850.0
9.27133, 18856.0
9.272, 18861.0
9.27267, 18866.0
9.27333, 18871.0
9.274, 18877.0
9.27467, 18882.0
9.27533, 18888.0
9.276, 18893.0
9.27667, 18899.0
9.27733, 18905.0
9.278, 18911.0
9.27867, 18918.0
9.27933, 18925.0
9.28, 18932.0
9.28067, 18940.0
9.28133, 18949.0
9.282, 18958.0
9.28267, 18968.0
9.28333, 18977.0
9.284, 18988.0
9.28467, 18998.0
9.28533, 19009.0
9.286, 19019.0
9.28667, 19030.0
9.28733, 19041.0
9.288, 19053.0
9.28867, 19064.0
9.28933, 19076.0
9.29, 19088.0
9.29067, 19101.0
9.29133, 19114.0
9.292, 19127.0
9.29267, 19140.0
9.29333, 19153.0
9.294, 19166.0
9.29467, 19179.0
9.29533, 19192.0
9.296, 19205.0
9.29667, 19217.0
9.29733, 19230.0
9.298, 19242.0
9.29867, 19254.0
9.29933, 19265.0
9.3, 19277.0
9.30067, 19287.0
9.30133, 19298.0
9.302, 19308.0
9.30267, 19318.0
9.30333, 19327.0
9.304, 19335.0
9.30467, 19343.0
9.30533, 19350.0
9.306, 19356.0
9.30667, 19361.0
9.30733, 19364.0
9.308, 19366.0
9.30867, 19368.0
9.30933, 19368.0
9.31, 19367.0
9.31067, 19365.0
9.31133, 19364.0
9.312, 19362.0
9.31267, 19361.0
9.31333, 19359.0
9.314, 19358.0
9.31467, 19357.0
9.31533, 19356.0
9.316, 19355.0
9.31667, 19355.0
9.31733, 19355.0
9.318, 19356.0
9.31867, 19357.0
9.31933, 19358.0
9.32, 19360.0
9.32067, 19362.0
9.32133, 19364.0
9.322, 19366.0
9.32267, 19368.0
9.32333, 19371.0
9.324, 19374.0
9.32467, 19377.0
9.32533, 19379.0
9.326, 19382.0
9.32667, 19385.0
9.32733, 19387.0
9.328, 19389.0
9.32867, 19391.0
9.32933, 19393.0
9.33, 19394.0
9.33067, 19395.0
9.33133, 19397.0
9.332, 19398.0
9.33267, 19400.0
9.33333, 19401.0
9.334, 19403.0
9.33467, 19404.0
9.33533, 19405.0
9.336, 19406.0
9.33667, 19407.0
9.33733, 19409.0
9.338, 19410.0
9.33867, 19412.0
9.33933, 19414.0
9.34, 19416.0
9.34067, 19418.0
9.34133, 19420.0
9.342, 19422.0
9.34267, 19424.0
9.34333, 19426.0
9.344, 19429.0
9.34467, 19431.0
9.34533, 19435.0
9.346, 19438.0
9.34667, 19443.0
9.34733, 19447.0
9.348, 19452.0
9.34867, 19456.0
9.34933, 19461.0
9.35, 19467.0
9.35067, 19473.0
9.35133, 19478.0
9.352, 19484.0
9.35267, 19490.0
9.35333, 19496.0
9.354, 19501.0
9.35467, 19507.0
9.35533, 19512.0
9.356, 19518.0
9.35667, 19524.0
9.35733, 19531.0
9.358, 19538.0
9.35867, 19546.0
9.35933, 19554.0
9.36, 19563.0
9.36067, 19573.0
9.36133, 19583.0
9.362, 19594.0
9.36267, 19605.0
9.36333, 19616.0
9.364, 19628.0
9.36467, 19640.0
9.36533, 19652.0
9.366, 19663.0
9.36667, 19675.0
9.36733, 19686.0
9.368, 19697.0
9.36867, 19707.0
9.36933, 19717.0
9.37, 19726.0
9.37067, 19735.0
9.37133, 19744.0
9.372, 19753.0
9.37267, 19762.0
9.37333, 19770.0
9.374, 19779.0
9.37467, 19788.0
9.37533, 19796.0
9.376, 19804.0
9.37667, 19813.0
9.37733, 19821.0
9.378, 19828.0
9.37867, 19836.0
9.37933, 19843.0
9.38, 19850.0
9.38067, 19856.0
9.38133, 19862.0
9.382, 19868.0
9.38267, 19874.0
9.38333, 19880.0
9.384, 19885.0
9.38467, 19891.0
9.38533, 19896.0
9.386, 19901.0
9.38667, 19906.0
9.38733, 19912.0
9.388, 19917.0
9.38867, 19922.0
9.38933, 19927.0
9.39, 19932.0
9.39067, 19937.0
9.39133, 19941.0
9.392, 19945.0
9.39267, 19949.0
9.39333, 19953.0
9.394, 19957.0
9.39467, 19962.0
9.39533, 19966.0
9.396, 19971.0
9.39667, 19976.0
9.39733, 19981.0
9.398, 19986.0
9.39867, 19991.0
9.39933, 19995.0
9.4, 19998.0
9.40067, 20002.0
9.40133, 20004.0
9.402, 20006.0
9.40267, 20008.0
9.40333, 20009.0
9.404, 20010.0
9.40467, 20011.0
9.40533, 20011.0
9.406, 20013.0
9.40667, 20014.0
9.40733, 20016.0
9.408, 20017.0
9.40867, 20019.0
9.40933, 20022.0
9.41, 20024.0
9.41067, 20026.0
9.41133, 20029.0
9.412, 20031.0
9.41267, 20034.0
9.41333, 20036.0
9.414, 20039.0
9.41467, 20041.0
9.41533, 20044.0
9.416, 20046.0
9.41667, 20048.0
9.41733, 20050.0
9.418, 20052.0
9.41867, 20054.0
9.41933, 20056.0
9.42, 20058.0
9.42067, 20060.0
9.42133, 20062.0
9.422, 20064.0
9.42267, 20066.0
9.42333, 20069.0
9.424, 20071.0
9.42467, 20072.0
9.42533, 20074.0
9.426, 20076.0
9.42667, 20077.0
9.42733, 20079.0
9.428, 20080.0
9.42867, 20082.0
9.42933, 20083.0
9.43, 20085.0
9.43067, 20086.0
9.43133, 20087.0
9.432, 20088.0
9.43267, 20088.0
9.43333, 20089.0
9.434, 20089.0
9.43467, 20089.0
9.43533, 20088.0
9.436, 20087.0
9.43667, 20086.0
9.43733, 20084.0
9.438, 20082.0
9.43867, 20081.0
9.43933, 20079.0
9.44, 20078.0
9.44067, 20077.0
9.44133, 20076.0
9.442, 20075.0
9.44267, 20074.0
9.44333, 20073.0
9.444, 20072.0
9.44467, 20071.0
9.44533, 20069.0
9.446, 20067.0
9.44667, 20064.0
9.44733, 20061.0
9.448, 20058.0
9.44867, 20055.0
9.44933, 20052.0
9.45, 20049.0
9.45067, 20047.0
9.45133, 20045.0
9.452, 20043.0
9.45267, 20041.0
9.45333, 20040.0
9.454, 20038.0
9.45467, 20036.0
9.45533, 20033.0
9.456, 20031.0
9.45667, 20029.0
9.45733, 20026.0
9.458, 20024.0
9.45867, 20022.0
9.45933, 20020.0
9.46, 20018.0
9.46067, 20016.0
9.46133, 20013.0
9.462, 20011.0
9.46267, 20007.0
9.46333, 20004.0
9.464, 20000.0
9.46467, 19996.0
9.46533, 19992.0
9.466, 19988.0
9.46667, 19984.0
9.46733, 19980.0
9.468, 19977.0
9.46867, 19974.0
9.46933, 19972.0
9.47, 19970.0
9.47067, 19968.0
9.47133, 19967.0
9.472, 19966.0
9.47267, 19965.0
9.47333, 19965.0
9.474, 19965.0
9.47467, 19965.0
9.47533, 19965.0
9.476, 19965.0
9.47667, 19965.0
9.47733, 19965.0
9.478, 19966.0
9.47867, 19967.0
9.47933, 19968.0
9.48, 19970.0
9.48067, 19973.0
9.48133, 19976.0
9.482, 19979.0
9.48267, 19983.0
9.48333, 19988.0
9.484, 19993.0
9.48467, 19998.0
9.48533, 20003.0
9.486, 20009.0
9.48667, 20015.0
9.48733, 20021.0
9.488, 20028.0
9.48867, 20035.0
9.48933, 20043.0
9.49, 20051.0
9.49067, 20060.0
9.49133, 20069.0
9.492, 20079.0
9.49267, 20089.0
9.49333, 20099.0
9.494, 20108.0
9.49467, 20118.0
9.49533, 20127.0
9.496, 20137.0
9.49667, 20146.0
9.49733, 20155.0
9.498, 20164.0
9.49867, 20174.0
9.49933, 20183.0
9.5, 20192.0
9.50067, 20202.0
9.50133, 20212.0
9.502, 20223.0
9.50267, 20234.0
9.50333, 20246.0
9.504, 20259.0
9.50467, 20272.0
9.50533, 20285.0
9.506, 20299.0
9.50667, 20314.0
9.50733, 20329.0
9.508, 20344.0
9.50867, 20359.0
9.50933, 20375.0
9.51, 20391.0
9.51067, 20407.0
9.51133, 20423.0
9.512, 20439.0
9.51267, 20455.0
9.51333, 20471.0
9.514, 20487.0
9.51467, 20503.0
9.51533, 20518.0
9.516, 20533.0
9.51667, 20548.0
9.51733, 20562.0
9.518, 20576.0
9.51867, 20590.0
9.51933, 20604.0
9.52, 20616.0
9.52067, 20628.0
9.52133, 20640.0
9.522, 20650.0
9.52267, 20660.0
9.52333, 20670.0
9.524, 20679.0
9.52467, 20687.0
9.52533, 20694.0
9.526, 20702.0
9.52667, 20710.0
9.52733, 20717.0
9.528, 20725.0
9.52867, 20732.0
9.52933, 20739.0
9.53, 20745.0
9.53067, 20752.0
9.53133, 20757.0
9.532, 20763.0
9.53267, 20768.0
9.53333, 20774.0
9.534, 20779.0
9.53467, 20784.0
9.53533, 20789.0
9.536, 20794.0
9.53667, 20799.0
9.53733, 20803.0
9.538, 20808.0
9.53867, 20813.0
9.53933, 20817.0
9.54, 20822.0
9.54067, 20827.0
9.54133, 20832.0
9.542, 20837.0
9.54267, 20841.0
9.54333, 20845.0
9.544, 20849.0
9.54467, 20852.0
9.54533, 20855.0
9.546, 20858.0
9.54667, 20860.0
9.54733, 20863.0
9.548, 20865.0
9.54867, 20867.0
9.54933, 20870.0
9.55, 20872.0
9.55067, 20875.0
9.55133, 20878.0
9.552, 20881.0
9.55267, 20885.0
9.55333, 20889.0
9.554, 20893.0
9.55467, 20897.0
9.55533, 20902.0
9.556, 20906.0
9.55667, 20911.0
9.55733, 20916.0
9.558, 20921.0
9.55867, 20926.0
9.55933, 20931.0
9.56, 20935.0
9.56067, 20940.0
9.56133, 20944.0
9.562, 20947.0
9.56267, 20951.0
9.56333, 20954.0
9.564, 20957.0
9.56467, 20960.0
9.56533, 20964.0
9.566, 20967.0
9.56667, 20970.0
9.56733, 20973.0
9.568, 20976.0
9.56867, 20978.0
9.56933, 20981.0
9.57, 20983.0
9.57067, 20985.0
9.57133, 20987.0
9.572, 20990.0
9.57267, 20992.0
9.57333, 20994.0
9.574, 20996.0
9.57467, 20999.0
9.57533, 21001.0
9.576, 21004.0
9.57667, 21006.0
9.57733, 21009.0
9.578, 21012.0
9.57867, 21016.0
9.57933, 21020.0
9.58, 21025.0
9.58067, 21030.0
9.58133, 21035.0
9.582, 21040.0
9.58267, 21046.0
9.58333, 21051.0
9.584, 21057.0
9.58467, 21062.0
9.58533, 21067.0
9.586, 21071.0
9.58667, 21075.0
9.58733, 21077.0
9.588, 21079.0
9.58867, 21080.0
9.58933, 21080.0
9.59, 21079.0
9.59067, 21077.0
9.59133, 21074.0
9.592, 21071.0
9.59267, 21068.0
9.59333, 21064.0
9.594, 21061.0
9.59467, 21058.0
9.59533, 21055.0
9.596, 21052.0
9.59667, 21050.0
9.59733, 21047.0
9.598, 21044.0
9.59867, 21040.0
9.59933, 21036.0
9.6, 21031.0
9.60067, 21025.0
9.60133, 21019.0
9.602, 21013.0
9.60267, 21006.0
9.60333, 20999.0
9.604, 20991.0
9.60467, 20983.0
9.60533, 20975.0
9.606, 20968.0
9.60667, 20960.0
9.60733, 20953.0
9.608, 20947.0
9.60867, 20940.0
9.60933, 20934.0
9.61, 20929.0
9.61067, 20924.0
9.61133, 20919.0
9.612, 20914.0
9.61267, 20909.0
9.61333, 20905.0
9.614, 20901.0
9.61467, 20897.0
9.61533, 20893.0
9.616, 20889.0
9.61667, 20886.0
9.61733, 20882.0
9.618, 20879.0
9.61867, 20876.0
9.61933, 20873.0
9.62, 20870.0
9.62067, 20867.0
9.62133, 20865.0
9.622, 20863.0
9.62267, 20862.0
9.62333, 20861.0
9.624, 20861.0
9.62467, 20862.0
9.62533, 20862.0
9.626, 20864.0
9.62667, 20865.0
9.62733, 20867.0
9.628, 20869.0
9.62867, 20872.0
9.62933, 20875.0
9.63, 20879.0
9.63067, 20883.0
9.63133, 20888.0
9.632, 20892.0
9.63267, 20897.0
9.63333, 20901.0
9.634, 20906.0
9.63467, 20910.0
9.63533, 20914.0
9.636, 20918.0
9.63667, 20922.0
9.63733, 20926.0
9.638, 20929.0
9.63867, 20932.0
9.63933, 20934.0
9.64, 20937.0
9.64067, 20940.0
9.64133, 20943.0
9.642, 20945.0
9.64267, 20948.0
9.64333, 20950.0
9.644, 20953.0
9.64467, 20955.0
9.64533, 20958.0
9.646, 20962.0
9.64667, 20965.0
9.64733, 20968.0
9.648, 20972.0
9.64867, 20975.0
9.64933, 20979.0
9.65, 20982.0
9.65067, 20986.0
9.65133, 20989.0
9.652, 20992.0
9.65267, 20995.0
9.65333, 20998.0
9.654, 21001.0
9.65467, 21004.0
9.65533, 21007.0
9.656, 21012.0
9.65667, 21016.0
9.65733, 21022.0
9.658, 21028.0
9.65867, 21034.0
9.65933, 21041.0
9.66, 21049.0
9.66067, 21057.0
9.66133, 21065.0
9.662, 21075.0
9.66267, 21084.0
9.66333, 21094.0
9.664, 21105.0
9.66467, 21115.0
9.66533, 21126.0
9.666, 21136.0
9.66667, 21146.0
9.66733, 21156.0
9.668, 21165.0
9.66867, 21174.0
9.66933, 21182.0
9.67, 21190.0
9.67067, 21198.0
9.67133, 21206.0
9.672, 21214.0
9.67267, 21223.0
9.67333, 21232.0
9.674, 21242.0
9.67467, 21252.0
9.67533, 21263.0
9.676, 21273.0
9.67667, 21284.0
9.67733, 21295.0
9.678, 21305.0
9.67867, 21316.0
9.67933, 21327.0
9.68, 21338.0
9.68067, 21349.0
9.68133, 21359.0
9.682, 21369.0
9.68267, 21379.0
9.68333, 21389.0
9.684, 21398.0
9.68467, 21406.0
9.68533, 21413.0
9.686, 21420.0
9.68667, 21426.0
9.68733, 21432.0
9.688, 21437.0
9.68867, 21442.0
9.68933, 21446.0
9.69, 21450.0
9.69067, 21453.0
9.69133, 21456.0
9.692, 21458.0
9.69267, 21461.0
9.69333, 21463.0
9.694, 21465.0
9.69467, 21466.0
9.69533, 21468.0
9.696, 21469.0
9.69667, 21471.0
9.69733, 21473.0
9.698, 21475.0
9.69867, 21477.0
9.69933, 21479.0
9.7, 21482.0
9.70067, 21484.0
9.70133, 21488.0
9.702, 21492.0
9.70267, 21496.0
9.70333, 21501.0
9.704, 21506.0
9.70467, 21511.0
9.70533, 21517.0
9.706, 21523.0
9.70667, 21528.0
9.70733, 21534.0
9.708, 21540.0
9.70867, 21546.0
9.70933, 21551.0
9.71, 21556.0
9.71067, 21560.0
9.71133, 21564.0
9.712, 21568.0
9.71267, 21571.0
9.71333, 21573.0
9.714, 21575.0
9.71467, 21575.0
9.71533, 21575.0
9.716, 21575.0
9.71667, 21574.0
9.71733, 21572.0
9.718, 21569.0
9.71867, 21566.0
9.71933, 21563.0
9.72, 21559.0
9.72067, 21554.0
9.72133, 21549.0
9.722, 21544.0
9.72267, 21537.0
9.72333, 21531.0
9.724, 21523.0
9.72467, 21516.0
9.72533, 21507.0
9.726, 21498.0
9.72667, 21489.0
9.72733, 21479.0
9.728, 21469.0
9.72867, 21458.0
9.72933, 21447.0
9.73, 21435.0
9.73067, 21423.0
9.73133, 21411.0
9.732, 21398.0
9.73267, 21386.0
9.73333, 21374.0
9.734, 21362.0
9.73467, 21351.0
9.73533, 21340.0
9.736, 21330.0
9.73667, 21320.0
9.73733, 21311.0
9.738, 21302.0
9.73867, 21294.0
9.73933, 21285.0
9.74, 21276.0
9.74067, 21268.0
9.74133, 21260.0
9.742, 21252.0
9.74267, 21245.0
9.74333, 21237.0
9.744, 21230.0
9.74467, 21223.0
9.74533, 21217.0
9.746, 21211.0
9.74667, 21205.0
9.74733, 21199.0
9.748, 21193.0
9.74867, 21187.0
9.74933, 21182.0
9.75, 21177.0
9.75067, 21172.0
9.75133, 21168.0
9.752, 21164.0
9.75267, 21162.0
9.75333, 21159.0
9.754, 21158.0
9.75467, 21157.0
9.75533, 21158.0
9.756, 21159.0
9.75667, 21161.0
9.75733, 21163.0
9.758, 21167.0
9.75867, 21171.0
9.75933, 21176.0
9.76, 21182.0
9.76067, 21188.0
9.76133, 21196.0
9.762, 21204.0
9.76267, 21213.0
9.76333, 21223.0
9.764, 21233.0
9.76467, 21243.0
9.76533, 21254.0
9.766, 21265.0
9.76667, 21277.0
9.76733, 21288.0
9.768, 21300.0
9.76867, 21313.0
9.76933, 21325.0
9.77, 21337.0
9.77067, 21350.0
9.77133, 21362.0
9.772, 21375.0
9.77267, 21387.0
9.77333, 21399.0
9.774, 21411.0
9.77467, 21424.0
9.77533, 21436.0
9.776, 21449.0
9.77667, 21461.0
9.77733, 21475.0
9.778, 21488.0
9.77867, 21501.0
9.77933, 21515.0
9.78, 21528.0
9.78067, 21540.0
9.78133, 21552.0
9.782, 21564.0
9.78267, 21575.0
9.78333, 21587.0
9.784, 21598.0
9.78467, 21608.0
9.78533, 21619.0
9.786, 21630.0
9.78667, 21640.0
9.78733, 21650.0
9.788, 21660.0
9.78867, 21671.0
9.78933, 21681.0
9.79, 21691.0
9.79067, 21701.0
9.79133, 21711.0
9.792, 21720.0
9.79267, 21730.0
9.79333, 21739.0
9.794, 21748.0
9.79467, 21758.0
9.79533, 21767.0
9.796, 21776.0
9.79667, 21785.0
9.79733, 21795.0
9.798, 21804.0
9.79867, 21814.0
9.79933, 21824.0
9.8, 21835.0
9.80067, 21846.0
9.80133, 21858.0
9.802, 21870.0
9.80267, 21881.0
9.80333, 21893.0
9.804, 21905.0
9.80467, 21917.0
9.80533, 21928.0
9.806, 21939.0
9.80667, 21950.0
9.80733, 21961.0
9.808, 21971.0
9.80867, 21981.0
9.80933, 21991.0
9.81, 22001.0
9.81067, 22010.0
9.81133, 22019.0
9.812, 22029.0
9.81267, 22038.0
9.81333, 22048.0
9.814, 22058.0
9.81467, 22068.0
9.81533, 22079.0
9.816, 22089.0
9.81667, 22099.0
9.81733, 22109.0
9.818, 22118.0
9.81867, 22127.0
9.81933, 22136.0
9.82, 22146.0
9.82067, 22155.0
9.82133, 22164.0
9.822, 22173.0
9.82267, 22182.0
9.82333, 22190.0
9.824, 22198.0
9.82467, 22206.0
9.82533, 22214.0
9.826, 22222.0
9.82667, 22229.0
9.82733, 22237.0
9.828, 22244.0
9.82867, 22252.0
9.82933, 22260.0
9.83, 22268.0
9.83067, 22276.0
9.83133, 22284.0
9.832, 22292.0
9.83267, 22301.0
9.83333, 22309.0
9.834, 22317.0
9.83467, 22326.0
9.83533, 22335.0
9.836, 22345.0
9.83667, 22355.0
9.83733, 22365.0
9.838, 22376.0
9.83867, 22386.0
9.83933, 22396.0
9.84, 22407.0
9.84067, 22417.0
9.84133, 22427.0
9.842, 22437.0
9.84267, 22447.0
9.84333, 22457.0
9.844, 22467.0
9.84467, 22477.0
9.84533, 22487.0
9.846, 22497.0
9.84667, 22507.0
9.84733, 22517.0
9.848, 22527.0
9.84867, 22537.0
9.84933, 22546.0
9.85, 22555.0
9.85067, 22565.0
9.85133, 22573.0
9.852, 22582.0
9.85267, 22590.0
9.85333, 22597.0
9.854, 22604.0
9.85467, 22610.0
9.85533, 22616.0
9.856, 22621.0
9.85667, 22625.0
9.85733, 22628.0
9.858, 22631.0
9.85867, 22634.0
9.85933, 22636.0
9.86, 22637.0
9.86067, 22638.0
9.86133, 22639.0
9.862, 22640.0
9.86267, 22641.0
9.86333, 22643.0
9.864, 22644.0
9.86467, 22645.0
9.86533, 22645.0
9.866, 22646.0
9.86667, 22645.0
9.86733, 22645.0
9.868, 22644.0
9.86867, 22643.0
9.86933, 22641.0
9.87, 22640.0
9.87067, 22639.0
9.87133, 22638.0
9.872, 22637.0
9.87267, 22636.0
9.87333, 22636.0
9.874, 22635.0
9.87467, 22635.0
9.87533, 22634.0
9.876, 22634.0
9.87667, 22633.0
9.87733, 22632.0
9.878, 22631.0
9.87867, 22630.0
9.87933, 22629.0
9.88, 22628.0
9.88067, 22627.0
9.88133, 22626.0
9.882, 22624.0
9.88267, 22622.0
9.88333, 22620.0
9.884, 22618.0
9.88467, 22616.0
9.88533, 22615.0
9.886, 22614.0
9.88667, 22613.0
9.88733, 22613.0
9.888, 22614.0
9.88867, 22615.0
9.88933, 22617.0
9.89, 22620.0
9.89067, 22624.0
9.89133, 22628.0
9.892, 22633.0
9.89267, 22638.0
9.89333, 22644.0
9.894, 22650.0
9.89467, 22656.0
9.89533, 22662.0
9.896, 22668.0
9.89667, 22675.0
9.89733, 22681.0
9.898, 22688.0
9.89867, 22696.0
9.89933, 22704.0
9.9, 22712.0
9.90067, 22721.0
9.90133, 22730.0
9.902, 22740.0
9.90267, 22749.0
9.90333, 22760.0
9.904, 22770.0
9.90467, 22781.0
9.90533, 22792.0
9.906, 22803.0
9.90667, 22814.0
9.90733, 22825.0
9.908, 22835.0
9.90867, 22845.0
9.90933, 22855.0
9.91, 22865.0
9.91067, 22874.0
9.91133, 22883.0
9.912, 22892.0
9.91267, 22900.0
9.91333, 22908.0
9.914, 22915.0
9.91467, 22922.0
9.91533, 22928.0
9.916, 22935.0
9.91667, 22941.0
9.91733, 22948.0
9.918, 22955.0
9.91867, 22962.0
9.91933, 22970.0
9.92, 22979.0
9.92067, 22987.0
9.92133, 22996.0
9.922, 23005.0
9.92267, 23015.0
9.92333, 23025.0
9.924, 23034.0
9.92467, 23044.0
9.92533, 23055.0
9.926, 23066.0
9.92667, 23076.0
9.92733, 23087.0
9.928, 23098.0
9.92867, 23108.0
9.92933, 23119.0
9.93, 23130.0
9.93067, 23141.0
9.93133, 23151.0
9.932, 23161.0
9.93267, 23171.0
9.93333, 23181.0
9.934, 23191.0
9.93467, 23200.0
9.93533, 23209.0
9.936, 23218.0
9.93667, 23227.0
9.93733, 23235.0
9.938, 23243.0
9.93867, 23251.0
9.93933, 23258.0
9.94, 23265.0
9.94067, 23271.0
9.94133, 23277.0
9.942, 23282.0
9.94267, 23287.0
9.94333, 23291.0
9.944, 23295.0
9.94467, 23298.0
9.94533, 23301.0
9.946, 23303.0
9.94667, 23305.0
9.94733, 23306.0
9.948, 23308.0
9.94867, 23309.0
9.94933, 23309.0
9.95, 23309.0
9.95067, 23309.0
9.95133, 23308.0
9.952, 23307.0
9.95267, 23307.0
9.95333, 23306.0
9.954, 23306.0
9.95467, 23306.0
9.95533, 23307.0
9.956, 23308.0
9.95667, 23310.0
9.95733, 23312.0
9.958, 23314.0
9.95867, 23316.0
9.95933, 23319.0
9.96, 23321.0
9.96067, 23324.0
9.96133, 23327.0
9.962, 23330.0
9.96267, 23334.0
9.96333, 23339.0
9.964, 23344.0
9.96467, 23350.0
9.96533, 23355.0
9.966, 23362.0
9.96667, 23368.0
9.96733, 23374.0
9.968, 23380.0
9.96867, 23386.0
9.96933, 23391.0
9.97, 23396.0
9.97067, 23400.0
9.97133, 23404.0
9.972, 23407.0
9.97267, 23410.0
9.97333, 23412.0
9.974, 23415.0
9.97467, 23416.0
9.97533, 23418.0
9.976, 23420.0
9.97667, 23421.0
9.97733, 23422.0
9.978, 23422.0
9.97867, 23422.0
9.97933, 23422.0
9.98, 23422.0
9.98067, 23422.0
9.98133, 23422.0
9.982, 23422.0
9.98267, 23423.0
9.98333, 23424.0
9.984, 23426.0
9.98467, 23428.0
9.98533, 23431.0
9.986, 23434.0
9.98667, 23438.0
9.98733, 23442.0
9.988, 23446.0
9.98867, 23451.0
9.98933, 23455.0
9.99, 23461.0
9.99067, 23466.0
9.99133, 23471.0
9.992, 23477.0
9.99267, 23483.0
9.99333, 23489.0
9.994, 23495.0
9.99467, 23501.0
9.99533, 23506.0
9.996, 23512.0
9.99667, 23517.0
9.99733, 23522.0
9.998, 23527.0
9.99867, 23532.0
9.99933, 23537.0
10.0, 23543.0
10.00067, 23549.0
10.00133, 23555.0
10.002, 23562.0
10.00267, 23569.0
10.00333, 23577.0
10.004, 23585.0
10.00467, 23592.0
10.00533, 23600.0
10.006, 23608.0
10.00667, 23616.0
10.00733, 23624.0
10.008, 23631.0
10.00867, 23638.0
10.00933, 23645.0
10.01, 23651.0
10.01067, 23657.0
10.01133, 23662.0
10.012, 23667.0
10.01267, 23671.0
10.01333, 23676.0
10.014, 23680.0
10.01467, 23685.0
10.01533, 23691.0
10.016, 23697.0
10.01667, 23705.0
10.01733, 23713.0
10.018, 23721.0
10.01867, 23731.0
10.01933, 23741.0
10.02, 23751.0
10.02067, 23761.0
10.02133, 23771.0
10.022, 23782.0
10.02267, 23793.0
10.02333, 23804.0
10.024, 23816.0
10.02467, 23828.0
10.02533, 23839.0
10.026, 23850.0
10.02667, 23861.0
10.02733, 23871.0
10.028, 23881.0
10.02867, 23890.0
10.02933, 23899.0
10.03, 23908.0
10.03067, 23916.0
10.03133, 23925.0
10.032, 23933.0
10.03267, 23941.0
10.03333, 23950.0
10.034, 23958.0
10.03467, 23967.0
10.03533, 23977.0
10.036, 23986.0
10.03667, 23996.0
10.03733, 24007.0
10.038, 24017.0
10.03867, 24028.0
10.03933, 24039.0
10.04, 24050.0
10.04067, 24062.0
10.04133, 24073.0
10.042, 24083.0
10.04267, 24094.0
10.04333, 24105.0
10.044, 24116.0
10.04467, 24127.0
10.04533, 24138.0
10.046, 24149.0
10.04667, 24159.0
10.04733, 24170.0
10.048, 24180.0
10.04867, 24190.0
10.04933, 24201.0
10.05, 24211.0
10.05067, 24221.0
10.05133, 24231.0
10.052, 24241.0
10.05267, 24250.0
10.05333, 24260.0
10.054, 24268.0
10.05467, 24277.0
10.05533, 24285.0
10.056, 24293.0
10.05667, 24300.0
10.05733, 24308.0
10.058, 24316.0
10.05867, 24323.0
10.05933, 24331.0
10.06, 24339.0
10.06067, 24348.0
10.06133, 24357.0
10.062, 24366.0
10.06267, 24376.0
10.06333, 24387.0
10.064, 24397.0
10.06467, 24408.0
10.06533, 24418.0
10.066, 24429.0
10.06667, 24439.0
10.06733, 24448.0
10.068, 24457.0
10.06867, 24466.0
10.06933, 24474.0
10.07, 24482.0
10.07067, 24489.0
10.07133, 24495.0
10.072, 24501.0
10.07267, 24506.0
10.07333, 24511.0
10.074, 24515.0
10.07467, 24519.0
10.07533, 24523.0
10.076, 24526.0
10.07667, 24529.0
10.07733, 24531.0
10.078, 24534.0
10.07867, 24537.0
10.07933, 24540.0
10.08, 24544.0
10.08067, 24547.0
10.08133, 24550.0
10.082, 24553.0
10.08267, 24555.0
10.08333, 24557.0
10.084, 24559.0
10.08467, 24559.0
10.08533, 24559.0
10.086, 24558.0
10.08667, 24557.0
10.08733, 24555.0
10.088, 24552.0
10.08867, 24549.0
10.08933, 24546.0
10.09, 24544.0
10.09067, 24541.0
10.09133, 24539.0
10.092, 24538.0
10.09267, 24538.0
10.09333, 24538.0
10.094, 24539.0
10.09467, 24542.0
10.09533, 24545.0
10.096, 24550.0
10.09667, 24555.0
10.09733, 24561.0
10.098, 24569.0
10.09867, 24577.0
10.09933, 24585.0
10.1, 24595.0
10.10067, 24605.0
10.10133, 24616.0
10.102, 24628.0
10.10267, 24641.0
10.10333, 24654.0
10.104, 24669.0
10.10467, 24683.0
10.10533, 24698.0
10.106, 24713.0
10.10667, 24728.0
10.10733, 24743.0
10.108, 24757.0
10.10867, 24771.0
10.10933, 24784.0
10.11, 24796.0
10.11067, 24807.0
10.11133, 24818.0
10.112, 24827.0
10.11267, 24834.0
10.11333, 24841.0
10.114, 24846.0
10.11467, 24850.0
10.11533, 24854.0
10.116, 24856.0
10.11667, 24857.0
10.11733, 24857.0
10.118, 24858.0
10.11867, 24858.0
10.11933, 24859.0
10.12, 24860.0
10.12067, 24862.0
10.12133, 24864.0
10.122, 24866.0
10.12267, 24869.0
10.12333, 24872.0
10.124, 24875.0
10.12467, 24877.0
10.12533, 24880.0
10.126, 24882.0
10.12667, 24884.0
10.12733, 24885.0
10.128, 24887.0
10.12867, 24889.0
10.12933, 24891.0
10.13, 24893.0
10.13067, 24896.0
10.13133, 24899.0
10.132, 24902.0
10.13267, 24906.0
10.13333, 24909.0
10.134, 24913.0
10.13467, 24916.0
10.13533, 24920.0
10.136, 24923.0
10.13667, 24927.0
10.13733, 24931.0
10.138, 24936.0
10.13867, 24940.0
10.13933, 24946.0
10.14, 24951.0
10.14067, 24957.0
10.14133, 24964.0
10.142, 24972.0
10.14267, 24981.0
10.14333, 24990.0
10.144, 24999.0
10.14467, 25010.0
10.14533, 25020.0
10.146, 25031.0
10.14667, 25042.0
10.14733, 25054.0
10.148, 25065.0
10.14867, 25076.0
10.14933, 25086.0
10.15, 25097.0
10.15067, 25109.0
10.15133, 25120.0
10.152, 25131.0
10.15267, 25144.0
10.15333, 25156.0
10.154, 25170.0
10.15467, 25184.0
10.15533, 25198.0
10.156, 25213.0
10.15667, 25228.0
10.15733, 25242.0
10.158, 25257.0
10.15867, 25271.0
10.15933, 25285.0
10.16, 25299.0
10.16067, 25313.0
10.16133, 25327.0
10.162, 25340.0
10.16267, 25354.0
10.16333, 25368.0
10.164, 25382.0
10.16467, 25396.0
10.16533, 25410.0
10.166, 25425.0
10.16667, 25440.0
10.16733, 25456.0
10.168, 25472.0
10.16867, 25488.0
10.16933, 25505.0
10.17, 25521.0
10.17067, 25537.0
10.17133, 25553.0
10.172, 25569.0
10.17267, 25585.0
10.17333, 25600.0
10.174, 25616.0
10.17467, 25631.0
10.17533, 25647.0
10.176, 25662.0
10.17667, 25678.0
10.17733, 25694.0
10.178, 25710.0
10.17867, 25726.0
10.17933, 25743.0
10.18, 25759.0
10.18067, 25775.0
10.18133, 25791.0
10.182, 25807.0
10.18267, 25822.0
10.18333, 25838.0
10.184, 25854.0
10.18467, 25869.0
10.18533, 25884.0
10.186, 25898.0
10.18667, 25911.0
10.18733, 25925.0
10.188, 25938.0
10.18867, 25951.0
10.18933, 25964.0
10.19, 25977.0
10.19067, 25990.0
10.19133, 26004.0
10.192, 26017.0
10.19267, 26029.0
10.19333, 26042.0
10.194, 26054.0
10.19467, 26065.0
10.19533, 26076.0
10.196, 26087.0
10.19667, 26097.0
10.19733, 26107.0
10.198, 26117.0
10.19867, 26126.0
10.19933, 26135.0
10.2, 26144.0
10.20067, 26153.0
10.20133, 26161.0
10.202, 26169.0
10.20267, 26178.0
10.20333, 26186.0
10.204, 26195.0
10.20467, 26203.0
10.20533, 26212.0
10.206, 26221.0
10.20667, 26230.0
10.20733, 26239.0
10.208, 26248.0
10.20867, 26258.0
10.20933, 26268.0
10.21, 26278.0
10.21067, 26288.0
10.21133, 26298.0
10.212, 26308.0
10.21267, 26318.0
10.21333, 26326.0
10.214, 26335.0
10.21467, 26342.0
10.21533, 26349.0
10.216, 26356.0
10.21667, 26362.0
10.21733, 26368.0
10.218, 26373.0
10.21867, 26377.0
10.21933, 26381.0
10.22, 26385.0
10.22067, 26387.0
10.22133, 26390.0
10.222, 26392.0
10.22267, 26394.0
10.22333, 26396.0
10.224, 26398.0
10.22467, 26400.0
10.22533, 26402.0
10.226, 26404.0
10.22667, 26406.0
10.22733, 26409.0
10.228, 26411.0
10.22867, 26414.0
10.22933, 26417.0
10.23, 26420.0
10.23067, 26424.0
10.23133, 26428.0
10.232, 26432.0
10.23267, 26436.0
10.23333, 26440.0
10.234, 26444.0
10.23467, 26448.0
10.23533, 26452.0
10.236, 26456.0
10.23667, 26461.0
10.23733, 26467.0
10.238, 26474.0
10.23867, 26481.0
10.23933, 26490.0
10.24, 26499.0
10.24067, 26509.0
10.24133, 26520.0
10.242, 26533.0
10.24267, 26546.0
10.24333, 26559.0
10.244, 26574.0
10.24467, 26589.0
10.24533, 26605.0
10.246, 26621.0
10.24667, 26637.0
10.24733, 26653.0
10.248, 26668.0
10.24867, 26682.0
10.24933, 26696.0
10.25, 26709.0
10.25067, 26722.0
10.25133, 26733.0
10.252, 26744.0
10.25267, 26754.0
10.25333, 26764.0
10.254, 26773.0
10.25467, 26781.0
10.25533, 26790.0
10.256, 26799.0
10.25667, 26808.0
10.25733, 26817.0
10.258, 26827.0
10.25867, 26838.0
10.25933, 26848.0
10.26, 26859.0
10.26067, 26869.0
10.26133, 26878.0
10.262, 26887.0
10.26267, 26895.0
10.26333, 26902.0
10.264, 26909.0
10.26467, 26915.0
10.26533, 26920.0
10.266, 26924.0
10.26667, 26928.0
10.26733, 26932.0
10.268, 26935.0
10.26867, 26937.0
10.26933, 26939.0
10.27, 26940.0
10.27067, 26941.0
10.27133, 26942.0
10.272, 26943.0
10.27267, 26945.0
10.27333, 26946.0
10.274, 26948.0
10.27467, 26951.0
10.27533, 26953.0
10.276, 26955.0
10.27667, 26957.0
10.27733, 26958.0
10.278, 26959.0
10.27867, 26959.0
10.27933, 26959.0
10.28, 26958.0
10.28067, 26958.0
10.28133, 26958.0
10.282, 26957.0
10.28267, 26957.0
10.28333, 26957.0
10.284, 26956.0
10.28467, 26956.0
10.28533, 26956.0
10.286, 26955.0
10.28667, 26954.0
10.28733, 26953.0
10.288, 26952.0
10.28867, 26951.0
10.28933, 26949.0
10.29, 26946.0
10.29067, 26944.0
10.29133, 26940.0
10.292, 26937.0
10.29267, 26933.0
10.29333, 26929.0
10.294, 26925.0
10.29467, 26920.0
10.29533, 26915.0
10.296, 26909.0
10.29667, 26904.0
10.29733, 26898.0
10.298, 26893.0
10.29867, 26887.0
10.29933, 26882.0
10.3, 26877.0
10.30067, 26872.0
10.30133, 26867.0
10.302, 26862.0
10.30267, 26858.0
10.30333, 26854.0
10.304, 26849.0
10.30467, 26845.0
10.30533, 26841.0
10.306, 26836.0
10.30667, 26831.0
10.30733, 26826.0
10.308, 26821.0
10.30867, 26817.0
10.30933, 26813.0
10.31, 26810.0
10.31067, 26807.0
10.31133, 26806.0
10.312, 26805.0
10.31267, 26805.0
10.31333, 26806.0
10.314, 26808.0
10.31467, 26811.0
10.31533, 26813.0
10.316, 26816.0
10.31667, 26820.0
10.31733, 26823.0
10.318, 26826.0
10.31867, 26829.0
10.31933, 26832.0
10.32, 26835.0
10.32067, 26838.0
10.32133, 26840.0
10.322, 26842.0
10.32267, 26844.0
10.32333, 26845.0
10.324, 26846.0
10.32467, 26847.0
10.32533, 26849.0
10.326, 26851.0
10.32667, 26853.0
10.32733, 26856.0
10.328, 26860.0
10.32867, 26864.0
10.32933, 26868.0
10.33, 26873.0
10.33067, 26878.0
10.33133, 26883.0
10.332, 26887.0
10.33267, 26891.0
10.33333, 26895.0
10.334, 26899.0
10.33467, 26903.0
10.33533, 26907.0
10.336, 26910.0
10.33667, 26914.0
10.33733, 26918.0
10.338, 26922.0
10.33867, 26927.0
10.33933, 26932.0
10.34, 26938.0
10.34067, 26944.0
10.34133, 26951.0
10.342, 26959.0
10.34267, 26966.0
10.34333, 26974.0
10.344, 26982.0
10.34467, 26989.0
10.34533, 26997.0
10.346, 27004.0
10.34667, 27010.0
10.34733, 27017.0
10.348, 27022.0
10.34867, 27028.0
10.34933, 27033.0
10.35, 27037.0
10.35067, 27041.0
10.35133, 27046.0
10.352, 27050.0
10.35267, 27055.0
10.35333, 27060.0
10.354, 27065.0
10.35467, 27070.0
10.35533, 27075.0
10.356, 27081.0
10.35667, 27086.0
10.35733, 27090.0
10.358, 27094.0
10.35867, 27097.0
10.35933, 27098.0
10.36, 27100.0
10.36067, 27100.0
10.36133, 27101.0
10.362, 27101.0
10.36267, 27100.0
10.36333, 27100.0
10.364, 27099.0
10.36467, 27098.0
10.36533, 27097.0
10.366, 27097.0
10.36667, 27096.0
10.36733, 27095.0
10.368, 27094.0
10.36867, 27093.0
10.36933, 27092.0
10.37, 27091.0
10.37067, 27090.0
10.37133, 27089.0
10.372, 27088.0
10.37267, 27087.0
10.37333, 27086.0
10.374, 27086.0
10.37467, 27087.0
10.37533, 27088.0
10.376, 27089.0
10.37667, 27090.0
10.37733, 27091.0
10.378, 27093.0
10.37867, 27095.0
10.37933, 27098.0
10.38, 27101.0
10.38067, 27105.0
10.38133, 27109.0
10.382, 27114.0
10.38267, 27120.0
10.38333, 27127.0
10.384, 27135.0
10.38467, 27143.0
10.38533, 27152.0
10.386, 27161.0
10.38667, 27170.0
10.38733, 27178.0
10.388, 27187.0
10.38867, 27196.0
10.38933, 27205.0
10.39, 27214.0
10.39067, 27224.0
10.39133, 27234.0
10.392, 27245.0
10.39267, 27257.0
10.39333, 27269.0
10.394, 27282.0
10.39467, 27296.0
10.39533, 27310.0
10.396, 27324.0
10.39667, 27339.0
10.39733, 27354.0
10.398, 27369.0
10.39867, 27384.0
10.39933, 27399.0
10.4, 27414.0
10.40067, 27428.0
10.40133, 27442.0
10.402, 27456.0
10.40267, 27469.0
10.40333, 27481.0
10.404, 27493.0
10.40467, 27505.0
10.40533, 27516.0
10.406, 27527.0
10.40667, 27537.0
10.40733, 27547.0
10.408, 27556.0
10.40867, 27565.0
10.40933, 27574.0
10.41, 27582.0
10.41067, 27590.0
10.41133, 27597.0
10.412, 27603.0
10.41267, 27609.0
10.41333, 27615.0
10.414, 27619.0
10.41467, 27623.0
10.41533, 27627.0
10.416, 27630.0
10.41667, 27632.0
10.41733, 27633.0
10.418, 27634.0
10.41867, 27635.0
10.41933, 27635.0
10.42, 27635.0
10.42067, 27635.0
10.42133, 27636.0
10.422, 27636.0
10.42267, 27636.0
10.42333, 27637.0
10.424, 27638.0
10.42467, 27639.0
10.42533, 27640.0
10.426, 27641.0
10.42667, 27641.0
10.42733, 27640.0
10.428, 27638.0
10.42867, 27636.0
10.42933, 27633.0
10.43, 27629.0
10.43067, 27624.0
10.43133, 27619.0
10.432, 27613.0
10.43267, 27606.0
10.43333, 27600.0
10.434, 27593.0
10.43467, 27586.0
10.43533, 27580.0
10.436, 27573.0
10.43667, 27567.0
10.43733, 27561.0
10.438, 27556.0
10.43867, 27551.0
10.43933, 27547.0
10.44, 27544.0
10.44067, 27541.0
10.44133, 27538.0
10.442, 27534.0
10.44267, 27531.0
10.44333, 27528.0
10.444, 27525.0
10.44467, 27521.0
10.44533, 27518.0
10.446, 27515.0
10.44667, 27512.0
10.44733, 27509.0
10.448, 27505.0
10.44867, 27502.0
10.44933, 27498.0
10.45, 27494.0
10.45067, 27490.0
10.45133, 27485.0
10.452, 27479.0
10.45267, 27473.0
10.45333, 27467.0
10.454, 27461.0
10.45467, 27455.0
10.45533, 27449.0
10.456, 27444.0
10.45667, 27440.0
10.45733, 27436.0
10.458, 27432.0
10.45867, 27429.0
10.45933, 27426.0
10.46, 27423.0
10.46067, 27421.0
10.46133, 27419.0
10.462, 27417.0
10.46267, 27415.0
10.46333, 27414.0
10.464, 27413.0
10.46467, 27412.0
10.46533, 27412.0
10.466, 27412.0
10.46667, 27413.0
10.46733, 27414.0
10.468, 27416.0
10.46867, 27417.0
10.46933, 27419.0
10.47, 27421.0
10.47067, 27422.0
10.47133, 27423.0
10.472, 27424.0
10.47267, 27425.0
10.47333, 27425.0
10.474, 27425.0
10.47467, 27426.0
10.47533, 27426.0
10.476, 27426.0
10.47667, 27427.0
10.47733, 27427.0
10.478, 27427.0
10.47867, 27427.0
10.47933, 27426.0
10.48, 27426.0
10.48067, 27424.0
10.48133, 27423.0
10.482, 27421.0
10.48267, 27419.0
10.48333, 27416.0
10.484, 27413.0
10.48467, 27410.0
10.48533, 27407.0
10.486, 27403.0
10.48667, 27398.0
10.48733, 27394.0
10.488, 27388.0
10.48867, 27382.0
10.48933, 27376.0
10.49, 27369.0
10.49067, 27361.0
10.49133, 27353.0
10.492, 27345.0
10.49267, 27336.0
10.49333, 27327.0
10.494, 27318.0
10.49467, 27310.0
10.49533, 27301.0
10.496, 27292.0
10.49667, 27284.0
10.49733, 27275.0
10.498, 27267.0
10.49867, 27258.0
10.49933, 27249.0
10.5, 27241.0
10.50067, 27233.0
10.50133, 27224.0
10.502, 27216.0
10.50267, 27209.0
10.50333, 27202.0
10.504, 27195.0
10.50467, 27189.0
10.50533, 27183.0
10.506, 27177.0
10.50667, 27172.0
10.50733, 27167.0
10.508, 27162.0
10.50867, 27158.0
10.50933, 27154.0
10.51, 27150.0
10.51067, 27146.0
10.51133, 27143.0
10.512, 27139.0
10.51267, 27134.0
10.51333, 27130.0
10.514, 27125.0
10.51467, 27120.0
10.51533, 27115.0
10.516, 27109.0
10.51667, 27103.0
10.51733, 27097.0
10.518, 27091.0
10.51867, 27084.0
10.51933, 27078.0
10.52, 27071.0
10.52067, 27063.0
10.52133, 27056.0
10.522, 27048.0
10.52267, 27041.0
10.52333, 27033.0
10.524, 27025.0
10.52467, 27018.0
10.52533, 27010.0
10.526, 27003.0
10.52667, 26996.0
10.52733, 26990.0
10.528, 26984.0
10.52867, 26979.0
10.52933, 26974.0
10.53, 26971.0
10.53067, 26969.0
10.53133, 26967.0
10.532, 26967.0
10.53267, 26967.0
10.53333, 26968.0
10.534, 26969.0
10.53467, 26971.0
10.53533, 26973.0
10.536, 26975.0
10.53667, 26978.0
10.53733, 26980.0
10.538, 26982.0
10.53867, 26984.0
10.53933, 26985.0
10.54, 26987.0
10.54067, 26987.0
10.54133, 26988.0
10.542, 26988.0
10.54267, 26987.0
10.54333, 26986.0
10.544, 26985.0
10.54467, 26983.0
10.54533, 26982.0
10.546, 26980.0
10.54667, 26979.0
10.54733, 26977.0
10.548, 26976.0
10.54867, 26975.0
10.54933, 26974.0
10.55, 26973.0
10.55067, 26973.0
10.55133, 26973.0
10.552, 26974.0
10.55267, 26975.0
10.55333, 26976.0
10.554, 26977.0
10.55467, 26978.0
10.55533, 26979.0
10.556, 26980.0
10.55667, 26982.0
10.55733, 26985.0
10.558, 26987.0
10.55867, 26991.0
10.55933, 26994.0
10.56, 26998.0
10.56067, 27002.0
10.56133, 27006.0
10.562, 27010.0
10.56267, 27014.0
10.56333, 27018.0
10.564, 27022.0
10.56467, 27025.0
10.56533, 27029.0
10.566, 27033.0
10.56667, 27037.0
10.56733, 27042.0
10.568, 27046.0
10.56867, 27051.0
10.56933, 27055.0
10.57, 27059.0
10.57067, 27063.0
10.57133, 27067.0
10.572, 27071.0
10.57267, 27074.0
10.57333, 27078.0
10.574, 27082.0
10.57467, 27086.0
10.57533, 27090.0
10.576, 27094.0
10.57667, 27098.0
10.57733, 27102.0
10.578, 27106.0
10.57867, 27108.0
10.57933, 27111.0
10.58, 27112.0
10.58067, 27113.0
10.58133, 27113.0
10.582, 27113.0
10.58267, 27113.0
10.58333, 27112.0
10.584, 27112.0
10.58467, 27111.0
10.58533, 27111.0
10.586, 27111.0
10.58667, 27111.0
10.58733, 27111.0
10.588, 27112.0
10.58867, 27114.0
10.58933, 27116.0
10.59, 27118.0
10.59067, 27120.0
10.59133, 27122.0
10.592, 27125.0
10.59267, 27129.0
10.59333, 27133.0
10.594, 27137.0
10.59467, 27141.0
10.59533, 27145.0
10.596, 27149.0
10.59667, 27152.0
10.59733, 27154.0
10.598, 27157.0
10.59867, 27158.0
10.59933, 27159.0
10.6, 27160.0
10.60067, 27161.0
10.60133, 27162.0
10.602, 27163.0
10.60267, 27164.0
10.60333, 27165.0
10.604, 27167.0
10.60467, 27168.0
10.60533, 27170.0
10.606, 27172.0
10.60667, 27174.0
10.60733, 27176.0
10.608, 27177.0
10.60867, 27179.0
10.60933, 27181.0
10.61, 27183.0
10.61067, 27185.0
10.61133, 27188.0
10.612, 27191.0
10.61267, 27195.0
10.61333, 27199.0
10.614, 27204.0
10.61467, 27209.0
10.61533, 27215.0
10.616, 27222.0
10.61667, 27228.0
10.61733, 27235.0
10.618, 27242.0
10.61867, 27249.0
10.61933, 27256.0
10.62, 27263.0
10.62067, 27270.0
10.62133, 27278.0
10.622, 27286.0
10.62267, 27294.0
10.62333, 27303.0
10.624, 27312.0
10.62467, 27321.0
10.62533, 27331.0
10.626, 27341.0
10.62667, 27352.0
10.62733, 27364.0
10.628, 27376.0
10.62867, 27389.0
10.62933, 27403.0
10.63, 27417.0
10.63067, 27431.0
10.63133, 27445.0
10.632, 27460.0
10.63267, 27474.0
10.63333, 27489.0
10.634, 27503.0
10.63467, 27518.0
10.63533, 27533.0
10.636, 27548.0
10.63667, 27563.0
10.63733, 27578.0
10.638, 27592.0
10.63867, 27606.0
10.63933, 27620.0
10.64, 27633.0
10.64067, 27645.0
10.64133, 27656.0
10.642, 27667.0
10.64267, 27677.0
10.64333, 27687.0
10.644, 27696.0
10.64467, 27706.0
10.64533, 27715.0
10.646, 27725.0
10.64667, 27735.0
10.64733, 27745.0
10.648, 27756.0
10.64867, 27767.0
10.64933, 27778.0
10.65, 27789.0
10.65067, 27800.0
10.65133, 27811.0
10.652, 27821.0
10.65267, 27831.0
10.65333, 27841.0
10.654, 27850.0
10.65467, 27858.0
10.65533, 27867.0
10.656, 27875.0
10.65667, 27882.0
10.65733, 27889.0
10.658, 27895.0
10.65867, 27901.0
10.65933, 27906.0
10.66, 27911.0
10.66067, 27915.0
10.66133, 27919.0
10.662, 27922.0
10.66267, 27925.0
10.66333, 27927.0
10.664, 27929.0
10.66467, 27930.0
10.66533, 27931.0
10.666, 27932.0
10.66667, 27932.0
10.66733, 27932.0
10.668, 27932.0
10.66867, 27932.0
10.66933, 27932.0
10.67, 27931.0
10.67067, 27930.0
10.67133, 27929.0
10.672, 27927.0
10.67267, 27926.0
10.67333, 27924.0
10.674, 27923.0
10.67467, 27921.0
10.67533, 27920.0
10.676, 27918.0
10.67667, 27917.0
10.67733, 27916.0
10.678, 27914.0
10.67867, 27913.0
10.67933, 27911.0
10.68, 27910.0
10.68067, 27908.0
10.68133, 27907.0
10.682, 27906.0
10.68267, 27904.0
10.68333, 27904.0
10.684, 27903.0
10.68467, 27902.0
10.68533, 27901.0
10.686, 27901.0
10.68667, 27899.0
10.68733, 27898.0
10.688, 27896.0
10.68867, 27894.0
10.68933, 27892.0
10.69, 27890.0
10.69067, 27888.0
10.69133, 27886.0
10.692, 27885.0
10.69267, 27885.0
10.69333, 27885.0
10.694, 27886.0
10.69467, 27887.0
10.69533, 27890.0
10.696, 27893.0
10.69667, 27897.0
10.69733, 27902.0
10.698, 27907.0
10.69867, 27914.0
10.69933, 27920.0
10.7, 27926.0
10.70067, 27933.0
10.70133, 27939.0
10.702, 27945.0
10.70267, 27951.0
10.70333, 27958.0
10.704, 27965.0
10.70467, 27972.0
10.70533, 27979.0
10.706, 27986.0
10.70667, 27993.0
10.70733, 28001.0
10.708, 28009.0
10.70867, 28017.0
10.70933, 28025.0
10.71, 28033.0
10.71067, 28039.0
10.71133, 28046.0
10.712, 28051.0
10.71267, 28056.0
10.71333, 28060.0
10.714, 28064.0
10.71467, 28067.0
10.71533, 28070.0
10.716, 28072.0
10.71667, 28074.0
10.71733, 28076.0
10.718, 28078.0
10.71867, 28079.0
10.71933, 28081.0
10.72, 28083.0
10.72067, 28084.0
10.72133, 28086.0
10.722, 28087.0
10.72267, 28089.0
10.72333, 28090.0
10.724, 28091.0
10.72467, 28091.0
10.72533, 28092.0
10.726, 28093.0
10.72667, 28094.0
10.72733, 28095.0
10.728, 28095.0
10.72867, 28096.0
10.72933, 28096.0
10.73, 28097.0
10.73067, 28097.0
10.73133, 28098.0
10.732, 28098.0
10.73267, 28098.0
10.73333, 28098.0
10.734, 28098.0
10.73467, 28097.0
10.73533, 28097.0
10.736, 28096.0
10.73667, 28096.0
10.73733, 28097.0
10.738, 28097.0
10.73867, 28097.0
10.73933, 28097.0
10.74, 28096.0
10.74067, 28096.0
10.74133, 28095.0
10.742, 28095.0
10.74267, 28094.0
10.74333, 28094.0
10.744, 28094.0
10.74467, 28094.0
10.74533, 28095.0
10.746, 28096.0
10.74667, 28097.0
10.74733, 28099.0
10.748, 28101.0
10.74867, 28103.0
10.74933, 28105.0
10.75, 28107.0
10.75067, 28108.0
10.75133, 28109.0
10.752, 28109.0
10.75267, 28109.0
10.75333, 28107.0
10.754, 28105.0
10.75467, 28103.0
10.75533, 28100.0
10.756, 28098.0
10.75667, 28096.0
10.75733, 28094.0
10.758, 28092.0
10.75867, 28090.0
10.75933, 28089.0
10.76, 28087.0
10.76067, 28086.0
10.76133, 28084.0
10.762, 28082.0
10.76267, 28080.0
10.76333, 28077.0
10.764, 28074.0
10.76467, 28072.0
10.76533, 28069.0
10.766, 28067.0
10.76667, 28065.0
10.76733, 28062.0
10.768, 28060.0
10.76867, 28058.0
10.76933, 28055.0
10.77, 28052.0
10.77067, 28049.0
10.77133, 28046.0
10.772, 28043.0
10.77267, 28040.0
10.77333, 28038.0
10.774, 28036.0
10.77467, 28034.0
10.77533, 28032.0
10.776, 28030.0
10.77667, 28029.0
10.77733, 28027.0
10.778, 28025.0
10.77867, 28024.0
10.77933, 28022.0
10.78, 28021.0
10.78067, 28020.0
10.78133, 28020.0
10.782, 28020.0
10.78267, 28020.0
10.78333, 28021.0
10.784, 28022.0
10.78467, 28023.0
10.78533, 28025.0
10.786, 28026.0
10.78667, 28028.0
10.78733, 28029.0
10.788, 28030.0
10.78867, 28031.0
10.78933, 28031.0
10.79, 28030.0
10.79067, 28029.0
10.79133, 28028.0
10.792, 28027.0
10.79267, 28026.0
10.79333, 28024.0
10.794, 28022.0
10.79467, 28020.0
10.79533, 28019.0
10.796, 28017.0
10.79667, 28016.0
10.79733, 28015.0
10.798, 28013.0
10.79867, 28012.0
10.79933, 28010.0
10.8, 28009.0
10.80067, 28008.0
10.80133, 28006.0
10.802, 28005.0
10.80267, 28003.0
10.80333, 28001.0
10.804, 27999.0
10.80467, 27997.0
10.80533, 27994.0
10.806, 27990.0
10.80667, 27986.0
10.80733, 27982.0
10.808, 27977.0
10.80867, 27973.0
10.80933, 27969.0
10.81, 27964.0
10.81067, 27959.0
10.81133, 27954.0
10.812, 27948.0
10.81267, 27942.0
10.81333, 27936.0
10.814, 27930.0
10.81467, 27924.0
10.81533, 27917.0
10.816, 27912.0
10.81667, 27906.0
10.81733, 27900.0
10.818, 27894.0
10.81867, 27888.0
10.81933, 27881.0
10.82, 27875.0
10.82067, 27868.0
10.82133, 27861.0
10.822, 27854.0
10.82267, 27847.0
10.82333, 27840.0
10.824, 27834.0
10.82467, 27829.0
10.82533, 27825.0
10.826, 27822.0
10.82667, 27820.0
10.82733, 27819.0
10.828, 27820.0
10.82867, 27822.0
10.82933, 27825.0
10.83, 27831.0
10.83067, 27837.0
10.83133, 27846.0
10.832, 27857.0
10.83267, 27870.0
10.83333, 27885.0
10.834, 27903.0
10.83467, 27924.0
10.83533, 27949.0
10.836, 27977.0
10.83667, 28009.0
10.83733, 28045.0
10.838, 28086.0
10.83867, 28133.0
10.83933, 28185.0
10.84, 28242.0
10.84067, 28307.0
10.84133, 28377.0
10.842, 28455.0
10.84267, 28541.0
10.84333, 28635.0
10.844, 28737.0
10.84467, 28848.0
10.84533, 28968.0
10.846, 29098.0
10.84667, 29238.0
10.84733, 29389.0
10.848, 29552.0
10.84867, 29728.0
10.84933, 29916.0
10.85, 30119.0
10.85067, 30338.0
10.85133, 30572.0
10.852, 30825.0
10.85267, 31096.0
10.85333, 31387.0
10.854, 31699.0
10.85467, 32033.0
10.85533, 32391.0
10.856, 32773.0
10.85667, 33181.0
10.85733, 33616.0
10.858, 34081.0
10.85867, 34576.0
10.85933, 35104.0
10.86, 35665.0
10.86067, 36262.0
10.86133, 36897.0
10.862, 37572.0
10.86267, 38288.0
10.86333, 39048.0
10.864, 39854.0
10.86467, 40708.0
10.86533, 41611.0
10.866, 42565.0
10.86667, 43572.0
10.86733, 44633.0
10.868, 45750.0
10.86867, 46923.0
10.86933, 48156.0
10.87, 49450.0
10.87067, 50805.0
10.87133, 52225.0
10.872, 53710.0
10.87267, 55263.0
10.87333, 56884.0
10.874, 58576.0
10.87467, 60339.0
10.87533, 62174.0
10.876, 64081.0
10.87667, 66061.0
10.87733, 68113.0
10.878, 70235.0
10.87867, 72425.0
10.87933, 74683.0
10.88, 77005.0
10.88067, 79390.0
10.88133, 81836.0
10.882, 84340.0
10.88267, 86900.0
10.88333, 89514.0
10.884, 92180.0
10.88467, 94895.0
10.88533, 97655.0
10.886, 100457.0
10.88667, 103297.0
10.88733, 106173.0
10.888, 109081.0
10.88867, 112016.0
10.88933, 114974.0
10.89, 117949.0
10.89067, 120938.0
10.89133, 123934.0
10.892, 126933.0
10.89267, 129929.0
10.89333, 132918.0
10.894, 135896.0
10.89467, 138857.0
10.89533, 141797.0
10.896, 144711.0
10.89667, 147597.0
10.89733, 150451.0
10.898, 153271.0
10.89867, 156056.0
10.89933, 158801.0
10.9, 161507.0
10.90067, 164172.0
10.90133, 166795.0
10.902, 169373.0
10.90267, 171906.0
10.90333, 174392.0
10.904, 176831.0
10.90467, 179221.0
10.90533, 181562.0
10.906, 183853.0
10.90667, 186094.0
10.90733, 188284.0
10.908, 190423.0
10.90867, 192509.0
10.90933, 194542.0
10.91, 196520.0
10.91067, 198443.0
10.91133, 200309.0
10.912, 202120.0
10.91267, 203874.0
10.91333, 205573.0
10.914, 207217.0
10.91467, 208806.0
10.91533, 210342.0
10.916, 211826.0
10.91667, 213258.0
10.91733, 214642.0
10.918, 215980.0
10.91867, 217272.0
10.91933, 218523.0
10.92, 219733.0
10.92067, 220904.0
10.92133, 222037.0
10.922, 223132.0
10.92267, 224192.0
10.92333, 225215.0
10.924, 226205.0
10.92467, 227162.0
10.92533, 228087.0
10.926, 228979.0
10.92667, 229839.0
10.92733, 230668.0
10.928, 231466.0
10.92867, 232235.0
10.92933, 232977.0
10.93, 233694.0
10.93067, 234386.0
10.93133, 235056.0
10.932, 235705.0
10.93267, 236333.0
10.93333, 236944.0
10.934, 237537.0
10.93467, 238113.0
10.93533, 238674.0
10.936, 239219.0
10.93667, 239746.0
10.93733, 240253.0
10.938, 240739.0
10.93867, 241200.0
10.93933, 241635.0
10.94, 242042.0
10.94067, 242418.0
10.94133, 242764.0
10.942, 243076.0
10.94267, 243357.0
10.94333, 243607.0
10.944, 243827.0
10.94467, 244017.0
10.94533, 244179.0
10.946, 244313.0
10.94667, 244418.0
10.94733, 244498.0
10.948, 244551.0
10.94867, 244580.0
10.94933, 244584.0
10.95, 244561.0
10.95067, 244511.0
10.95133, 244432.0
10.952, 244325.0
10.95267, 244186.0
10.95333, 244016.0
10.954, 243813.0
10.95467, 243579.0
10.95533, 243314.0
10.956, 243019.0
10.95667, 242695.0
10.95733, 242343.0
10.958, 241963.0
10.95867, 241558.0
10.95933, 241128.0
10.96, 240675.0
10.96067, 240202.0
10.96133, 239710.0
10.962, 239200.0
10.96267, 238673.0
10.96333, 238131.0
10.964, 237571.0
10.96467, 236996.0
10.96533, 236405.0
10.966, 235800.0
10.96667, 235180.0
10.96733, 234547.0
10.968, 233901.0
10.96867, 233243.0
10.96933, 232573.0
10.97, 231893.0
10.97067, 231203.0
10.97133, 230503.0
10.972, 229795.0
10.97267, 229080.0
10.97333, 228357.0
10.974, 227629.0
10.97467, 226898.0
10.97533, 226165.0
10.976, 225431.0
10.97667, 224698.0
10.97733, 223968.0
10.978, 223242.0
10.97867, 222519.0
10.97933, 221800.0
10.98, 221085.0
10.98067, 220375.0
10.98133, 219669.0
10.982, 218966.0
10.98267, 218268.0
10.98333, 217574.0
10.984, 216885.0
10.98467, 216201.0
10.98533, 215521.0
10.986, 214848.0
10.98667, 214180.0
10.98733, 213518.0
10.988, 212862.0
10.98867, 212213.0
10.98933, 211571.0
10.99, 210937.0
10.99067, 210312.0
10.99133, 209695.0
10.992, 209088.0
10.99267, 208491.0
10.99333, 207903.0
10.994, 207325.0
10.99467, 206756.0
10.99533, 206197.0
10.996, 205647.0
10.99667, 205107.0
10.99733, 204577.0
10.998, 204059.0
10.99867, 203552.0
10.99933, 203057.0
11.0, 202574.0
11.00067, 202103.0
11.00133, 201645.0
11.002, 201198.0
11.00267, 200764.0
11.00333, 200340.0
11.004, 199927.0
11.00467, 199524.0
11.00533, 199131.0
11.006, 198747.0
11.00667, 198372.0
11.00733, 198006.0
11.008, 197649.0
11.00867, 197299.0
11.00933, 196956.0
11.01, 196620.0
11.01067, 196289.0
11.01133, 195961.0
11.012, 195637.0
11.01267, 195314.0
11.01333, 194993.0
11.014, 194672.0
11.01467, 194352.0
11.01533, 194032.0
11.016, 193713.0
11.01667, 193395.0
11.01733, 193077.0
11.018, 192760.0
11.01867, 192443.0
11.01933, 192127.0
11.02, 191811.0
11.02067, 191495.0
11.02133, 191181.0
11.022, 190867.0
11.02267, 190555.0
11.02333, 190243.0
11.024, 189933.0
11.02467, 189624.0
11.02533, 189316.0
11.026, 189007.0
11.02667, 188697.0
11.02733, 188383.0
11.028, 188065.0
11.02867, 187740.0
11.02933, 187407.0
11.03, 187063.0
11.03067, 186708.0
11.03133, 186340.0
11.032, 185959.0
11.03267, 185564.0
11.03333, 185156.0
11.034, 184736.0
11.03467, 184303.0
11.03533, 183858.0
11.036, 183403.0
11.03667, 182938.0
11.03733, 182464.0
11.038, 181983.0
11.03867, 181495.0
11.03933, 181003.0
11.04, 180507.0
11.04067, 180008.0
11.04133, 179507.0
11.042, 179002.0
11.04267, 178495.0
11.04333, 177983.0
11.044, 177466.0
11.04467, 176944.0
11.04533, 176415.0
11.046, 175880.0
11.04667, 175337.0
11.04733, 174789.0
11.048, 174234.0
11.04867, 173674.0
11.04933, 173109.0
11.05, 172540.0
11.05067, 171967.0
11.05133, 171391.0
11.052, 170812.0
11.05267, 170231.0
11.05333, 169647.0
11.054, 169062.0
11.05467, 168475.0
11.05533, 167888.0
11.056, 167300.0
11.05667, 166713.0
11.05733, 166128.0
11.058, 165544.0
11.05867, 164961.0
11.05933, 164381.0
11.06, 163803.0
11.06067, 163227.0
11.06133, 162654.0
11.062, 162084.0
11.06267, 161516.0
11.06333, 160949.0
11.064, 160382.0
11.06467, 159815.0
11.06533, 159247.0
11.066, 158678.0
11.06667, 158107.0
11.06733, 157532.0
11.068, 156952.0
11.06867, 156366.0
11.06933, 155773.0
11.07, 155172.0
11.07067, 154563.0
11.07133, 153945.0
11.072, 153319.0
11.07267, 152684.0
11.07333, 152042.0
11.074, 151394.0
11.07467, 150739.0
11.07533, 150079.0
11.076, 149413.0
11.07667, 148744.0
11.07733, 148071.0
11.078, 147395.0
11.07867, 146718.0
11.07933, 146040.0
11.08, 145361.0
11.08067, 144684.0
11.08133, 144007.0
11.082, 143333.0
11.08267, 142663.0
11.08333, 141997.0
11.084, 141334.0
11.08467, 140676.0
11.08533, 140023.0
11.086, 139374.0
11.08667, 138730.0
11.08733, 138090.0
11.088, 137456.0
11.08867, 136826.0
11.08933, 136202.0
11.09, 135584.0
11.09067, 134972.0
11.09133, 134365.0
11.092, 133765.0
11.09267, 133170.0
11.09333, 132582.0
11.094, 132000.0
11.09467, 131423.0
11.09533, 130851.0
11.096, 130283.0
11.09667, 129719.0
11.09733, 129161.0
11.098, 128606.0
11.09867, 128057.0
11.09933, 127511.0
11.1, 126969.0
11.10067, 126430.0
11.10133, 125896.0
11.102, 125367.0
11.10267, 124842.0
11.10333, 124324.0
11.104, 123811.0
11.10467, 123305.0
11.10533, 122807.0
11.106, 122316.0
11.10667, 121833.0
11.10733, 121359.0
11.108, 120892.0
11.10867, 120435.0
11.10933, 119986.0
11.11, 119545.0
11.11067, 119112.0
11.11133, 118688.0
11.112, 118272.0
11.11267, 117863.0
11.11333, 117460.0
11.114, 117064.0
11.11467, 116673.0
11.11533, 116287.0
11.116, 115904.0
11.11667, 115526.0
11.11733, 115151.0
11.118, 114779.0
11.11867, 114410.0
11.11933, 114044.0
11.12, 113682.0
11.12067, 113321.0
11.12133, 112963.0
11.122, 112607.0
11.12267, 112253.0
11.12333, 111900.0
11.124, 111550.0
11.12467, 111202.0
11.12533, 110856.0
11.126, 110512.0
11.12667, 110169.0
11.12733, 109829.0
11.128, 109492.0
11.12867, 109157.0
11.12933, 108825.0
11.13, 108497.0
11.13067, 108173.0
11.13133, 107854.0
11.132, 107539.0
11.13267, 107229.0
11.13333, 106924.0
11.134, 106624.0
11.13467, 106330.0
11.13533, 106040.0
11.136, 105755.0
11.13667, 105475.0
11.13733, 105200.0
11.138, 104930.0
11.13867, 104664.0
11.13933, 104404.0
11.14, 104148.0
11.14067, 103897.0
11.14133, 103650.0
11.142, 103407.0
11.14267, 103167.0
11.14333, 102931.0
11.144, 102697.0
11.14467, 102465.0
11.14533, 102235.0
11.146, 102005.0
11.14667, 101777.0
11.14733, 101549.0
11.148, 101323.0
11.14867, 101097.0
11.14933, 100874.0
11.15, 100651.0
11.15067, 100430.0
11.15133, 100212.0
11.152, 99995.0
11.15267, 99780.0
11.15333, 99567.0
11.154, 99357.0
11.15467, 99149.0
11.15533, 98946.0
11.156, 98747.0
11.15667, 98553.0
11.15733, 98364.0
11.158, 98180.0
11.15867, 98001.0
11.15933, 97827.0
11.16, 97658.0
11.16067, 97494.0
11.16133, 97334.0
11.162, 97178.0
11.16267, 97027.0
11.16333, 96879.0
11.164, 96736.0
11.16467, 96597.0
11.16533, 96462.0
11.166, 96330.0
11.16667, 96203.0
11.16733, 96079.0
11.168, 95958.0
11.16867, 95841.0
11.16933, 95727.0
11.17, 95615.0
11.17067, 95506.0
11.17133, 95399.0
11.172, 95293.0
11.17267, 95187.0
11.17333, 95082.0
11.174, 94977.0
11.17467, 94871.0
11.17533, 94765.0
11.176, 94658.0
11.17667, 94550.0
11.17733, 94440.0
11.178, 94330.0
11.17867, 94217.0
11.17933, 94103.0
11.18, 93987.0
11.18067, 93869.0
11.18133, 93749.0
11.182, 93628.0
11.18267, 93505.0
11.18333, 93380.0
11.184, 93254.0
11.18467, 93127.0
11.18533, 92997.0
11.186, 92866.0
11.18667, 92732.0
11.18733, 92595.0
11.188, 92456.0
11.18867, 92314.0
11.18933, 92168.0
11.19, 92019.0
11.19067, 91865.0
11.19133, 91707.0
11.192, 91544.0
11.19267, 91376.0
11.19333, 91204.0
11.194, 91026.0
11.19467, 90843.0
11.19533, 90655.0
11.196, 90462.0
11.19667, 90264.0
11.19733, 90062.0
11.198, 89854.0
11.19867, 89643.0
11.19933, 89427.0
11.2, 89209.0
11.20067, 88987.0
11.20133, 88762.0
11.202, 88535.0
11.20267, 88306.0
11.20333, 88076.0
11.204, 87844.0
11.20467, 87611.0
11.20533, 87378.0
11.206, 87144.0
11.20667, 86909.0
11.20733, 86674.0
11.208, 86438.0
11.20867, 86202.0
11.20933, 85965.0
11.21, 85729.0
11.21067, 85492.0
11.21133, 85256.0
11.212, 85018.0
11.21267, 84781.0
11.21333, 84542.0
11.214, 84301.0
11.21467, 84059.0
11.21533, 83814.0
11.216, 83566.0
11.21667, 83314.0
11.21733, 83057.0
11.218, 82796.0
11.21867, 82529.0
11.21933, 82257.0
11.22, 81979.0
11.22067, 81695.0
11.22133, 81406.0
11.222, 81112.0
11.22267, 80813.0
11.22333, 80509.0
11.224, 80200.0
11.22467, 79888.0
11.22533, 79571.0
11.226, 79251.0
11.22667, 78928.0
11.22733, 78602.0
11.228, 78273.0
11.22867, 77942.0
11.22933, 77609.0
11.23, 77275.0
11.23067, 76939.0
11.23133, 76602.0
11.232, 76264.0
11.23267, 75926.0
11.23333, 75587.0
11.234, 75249.0
11.23467, 74911.0
11.23533, 74576.0
11.236, 74243.0
11.23667, 73913.0
11.23733, 73586.0
11.238, 73263.0
11.23867, 72945.0
11.23933, 72631.0
11.24, 72323.0
11.24067, 72019.0
11.24133, 71721.0
11.242, 71428.0
11.24267, 71140.0
11.24333, 70856.0
11.244, 70577.0
11.24467, 70301.0
11.24533, 70030.0
11.246, 69762.0
11.24667, 69498.0
11.24733, 69238.0
11.248, 68982.0
11.24867, 68730.0
11.24933, 68482.0
11.25, 68238.0
11.25067, 67999.0
11.25133, 67762.0
11.252, 67530.0
11.25267, 67301.0
11.25333, 67074.0
11.254, 66851.0
11.25467, 66630.0
11.25533, 66411.0
11.256, 66194.0
11.25667, 65979.0
11.25733, 65767.0
11.258, 65556.0
11.25867, 65348.0
11.25933, 65142.0
11.26, 64939.0
11.26067, 64739.0
11.26133, 64541.0
11.262, 64346.0
11.26267, 64153.0
11.26333, 63963.0
11.264, 63776.0
11.26467, 63592.0
11.26533, 63410.0
11.266, 63232.0
11.26667, 63056.0
11.26733, 62884.0
11.268, 62714.0
11.26867, 62546.0
11.26933, 62381.0
11.27, 62218.0
11.27067, 62056.0
11.27133, 61895.0
11.272, 61734.0
11.27267, 61574.0
11.27333, 61414.0
11.274, 61254.0
11.27467, 61093.0
11.27533, 60932.0
11.276, 60770.0
11.27667, 60607.0
11.27733, 60443.0
11.278, 60278.0
11.27867, 60112.0
11.27933, 59944.0
11.28, 59774.0
11.28067, 59603.0
11.28133, 59430.0
11.282, 59255.0
11.28267, 59078.0
11.28333, 58900.0
11.284, 58720.0
11.28467, 58538.0
11.28533, 58354.0
11.286, 58169.0
11.28667, 57982.0
11.28733, 57793.0
11.288, 57602.0
11.28867, 57411.0
11.28933, 57218.0
11.29, 57025.0
11.29067, 56832.0
11.29133, 56638.0
11.292, 56445.0
11.29267, 56251.0
11.29333, 56057.0
11.294, 55863.0
11.29467, 55670.0
11.29533, 55478.0
11.296, 55286.0
11.29667, 55095.0
11.29733, 54904.0
11.298, 54715.0
11.29867, 54526.0
11.29933, 54339.0
11.3, 54152.0
11.30067, 53967.0
11.30133, 53782.0
11.302, 53597.0
11.30267, 53414.0
11.30333, 53231.0
11.304, 53048.0
11.30467, 52865.0
11.30533, 52682.0
11.306, 52500.0
11.30667, 52317.0
11.30733, 52136.0
11.308, 51955.0
11.30867, 51775.0
11.30933, 51596.0
11.31, 51418.0
11.31067, 51242.0
11.31133, 51068.0
11.312, 50896.0
11.31267, 50725.0
11.31333, 50556.0
11.314, 50389.0
11.31467, 50224.0
11.31533, 50060.0
11.316, 49897.0
11.31667, 49737.0
11.31733, 49577.0
11.318, 49420.0
11.31867, 49264.0
11.31933, 49109.0
11.32, 48956.0
11.32067, 48804.0
11.32133, 48654.0
11.322, 48505.0
11.32267, 48357.0
11.32333, 48210.0
11.324, 48064.0
11.32467, 47920.0
11.32533, 47778.0
11.326, 47636.0
11.32667, 47496.0
11.32733, 47358.0
11.328, 47221.0
11.32867, 47086.0
11.32933, 46953.0
11.33, 46820.0
11.33067, 46689.0
11.33133, 46560.0
11.332, 46431.0
11.33267, 46304.0
11.33333, 46178.0
11.334, 46053.0
11.33467, 45928.0
11.33533, 45804.0
11.336, 45681.0
11.33667, 45558.0
11.33733, 45435.0
11.338, 45312.0
11.33867, 45189.0
11.33933, 45066.0
11.34, 44942.0
11.34067, 44817.0
11.34133, 44692.0
11.342, 44565.0
11.34267, 44439.0
11.34333, 44312.0
11.344, 44183.0
11.34467, 44055.0
11.34533, 43926.0
11.346, 43796.0
11.34667, 43666.0
11.34733, 43536.0
11.348, 43407.0
11.34867, 43278.0
11.34933, 43150.0
11.35, 43023.0
11.35067, 42897.0
11.35133, 42773.0
11.352, 42650.0
11.35267, 42528.0
11.35333, 42407.0
11.354, 42288.0
11.35467, 42171.0
11.35533, 42055.0
11.356, 41941.0
11.35667, 41829.0
11.35733, 41718.0
11.358, 41609.0
11.35867, 41501.0
11.35933, 41394.0
11.36, 41288.0
11.36067, 41182.0
11.36133, 41076.0
11.362, 40970.0
11.36267, 40863.0
11.36333, 40756.0
11.364, 40649.0
11.36467, 40541.0
11.36533, 40432.0
11.366, 40323.0
11.36667, 40215.0
11.36733, 40106.0
11.368, 39998.0
11.36867, 39890.0
11.36933, 39782.0
11.37, 39675.0
11.37067, 39569.0
11.37133, 39463.0
11.372, 39359.0
11.37267, 39255.0
11.37333, 39153.0
11.374, 39051.0
11.37467, 38951.0
11.37533, 38852.0
11.376, 38755.0
11.37667, 38658.0
11.37733, 38562.0
11.378, 38467.0
11.37867, 38372.0
11.37933, 38279.0
11.38, 38186.0
11.38067, 38094.0
11.38133, 38002.0
11.382, 37910.0
11.38267, 37818.0
11.38333, 37727.0
11.384, 37635.0
11.38467, 37544.0
11.38533, 37452.0
11.386, 37361.0
11.38667, 37270.0
11.38733, 37179.0
11.388, 37089.0
11.38867, 37000.0
11.38933, 36912.0
11.39, 36825.0
11.39067, 36739.0
11.39133, 36654.0
11.392, 36570.0
11.39267, 36488.0
11.39333, 36408.0
11.394, 36329.0
11.39467, 36252.0
11.39533, 36177.0
11.396, 36103.0
11.39667, 36031.0
11.39733, 35960.0
11.398, 35890.0
11.39867, 35822.0
11.39933, 35754.0
11.4, 35688.0
11.40067, 35624.0
11.40133, 35560.0
11.402, 35497.0
11.40267, 35435.0
11.40333, 35374.0
11.404, 35314.0
11.40467, 35255.0
11.40533, 35197.0
11.406, 35140.0
11.40667, 35084.0
11.40733, 35029.0
11.408, 34975.0
11.40867, 34921.0
11.40933, 34868.0
11.41, 34816.0
11.41067, 34764.0
11.41133, 34712.0
11.412, 34660.0
11.41267, 34609.0
11.41333, 34558.0
11.414, 34507.0
11.41467, 34458.0
11.41533, 34408.0
11.416, 34360.0
11.41667, 34312.0
11.41733, 34265.0
11.418, 34219.0
11.41867, 34173.0
11.41933, 34128.0
11.42, 34084.0
11.42067, 34040.0
11.42133, 33997.0
11.422, 33954.0
11.42267, 33912.0
11.42333, 33870.0
11.424, 33830.0
11.42467, 33790.0
11.42533, 33751.0
11.426, 33713.0
11.42667, 33676.0
11.42733, 33639.0
11.428, 33604.0
11.42867, 33569.0
11.42933, 33535.0
11.43, 33501.0
11.43067, 33468.0
11.43133, 33435.0
11.432, 33403.0
11.43267, 33371.0
11.43333, 33338.0
11.434, 33306.0
11.43467, 33273.0
11.43533, 33240.0
11.436, 33206.0
11.43667, 33173.0
11.43733, 33139.0
11.438, 33105.0
11.43867, 33071.0
11.43933, 33037.0
11.44, 33002.0
11.44067, 32967.0
11.44133, 32933.0
11.442, 32898.0
11.44267, 32864.0
11.44333, 32830.0
11.444, 32796.0
11.44467, 32762.0
11.44533, 32728.0
11.446, 32694.0
11.44667, 32660.0
11.44733, 32626.0
11.448, 32591.0
11.44867, 32557.0
11.44933, 32522.0
11.45, 32488.0
11.45067, 32454.0
11.45133, 32420.0
11.452, 32387.0
11.45267, 32354.0
11.45333, 32320.0
11.454, 32287.0
11.45467, 32254.0
11.45533, 32221.0
11.456, 32188.0
11.45667, 32156.0
11.45733, 32124.0
11.458, 32092.0
11.45867, 32061.0
11.45933, 32030.0
11.46, 32000.0
11.46067, 31969.0
11.46133, 31940.0
11.462, 31910.0
11.46267, 31880.0
11.46333, 31851.0
11.464, 31822.0
11.46467, 31792.0
11.46533, 31762.0
11.466, 31733.0
11.46667, 31703.0
11.46733, 31674.0
11.468, 31646.0
11.46867, 31618.0
11.46933, 31590.0
11.47, 31564.0
11.47067, 31537.0
11.47133, 31512.0
11.472, 31486.0
11.47267, 31462.0
11.47333, 31437.0
11.474, 31413.0
11.47467, 31388.0
11.47533, 31364.0
11.476, 31340.0
11.47667, 31316.0
11.47733, 31292.0
11.478, 31267.0
11.47867, 31243.0
11.47933, 31218.0
11.48, 31194.0
11.48067, 31170.0
11.48133, 31146.0
11.482, 31123.0
11.48267, 31099.0
11.48333, 31076.0
11.484, 31052.0
11.48467, 31029.0
11.48533, 31006.0
11.486, 30982.0
11.48667, 30958.0
11.48733, 30934.0
11.488, 30909.0
11.48867, 30885.0
11.48933, 30860.0
11.49, 30835.0
11.49067, 30810.0
11.49133, 30785.0
11.492, 30760.0
11.49267, 30735.0
11.49333, 30710.0
11.494, 30685.0
11.49467, 30661.0
11.49533, 30636.0
11.496, 30611.0
11.49667, 30587.0
11.49733, 30562.0
11.498, 30537.0
11.49867, 30511.0
11.49933, 30486.0
11.5, 30460.0
11.50067, 30434.0
11.50133, 30409.0
11.502, 30383.0
11.50267, 30358.0
11.50333, 30332.0
11.504, 30307.0
11.50467, 30281.0
11.50533, 30256.0
11.506, 30231.0
11.50667, 30205.0
11.50733, 30180.0
11.508, 30154.0
11.50867, 30129.0
11.50933, 30103.0
11.51, 30078.0
11.51067, 30053.0
11.51133, 30028.0
11.512, 30004.0
11.51267, 29980.0
11.51333, 29957.0
11.514, 29934.0
11.51467, 29912.0
11.51533, 29890.0
11.516, 29869.0
11.51667, 29848.0
11.51733, 29827.0
11.518, 29807.0
11.51867, 29787.0
11.51933, 29768.0
11.52, 29749.0
11.52067, 29731.0
11.52133, 29713.0
11.522, 29694.0
11.52267, 29676.0
11.52333, 29658.0
11.524, 29640.0
11.52467, 29623.0
11.52533, 29605.0
11.526, 29588.0
11.52667, 29570.0
11.52733, 29553.0
11.528, 29535.0
11.52867, 29517.0
11.52933, 29500.0
11.53, 29482.0
11.53067, 29465.0
11.53133, 29447.0
11.532, 29430.0
11.53267, 29414.0
11.53333, 29397.0
11.534, 29381.0
11.53467, 29365.0
11.53533, 29349.0
11.536, 29334.0
11.53667, 29319.0
11.53733, 29303.0
11.538, 29288.0
11.53867, 29273.0
11.53933, 29258.0
11.54, 29243.0
11.54067, 29227.0
11.54133, 29211.0
11.542, 29195.0
11.54267, 29179.0
11.54333, 29163.0
11.544, 29147.0
11.54467, 29130.0
11.54533, 29114.0
11.546, 29097.0
11.54667, 29081.0
11.54733, 29064.0
11.548, 29048.0
11.54867, 29031.0
11.54933, 29015.0
11.55, 28999.0
11.55067, 28982.0
11.55133, 28966.0
11.552, 28950.0
11.55267, 28934.0
11.55333, 28918.0
11.554, 28902.0
11.55467, 28885.0
11.55533, 28868.0
11.556, 28851.0
11.55667, 28834.0
11.55733, 28817.0
11.558, 28799.0
11.55867, 28782.0
11.55933, 28765.0
11.56, 28748.0
11.56067, 28731.0
11.56133, 28715.0
11.562, 28700.0
11.56267, 28685.0
11.56333, 28670.0
11.564, 28656.0
11.56467, 28642.0
11.56533, 28629.0
11.566, 28617.0
11.56667, 28604.0
11.56733, 28592.0
11.568, 28580.0
11.56867, 28569.0
11.56933, 28557.0
11.57, 28546.0
11.57067, 28535.0
11.57133, 28524.0
11.572, 28513.0
11.57267, 28504.0
11.57333, 28495.0
11.574, 28486.0
11.57467, 28479.0
11.57533, 28472.0
11.576, 28465.0
11.57667, 28460.0
11.57733, 28454.0
11.578, 28449.0
11.57867, 28443.0
11.57933, 28438.0
11.58, 28433.0
11.58067, 28427.0
11.58133, 28421.0
11.582, 28415.0
11.58267, 28409.0
11.58333, 28402.0
11.584, 28395.0
11.58467, 28387.0
11.58533, 28379.0
11.586, 28371.0
11.58667, 28362.0
11.58733, 28353.0
11.588, 28343.0
11.58867, 28334.0
11.58933, 28323.0
11.59, 28313.0
11.59067, 28302.0
11.59133, 28291.0
11.592, 28280.0
11.59267, 28269.0
11.59333, 28258.0
11.594, 28247.0
11.59467, 28236.0
11.59533, 28225.0
11.596, 28214.0
11.59667, 28204.0
11.59733, 28193.0
11.598, 28182.0
11.59867, 28171.0
11.59933, 28160.0
11.6, 28148.0
11.60067, 28136.0
11.60133, 28124.0
11.602, 28111.0
11.60267, 28098.0
11.60333, 28085.0
11.604, 28072.0
11.60467, 28057.0
11.60533, 28043.0
11.606, 28028.0
11.60667, 28012.0
11.60733, 27996.0
11.608, 27980.0
11.60867, 27964.0
11.60933, 27948.0
11.61, 27932.0
11.61067, 27916.0
11.61133, 27899.0
11.612, 27882.0
11.61267, 27864.0
11.61333, 27846.0
11.614, 27827.0
11.61467, 27807.0
11.61533, 27788.0
11.616, 27768.0
11.61667, 27748.0
11.61733, 27728.0
11.618, 27709.0
11.61867, 27689.0
11.61933, 27670.0
11.62, 27650.0
11.62067, 27630.0
11.62133, 27610.0
11.622, 27590.0
11.62267, 27571.0
11.62333, 27551.0
11.624, 27531.0
11.62467, 27512.0
11.62533, 27493.0
11.626, 27473.0
11.62667, 27454.0
11.62733, 27435.0
11.628, 27416.0
11.62867, 27397.0
11.62933, 27378.0
11.63, 27360.0
11.63067, 27342.0
11.63133, 27324.0
11.632, 27307.0
11.63267, 27291.0
11.63333, 27274.0
11.634, 27258.0
11.63467, 27243.0
11.63533, 27227.0
11.636, 27212.0
11.63667, 27198.0
11.63733, 27183.0
11.638, 27168.0
11.63867, 27153.0
11.63933, 27139.0
11.64, 27124.0
11.64067, 27109.0
11.64133, 27093.0
11.642, 27078.0
11.64267, 27062.0
11.64333, 27047.0
11.644, 27031.0
11.64467, 27016.0
11.64533, 27001.0
11.646, 26986.0
11.64667, 26972.0
11.64733, 26958.0
11.648, 26945.0
11.64867, 26933.0
11.64933, 26920.0
11.65, 26909.0
11.65067, 26897.0
11.65133, 26886.0
11.652, 26875.0
11.65267, 26865.0
11.65333, 26854.0
11.654, 26845.0
11.65467, 26835.0
11.65533, 26826.0
11.656, 26817.0
11.65667, 26808.0
11.65733, 26801.0
11.658, 26794.0
11.65867, 26787.0
11.65933, 26782.0
11.66, 26778.0
11.66067, 26774.0
11.66133, 26770.0
11.662, 26767.0
11.66267, 26765.0
11.66333, 26762.0
11.664, 26760.0
11.66467, 26757.0
11.66533, 26755.0
11.666, 26752.0
11.66667, 26749.0
11.66733, 26747.0
11.668, 26744.0
11.66867, 26742.0
11.66933, 26740.0
11.67, 26739.0
11.67067, 26738.0
11.67133, 26737.0
11.672, 26736.0
11.67267, 26736.0
11.67333, 26736.0
11.674, 26736.0
11.67467, 26736.0
11.67533, 26736.0
11.676, 26736.0
11.67667, 26736.0
11.67733, 26736.0
11.678, 26735.0
11.67867, 26734.0
11.67933, 26733.0
11.68, 26732.0
11.68067, 26730.0
11.68133, 26728.0
11.682, 26726.0
11.68267, 26724.0
11.68333, 26722.0
11.684, 26719.0
11.68467, 26717.0
11.68533, 26714.0
11.686, 26712.0
11.68667, 26710.0
11.68733, 26708.0
11.688, 26706.0
11.68867, 26703.0
11.68933, 26701.0
11.69, 26699.0
11.69067, 26696.0
11.69133, 26693.0
11.692, 26690.0
11.69267, 26686.0
11.69333, 26682.0
11.694, 26679.0
11.69467, 26677.0
11.69533, 26674.0
11.696, 26673.0
11.69667, 26672.0
11.69733, 26671.0
11.698, 26670.0
11.69867, 26669.0
11.69933, 26669.0
11.7, 26668.0
11.70067, 26667.0
11.70133, 26667.0
11.702, 26667.0
11.70267, 26667.0
11.70333, 26667.0
11.704, 26668.0
11.70467, 26669.0
11.70533, 26670.0
11.706, 26671.0
11.70667, 26672.0
11.70733, 26673.0
11.708, 26675.0
11.70867, 26677.0
11.70933, 26679.0
11.71, 26681.0
11.71067, 26684.0
11.71133, 26687.0
11.712, 26690.0
11.71267, 26694.0
11.71333, 26698.0
11.714, 26702.0
11.71467, 26707.0
11.71533, 26712.0
11.716, 26718.0
11.71667, 26723.0
11.71733, 26730.0
11.718, 26736.0
11.71867, 26743.0
11.71933, 26749.0
11.72, 26756.0
11.72067, 26763.0
11.72133, 26770.0
11.722, 26776.0
11.72267, 26782.0
11.72333, 26788.0
11.724, 26794.0
11.72467, 26800.0
11.72533, 26806.0
11.726, 26813.0
11.72667, 26819.0
11.72733, 26826.0
11.728, 26833.0
11.72867, 26840.0
11.72933, 26847.0
11.73, 26855.0
11.73067, 26862.0
11.73133, 26869.0
11.732, 26876.0
11.73267, 26882.0
11.73333, 26888.0
11.734, 26894.0
11.73467, 26899.0
11.73533, 26904.0
11.736, 26909.0
11.73667, 26914.0
11.73733, 26919.0
11.738, 26924.0
11.73867, 26930.0
11.73933, 26937.0
11.74, 26944.0
11.74067, 26951.0
11.74133, 26959.0
11.742, 26968.0
11.74267, 26976.0
11.74333, 26986.0
11.744, 26996.0
11.74467, 27007.0
11.74533, 27018.0
11.746, 27031.0
11.74667, 27044.0
11.74733, 27057.0
11.748, 27071.0
11.74867, 27084.0
11.74933, 27098.0
11.75, 27112.0
11.75067, 27125.0
11.75133, 27139.0
11.752, 27151.0
11.75267, 27164.0
11.75333, 27176.0
11.754, 27188.0
11.75467, 27199.0
11.75533, 27209.0
11.756, 27219.0
11.75667, 27229.0
11.75733, 27238.0
11.758, 27247.0
11.75867, 27256.0
11.75933, 27263.0
11.76, 27271.0
11.76067, 27278.0
11.76133, 27284.0
11.762, 27290.0
11.76267, 27295.0
11.76333, 27300.0
11.764, 27305.0
11.76467, 27309.0
11.76533, 27312.0
11.766, 27316.0
11.76667, 27318.0
11.76733, 27321.0
11.768, 27323.0
11.76867, 27325.0
11.76933, 27327.0
11.77, 27328.0
11.77067, 27330.0
11.77133, 27331.0
11.772, 27332.0
11.77267, 27333.0
11.77333, 27334.0
11.774, 27335.0
11.77467, 27336.0
11.77533, 27337.0
11.776, 27338.0
11.77667, 27338.0
11.77733, 27339.0
11.778, 27338.0
11.77867, 27337.0
11.77933, 27336.0
11.78, 27334.0
11.78067, 27332.0
11.78133, 27329.0
11.782, 27326.0
11.78267, 27324.0
11.78333, 27321.0
11.784, 27318.0
11.78467, 27315.0
11.78533, 27312.0
11.786, 27309.0
11.78667, 27306.0
11.78733, 27303.0
11.788, 27301.0
11.78867, 27299.0
11.78933, 27298.0
11.79, 27297.0
11.79067, 27297.0
11.79133, 27297.0
11.792, 27299.0
11.79267, 27301.0
11.79333, 27303.0
11.794, 27305.0
11.79467, 27307.0
11.79533, 27308.0
11.796, 27309.0
11.79667, 27310.0
11.79733, 27311.0
11.798, 27311.0
11.79867, 27311.0
11.79933, 27312.0
11.8, 27312.0
11.80067, 27312.0
11.80133, 27313.0
11.802, 27314.0
11.80267, 27315.0
11.80333, 27316.0
11.804, 27317.0
11.80467, 27318.0
11.80533, 27319.0
11.806, 27319.0
11.80667, 27320.0
11.80733, 27320.0
11.808, 27320.0
11.80867, 27320.0
11.80933, 27320.0
11.81, 27319.0
11.81067, 27317.0
11.81133, 27316.0
11.812, 27314.0
11.81267, 27312.0
11.81333, 27311.0
11.814, 27308.0
11.81467, 27305.0
11.81533, 27302.0
11.816, 27299.0
11.81667, 27294.0
11.81733, 27289.0
11.818, 27283.0
11.81867, 27277.0
11.81933, 27271.0
11.82, 27264.0
11.82067, 27256.0
11.82133, 27248.0
11.822, 27240.0
11.82267, 27232.0
11.82333, 27224.0
11.824, 27217.0
11.82467, 27209.0
11.82533, 27201.0
11.826, 27193.0
11.82667, 27185.0
11.82733, 27178.0
11.828, 27170.0
11.82867, 27163.0
11.82933, 27156.0
11.83, 27149.0
11.83067, 27141.0
11.83133, 27133.0
11.832, 27126.0
11.83267, 27118.0
11.83333, 27110.0
11.834, 27102.0
11.83467, 27094.0
11.83533, 27086.0
11.836, 27078.0
11.83667, 27069.0
11.83733, 27061.0
11.838, 27052.0
11.83867, 27042.0
11.83933, 27033.0
11.84, 27023.0
11.84067, 27013.0
11.84133, 27002.0
11.842, 26992.0
11.84267, 26982.0
11.84333, 26971.0
11.844, 26961.0
11.84467, 26951.0
11.84533, 26942.0
11.846, 26933.0
11.84667, 26925.0
11.84733, 26917.0
11.848, 26909.0
11.84867, 26901.0
11.84933, 26894.0
11.85, 26886.0
11.85067, 26879.0
11.85133, 26872.0
11.852, 26864.0
11.85267, 26858.0
11.85333, 26851.0
11.854, 26844.0
11.85467, 26838.0
11.85533, 26831.0
11.856, 26824.0
11.85667, 26817.0
11.85733, 26811.0
11.858, 26804.0
11.85867, 26797.0
11.85933, 26791.0
11.86, 26785.0
11.86067, 26779.0
11.86133, 26773.0
11.862, 26767.0
11.86267, 26762.0
11.86333, 26756.0
11.864, 26751.0
11.86467, 26746.0
11.86533, 26741.0
11.866, 26736.0
11.86667, 26731.0
11.86733, 26726.0
11.868, 26721.0
11.86867, 26716.0
11.86933, 26711.0
11.87, 26706.0
11.87067, 26702.0
11.87133, 26697.0
11.872, 26693.0
11.87267, 26689.0
11.87333, 26686.0
11.874, 26682.0
11.87467, 26679.0
11.87533, 26677.0
11.876, 26674.0
11.87667, 26672.0
11.87733, 26670.0
11.878, 26669.0
11.87867, 26669.0
11.87933, 26669.0
11.88, 26670.0
11.88067, 26672.0
11.88133, 26674.0
11.882, 26677.0
11.88267, 26681.0
11.88333, 26685.0
11.884, 26689.0
11.88467, 26693.0
11.88533, 26697.0
11.886, 26702.0
11.88667, 26705.0
11.88733, 26708.0
11.888, 26711.0
11.88867, 26713.0
11.88933, 26715.0
11.89, 26716.0
11.89067, 26717.0
11.89133, 26717.0
11.892, 26716.0
11.89267, 26715.0
11.89333, 26713.0
11.894, 26710.0
11.89467, 26706.0
11.89533, 26702.0
11.896, 26697.0
11.89667, 26693.0
11.89733, 26688.0
11.898, 26683.0
11.89867, 26678.0
11.89933, 26674.0
11.9, 26670.0
11.90067, 26667.0
11.90133, 26664.0
11.902, 26661.0
11.90267, 26659.0
11.90333, 26657.0
11.904, 26655.0
11.90467, 26654.0
11.90533, 26653.0
11.906, 26653.0
11.90667, 26653.0
11.90733, 26654.0
11.908, 26655.0
11.90867, 26656.0
11.90933, 26657.0
11.91, 26658.0
11.91067, 26659.0
11.91133, 26660.0
11.912, 26661.0
11.91267, 26661.0
11.91333, 26661.0
11.914, 26662.0
11.91467, 26662.0
11.91533, 26663.0
11.916, 26664.0
11.91667, 26666.0
11.91733, 26668.0
11.918, 26670.0
11.91867, 26672.0
11.91933, 26674.0
11.92, 26677.0
11.92067, 26679.0
11.92133, 26681.0
11.922, 26684.0
11.92267, 26686.0
11.92333, 26687.0
11.924, 26689.0
11.92467, 26691.0
11.92533, 26694.0
11.926, 26697.0
11.92667, 26699.0
11.92733, 26702.0
11.928, 26705.0
11.92867, 26708.0
11.92933, 26711.0
11.93, 26714.0
11.93067, 26718.0
11.93133, 26721.0
11.932, 26726.0
11.93267, 26730.0
11.93333, 26735.0
11.934, 26740.0
11.93467, 26745.0
11.93533, 26750.0
11.936, 26756.0
11.93667, 26761.0
11.93733, 26767.0
11.938, 26773.0
11.93867, 26780.0
11.93933, 26787.0
11.94, 26794.0
11.94067, 26801.0
11.94133, 26808.0
11.942, 26816.0
11.94267, 26825.0
11.94333, 26833.0
11.944, 26843.0
11.94467, 26852.0
11.94533, 26862.0
11.946, 26872.0
11.94667, 26883.0
11.94733, 26894.0
11.948, 26904.0
11.94867, 26915.0
11.94933, 26925.0
11.95, 26935.0
11.95067, 26945.0
11.95133, 26954.0
11.952, 26964.0
11.95267, 26973.0
11.95333, 26983.0
11.954, 26993.0
11.95467, 27003.0
11.95533, 27014.0
11.956, 27024.0
11.95667, 27035.0
11.95733, 27046.0
11.958, 27057.0
11.95867, 27067.0
11.95933, 27078.0
11.96, 27088.0
11.96067, 27098.0
11.96133, 27107.0
11.962, 27115.0
11.96267, 27123.0
11.96333, 27131.0
11.964, 27138.0
11.96467, 27144.0
11.96533, 27150.0
11.966, 27156.0
11.96667, 27161.0
11.96733, 27166.0
11.968, 27171.0
11.96867, 27175.0
11.96933, 27179.0
11.97, 27183.0
11.97067, 27186.0
11.97133, 27188.0
11.972, 27191.0
11.97267, 27192.0
11.97333, 27194.0
11.974, 27195.0
11.97467, 27196.0
11.97533, 27196.0
11.976, 27197.0
11.97667, 27197.0
11.97733, 27198.0
11.978, 27198.0
11.97867, 27199.0
11.97933, 27199.0
11.98, 27200.0
11.98067, 27200.0
11.98133, 27200.0
11.982, 27201.0
11.98267, 27201.0
11.98333, 27201.0
11.984, 27201.0
11.98467, 27201.0
11.98533, 27200.0
11.986, 27199.0
11.98667, 27198.0
11.98733, 27197.0
11.988, 27196.0
11.98867, 27194.0
11.98933, 27193.0
11.99, 27190.0
11.99067, 27188.0
11.99133, 27185.0
11.992, 27182.0
11.99267, 27178.0
11.99333, 27174.0
11.994, 27170.0
11.99467, 27165.0
11.99533, 27161.0
11.996, 27155.0
11.99667, 27151.0
11.99733, 27146.0
11.998, 27142.0
11.99867, 27138.0
11.99933, 27134.0
12.0, 27130.0
##END=$$ End of the data block

`;

export default gcJcamp2;
